(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1033],{

/***/ 337247:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ HeaderInfoIcon; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(785893);

var HeaderInfoIcon = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        id: "information",
        xmlns: "http://www.w3.org/2000/svg",
        width: props.width || "13.757",
        height: props.height || "16.008",
        viewBox: "0 0 13.757 16.008",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
            id: "Group_160946",
            "data-name": "Group 160946",
            transform: "translate(0 0)",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                id: "Group_160945",
                "data-name": "Group 160945",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        id: "Path_229366",
                        fill: props.color || "#000",
                        "data-name": "Path 229366",
                        d: "M234.921,182.774c-.4,0-.68.168-.68.415v3.366c0,.212.283.424.68.424.38,0,.689-.212.689-.424v-3.366C235.611,182.942,235.3,182.774,234.921,182.774Z",
                        transform: "translate(-228.043 -177.06)"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        id: "Path_229367",
                        fill: props.color || "#000",
                        "data-name": "Path 229367",
                        d: "M233.553,116.361a.637.637,0,1,0,.716.627A.684.684,0,0,0,233.553,116.361Z",
                        transform: "translate(-226.674 -112.723)"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        id: "Path_229368",
                        fill: props.color || "#000",
                        "data-name": "Path 229368",
                        d: "M42.878,0A6.875,6.875,0,0,0,40.8,13.428l1.564,2.306a.625.625,0,0,0,1.035,0l1.564-2.306A6.875,6.875,0,0,0,42.878,0ZM44.4,12.29a.625.625,0,0,0-.349.251l-1.172,1.727-1.172-1.727a.625.625,0,0,0-.349-.251,5.628,5.628,0,1,1,3.042,0Z",
                        transform: "translate(-36 0)"
                    })
                ]
            })
        })
    });
};


/***/ }),

/***/ 282513:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ MinusIcon; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(626042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(269396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(785893);



function MinusIcon(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        width: (props === null || props === void 0 ? void 0 : props.iconWidth) ? props === null || props === void 0 ? void 0 : props.iconWidth : 24,
        height: props.iconHeight || 24,
        fill: "none",
        stroke: "currentColor",
        strokeWidth: 2,
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            fill: props.iconColor || "#000000",
            d: "M5 12h14"
        })
    }));
}


/***/ }),

/***/ 408886:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ PlusIcon; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(626042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(269396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(785893);



function PlusIcon(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        width: (props === null || props === void 0 ? void 0 : props.iconWidth) ? props === null || props === void 0 ? void 0 : props.iconWidth : 24,
        height: 24,
        fill: "none",
        stroke: "currentColor",
        strokeWidth: 2,
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            fill: props.iconColor || "#000000",
            d: "M12 5v14M5 12h14"
        })
    }));
}


/***/ }),

/***/ 350127:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ SearchIcon; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(626042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(269396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(785893);



function SearchIcon(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
        xmlns: "http://www.w3.org/2000/svg",
        width: props.size || 24.295,
        height: props.size || 24.295,
        viewBox: "0 0 24.295 24.295"
    }, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M24.018 22.683l-5.929-5.929a10.24 10.24 0 10-1.336 1.336l5.929 5.929a.945.945 0 101.336-1.336zM1.889 10.226a8.336 8.336 0 118.336 8.336 8.346 8.346 0 01-8.336-8.336z",
            fill: props.color
        })
    }));
}


/***/ }),

/***/ 198806:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(785893);

var SliderArrowForward = function(param) {
    var _color = param.color, color = _color === void 0 ? "#000000" : _color, _height = param.height, height = _height === void 0 ? 12 : _height, _width = param.width, width = _width === void 0 ? 7 : _width;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 7 12",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M1.7071 0.292886C1.31659 -0.0976287 0.683402 -0.0976287 0.292886 0.292886C-0.0976288 0.683401 -0.0976288 1.31659 0.292886 1.7071L4.58579 6L0.292886 10.2929C-0.0976288 10.6834 -0.0976288 11.3166 0.292886 11.7071C0.683402 12.0976 1.31659 12.0976 1.7071 11.7071L6.70711 6.70711C7.09763 6.31659 7.09763 5.68341 6.70711 5.29289L1.7071 0.292886Z",
            fill: color
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SliderArrowForward);


/***/ }),

/***/ 281431:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ SupermarketIcon; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(626042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(269396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(785893);



function SupermarketIcon(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
        xmlns: "http://www.w3.org/2000/svg",
        width: props.width || 28,
        height: props.height || 24.61,
        viewBox: "0 0 28 24.61"
    }, props), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("style", {
                    children: ".prefix__a{fill:".concat(props.color, "}")
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                className: "prefix__a",
                d: "M9.021 16.407H23.9a.82.82 0 00.789-.595l3.28-11.485a.82.82 0 00-.789-1.046H7.129L6.543.643A.82.82 0 005.742 0H.82a.82.82 0 000 1.641h4.264l2.962 13.328a2.461 2.461 0 00.978 4.719H23.9a.82.82 0 000-1.641H9.023a.82.82 0 010-1.64zM26.092 4.922l-2.812 9.844H9.681L7.494 4.922zm0 0M8.203 22.149a2.461 2.461 0 102.461-2.461 2.464 2.464 0 00-2.461 2.461zm2.461-.82a.82.82 0 11-.82.82.821.821 0 01.82-.82zm0 0M19.797 22.149a2.461 2.461 0 102.461-2.461 2.464 2.464 0 00-2.461 2.461zm2.461-.82a.82.82 0 11-.82.82.821.821 0 01.82-.82zm0 0"
            })
        ]
    }));
}


/***/ }),

/***/ 252514:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": function() { return /* binding */ UserIconDark; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(785893);

var UserIconDark = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: props.width || "33",
        height: props.height || "33",
        viewBox: "0 0 33 33",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
            id: "Group_160983",
            "data-name": "Group 160983",
            transform: "translate(-1002.137 -16.628)",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                id: "User",
                transform: "translate(1002.413 16.903)",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                        id: "Ellipse_5156",
                        "data-name": "Ellipse 5156",
                        cx: "16.5",
                        cy: "16.5",
                        r: "16.5",
                        transform: "translate(-0.275 -0.275)",
                        fill: "#efefef"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                        id: "Group_160982",
                        "data-name": "Group 160982",
                        transform: "translate(3.728 6.554)",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                id: "Path_296382",
                                "data-name": "Path 296382",
                                d: "M32.084,44.26a15.588,15.588,0,0,0-24.972-.008,15.539,15.539,0,0,0,24.972.008Z",
                                transform: "translate(-7.112 -24.671)",
                                fill: props.color || "#464e58"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                                id: "Ellipse_5157",
                                "data-name": "Ellipse 5157",
                                cx: "5.896",
                                cy: "5.896",
                                r: "5.896",
                                transform: "translate(6.593 0)",
                                fill: props.color || "#464e58"
                            })
                        ]
                    })
                ]
            })
        })
    });
};


/***/ }),

/***/ 973664:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(785893);
/* harmony import */ var src_constants_wishlist__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(298627);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(225617);



var WishlistHeartBuilderIcon = function(param) {
    var _color = param.color, color = _color === void 0 ? "white" : _color, _size = param.size, size = _size === void 0 ? 20 : _size, _isActive = param.isActive, isActive = _isActive === void 0 ? true : _isActive;
    var ref = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function(state) {
        var ref, ref1, ref2, ref3;
        return {
            isWishlistItemPresentOnStore: (ref = state.wishlistReducer) === null || ref === void 0 ? void 0 : ref.wishlistItemCount,
            wishlistFeatureActive: (ref1 = state.storeReducer) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.store) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.services) === null || ref3 === void 0 ? void 0 : ref3.wishlist_flag
        };
    }), isWishlistItemPresentOnStore = ref.isWishlistItemPresentOnStore, wishlistFeatureActive = ref.wishlistFeatureActive;
    if (wishlistFeatureActive !== src_constants_wishlist__WEBPACK_IMPORTED_MODULE_1__/* .WISHLIST_FEATURE_STATUS.WISHLIST_ACTIVE */ .g.WISHLIST_ACTIVE) return null;
    return !isWishlistItemPresentOnStore || !isActive ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M11.9773 21.6668C11.7479 21.6668 11.521 21.6265 11.2969 21.5459C11.0725 21.4652 10.875 21.3421 10.7044 21.1764L9.35233 19.9904C7.25646 18.1411 5.40703 16.3428 3.80406 14.5955C2.20129 12.8481 1.3999 11.0322 1.3999 9.14759C1.3999 7.69273 1.90881 6.47113 2.92661 5.48279C3.94422 4.49426 5.202 4 6.69995 4C7.55915 4 8.45378 4.21086 9.38384 4.63258C10.3141 5.05411 11.1861 5.84932 12 7.01821C12.8139 5.84932 13.6859 5.05411 14.6162 4.63258C15.5462 4.21086 16.4409 4 17.3001 4C18.798 4 20.0558 4.49426 21.0734 5.48279C22.0912 6.47113 22.6001 7.69273 22.6001 9.14759C22.6001 11.076 21.7658 12.9297 20.0973 14.7087C18.4288 16.4877 16.6024 18.2504 14.6182 19.997L13.2729 21.1764C13.1023 21.3421 12.9011 21.4652 12.6693 21.5459C12.4375 21.6265 12.2068 21.6668 11.9773 21.6668ZM11.4247 8.20616C10.7195 7.10171 9.98647 6.31527 9.22543 5.84684C8.46438 5.37822 7.62255 5.14391 6.69995 5.14391C5.52216 5.14391 4.54067 5.52521 3.75548 6.28782C2.97029 7.05043 2.57769 8.00368 2.57769 9.14759C2.57769 9.99237 2.82385 10.8587 3.31616 11.7466C3.80828 12.6346 4.46922 13.5443 5.29897 14.4756C6.12872 15.4068 7.08234 16.3593 8.15982 17.3331C9.2371 18.307 10.3587 19.3093 11.5245 20.3402C11.6603 20.4576 11.8188 20.5163 12 20.5163C12.1812 20.5163 12.3397 20.4576 12.4755 20.3402C13.6413 19.3093 14.7629 18.307 15.8402 17.3331C16.9177 16.3593 17.8713 15.4068 18.701 14.4756C19.5308 13.5443 20.1917 12.6346 20.6838 11.7466C21.1762 10.8587 21.4223 9.99237 21.4223 9.14759C21.4223 8.00368 21.0297 7.05043 20.2445 6.28782C19.4593 5.52521 18.4778 5.14391 17.3001 5.14391C16.3774 5.14391 15.5356 5.37822 14.7746 5.84684C14.0135 6.31527 13.2805 7.10171 12.5754 8.20616C12.5133 8.30873 12.4295 8.38566 12.3239 8.43694C12.2183 8.48842 12.1103 8.51415 12 8.51415C11.8897 8.51415 11.7817 8.48842 11.6761 8.43694C11.5705 8.38566 11.4867 8.30873 11.4247 8.20616Z",
            fill: color
        })
    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "22",
        height: "19",
        viewBox: "0 0 22 19",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M5.7002 1C6.55924 1.00008 7.45488 1.21117 8.38477 1.63281C9.3147 2.05444 10.1874 2.85003 11.001 4.01855C11.8147 2.84998 12.6862 2.05437 13.6162 1.63281C14.2612 1.34041 14.8901 1.15015 15.501 1.06055C15.2904 1.43964 15.1407 1.85688 15.0625 2.29883C14.6108 2.4154 14.1812 2.5969 13.7754 2.84668C13.0144 3.31505 12.2812 4.10184 11.5762 5.20605C11.5142 5.30849 11.4296 5.38524 11.3242 5.43652C11.2189 5.48785 11.111 5.51352 11.001 5.51367C10.8908 5.51367 10.7822 5.48787 10.6768 5.43652C10.5712 5.38527 10.4868 5.30851 10.4248 5.20605C9.71986 4.1019 8.98646 3.31511 8.22559 2.84668C7.46475 2.37827 6.62248 2.14364 5.7002 2.14355C4.52264 2.14361 3.54096 2.52569 2.75586 3.28809C1.97082 4.05063 1.57816 5.0037 1.57812 6.14746C1.57812 6.99209 1.82426 7.85839 2.31641 8.74609C2.80851 9.63408 3.47012 10.5443 4.2998 11.4756C5.12944 12.4066 6.08288 13.3593 7.16016 14.333C8.23736 15.3068 9.35967 16.3091 10.5254 17.3398C10.6611 17.4571 10.82 17.5166 11.001 17.5166C11.1817 17.5164 11.34 17.457 11.4756 17.3398C12.6413 16.3091 13.7636 15.3068 14.8408 14.333C15.9181 13.3593 16.8716 12.4066 17.7012 11.4756C18.5308 10.5443 19.1925 9.63407 19.6846 8.74609C20.0594 8.06998 20.2906 7.40601 20.3799 6.75488C20.8293 6.58967 21.2405 6.34544 21.5977 6.04004C21.5983 6.07571 21.6006 6.1115 21.6006 6.14746C21.6006 8.07581 20.766 9.93009 19.0977 11.709C17.4293 13.4877 15.6031 15.2507 13.6191 16.9971L12.2734 18.1768C12.103 18.3422 11.9014 18.4653 11.6699 18.5459C11.4383 18.6265 11.2069 18.6669 10.9775 18.667C10.7483 18.667 10.5208 18.6264 10.2969 18.5459C10.0729 18.4653 9.87544 18.3421 9.70508 18.1768L8.35254 16.9902C6.25695 15.1411 4.4075 13.3428 2.80469 11.5957C1.20191 9.84838 0.399414 8.03205 0.399414 6.14746C0.399445 4.69266 0.908983 3.47073 1.92676 2.48242C2.94427 1.49412 4.20248 1.00005 5.7002 1ZM19 0C20.6569 0 22 1.34315 22 3C22 4.65685 20.6569 6 19 6C17.3431 6 16 4.65685 16 3C16 1.34315 17.3431 0 19 0Z",
            fill: color
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (WishlistHeartBuilderIcon);


/***/ }),

/***/ 407056:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ svgExports_WishlistHeartIcon; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(785893);
// EXTERNAL MODULE: ./src/constants/wishlist.js
var wishlist = __webpack_require__(298627);
;// CONCATENATED MODULE: ./src/assets/svgExports/WishlistHeartIconWithDot.js

var WishlistHeartIconWithDot = function(param) {
    var _heartColor = param.heartColor, heartColor = _heartColor === void 0 ? "black" : _heartColor, _circleColor = param.circleColor, circleColor = _circleColor === void 0 ? "white" : _circleColor;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "30",
        height: "29",
        viewBox: "0 0 30 29",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("mask", {
                id: "mask0_68_3380",
                "mask-type": "alpha",
                maskUnits: "userSpaceOnUse",
                x: "0",
                y: "0",
                width: "30",
                height: "29",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                    x: "0.294128",
                    width: "29",
                    height: "29",
                    fill: "#D9D9D9"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                mask: "url(#mask0_68_3380)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M14.7942 24.5609L13.4605 23.3619C11.4575 21.5448 9.80103 19.9833 8.4912 18.6775C7.18137 17.3715 6.14341 16.2092 5.37733 15.1906C4.61124 14.1722 4.07605 13.243 3.77175 12.4033C3.46725 11.5637 3.315 10.7117 3.315 9.84733C3.315 8.1325 3.89319 6.6968 5.04956 5.54023C6.20614 4.38385 7.64184 3.80566 9.35667 3.80566C10.4115 3.80566 11.4084 4.05237 12.3473 4.54577C13.2862 5.03917 14.1018 5.74675 14.7942 6.66851C15.4865 5.74675 16.3022 5.03917 17.241 4.54577C18.1799 4.05237 19.1768 3.80566 20.2317 3.80566C21.9465 3.80566 23.3822 4.38385 24.5388 5.54023C25.6951 6.6968 26.2733 8.1325 26.2733 9.84733C26.2733 10.7117 26.1211 11.5637 25.8166 12.4033C25.5123 13.243 24.9771 14.1722 24.211 15.1906C23.4449 16.2092 22.4089 17.3715 21.1029 18.6775C19.7971 19.9833 18.1387 21.5448 16.1279 23.3619L14.7942 24.5609ZM14.7942 22.1119C16.7275 20.3723 18.3185 18.8812 19.5671 17.6387C20.8157 16.3963 21.8025 15.317 22.5275 14.4006C23.2525 13.4843 23.756 12.6706 24.0379 11.9595C24.3199 11.2486 24.4608 10.5445 24.4608 9.84733C24.4608 8.639 24.0581 7.63205 23.2525 6.8265C22.4469 6.02094 21.44 5.61816 20.2317 5.61816C19.2775 5.61816 18.3956 5.88883 17.586 6.43016C16.7766 6.9717 16.1357 7.72499 15.6633 8.69005H13.9251C13.4448 7.71714 12.8018 6.96193 11.9963 6.42442C11.1907 5.88692 10.3108 5.61816 9.35667 5.61816C8.15599 5.61816 7.15096 6.02094 6.34158 6.8265C5.53219 7.63205 5.1275 8.639 5.1275 9.84733C5.1275 10.5445 5.26847 11.2486 5.55042 11.9595C5.83236 12.6706 6.33584 13.4843 7.06084 14.4006C7.78584 15.317 8.77264 16.3944 10.0213 17.6329C11.2699 18.8715 12.8608 20.3645 14.7942 22.1119Z",
                        fill: heartColor
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                        cx: "24.1764",
                        cy: "5.11765",
                        r: "4.26471",
                        fill: heartColor,
                        stroke: circleColor,
                        "stroke-width": "1.70588"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var svgExports_WishlistHeartIconWithDot = (WishlistHeartIconWithDot);

// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(225617);
;// CONCATENATED MODULE: ./src/assets/svgExports/WishlistHeartIcon.js




var WishlistHeartIcon = function(param) {
    var _color = param.color, color = _color === void 0 ? "white" : _color, _iconSize = param.iconSize, iconSize = _iconSize === void 0 ? 20 : _iconSize, _isActive = param.isActive, isActive = _isActive === void 0 ? true : _isActive;
    var ref = (0,es/* useSelector */.v9)(function(state) {
        var ref, ref1, ref2, ref3;
        return {
            isWishlistItemPresentOnStore: (ref = state.wishlistReducer) === null || ref === void 0 ? void 0 : ref.wishlistItemCount,
            wishlistFeatureActive: (ref1 = state.storeReducer) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.store) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.services) === null || ref3 === void 0 ? void 0 : ref3.wishlist_flag
        };
    }), isWishlistItemPresentOnStore = ref.isWishlistItemPresentOnStore, wishlistFeatureActive = ref.wishlistFeatureActive;
    var circleColor = color === "white" ? "black" : "white";
    if (wishlistFeatureActive !== wishlist/* WISHLIST_FEATURE_STATUS.WISHLIST_ACTIVE */.g.WISHLIST_ACTIVE) return null;
    return !isWishlistItemPresentOnStore || !isActive ? /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "30",
        height: "29",
        viewBox: "0 0 30 29",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
            transform: "translate(3.5, 3)",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M11.7352 21.5609L10.4015 20.3619C8.39853 18.5448 6.7421 16.9833 5.43227 15.6775C4.12244 14.3715 3.08448 13.2092 2.3184 12.1906C1.55231 11.1722 1.01712 10.243 0.712823 9.40326C0.408323 8.56367 0.256073 7.71169 0.256073 6.84733C0.256073 5.1325 0.834261 3.6968 1.99064 2.54023C3.14721 1.38385 4.58291 0.805664 6.29774 0.805664C7.35261 0.805664 8.34949 1.05237 9.28836 1.54577C10.2272 2.03917 11.0429 2.74675 11.7352 3.66851C12.4276 2.74675 13.2432 2.03917 14.1821 1.54577C15.121 1.05237 16.1179 0.805664 17.1727 0.805664C18.8876 0.805664 20.3233 1.38385 21.4798 2.54023C22.6362 3.6968 23.2144 5.1325 23.2144 6.84733C23.2144 7.71169 23.0622 8.56367 22.7577 9.40326C22.4534 10.243 21.9182 11.1722 21.1521 12.1906C20.386 13.2092 19.35 14.3715 18.0439 15.6775C16.7381 16.9833 15.0798 18.5448 13.0689 20.3619L11.7352 21.5609ZM11.7352 19.1119C13.6686 17.3723 15.2595 15.8812 16.5082 14.6387C17.7568 13.3963 18.7436 12.317 19.4686 11.4006C20.1936 10.4843 20.697 9.6706 20.979 8.9595C21.2609 8.24859 21.4019 7.54454 21.4019 6.84733C21.4019 5.639 20.9991 4.63205 20.1936 3.8265C19.388 3.02094 18.3811 2.61816 17.1727 2.61816C16.2186 2.61816 15.3367 2.88883 14.5271 3.43016C13.7177 3.9717 13.0768 4.72499 12.6043 5.69005H10.8661C10.3858 4.71714 9.7429 3.96193 8.93734 3.42442C8.13179 2.88692 7.25192 2.61816 6.29774 2.61816C5.09706 2.61816 4.09203 3.02094 3.28265 3.8265C2.47326 4.63205 2.06857 5.639 2.06857 6.84733C2.06857 7.54454 2.20955 8.24859 2.49149 8.9595C2.77343 9.6706 3.27691 10.4843 4.00191 11.4006C4.72691 12.317 5.71371 13.3944 6.96232 14.6329C8.21093 15.8715 9.80191 17.3645 11.7352 19.1119Z",
                fill: color
            })
        })
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(svgExports_WishlistHeartIconWithDot, {
        heartColor: color,
        circleColor: circleColor
    });
};
/* harmony default export */ var svgExports_WishlistHeartIcon = (WishlistHeartIcon);


/***/ }),

/***/ 9997:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_BasicSlider; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(626042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(269396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(785893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(667294);
// EXTERNAL MODULE: ./node_modules/react-slick/lib/index.js
var lib = __webpack_require__(446066);
;// CONCATENATED MODULE: ./src/assets/svgExports/SliderArrowBack.js

var SliderArrowBack = function(param) {
    var _color = param.color, color = _color === void 0 ? "#000000" : _color;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "7",
        height: "12",
        viewBox: "0 0 7 12",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M5.2929 0.292886C5.68341 -0.0976287 6.3166 -0.0976287 6.70711 0.292886C7.09763 0.683401 7.09763 1.31659 6.70711 1.7071L2.41421 6L6.70711 10.2929C7.09763 10.6834 7.09763 11.3166 6.70711 11.7071C6.3166 12.0976 5.68341 12.0976 5.2929 11.7071L0.292887 6.70711C-0.0976281 6.31659 -0.0976281 5.68341 0.292887 5.29289L5.2929 0.292886Z",
            fill: color
        })
    });
};
/* harmony default export */ var svgExports_SliderArrowBack = (SliderArrowBack);

// EXTERNAL MODULE: ./src/assets/svgExports/SliderArrowForward.js
var SliderArrowForward = __webpack_require__(198806);
;// CONCATENATED MODULE: ./src/hooks/useBasicSliderHook.tsx


var useSliderHook = function() {
    var customSettings = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var sliderRef = (0,react.useRef)(null);
    var settings = (0,_object_spread/* default */.Z)({
        infinite: true,
        arrows: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        speed: 500,
        autoplaySpeed: 5000,
        pauseOnHover: true
    }, customSettings);
    var onPrevClick = function() {
        var ref;
        if (sliderRef === null || sliderRef === void 0 ? void 0 : (ref = sliderRef.current) === null || ref === void 0 ? void 0 : ref.slickPrev) {
            var ref1;
            sliderRef === null || sliderRef === void 0 ? void 0 : (ref1 = sliderRef.current) === null || ref1 === void 0 ? void 0 : ref1.slickPrev();
        }
    };
    var onNextClick = function() {
        var ref;
        if (sliderRef === null || sliderRef === void 0 ? void 0 : (ref = sliderRef.current) === null || ref === void 0 ? void 0 : ref.slickNext) {
            var ref1;
            sliderRef === null || sliderRef === void 0 ? void 0 : (ref1 = sliderRef.current) === null || ref1 === void 0 ? void 0 : ref1.slickNext();
        }
    };
    var goToIndex = function(index) {
        if (sliderRef.current) {
            var ref;
            sliderRef === null || sliderRef === void 0 ? void 0 : (ref = sliderRef.current) === null || ref === void 0 ? void 0 : ref.slickGoTo(index);
        }
    };
    var startAutoPlay = function() {
        if (sliderRef.current) {
            var ref, ref1;
            sliderRef === null || sliderRef === void 0 ? void 0 : (ref = sliderRef.current) === null || ref === void 0 ? void 0 : (ref1 = ref.slickPlay) === null || ref1 === void 0 ? void 0 : ref1.call(ref);
        }
    };
    return {
        sliderRef: sliderRef,
        settings: settings,
        onPrevClick: onPrevClick,
        onNextClick: onNextClick,
        goToIndex: goToIndex,
        startAutoPlay: startAutoPlay
    };
};
/* harmony default export */ var useBasicSliderHook = (useSliderHook);

;// CONCATENATED MODULE: ./src/components/BasicSlider/index.tsx








var BasicSlider = function(param) {
    var _showArrows = param.showArrows, showArrows = _showArrows === void 0 ? false : _showArrows, _arrowColor = param.arrowColor, arrowColor = _arrowColor === void 0 ? "#000000" : _arrowColor, _removeArrowDefault = param.removeArrowDefault, removeArrowDefault = _removeArrowDefault === void 0 ? false : _removeArrowDefault, _arrowCommonClasses = param.arrowCommonClasses, arrowCommonClasses = _arrowCommonClasses === void 0 ? "" : _arrowCommonClasses, _arrowLeftClasses = param.arrowLeftClasses, arrowLeftClasses = _arrowLeftClasses === void 0 ? "" : _arrowLeftClasses, _arrowRightClasses = param.arrowRightClasses, arrowRightClasses = _arrowRightClasses === void 0 ? "" : _arrowRightClasses, _customArrowLeft = param.customArrowLeft, customArrowLeft = _customArrowLeft === void 0 ? null : _customArrowLeft, _customArrowRight = param.customArrowRight, customArrowRight = _customArrowRight === void 0 ? null : _customArrowRight, _showDots = param.showDots, showDots = _showDots === void 0 ? true : _showDots, _children = param.children, children = _children === void 0 ? null : _children, _customSettings = param.customSettings, customSettings = _customSettings === void 0 ? {} : _customSettings, _activeIndex = param.activeIndex, activeIndex = _activeIndex === void 0 ? -1 : _activeIndex, _customStyles = param.customStyles, customStyles = _customStyles === void 0 ? "" : _customStyles;
    var ref = useBasicSliderHook(customSettings), sliderRef = ref.sliderRef, settings = ref.settings, onPrevClick = ref.onPrevClick, onNextClick = ref.onNextClick, goToIndex = ref.goToIndex, startAutoPlay = ref.startAutoPlay;
    var deafultArrowClasses = !removeArrowDefault ? "tw-absolute -tw-translate-y-1/2 tw-top-[50%] tw-cursor-pointer" : "";
    var defaultArrowLeftClasses = !removeArrowDefault ? "tw-left-[-24px]" : "";
    var defaultArrowRightClasses = !removeArrowDefault ? "tw-right-[-24px]" : "";
    (0,react.useEffect)(function() {
        // Dynamically load slick-carousel CSS
        Promise.resolve(/* import() */).then(__webpack_require__.t.bind(__webpack_require__, 498322, 23));
        Promise.resolve(/* import() */).then(__webpack_require__.t.bind(__webpack_require__, 498745, 23));
    }, []);
    // This effect enables the component to go to a perticular index.
    (0,react.useEffect)(function() {
        if (activeIndex !== -1) {
            goToIndex(activeIndex);
        } else {
            settings.autoplay && startAutoPlay();
        }
    }, [
        activeIndex
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "tw-relative",
        children: [
            showArrows && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "".concat(deafultArrowClasses, " ").concat(arrowCommonClasses, " ").concat(defaultArrowLeftClasses, "  ").concat(arrowLeftClasses),
                onClick: onPrevClick,
                children: customArrowLeft ? customArrowLeft : /*#__PURE__*/ (0,jsx_runtime.jsx)(svgExports_SliderArrowBack, {
                    color: arrowColor
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                ref: function(slider) {
                    return sliderRef.current = slider;
                }
            }, settings), {
                dots: showDots,
                children: children
            })),
            showArrows && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "".concat(deafultArrowClasses, " ").concat(arrowCommonClasses, " ").concat(defaultArrowRightClasses, "  ").concat(arrowRightClasses),
                onClick: onNextClick,
                children: customArrowLeft ? customArrowRight : /*#__PURE__*/ (0,jsx_runtime.jsx)(SliderArrowForward/* default */.Z, {
                    color: arrowColor
                })
            }),
            !!customStyles && /*#__PURE__*/ (0,jsx_runtime.jsx)("style", {
                children: customStyles
            })
        ]
    });
};
/* harmony default export */ var components_BasicSlider = (BasicSlider);


/***/ }),

/***/ 672651:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_assert_this_initialized_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(104111);
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(51438);
/* harmony import */ var _swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(352951);
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(414924);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(288029);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(626042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(269396);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(805950);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(785893);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(667294);











// env
var inBrowser = "object" !== "undefined";
var UA = inBrowser && window.navigator.userAgent.toLowerCase();
var isIE9 = UA && UA.indexOf("msie 9.0") > 0;
var Dialog = function(props) {
    var animation = (props.animationType === "enter" ? props.enterAnimation : props.leaveAnimation) || props.animation;
    var className = "rodal-dialog rodal-".concat(animation, "-").concat(props.animationType);
    var CloseButton = props.showCloseButton ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
        className: "rodal-close",
        onClick: props.onClose,
        children: "Close"
    }) : null;
    var width = props.width, height = props.height, measure = props.measure, duration = props.duration, customStyles = props.customStyles;
    var style = {
        width: width + "%",
        minHeight: height + measure,
        animationDuration: duration + "ms",
        WebkitAnimationDuration: duration + "ms"
    };
    var mergedStyles = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, style, customStyles);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        style: mergedStyles,
        className: className,
        children: [
            props.children,
            CloseButton
        ]
    });
};
var _Component;
var rodal = /*#__PURE__*/ function(_superClass) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(rodal, _superClass);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(rodal);
    function rodal() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(this, rodal);
        var _this;
        _this = _super.apply(this, arguments);
        (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_assert_this_initialized_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_this), "state", {
            isShow: false,
            animationType: "leave"
        });
        (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_assert_this_initialized_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_this), "onKeyUp", function(event) {
            if (_this.props.closeOnEsc && event.keyCode === 27) {
                _this.props.onClose();
            }
        });
        (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_assert_this_initialized_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_this), "animationEnd", function(event) {
            if (_this.state.animationType === "leave") {
                _this.setState({
                    isShow: false
                });
            } else if (_this.props.closeOnEsc) {
                _this.el.focus();
            }
            if (event.target === _this.el) {
                var onAnimationEnd = _this.props.onAnimationEnd;
                onAnimationEnd && onAnimationEnd();
            }
        });
        return _this;
    }
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(rodal, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                if (this.props.visible) {
                    this.enter();
                }
            }
        },
        {
            key: "componentWillReceiveProps",
            value: function componentWillReceiveProps(nextProps) {
                if (!this.props.visible && nextProps.visible) {
                    this.enter();
                } else if (this.props.visible && !nextProps.visible) {
                    this.leave();
                }
            }
        },
        {
            key: "enter",
            value: function enter() {
                this.setState({
                    isShow: true,
                    animationType: "enter"
                });
                document.getElementsByTagName("html")[0].style.overflow = "hidden";
            }
        },
        {
            key: "leave",
            value: function leave() {
                this.setState(isIE9 ? {
                    isShow: false
                } : {
                    animationType: "leave"
                });
                document.getElementsByTagName("html")[0].style.overflow = "";
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                document.getElementsByTagName("body")[0].style.overflowY = "";
                document.getElementsByTagName("html")[0].style.overflow = "";
            }
        },
        {
            key: "render",
            value: function render() {
                var _this = this;
                var ref = this, props = ref.props, state = ref.state;
                var onClick = props.closeMaskOnClick ? props.onClose : null;
                var mask = props.showMask ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "rodal-mask",
                    style: props.customMaskStyles,
                    onClick: onClick
                }) : null;
                var style = {
                    display: state.isShow ? "block" : "none",
                    animationDuration: props.duration + "ms",
                    WebkitAnimationDuration: props.duration + "ms"
                };
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    style: style,
                    className: "rodal rodal-fade-" + state.animationType + " " + props.className,
                    onAnimationEnd: this.animationEnd,
                    tabIndex: "-1",
                    ref: function(el) {
                        _this.el = el;
                    },
                    onKeyUp: this.onKeyUp,
                    children: [
                        mask,
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Dialog, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, props), {
                            animationType: state.animationType,
                            children: props.children
                        }))
                    ]
                });
            }
        }
    ]);
    return rodal;
}(_Component = react__WEBPACK_IMPORTED_MODULE_1__.Component);
(0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(rodal, "propTypes", {
    width: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().number),
    height: prop_types__WEBPACK_IMPORTED_MODULE_10___default().oneOfType([
        (prop_types__WEBPACK_IMPORTED_MODULE_10___default().number),
        (prop_types__WEBPACK_IMPORTED_MODULE_10___default().string)
    ]),
    measure: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().string),
    visible: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().bool),
    showMask: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().bool),
    closeOnEsc: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().bool),
    closeMaskOnClick: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().bool),
    showCloseButton: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().bool),
    animation: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().string),
    enterAnimation: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().string),
    leaveAnimation: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().string),
    duration: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().number),
    className: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().string),
    customStyles: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().object),
    customMaskStyles: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().object),
    onClose: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().func.isRequired),
    onAnimationEnd: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().func)
});
// ...
(0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(rodal, "defaultProps", {
    width: 100,
    height: 300,
    measure: "px",
    visible: false,
    showMask: true,
    closeOnEsc: false,
    closeMaskOnClick: true,
    showCloseButton: false,
    animation: "zoom",
    enterAnimation: "",
    leaveAnimation: "",
    duration: 300,
    className: "",
    customStyles: {},
    customMaskStyles: {}
});
/* harmony default export */ __webpack_exports__["Z"] = (rodal);


/***/ }),

/***/ 70440:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ ReactHamburger; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(785893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(667294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(307297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(150066);
;// CONCATENATED MODULE: ./src/components/Common/ReactHamburger/index.style.js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  top: 5%;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-around;\n  width: 22px;\n  height: 22px;\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  padding: 0;\n  z-index: 10;\n  flex: 0 0 auto;\n\n  &:focus {\n    outline: none;\n  }\n\n  & div {\n    background: ",
        ";\n  }\n\n  div {\n    width: 100%;\n    height: 2px;\n    border-radius: 10px;\n    transition: all 0.3s linear;\n    position: relative;\n    transform-origin: 1px;\n\n    :first-child {\n      transform: ",
        ";\n    }\n\n    :nth-child(2) {\n      opacity: ",
        ";\n      transform: ",
        ";\n    }\n\n    :nth-child(3) {\n      transform: ",
        ";\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var StyledBurger = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    displayName: "StyledBurger",
    componentId: "sc-52da0d30-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme ? theme : "#000000";
}, function(param) {
    var open = param.open;
    return open ? "rotate(45deg)" : "rotate(0)";
}, function(param) {
    var open = param.open;
    return open ? "0" : "1";
}, function(param) {
    var open = param.open;
    return open ? "translateX(-20px)" : "translateX(0)";
}, function(param) {
    var open = param.open;
    return open ? "rotate(-45deg)" : "rotate(0)";
});

;// CONCATENATED MODULE: ./src/components/Common/ReactHamburger/index.js



var Burger = function(param) {
    var open = param.open, setOpen = param.setOpen, theme = param.theme, _style = param.style, style = _style === void 0 ? {} : _style, _showIcon = param.showIcon, showIcon = _showIcon === void 0 ? null : _showIcon, _showDiffIcon = param.showDiffIcon, showDiffIcon = _showDiffIcon === void 0 ? false : _showDiffIcon;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            showDiffIcon && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                onClick: function() {
                    return setOpen(!open);
                },
                children: showIcon === null || showIcon === void 0 ? void 0 : showIcon()
            }),
            !showDiffIcon && /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledBurger, {
                style: style,
                open: open,
                onClick: function() {
                    return setOpen(!open);
                },
                theme: theme,
                "aria-label": "menu",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {})
                ]
            })
        ]
    });
};
/* harmony default export */ var ReactHamburger = (Burger);


/***/ }),

/***/ 151592:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$1": function() { return /* binding */ InteractionComponent; },
/* harmony export */   "J7": function() { return /* binding */ CentralText; },
/* harmony export */   "tY": function() { return /* binding */ CartButtonBody; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(307297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(150066);
/* harmony import */ var _util__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(452388);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  cursor: pointer;\n  border: 1px solid;\n  border-color: ",
        ";\n  color: ",
        ";\n  background-color: #ffffff;\n  display: flex;\n  align-items: center;\n  justify-content: ",
        ";\n  text-transform: capitalize;\n  outline: none;\n  width: ",
        ";\n  border-radius: ",
        ";\n  height: ",
        ";\n  position: ",
        ";\n  cursor: ",
        ";\n  font-size: ",
        "px;\n  ",
        ";\n  ",
        ";\n  ",
        ";\n  ",
        ";\n  ",
        "\n  ",
        "\n  ",
        ";\n  ",
        ";\n  ",
        ";\n  ",
        ";\n  ",
        "\n  ",
        "\n  ",
        ";\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  position: ",
        ";\n  color: inherit;\n  align-items: center;\n  justify-content: center;\n  font-size: ",
        "px;\n  width: 100%;\n  white-space: nowrap;\n  user-select: none;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: ",
        ";\n  display: flex;\n  align-items: center;\n  height: 100%;\n  width: ",
        ";\n  cursor: pointer;\n  padding: 0 4px;\n  z-index: ",
        ";\n  ",
        ";\n\n  & > div {\n    width: 12px;\n\n    & > svg {\n      width: 100%;\n    }\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}


var CartButtonBody = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "CartButtonBody",
    componentId: "sc-59554d39-0"
})(_templateObject(), function(props) {
    return props.primaryColor ? props.primaryColor : "#000000";
}, function(props) {
    return props.primaryColor ? props.primaryColor : "#000000";
}, function(props) {
    return props.isPDPPage ? props.centered ? "center" : "space-between" : props.centered ? "center" : "space-between";
}, function(props) {
    return (props === null || props === void 0 ? void 0 : props.width) ? props === null || props === void 0 ? void 0 : props.width : "fit-content";
}, function(props) {
    return (0,_util__WEBPACK_IMPORTED_MODULE_2__/* .roundnessCalculator */ .M)(props.roundness);
}, function(props) {
    return (props === null || props === void 0 ? void 0 : props.height) ? props === null || props === void 0 ? void 0 : props.height : "fit-content";
}, function(props) {
    return props.isPDPPage ? "static" : "relative";
}, function(props) {
    return props.cursor;
}, function(props) {
    return props.fontSize || 14;
}, function(props) {
    return props.pt && "padding-top: ".concat(props.pt);
}, function(props) {
    return props.pb && "padding-bottom: ".concat(props.pb);
}, function(props) {
    return props.pl && "padding-left: ".concat(props.pl);
}, function(props) {
    return props.pr && "padding-right: ".concat(props.pr);
}, function(props) {
    return props.px && "\n      padding-left: ".concat(props.px, ";\n      padding-right: ").concat(props.px, ";\n    ");
}, function(props) {
    return props.py && "\n      padding-top: ".concat(props.py, ";\n      padding-bottom: ").concat(props.py, ";\n    ");
}, function(props) {
    return props.mt && "margin-top: ".concat(props.mt);
}, function(props) {
    return props.mb && "margin-bottom: ".concat(props.mb);
}, function(props) {
    return props.ml && "margin-left: ".concat(props.ml);
}, function(props) {
    return props.mr && "margin-right: ".concat(props.mr);
}, function(props) {
    return props.mx && "\n      margin-left: ".concat(props.mx).concat(props.mx !== "auto" && "", ";\n      margin-right: ").concat(props.mx).concat(props.mx !== "auto" && "", ";\n    ");
}, function(props) {
    return props.my && "\n      margin-top: ".concat(props.my).concat(props.my !== "auto" && "", ";\n      margin-bottom: ").concat(props.my).concat(props.my !== "auto" && "", ";\n    ");
}, function(props) {
    return props.maxWidth && "max-width: ".concat(props.maxWidth);
}, function(props) {
    return props.borderColor && "border-color: ".concat(props.borderColor);
});
var CentralText = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    displayName: "CentralText",
    componentId: "sc-59554d39-1"
})(_templateObject1(), function(props) {
    return props.isPDPPage ? "static" : "relative";
}, function(props) {
    return props.fontSize || 14;
});
var InteractionComponent = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    displayName: "InteractionComponent",
    componentId: "sc-59554d39-2"
})(_templateObject2(), function(props) {
    return props.isPDPPage ? "static" : "absolute";
}, function(props) {
    return props.width || "20px";
}, function(props) {
    return props.zIndex || 11;
}, function(props) {
    return props.position;
});


/***/ }),

/***/ 398221:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(785893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(667294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(225617);



var MAX_ALLOWED_CUSTOM_INPUT_VALUE = 10000;
var CartItemInput = function(param) {
    var value = param.value, onChange = param.onChange;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null), localCount = ref[0], setLocalCount = ref[1];
    var cartData = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function(state) {
        return {
            cartData: state.cartReducer
        };
    }).cartData;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        localCount !== value && setLocalCount(value);
    }, [
        cartData,
        value
    ]);
    var handleInputChange = function(e) {
        var updatedCount = +e.target.value;
        if (!isNaN(updatedCount) && updatedCount < MAX_ALLOWED_CUSTOM_INPUT_VALUE) {
            setLocalCount(updatedCount);
        }
    };
    var reset = function() {
        return setLocalCount(value);
    };
    var onSubmit = function() {
        if (localCount !== value) {
            onChange(+localCount || 1, reset);
            !+localCount && setLocalCount(1);
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
        value: localCount || "",
        onChange: handleInputChange,
        onBlur: onSubmit,
        className: "tw-mx-auto tw-w-[40px] tw-border-none tw-text-center focus:tw-bg-[#AAD7F8]"
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CartItemInput);


/***/ }),

/***/ 891815:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ AtomicComponents_CartButton; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(626042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(269396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(999534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(785893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(667294);
// EXTERNAL MODULE: ./src/components/DesignSystem/AtomicComponents/CartButton/CartButton.styles.js
var CartButton_styles = __webpack_require__(151592);
// EXTERNAL MODULE: ./src/assets/svgExports/MinusIcon.js
var MinusIcon = __webpack_require__(282513);
// EXTERNAL MODULE: ./src/assets/svgExports/PlusIcon.js
var PlusIcon = __webpack_require__(408886);
// EXTERNAL MODULE: ./src/redux/ssrStore.ts + 1 modules
var ssrStore = __webpack_require__(326706);
// EXTERNAL MODULE: ./src/components/DesignSystem/AtomicComponents/CartButton/CartItemInput.tsx
var CartItemInput = __webpack_require__(398221);
// EXTERNAL MODULE: ./src/components/WidgetMaker/WidgetDnD/WIdgetPropertiesBasic/EcommWidgets/HeroBanner/Svgs.tsx
var Svgs = __webpack_require__(837210);
// EXTERNAL MODULE: ./src/context/CartContext.ts
var CartContext = __webpack_require__(852271);
// EXTERNAL MODULE: ./src/utils/getThemeColor.js
var getThemeColor = __webpack_require__(270758);
;// CONCATENATED MODULE: ./src/assets/svgExports/NewShoppingCartIcon.js

var NewShoppingCartIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("mask", {
                id: "mask0_133_6203",
                style: {
                    maskType: "alpha"
                },
                maskUnits: "userSpaceOnUse",
                x: "0",
                y: "0",
                width: "16",
                height: "16",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                    width: "16",
                    height: "16",
                    fill: "#D9D9D9"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                mask: "url(#mask0_133_6203)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M4.76917 14.3718C4.44528 14.3718 4.16989 14.2583 3.943 14.0313C3.71611 13.8044 3.60267 13.5291 3.60267 13.2052C3.60267 12.8812 3.71611 12.6057 3.943 12.3788C4.16989 12.1519 4.44528 12.0385 4.76917 12.0385C5.09317 12.0385 5.36861 12.1519 5.5955 12.3788C5.82239 12.6057 5.93583 12.8812 5.93583 13.2052C5.93583 13.5291 5.82239 13.8044 5.5955 14.0313C5.36861 14.2583 5.09317 14.3718 4.76917 14.3718ZM11.2308 14.3718C10.9068 14.3718 10.6314 14.2583 10.4045 14.0313C10.1776 13.8044 10.0642 13.5291 10.0642 13.2052C10.0642 12.8812 10.1776 12.6057 10.4045 12.3788C10.6314 12.1519 10.9068 12.0385 11.2308 12.0385C11.5547 12.0385 11.8301 12.1519 12.057 12.3788C12.2839 12.6057 12.3973 12.8812 12.3973 13.2052C12.3973 13.5291 12.2839 13.8044 12.057 14.0313C11.8301 14.2583 11.5547 14.3718 11.2308 14.3718ZM4.01017 3.83333L5.7 7.37183H10.2448C10.2833 7.37183 10.3175 7.36222 10.3475 7.343C10.3774 7.32378 10.403 7.29706 10.4243 7.26283L12.2128 4.01283C12.2385 3.96583 12.2406 3.92417 12.2192 3.88783C12.1978 3.8515 12.1615 3.83333 12.1102 3.83333H4.01017ZM3.53083 2.83333H12.7872C13.0598 2.83333 13.266 2.94939 13.4057 3.1815C13.5454 3.4135 13.5521 3.65044 13.4257 3.89233L11.2897 7.7615C11.1803 7.95383 11.0357 8.10361 10.8558 8.21083C10.6758 8.31817 10.4786 8.37183 10.2642 8.37183H5.4L4.62817 9.782C4.59394 9.83333 4.59289 9.88889 4.625 9.94867C4.657 10.0086 4.70506 10.0385 4.76917 10.0385H12.3973V11.0385H4.76917C4.32472 11.0385 3.99078 10.8468 3.76733 10.4635C3.54378 10.0802 3.53589 9.69744 3.74367 9.31533L4.69483 7.60517L2.26933 2.5H1V1.5H2.8975L3.53083 2.83333Z",
                    fill: "#1C1B1F"
                })
            })
        ]
    });
};
/* harmony default export */ var svgExports_NewShoppingCartIcon = (NewShoppingCartIcon);

;// CONCATENATED MODULE: ./src/assets/svgExports/NotificationBellIcon.js

var NotificationBellIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("mask", {
                id: "mask0_279_3782",
                "mask-type": "alpha",
                maskUnits: "userSpaceOnUse",
                x: "0",
                y: "0",
                width: "16",
                height: "16",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                    width: "16",
                    height: "16",
                    fill: "#D9D9D9"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                mask: "url(#mask0_279_3782)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("mask", {
                        id: "mask1_279_3782",
                        "mask-type": "alpha",
                        maskUnits: "userSpaceOnUse",
                        x: "0",
                        y: "0",
                        width: "16",
                        height: "16",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                            width: "16",
                            height: "16",
                            fill: "#D9D9D9"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                        mask: "url(#mask1_279_3782)",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M3.5 12.59C3.35833 12.59 3.23961 12.5421 3.14383 12.4463C3.04794 12.3504 3 12.2316 3 12.0898C3 11.9482 3.04794 11.8294 3.14383 11.7337C3.23961 11.638 3.35833 11.5902 3.5 11.5902H4.20517V6.61566C4.20517 5.7191 4.48189 4.92638 5.03533 4.23749C5.58867 3.5486 6.29911 3.10799 7.16667 2.91566V2.50033C7.16667 2.26888 7.24761 2.0721 7.4095 1.90999C7.57139 1.74799 7.76794 1.66699 7.99917 1.66699C8.2305 1.66699 8.42733 1.74799 8.58967 1.90999C8.75211 2.0721 8.83333 2.26888 8.83333 2.50033V2.91566C9.70089 3.10799 10.4113 3.5486 10.9647 4.23749C11.5181 4.92638 11.7948 5.7191 11.7948 6.61566V11.5902H12.5C12.6417 11.5902 12.7604 11.638 12.8562 11.7338C12.9521 11.8297 13 11.9485 13 12.0903C13 12.232 12.9521 12.3507 12.8562 12.4465C12.7604 12.5422 12.6417 12.59 12.5 12.59H3.5ZM7.99883 14.4618C7.66717 14.4618 7.38361 14.3438 7.14817 14.1078C6.91261 13.8718 6.79483 13.5881 6.79483 13.2567H9.20517C9.20517 13.5892 9.08706 13.8732 8.85083 14.1087C8.61461 14.3441 8.33061 14.4618 7.99883 14.4618ZM5.20517 11.5902H10.7948V6.61566C10.7948 5.84388 10.522 5.18516 9.97633 4.63949C9.43056 4.09371 8.77178 3.82083 8 3.82083C7.22822 3.82083 6.56944 4.09371 6.02367 4.63949C5.478 5.18516 5.20517 5.84388 5.20517 6.61566V11.5902Z",
                            fill: "#1C1B1F"
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var svgExports_NotificationBellIcon = (NotificationBellIcon);

;// CONCATENATED MODULE: ./src/components/DesignSystem/AtomicComponents/CartButton/index.js















var BUTTON_ACTION = {
    INCREMENT: "inc",
    DECREMENT: "dec"
};
var AnimatedDash = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "tw-absolute tw-bottom-0 tw-left-0 tw-right-0",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "tw-h-[2px] tw-w-[20%] tw-animate-[sprint_0.5s_linear_infinite]",
            style: {
                backgroundColor: (0,getThemeColor/* getThemeColor */.p)()
            }
        })
    });
};
var CartButton = function(props) {
    var ref, ref1;
    var _px = props.px, px = _px === void 0 ? "1rem" : _px, _py = props.py, py = _py === void 0 ? "0.3rem" : _py;
    var _allowCustomInput = props.allowCustomInput, allowCustomInput = _allowCustomInput === void 0 ? false : _allowCustomInput, _allowItemDeletion = props.allowItemDeletion, allowItemDeletion = _allowItemDeletion === void 0 ? false : _allowItemDeletion, quantity = props.quantity, _fontSize = props.fontSize, fontSize = _fontSize === void 0 ? 20 : _fontSize, onChange = props.onChange, _disableAddition = props.disableAddition, disableAddition = _disableAddition === void 0 ? false : _disableAddition, _customClasses = props.customClasses, customClasses = _customClasses === void 0 ? "" : _customClasses, _wrapperClasses = props.wrapperClasses, wrapperClasses = _wrapperClasses === void 0 ? "" : _wrapperClasses, isPDPPage = props.isPDPPage, _isWishlistCard = props.isWishlistCard, isWishlistCard = _isWishlistCard === void 0 ? false : _isWishlistCard, _itemInventryStatus = props.itemInventryStatus, itemInventryStatus = _itemInventryStatus === void 0 ? 1 : _itemInventryStatus, _isUpdating = props.isUpdating, isUpdating = _isUpdating === void 0 ? false : _isUpdating, _hasScheduler = props.hasScheduler, hasScheduler = _hasScheduler === void 0 ? false : _hasScheduler, handleMoveItemToWishlist = props.handleMoveItemToWishlist, args = (0,_object_without_properties/* default */.Z)(props, [
        "allowCustomInput",
        "allowItemDeletion",
        "quantity",
        "fontSize",
        "onChange",
        "disableAddition",
        "customClasses",
        "wrapperClasses",
        "isPDPPage",
        "isWishlistCard",
        "itemInventryStatus",
        "isUpdating",
        "hasScheduler",
        "handleMoveItemToWishlist"
    ]);
    var setDeletionAlertState = (0,react.useContext)(CartContext/* CartContext */.A).setDeletionAlertState;
    var storeInfo = (0,ssrStore/* useSSRSelector */.kF)(function(state) {
        return state.storeReducer.store;
    });
    var isEditable = (storeInfo === null || storeInfo === void 0 ? void 0 : (ref = storeInfo.services) === null || ref === void 0 ? void 0 : ref.custom_cart_item_quantity_flag) && allowCustomInput;
    var onChangeBtn = function(e, type) {
        var isLabel = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
        if (!hasScheduler) {
            var ref, ref1;
            (ref = e.stopPropagation) === null || ref === void 0 ? void 0 : ref.call(e);
            (ref1 = e.preventDefault) === null || ref1 === void 0 ? void 0 : ref1.call(e);
            if (isLabel && quantity) return;
            if (type === BUTTON_ACTION.DECREMENT && quantity <= 1 && allowItemDeletion) return;
            if (type === BUTTON_ACTION.INCREMENT && disableAddition) return;
            onChange === null || onChange === void 0 ? void 0 : onChange(type);
        }
    };
    var onDeleteClick = function() {
        setDeletionAlertState === null || setDeletionAlertState === void 0 ? void 0 : setDeletionAlertState({
            show: true,
            callback: function() {
                var status = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
                onChange === null || onChange === void 0 ? void 0 : onChange("custom", 0);
                if (status) handleMoveItemToWishlist === null || handleMoveItemToWishlist === void 0 ? void 0 : handleMoveItemToWishlist();
            }
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "tw-flex tw-h-fit tw-items-center tw-gap-[8px] ".concat(wrapperClasses),
        children: [
            allowItemDeletion && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                onClick: onDeleteClick,
                className: "tw-absolute tw-right-0 tw-top-0 tw-cursor-pointer md:tw-static",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Svgs/* DeleteIcon */.pJ, {
                    className: "tw-h-[20px] tw-w-[20px] md:tw-h-[14px] md:tw-w-[14px]"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(CartButton_styles/* CartButtonBody */.tY, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                className: "!tw-h-full tw-w-full tw-min-w-[80px]  !tw-justify-between ".concat(customClasses),
                roundness: storeInfo === null || storeInfo === void 0 ? void 0 : (ref1 = storeInfo.theme) === null || ref1 === void 0 ? void 0 : ref1.roundness,
                px: px,
                py: py,
                centered: !quantity,
                isPDPPage: isPDPPage,
                cursor: !quantity ? "pointer" : "default"
            }, args), {
                children: [
                    !quantity ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(CartButton_styles/* CentralText */.J7, {
                        className: "tw-min-w-[40px]",
                        onClick: function(e) {
                            itemInventryStatus ? onChangeBtn(e, "add", true) : onChange("OOS");
                        },
                        quantity: quantity,
                        fontSize: fontSize,
                        isPDPPage: isPDPPage,
                        children: [
                            isWishlistCard ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "tw-mr-[8px]",
                                children: [
                                    " ",
                                    itemInventryStatus ? /*#__PURE__*/ (0,jsx_runtime.jsx)(svgExports_NewShoppingCartIcon, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(svgExports_NotificationBellIcon, {}),
                                    " "
                                ]
                            }) : "",
                            props.label ? props.label : isPDPPage ? "Add to Cart" : "ADD"
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            props.leftButton ? props.leftButton : /*#__PURE__*/ (0,jsx_runtime.jsx)(CartButton_styles/* InteractionComponent */.$1, {
                                position: "left:0px;",
                                onClick: function(e) {
                                    return onChangeBtn(e, BUTTON_ACTION.DECREMENT);
                                },
                                isPDPPage: isPDPPage,
                                zIndex: 9,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "dib flex items-center\n                  ".concat(disableAddition ? "o-20" : "o-100", "\n                "),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MinusIcon/* MinusIcon */.V, {})
                                })
                            }),
                            isEditable ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CartItemInput/* default */.Z, {
                                value: quantity,
                                onChange: function(value, reset) {
                                    return onChange === null || onChange === void 0 ? void 0 : onChange("custom", value, reset);
                                }
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(CartButton_styles/* CentralText */.J7, {
                                isPDPPage: isPDPPage,
                                quantity: quantity === 0,
                                fontSize: fontSize,
                                children: quantity || 0
                            }),
                            props.rightButton ? props.rightButton : /*#__PURE__*/ (0,jsx_runtime.jsx)(CartButton_styles/* InteractionComponent */.$1, {
                                position: "right:0px;",
                                onClick: function(e) {
                                    return onChangeBtn(e, BUTTON_ACTION.INCREMENT);
                                },
                                isPDPPage: isPDPPage,
                                zIndex: 9,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "dib flex items-center\n                  ".concat(disableAddition ? "o-20" : "o-100", "\n                "),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PlusIcon/* PlusIcon */.p, {})
                                })
                            })
                        ]
                    }),
                    isUpdating && /*#__PURE__*/ (0,jsx_runtime.jsx)(AnimatedDash, {})
                ]
            }))
        ]
    });
};
/* harmony default export */ var AtomicComponents_CartButton = (CartButton);


/***/ }),

/***/ 452388:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ roundnessCalculator; }
/* harmony export */ });
/*
  Utility file for atomic components
  Conains code that may be used by all components
 */ var roundnessCalculator = function(val) {
    switch(val){
        case 0:
            return "0px";
        case 2:
            return "5px";
        case 4:
            return "30px";
        default:
            return "0px";
    }
};


/***/ }),

/***/ 99650:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "G": function() { return /* reexport */ MegaMenuDrawerDesktop; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(626042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(269396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(785893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(667294);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(693967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./src/components/DesignSystem/Drawer/MegaMenuDrawerDesktop/megaMenu.module.scss
var megaMenu_module = __webpack_require__(759443);
var megaMenu_module_default = /*#__PURE__*/__webpack_require__.n(megaMenu_module);
// EXTERNAL MODULE: ./src/utils/routes.js + 1 modules
var routes = __webpack_require__(540190);
// EXTERNAL MODULE: ./src/components/DesignSystem/Drawer/MegaMenuDrawerDesktop/svgIcons.js
var svgIcons = __webpack_require__(569384);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(811163);
var router_default = /*#__PURE__*/__webpack_require__.n(router);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(225617);
// EXTERNAL MODULE: ./src/components/DesignSystem/Widgets2.0/CommonLinkWrapper/index.tsx
var CommonLinkWrapper = __webpack_require__(486353);
// EXTERNAL MODULE: ./src/utils/smartWordBreakStyle.ts
var smartWordBreakStyle = __webpack_require__(451959);
;// CONCATENATED MODULE: ./src/components/DesignSystem/Drawer/MegaMenuDrawerDesktop/RenderCategory.js










var RenderCategory = function(props) {
    var splitObjectsIntoGroups = function splitObjectsIntoGroups(objects, batchSize) {
        var result = [];
        for(var i = 0; i < objects.length; i += batchSize){
            var batch = objects.slice(i, i + batchSize);
            result.push(batch);
        }
        return result;
    };
    var categories = props.categories, onClose = props.onClose, collectionId = props.collectionId, customLinkStyling = props.customLinkStyling, _parentIndex = props.parentIndex, parentIndex = _parentIndex === void 0 ? -1 : _parentIndex;
    var ref = customLinkStyling || {}, onLinkHoverEnter = ref.onLinkHoverEnter, onLinkHoverLeave = ref.onLinkHoverLeave, getNavElementStyle = ref.getNavElementStyle;
    var ref1 = (0,react.useState)([]), currCategories = ref1[0], setCurrCategories = ref1[1];
    var ref2 = (0,react.useState)({
        more: false,
        less: false
    }), showMoreLess = ref2[0], setShowMoreLess = ref2[1];
    var moreLimit = props.showMoreCount || 36;
    var storeData = (0,es/* useSelector */.v9)(function(state) {
        return {
            storeData: state.storeReducer.store
        };
    }).storeData;
    (0,react.useEffect)(function() {
        if (categories.length < moreLimit) {
            setCurrCategories(categories);
        } else if (categories.length >= moreLimit) {
            setShowMoreLess({
                more: true,
                less: false
            });
            setCurrCategories(categories.slice(0, moreLimit));
        }
    }, [
        categories.length
    ]);
    (0,react.useEffect)(function() {
        if (showMoreLess.more) {
            setCurrCategories(categories.slice(0, moreLimit));
        } else {
            setCurrCategories(categories);
        }
    }, [
        showMoreLess
    ]);
    var totalCategories = currCategories === null || currCategories === void 0 ? void 0 : currCategories.length;
    var maxCols = Math.min(6, Math.ceil(totalCategories / 6));
    var maxRows = Math.max(6, Math.ceil(totalCategories / maxCols));
    var getCategoryLink = function(category) {
        var ref;
        return (0,routes.getRoute)("".concat(routes.PATH.collectionCategories(collectionId), "?cid=").concat(category.id), storeData === null || storeData === void 0 ? void 0 : (ref = storeData.store_info) === null || ref === void 0 ? void 0 : ref.domain);
    };
    var handleCategoryClick = function(category) {
        if (category.isMoreLess) return;
        var categoryLink = getCategoryLink(category);
        router_default().push(categoryLink, undefined, {
            shallow: true,
            scroll: true
        });
        onClose && onClose();
    };
    var displayMoreLess = function(type) {
        var styling = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex tw-relative",
            style: {
                gap: "2px",
                alignItems: "center",
                cursor: "pointer"
            },
            onClick: handleMoreLessClick,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    style: (0,_object_spread/* default */.Z)({
                        color: "#000"
                    }, styling),
                    children: type
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    style: {
                        position: "absolute",
                        top: "9px",
                        transform: "translateY(-50%)",
                        right: "-23px"
                    },
                    children: showMoreLess.more ? /*#__PURE__*/ (0,jsx_runtime.jsx)(svgIcons/* MoreCarat */.MK, {
                        color: styling.color
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(svgIcons/* LessCarat */.gO, {
                        color: styling.color
                    })
                })
            ]
        });
    };
    var handleMoreLessClick = function() {
        if (showMoreLess.more) {
            setShowMoreLess({
                more: false,
                less: true
            });
        } else {
            setShowMoreLess({
                more: true,
                less: false
            });
        }
    };
    var splittedCategories = splitObjectsIntoGroups(currCategories, maxRows);
    if (currCategories.length >= moreLimit) {
        var ref3;
        (ref3 = splittedCategories[maxCols - 1]) === null || ref3 === void 0 ? void 0 : ref3.push({
            isMoreLess: true,
            type: showMoreLess.more ? "More" : "Less"
        });
    }
    var categoriesGrid = [];
    for(var row = 0; row < maxRows; row++){
        categoriesGrid.push([]);
        for(var col = 0; col < maxCols; col++){
            var index = row + col * maxRows;
            if (index < totalCategories) {
                categoriesGrid[row].push(currCategories[index]);
            } else {
                categoriesGrid[row].push(null); // Add a placeholder for empty cells
            }
        }
    }
    return splittedCategories.map(function(col, colIndex) {
        /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
            children: col.map(function(category, idx) {
                var styling = (getNavElementStyle === null || getNavElementStyle === void 0 ? void 0 : getNavElementStyle(idx, parentIndex, props.isParentCategoryHovered)) || {};
                var showMoreLessOption = category.isMoreLess && categories.length > moreLimit;
                var menuOption = function(avoidBubbleClick) {
                    var ref;
                    /*#__PURE__*/ return (0,jsx_runtime.jsxs)("p", {
                        onMouseEnter: function() {
                            return onLinkHoverEnter(idx);
                        },
                        onMouseLeave: onLinkHoverLeave,
                        className: classnames_default()("tw-relative tw-m-0 tw-max-w-fit tw-cursor-pointer tw-select-none tw-text-[12px] tw-font-normal tw-uppercase tw-leading-[15.62px] tw-tracking-[1px] ", // idx !== col?.length - 1 ? 'tw-mb-[12px]' : '',
                        "tw-mb-[12px]", "[&>.underline-comp]:hover:tw-block"),
                        onClick: function() {
                            return !avoidBubbleClick ? handleCategoryClick(category) : null;
                        },
                        style: (0,_object_spread/* default */.Z)({}, styling, smartWordBreakStyle/* smartWordBreakStyle */.t),
                        children: [
                            showMoreLessOption ? displayMoreLess(category.type, styling) : category.name,
                            (ref = props._RenderUnderlineComponent) === null || ref === void 0 ? void 0 : ref.call(props, idx, {
                                bottom: -4,
                                width: "100%",
                                top: undefined,
                                height: "1px"
                            })
                        ]
                    }, colIndex);
                };
                return !showMoreLessOption ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CommonLinkWrapper/* default */.Z, {
                    link: getCategoryLink(category),
                    children: menuOption(true)
                }, colIndex) : menuOption(false);
            })
        }, colIndex);
    });
};
/* harmony default export */ var MegaMenuDrawerDesktop_RenderCategory = (RenderCategory);

// EXTERNAL MODULE: ./src/utils/routeToCollectionPage.js
var routeToCollectionPage = __webpack_require__(385618);
// EXTERNAL MODULE: ./src/redux/ssrStore.ts + 1 modules
var ssrStore = __webpack_require__(326706);
// EXTERNAL MODULE: ./node_modules/masonic/dist/module/masonry.js + 23 modules
var masonry = __webpack_require__(208206);
// EXTERNAL MODULE: ./node_modules/@mui/material/ClickAwayListener/ClickAwayListener.js
var ClickAwayListener = __webpack_require__(607982);
// EXTERNAL MODULE: ./node_modules/tailwind-merge/dist/bundle-mjs.mjs
var bundle_mjs = __webpack_require__(798388);
// EXTERNAL MODULE: ./src/hooks/useNavlinkStyling.ts
var useNavlinkStyling = __webpack_require__(177137);
// EXTERNAL MODULE: ./node_modules/lodash/merge.js
var merge = __webpack_require__(682492);
var merge_default = /*#__PURE__*/__webpack_require__.n(merge);
;// CONCATENATED MODULE: ./src/components/DesignSystem/Drawer/MegaMenuDrawerDesktop/MegaMenuDrawerDesktop.tsx
"use client";















var MegaMenuDrawerDesktop = function(param) {
    var open = param.open, onClose = param.onClose, forNewHeader = param.forNewHeader, _customStylist = param.customStylist, customStylist = _customStylist === void 0 ? {} : _customStylist, _RenderUnderlineComponent = param._RenderUnderlineComponent;
    var _megaMenuStyles = customStylist.megaMenuStyles, megaMenuStyles = _megaMenuStyles === void 0 ? {} : _megaMenuStyles, isScroll = customStylist.isScroll;
    var collections = (0,ssrStore/* useSSRSelector */.kF)(function(state) {
        return {
            collections: state.catalogReducer.collections
        };
    }).collections;
    var ref = (0,react.useState)(null), collectionHoverIndex = ref[0], setCollectionHoverIndex = ref[1];
    var customLinkStyling = (0,useNavlinkStyling/* useNavlinkStyling */.u)({
        isScrollable: isScroll,
        parentHoverIndex: collectionHoverIndex
    });
    var onLinkHoverEnter = customLinkStyling.onLinkHoverEnter, onLinkHoverLeave = customLinkStyling.onLinkHoverLeave, getNavElementStyle = customLinkStyling.getNavElementStyle;
    var numColumns = collections.length >= 4 ? 4 : collections.length;
    (0,react.useEffect)(function() {
        if (open) {
            document.body.classList.add("tw-overflow-y-hidden");
        // document.body.classList.remove('tw-overflow-y-auto');
        } else {
            // document.body.classList.add('tw-overflow-y-auto');
            document.body.classList.remove("tw-overflow-y-hidden");
        }
        return function() {
            // document.body.classList.add('tw-overflow-y-auto');
            document.body.classList.remove("tw-overflow-y-hidden");
        };
    }, [
        open
    ]);
    var MasonryCard = (0,react.useCallback)(function(param) {
        var index = param.index, collection = param.data;
        var ref;
        return !!((ref = collection.categories) === null || ref === void 0 ? void 0 : ref.length) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "tw-relative tw-flex tw-w-[100%] tw-select-none tw-flex-col ",
            onMouseEnter: function() {
                return setCollectionHoverIndex(index);
            },
            onMouseLeave: function() {
                return setCollectionHoverIndex(-1);
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                    onMouseEnter: function() {
                        return onLinkHoverEnter(index);
                    },
                    onMouseLeave: onLinkHoverLeave,
                    className: (0,bundle_mjs/* twMerge */.m6)("tw-relative tw-m-0 tw-mb-[12px] tw-max-w-fit tw-cursor-pointer tw-text-[12px] tw-font-bold tw-uppercase tw-leading-[15.62px] tw-tracking-[1px]", "[&>.underline-comp]:hover:tw-block"),
                    onClick: function() {
                        (0,routeToCollectionPage/* routeToCollectionPage */.L)(collection);
                        onClose();
                    },
                    style: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, getNavElementStyle(index), smartWordBreakStyle/* smartWordBreakStyle */.t), {
                        fontWeight: "700"
                    }),
                    children: [
                        collection.name,
                        _RenderUnderlineComponent === null || _RenderUnderlineComponent === void 0 ? void 0 : _RenderUnderlineComponent(index, {
                            bottom: -4,
                            width: "100%",
                            top: undefined,
                            height: "1px"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(MegaMenuDrawerDesktop_RenderCategory, {
                    collectionId: collection.id,
                    categories: collection.categories,
                    onClose: onClose,
                    showMoreCount: 4,
                    forNewHeader: forNewHeader,
                    customLinkStyling: customLinkStyling,
                    parentIndex: index,
                    isParentCategoryHovered: collectionHoverIndex === index,
                    _RenderUnderlineComponent: _RenderUnderlineComponent
                })
            ]
        }, collection.id);
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ClickAwayListener/* ClickAwayListener */.d, {
            onClickAway: onClose,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classnames_default()("tw-font-dmSans", "tw-absolute tw-left-0 tw-right-0 tw-top-[100%] tw-z-[12] tw-h-[370px] tw-min-h-[200px] tw-bg-white tw-px-[20px] tw-py-[28px]", open ? "tw-block" : "tw-hidden"),
                style: merge_default()(megaMenuStyles, {
                    borderTop: "1px solid ".concat(!megaMenuStyles.background || [
                        "#fff",
                        "#ffffff"
                    ].includes(megaMenuStyles.background) ? "#111C361F" : "#ffffff4d")
                }),
                onClick: function(e) {
                    return e.stopPropagation();
                },
                onMouseLeave: onClose,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (0,bundle_mjs/* twMerge */.m6)((megaMenu_module_default()).megaMenuScrollStyle, "tw-m-auto tw-flex tw-h-[100%] tw-max-w-[1000px] tw-flex-wrap tw-justify-center tw-overflow-y-auto tw-pr-[14px]"),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(masonry/* Masonry */.R, {
                        columnCount: numColumns,
                        items: collections,
                        columnWidth: 100,
                        maxColumnWidth: 200,
                        columnGutter: 68,
                        rowGutter: 34,
                        render: MasonryCard
                    })
                })
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/DesignSystem/Drawer/MegaMenuDrawerDesktop/index.ts



/***/ }),

/***/ 569384:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Be": function() { return /* binding */ AccordionOpenIcon; },
/* harmony export */   "MK": function() { return /* binding */ MoreCarat; },
/* harmony export */   "gO": function() { return /* binding */ LessCarat; },
/* harmony export */   "x$": function() { return /* binding */ AccordionCloseIcon; }
/* harmony export */ });
/* unused harmony exports LeftCaratIcon, CollectionWithNoImage, CollectionWithNoImageMobile */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(785893);

function LeftCaratIcon() {
    return /*#__PURE__*/ _jsx("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "11",
        height: "11",
        viewBox: "0 0 11 11",
        fill: "none",
        children: /*#__PURE__*/ _jsx("path", {
            d: "M3.28956 2.03627C3.25196 1.99649 3.22258 1.9497 3.20307 1.89856C3.18356 1.84742 3.17432 1.79295 3.17587 1.73824C3.17742 1.68353 3.18972 1.62966 3.21209 1.57971C3.23446 1.52975 3.26644 1.4847 3.30622 1.44711C3.346 1.40951 3.3928 1.38013 3.44393 1.36062C3.49507 1.34111 3.54955 1.33187 3.60426 1.33342C3.65897 1.33497 3.71283 1.34727 3.76279 1.36964C3.81274 1.39201 3.8578 1.42399 3.89539 1.46377L7.43706 5.21377C7.5102 5.29113 7.55095 5.39356 7.55095 5.50002C7.55095 5.60649 7.5102 5.70891 7.43706 5.78627L3.89539 9.53669C3.85805 9.57734 3.813 9.61017 3.76286 9.63326C3.71273 9.65635 3.6585 9.66925 3.60334 9.67121C3.54817 9.67317 3.49317 9.66415 3.44152 9.64468C3.38987 9.6252 3.34261 9.59565 3.30247 9.55776C3.26234 9.51986 3.23014 9.47436 3.20773 9.42391C3.18533 9.37347 3.17318 9.31907 3.17197 9.26388C3.17077 9.2087 3.18055 9.15382 3.20073 9.10245C3.22092 9.05107 3.25111 9.00422 3.28956 8.96461L6.56122 5.50002L3.28956 2.03627Z",
            fill: "#414141"
        })
    });
}
function CollectionWithNoImage() {
    return /*#__PURE__*/ _jsxs("svg", {
        width: "211",
        height: "210",
        viewBox: "0 0 211 210",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "210",
                height: "210",
                transform: "translate(0.253906)",
                fill: "#DFDFDF"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M95.2539 113.333H115.254L109.004 105L104.004 111.667L100.254 106.667L95.2539 113.333ZM90.2539 120V90H120.254V120H90.2539Z",
                fill: "#5E5E5E"
            })
        ]
    });
}
function CollectionWithNoImageMobile() {
    return /*#__PURE__*/ _jsxs("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "32",
                height: "32",
                rx: "2",
                fill: "#DFDFDF"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M11.7598 18.6592H19.2832L16.9321 15.5244L15.0513 18.0322L13.6406 16.1514L11.7598 18.6592ZM9.87891 21.167V9.88184H21.1641V21.167H9.87891Z",
                fill: "#5E5E5E"
            })
        ]
    });
}
function AccordionCloseIcon(props) {
    var secondaryColor = props.secondaryColor;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M2.45686 11.1452C2.39322 11.2054 2.31835 11.2524 2.23653 11.2836C2.15471 11.3148 2.06754 11.3296 1.98001 11.3271C1.89247 11.3246 1.80628 11.3049 1.72636 11.2692C1.64644 11.2334 1.57434 11.1822 1.5142 11.1185C1.45405 11.0549 1.40703 10.98 1.37582 10.8982C1.34461 10.8164 1.32982 10.7292 1.3323 10.6417C1.33477 10.5542 1.35447 10.468 1.39025 10.388C1.42604 10.3081 1.47722 10.236 1.54086 10.1759L7.54086 4.50921C7.66464 4.39218 7.82852 4.32698 7.99886 4.32698C8.16921 4.32698 8.33309 4.39218 8.45686 4.50921L14.4575 10.1759C14.5226 10.2356 14.5751 10.3077 14.612 10.3879C14.649 10.4681 14.6696 10.5549 14.6728 10.6432C14.6759 10.7314 14.6615 10.8194 14.6303 10.9021C14.5991 10.9847 14.5519 11.0603 14.4912 11.1245C14.4306 11.1888 14.3578 11.2403 14.2771 11.2761C14.1964 11.312 14.1093 11.3314 14.021 11.3333C13.9327 11.3353 13.8449 11.3196 13.7627 11.2873C13.6805 11.255 13.6056 11.2067 13.5422 11.1452L7.99886 5.91054L2.45686 11.1452Z",
            fill: secondaryColor || "#414141"
        })
    });
}
function AccordionOpenIcon(props) {
    var secondaryColor = props.secondaryColor;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M13.5431 4.85479C13.6068 4.79465 13.6817 4.74763 13.7635 4.71642C13.8453 4.68521 13.9325 4.67042 14.02 4.67289C14.1075 4.67537 14.1937 4.69506 14.2736 4.73085C14.3536 4.76663 14.4257 4.81781 14.4858 4.88146C14.5459 4.94511 14.593 5.01998 14.6242 5.1018C14.6554 5.18362 14.6702 5.27078 14.6677 5.35831C14.6652 5.44585 14.6455 5.53204 14.6097 5.61196C14.574 5.69189 14.5228 5.76398 14.4591 5.82413L8.45914 11.4908C8.33536 11.6078 8.17148 11.673 8.00114 11.673C7.83079 11.673 7.66691 11.6078 7.54314 11.4908L1.54247 5.82413C1.47743 5.76438 1.42491 5.6923 1.38796 5.61208C1.35101 5.53186 1.33036 5.4451 1.32723 5.35684C1.32409 5.26858 1.33853 5.18057 1.36969 5.09793C1.40085 5.0153 1.44813 4.93967 1.50876 4.87546C1.5694 4.81125 1.64219 4.75972 1.72291 4.72388C1.80363 4.68803 1.89066 4.66858 1.97896 4.66666C2.06726 4.66474 2.15506 4.68038 2.23726 4.71268C2.31946 4.74497 2.39443 4.79328 2.4578 4.85479L8.00114 10.0895L13.5431 4.85479Z",
            fill: secondaryColor || "#414141"
        })
    });
}
function MoreCarat(param) {
    var _color = param.color, color = _color === void 0 ? "black" : _color;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "25",
        height: "24",
        viewBox: "0 0 25 24",
        fill: "none",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M16.778 10.2099C16.926 10.3499 17 10.528 17 10.7443C17 10.9606 16.926 11.1387 16.778 11.2786L13.065 14.7901C12.9843 14.8664 12.8969 14.9204 12.8027 14.9519C12.7085 14.9835 12.6076 14.9995 12.5 15C12.3924 15 12.288 14.9809 12.1868 14.9427C12.0857 14.9046 12.0017 14.8537 11.935 14.7901L8.22197 11.2786C8.07399 11.1387 8 10.9606 8 10.7443C8 10.528 8.07399 10.3499 8.22197 10.2099C8.36996 10.07 8.5583 10 8.787 10C9.0157 10 9.20404 10.07 9.35202 10.2099L12.5 13.187L15.648 10.2099C15.796 10.07 15.9843 10 16.213 10C16.4417 10 16.63 10.07 16.778 10.2099Z",
            fill: color
        })
    });
}
function LessCarat(param) {
    var _color = param.color, color = _color === void 0 ? "black" : _color;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "25",
        height: "24",
        viewBox: "0 0 25 24",
        fill: "none",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M8.88604 13.7901C8.73805 13.6501 8.66406 13.472 8.66406 13.2557C8.66406 13.0394 8.73805 12.8613 8.88604 12.7214L12.599 9.20992C12.6798 9.13359 12.7672 9.07964 12.8614 9.04809C12.9555 9.01654 13.0564 9.00051 13.1641 9C13.2717 9 13.3761 9.01908 13.4772 9.05725C13.5784 9.09542 13.6624 9.14631 13.7291 9.20992L17.4421 12.7214C17.5901 12.8613 17.6641 13.0394 17.6641 13.2557C17.6641 13.472 17.5901 13.6501 17.4421 13.7901C17.2941 13.93 17.1058 14 16.8771 14C16.6484 14 16.46 13.93 16.312 13.7901L13.1641 10.813L10.0161 13.7901C9.8681 13.93 9.67976 14 9.45106 14C9.22236 14 9.03402 13.93 8.88604 13.7901Z",
            fill: color
        })
    });
}


/***/ }),

/***/ 586361:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "R": function() { return /* reexport */ MenuDrawerMobile; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(999534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(785893);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js + 2 modules
var Box = __webpack_require__(394253);
// EXTERNAL MODULE: ./node_modules/@mui/material/Drawer/Drawer.js + 1 modules
var Drawer = __webpack_require__(758826);
// EXTERNAL MODULE: ./node_modules/@mui/material/List/List.js + 1 modules
var List = __webpack_require__(78462);
// EXTERNAL MODULE: ./node_modules/@mui/material/ListItem/ListItem.js + 4 modules
var ListItem = __webpack_require__(370891);
// EXTERNAL MODULE: ./src/redux/ssrStore.ts + 1 modules
var ssrStore = __webpack_require__(326706);
// EXTERNAL MODULE: ./src/components/DesignSystem/Drawer/MenuDrawerMobile/utils.tsx
var utils = __webpack_require__(572164);
// EXTERNAL MODULE: ./src/hooks/useFeatureLocks.ts
var useFeatureLocks = __webpack_require__(482516);
// EXTERNAL MODULE: ./src/components/InstallAppInstructionsOverlay/useInstallAppOverlayActions.tsx
var useInstallAppOverlayActions = __webpack_require__(141771);
// EXTERNAL MODULE: ./src/components/LogoutModal/index.js
var LogoutModal = __webpack_require__(821448);
// EXTERNAL MODULE: ./src/utils/excuteLogout.js
var excuteLogout = __webpack_require__(385126);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(225617);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(811163);
var router_default = /*#__PURE__*/__webpack_require__.n(router);
// EXTERNAL MODULE: ./src/redux/actions/common.js
var common = __webpack_require__(731024);
// EXTERNAL MODULE: ./src/utils/routes.js + 1 modules
var routes = __webpack_require__(540190);
// EXTERNAL MODULE: ./src/components/LoginAndDropdownComponent/index.js
var LoginAndDropdownComponent = __webpack_require__(629492);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(693967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./src/utils/showMegaMenu.js
var showMegaMenu = __webpack_require__(36408);
// EXTERNAL MODULE: ./src/hooks/useGetDeviceType.tsx
var useGetDeviceType = __webpack_require__(662946);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(505152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./src/utils/checkRenderEnv.js
var checkRenderEnv = __webpack_require__(506337);
// EXTERNAL MODULE: ./src/hooks/useNavlinkStyling.ts
var useNavlinkStyling = __webpack_require__(177137);
// EXTERNAL MODULE: ./src/hooks/useNavConfigs.ts
var useNavConfigs = __webpack_require__(232876);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Close.js
var Close = __webpack_require__(450594);
// EXTERNAL MODULE: ./src/constants/wishlist.js
var wishlist = __webpack_require__(298627);
;// CONCATENATED MODULE: ./src/components/DesignSystem/Drawer/MenuDrawerMobile/MenuDrawerMobile.tsx
/* eslint no-unused-vars: 0 */ // --> OFF


























var InstallAppInstructionsOverlay = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 557).then(__webpack_require__.bind(__webpack_require__, 700557));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(700557)
            ];
        }
    },
    ssr: false
});
function MenuDrawerMobile(_param) {
    var isVisible = _param.isVisible, closeDrawer = _param.closeDrawer, renderList = _param.renderList, _fromNewHeader = _param.fromNewHeader, fromNewHeader = _fromNewHeader === void 0 ? false : _fromNewHeader, _customItemList = _param.customItemList, customItemList = _customItemList === void 0 ? undefined : _customItemList, _isScroll = _param.isScroll, isScroll = _isScroll === void 0 ? false : _isScroll, _isHeaderHovered = _param.isHeaderHovered, isHeaderHovered = _isHeaderHovered === void 0 ? false : _isHeaderHovered, props = (0,_object_without_properties/* default */.Z)(_param, [
        "isVisible",
        "closeDrawer",
        "renderList",
        "fromNewHeader",
        "customItemList",
        "isScroll",
        "isHeaderHovered"
    ]);
    var ref;
    var deviceType = (0,useGetDeviceType/* useGetDeviceType */.n)().deviceType;
    var isMobile = deviceType === "mobile";
    var dispatch = (0,es/* useDispatch */.I0)();
    var currentClass = (0,useNavConfigs/* useNavConfigs */.Z)(isScroll, isHeaderHovered).currentClass;
    var headerBackground = currentClass === null || currentClass === void 0 ? void 0 : (ref = currentClass.base_config) === null || ref === void 0 ? void 0 : ref.defaultBackgroundColor;
    var getNavElementStyle = (0,useNavlinkStyling/* useNavlinkStyling */.u)().getNavElementStyle;
    var navElementStyle = getNavElementStyle();
    var ref1 = (0,ssrStore/* useSSRSelector */.kF)(function(state) {
        var ref, ref1;
        return {
            storeData: state.storeReducer.store,
            collections: state.catalogReducer.collections,
            navigationList: state.additionalPagesReducer.navigationList,
            userLogin: state.userReducer.isLogin,
            showLogoutConfirmationModal: state.commonReducer.showLogoutConfirmationModal,
            wishlistFeatureEnabled: (ref = state.storeReducer.store) === null || ref === void 0 ? void 0 : (ref1 = ref.services) === null || ref1 === void 0 ? void 0 : ref1.wishlist_flag
        };
    }), storeData = ref1.storeData, navigationList = ref1.navigationList, // collections,
    userLogin = ref1.userLogin, showLogoutConfirmationModal = ref1.showLogoutConfirmationModal, wishlistFeatureEnabled = ref1.wishlistFeatureEnabled;
    var ref2 = (0,useFeatureLocks/* useFeatureLocks */.r)(), installAppFeatureStatus = ref2.installAppFeatureStatus, wishlistFeatureStatus = ref2.wishlistFeatureStatus;
    var showMyOrders = isMobile;
    var showInstallApp = (installAppFeatureStatus === null || installAppFeatureStatus === void 0 ? void 0 : installAppFeatureStatus.isVisible) && !checkRenderEnv/* IS_WEBVIEW */.x5;
    var showWishlistMenu = !(wishlistFeatureStatus === null || wishlistFeatureStatus === void 0 ? void 0 : wishlistFeatureStatus.isLocked) && wishlistFeatureEnabled === wishlist/* WISHLIST_FEATURE_STATUS.WISHLIST_ACTIVE */.g.WISHLIST_ACTIVE && !checkRenderEnv/* IS_WEBVIEW */.x5;
    var openIntallAppOverlay = (0,useInstallAppOverlayActions/* default */.Z)().openIntallAppOverlay;
    var navItemsState = (0,utils/* useGetNavList */.Yt)(navigationList);
    var toggleLogoutModal = function() {
        return dispatch((0,common/* toggleLogoutConfirmModal */.oD)());
    };
    var toggleAuthModal = function() {
        closeDrawer();
        if (userLogin) {
            toggleLogoutModal();
        } else {
            var ref;
            router_default().push((0,routes.getRoute)(routes.PATH.ORDERS, storeData === null || storeData === void 0 ? void 0 : (ref = storeData.store_info) === null || ref === void 0 ? void 0 : ref.domain));
        }
    };
    var getShopComponent = function(navItemsState) {
        return navItemsState === null || navItemsState === void 0 ? void 0 : navItemsState.find(function(data) {
            return data.slug_url === "shop";
        });
    };
    var renderMobileLoginLogout = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "flex items-center ".concat(utils/* baseNavItemClass */.Zk, " !tw-border-none"),
            onClick: toggleAuthModal,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex items-center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: userLogin ? "red" : "black",
                    children: userLogin ? "Logout" : "Login"
                })
            })
        });
    };
    var DrawerList = /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        sx: {
            width: "336px",
            padding: "16px",
            display: "flex",
            flexDirection: "column",
            height: "100%",
            maxHeight: "100vh",
            background: headerBackground
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Close["default"], {
                onClick: closeDrawer,
                style: {
                    color: navElementStyle.color
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(List/* default */.Z, {
                className: "no-scrollbar",
                disablePadding: true,
                sx: {
                    flexGrow: 1,
                    overflowY: "auto"
                },
                children: [
                    !fromNewHeader ? navItemsState === null || navItemsState === void 0 ? void 0 : navItemsState.map(function(page) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItem/* default */.ZP, {
                            disablePadding: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(utils/* OldNavigationItem */.ps, {
                                page: page,
                                dropdownNav: true,
                                fromMobileMenuDrawer: true,
                                isLastListBox: !showInstallApp && !showMyOrders,
                                customItemClasses: "!tw-text-[13px]",
                                showMegaMenuMobileOnDesktopDrawer: true,
                                closeParentContainer: closeDrawer
                            })
                        }, page);
                    }) : renderList === null || renderList === void 0 ? void 0 : renderList.map(function(page) {
                        /*#__PURE__*/ return (0,jsx_runtime.jsx)(ListItem/* default */.ZP, {
                            disablePadding: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(utils/* NewNavigationItem */.HW, {
                                data: page,
                                showMegaMenu: (page === null || page === void 0 ? void 0 : page.isShopComponent) ? (0,showMegaMenu/* showMegaMenu */.G)() : false,
                                megaMenuData: (page === null || page === void 0 ? void 0 : page.isShopComponent) ? getShopComponent(navItemsState) : "",
                                showMegaMenuMobileOnDesktopDrawer: (page === null || page === void 0 ? void 0 : page.isShopComponent) ? (0,showMegaMenu/* showMegaMenu */.G)() : false,
                                fromMobileMenuDrawer: true,
                                isLastListBox: !showInstallApp && !showMyOrders,
                                customItemClasses: "tw-text-[13px]",
                                closeParentContainer: closeDrawer,
                                background: headerBackground
                            })
                        }, page);
                    }),
                    Array.isArray(customItemList) && (customItemList === null || customItemList === void 0 ? void 0 : customItemList.map(function(child, idx) {
                        var isLastItemInWholeList = idx === (customItemList === null || customItemList === void 0 ? void 0 : customItemList.length) - 1 && !showMyOrders && !(installAppFeatureStatus === null || installAppFeatureStatus === void 0 ? void 0 : installAppFeatureStatus.isVisible);
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItem/* default */.ZP, {
                            disablePadding: true,
                            className: classnames_default()("".concat(utils/* baseNavItemClass */.Zk, " tw-cursor-pointer tw-text-[15px]"), isLastItemInWholeList && "!tw-border-none"),
                            style: navElementStyle,
                            children: child
                        }, idx);
                    })),
                    showWishlistMenu && !fromNewHeader && /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItem/* default */.ZP, {
                        disablePadding: true,
                        className: classnames_default()("".concat(utils/* baseNavItemClass */.Zk, " tw-cursor-pointer tw-text-[15px]"), !showInstallApp && "!tw-border-none"),
                        onClick: function() {
                            var ref;
                            closeDrawer();
                            router_default().push((0,routes.getRoute)(routes.PATH.WISHLIST, storeData === null || storeData === void 0 ? void 0 : (ref = storeData.store_info) === null || ref === void 0 ? void 0 : ref.domain));
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: " Wishlist "
                        })
                    }),
                    showMyOrders && !fromNewHeader && /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItem/* default */.ZP, {
                        disablePadding: true,
                        className: classnames_default()("".concat(utils/* baseNavItemClass */.Zk, " tw-cursor-pointer tw-text-[15px]"), !showInstallApp && "!tw-border-none"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LoginAndDropdownComponent/* default */.Z, {
                            disableDropdown: true,
                            closeParentContainer: closeDrawer,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: "My Orders"
                            })
                        })
                    }),
                    showInstallApp && /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItem/* default */.ZP, {
                        disablePadding: true,
                        className: "".concat(utils/* baseNavItemClass */.Zk, "  !tw-border-none tw-text-[15px] pwa:tw-hidden"),
                        onClick: function() {
                            closeDrawer();
                            openIntallAppOverlay();
                        },
                        style: navElementStyle,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: "Install App"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItem/* default */.ZP, {
                disablePadding: true,
                children: renderMobileLoginLogout()
            })
        ]
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Drawer/* default */.ZP, {
                className: "tw-z-[600] tw-select-none tw-font-dmSans",
                open: isVisible,
                onClose: closeDrawer,
                children: DrawerList
            }),
            showLogoutConfirmationModal && /*#__PURE__*/ (0,jsx_runtime.jsx)(LogoutModal["default"], {
                toggleLogoutModal: toggleLogoutModal,
                executeLogout: excuteLogout/* executeLogout */.q,
                showLogoutConfirmation: showLogoutConfirmationModal
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(InstallAppInstructionsOverlay, {})
        ]
    });
}

;// CONCATENATED MODULE: ./src/components/DesignSystem/Drawer/MenuDrawerMobile/index.ts



/***/ }),

/***/ 572164:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "HW": function() { return /* binding */ NewNavigationItem; },
/* harmony export */   "Yt": function() { return /* binding */ useGetNavList; },
/* harmony export */   "Zk": function() { return /* binding */ baseNavItemClass; },
/* harmony export */   "ps": function() { return /* binding */ OldNavigationItem; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(626042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(269396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(999534);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(629815);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(785893);
/* harmony import */ var _utils_getCustomHeaderTextColor__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(956494);
/* harmony import */ var _assets_svgExports_HeaderInfoIcon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(337247);
/* harmony import */ var _Headers_ShopComponent__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(811525);
/* harmony import */ var _Headers_CommonNavbarText_CommonNavbarText__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(932461);
/* harmony import */ var _utils_routes__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(540190);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(811163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _redux_ssrStore__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(326706);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(667294);
/* harmony import */ var _MegaMenuDrawerDesktop_svgIcons__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(569384);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(693967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var tailwind_merge__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(798388);
/* harmony import */ var src_hooks_useNavlinkStyling__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(177137);
/* harmony import */ var _Widgets2_0_CommonLinkWrapper__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(486353);
/* harmony import */ var src_assets_svgExports_WishlistHeartIcon__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(407056);
/* harmony import */ var _Widgets2_0_Header_utils__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(545588);




















var baseNavItemClass = " tw-w-[100%] tw-border-b-[1px] tw-border-solid tw-border-[#111C36]/[0.12] tw-py-[16px] tw-text-[14px] tw-font-normal tw-leading-[18px] ";
var useGetNavList = function(navigationList) {
    var subNavObj = {
        page_type: "subNavList",
        subNavs: [],
        is_editable: false,
        page_id: "616d2bd6152384798123d775",
        page_name: "More",
        slug_url: "subNavList"
    };
    var list = (0,react__WEBPACK_IMPORTED_MODULE_8__.useMemo)(function() {
        if ((navigationList === null || navigationList === void 0 ? void 0 : navigationList.length) > 0) {
            var tempNavList = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)(navigationList);
            if ((navigationList === null || navigationList === void 0 ? void 0 : navigationList.length) > 5) {
                var extractedNavList = tempNavList.splice(5, tempNavList.length);
                subNavObj.subNavs = extractedNavList;
                var newNavList = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)(tempNavList).concat([
                    subNavObj
                ]);
                return newNavList;
            } else {
                return navigationList;
            }
        }
    }, [
        navigationList
    ]);
    return list;
};
var OldNavigationItem = function(_param) {
    var page = _param.page, _dropdownNav = _param.dropdownNav, dropdownNav = _dropdownNav === void 0 ? false : _dropdownNav, isLastListBox = _param.isLastListBox, _showMegaMenuMobileOnDesktopDrawer = _param.showMegaMenuMobileOnDesktopDrawer, showMegaMenuMobileOnDesktopDrawer = _showMegaMenuMobileOnDesktopDrawer === void 0 ? false : _showMegaMenuMobileOnDesktopDrawer, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(_param, [
        "page",
        "dropdownNav",
        "isLastListBox",
        "showMegaMenuMobileOnDesktopDrawer"
    ]);
    var ref, ref1;
    var headerBgColor = (props === null || props === void 0 ? void 0 : (ref = props.config) === null || ref === void 0 ? void 0 : (ref1 = ref.color_scheme) === null || ref1 === void 0 ? void 0 : ref1.bg_color) || "#ffffff";
    var storeData = (0,_redux_ssrStore__WEBPACK_IMPORTED_MODULE_7__/* .useSSRSelector */ .kF)(function(state) {
        return {
            storeData: state.storeReducer.store
        };
    }).storeData;
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_8__.useState)(false), openMore = ref2[0], setOpenMore = ref2[1];
    var menuItemClick = function(nav) {
        if ((nav === null || nav === void 0 ? void 0 : nav.page_type) === "blank_page" && (nav === null || nav === void 0 ? void 0 : nav.is_external_url)) {
            var ref;
            window.open(nav.slug_url, "_blank");
            (ref = props.closeParentContainer) === null || ref === void 0 ? void 0 : ref.call(props);
            return;
        } else if (nav.slug_url === "subNavList") {
            setOpenMore(!openMore);
        } else {
            var ref1;
            if (nav.is_editable) {
                var ref2;
                next_router__WEBPACK_IMPORTED_MODULE_6___default().push((0,_utils_routes__WEBPACK_IMPORTED_MODULE_5__.getRoute)(_utils_routes__WEBPACK_IMPORTED_MODULE_5__.PATH.additionalPage(nav.slug_url), storeData === null || storeData === void 0 ? void 0 : (ref2 = storeData.store_info) === null || ref2 === void 0 ? void 0 : ref2.domain));
            } else {
                var ref3;
                next_router__WEBPACK_IMPORTED_MODULE_6___default().push((0,_utils_routes__WEBPACK_IMPORTED_MODULE_5__.getRoute)(nav.slug_url, storeData === null || storeData === void 0 ? void 0 : (ref3 = storeData.store_info) === null || ref3 === void 0 ? void 0 : ref3.domain));
            }
            (ref1 = props.closeParentContainer) === null || ref1 === void 0 ? void 0 : ref1.call(props);
        }
    };
    var navSubList = function(nav) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "tw-mt-[22.5px] tw-font-dmSans",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "",
                children: nav.map(function(n, index, arr) {
                    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: (0,tailwind_merge__WEBPACK_IMPORTED_MODULE_17__/* .twMerge */ .m6)("tw-m-0 tw-text-[13px] tw-font-semibold", index !== (arr === null || arr === void 0 ? void 0 : arr.length) - 1 && "tw-pb-[15.5px]"),
                        onClick: function() {
                            return menuItemClick(n);
                        },
                        children: n.page_name
                    }, n.page_id);
                })
            })
        });
    };
    switch(page.slug_url){
        case "":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                className: " relative " + baseNavItemClass,
                onClick: function() {
                    return menuItemClick(page);
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "flex items-center justify-between",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "flex items-center",
                        style: {
                            flex: "1 1 auto"
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Headers_CommonNavbarText_CommonNavbarText__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                            classes: props.customItemClasses,
                            bgColor: headerBgColor,
                            page: page
                        })
                    })
                })
            }, page.page_id);
        case "wishlist":
            var ref3, ref4;
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                className: " relative " + baseNavItemClass,
                onClick: function() {
                    return menuItemClick(page);
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "flex items-center justify-between",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex items-center",
                        style: {
                            flex: "1 1 auto"
                        },
                        children: [
                            !props.fromMobileMenuDrawer && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "mr3 visible-mobile",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_assets_svgExports_WishlistHeartIcon__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                                    color: (storeData === null || storeData === void 0 ? void 0 : (ref3 = storeData.theme) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.colors) === null || ref4 === void 0 ? void 0 : ref4.primary_color) !== "#ffffff" ? "#000000" : "#ffffff"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Headers_CommonNavbarText_CommonNavbarText__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                classes: props.customItemClasses,
                                bgColor: headerBgColor,
                                page: page
                            })
                        ]
                    })
                })
            }, page.page_id);
        case "shop":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Headers_ShopComponent__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                page: page,
                showIcon: false,
                baseClass: baseNavItemClass,
                fromMobileMenuDrawer: true,
                customItemClasses: props.customItemClasses,
                showMegaMenuMobileOnDesktopDrawer: showMegaMenuMobileOnDesktopDrawer,
                closeParentContainer: props.closeParentContainer
            });
        case "subNavList":
            var ref5;
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                className: " relative " + baseNavItemClass,
                onClick: function() {
                    return menuItemClick(page);
                },
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex items-center justify-between",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "flex items-center",
                                style: {
                                    flex: "1 1 auto"
                                },
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Headers_CommonNavbarText_CommonNavbarText__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                    classes: props.customItemClasses,
                                    page: {
                                        page_name: "More"
                                    },
                                    bgColor: headerBgColor
                                })
                            }),
                            (page === null || page === void 0 ? void 0 : (ref5 = page.subNavs) === null || ref5 === void 0 ? void 0 : ref5.length) > 0 && (!openMore ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_MegaMenuDrawerDesktop_svgIcons__WEBPACK_IMPORTED_MODULE_9__/* .AccordionCloseIcon */ .x$, {}) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_MegaMenuDrawerDesktop_svgIcons__WEBPACK_IMPORTED_MODULE_9__/* .AccordionOpenIcon */ .Be, {}))
                        ]
                    }),
                    openMore && navSubList(page.subNavs)
                ]
            }, page === null || page === void 0 ? void 0 : page.page_id);
        case "about-us":
            var ref6, ref7;
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                className: " relative " + (props.fromMobileMenuDrawer ? baseNavItemClass : "menu-item"),
                onClick: function() {
                    return menuItemClick(page);
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "flex items-center justify-between",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex items-center",
                        style: {
                            flex: "1 1 auto"
                        },
                        children: [
                            !props.fromMobileMenuDrawer && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "mr3 visible-mobile",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_assets_svgExports_HeaderInfoIcon__WEBPACK_IMPORTED_MODULE_2__/* .HeaderInfoIcon */ .V, {
                                    color: (storeData === null || storeData === void 0 ? void 0 : (ref6 = storeData.theme) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.colors) === null || ref7 === void 0 ? void 0 : ref7.primary_color) !== "#ffffff" ? "#000000" : "#ffffff"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Headers_CommonNavbarText_CommonNavbarText__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                classes: props.customItemClasses,
                                bgColor: headerBgColor,
                                page: page
                            })
                        ]
                    })
                })
            }, page.page_id);
        default:
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                className: "".concat(baseNavItemClass, " ").concat((0,_utils_getCustomHeaderTextColor__WEBPACK_IMPORTED_MODULE_1__/* .getCustomHeaderTextColor */ .s)(headerBgColor), " ").concat(isLastListBox ? "!tw-border-none" : "", " ").concat(props.customItemClasses),
                onClick: function() {
                    return menuItemClick(page);
                },
                children: page.page_name
            }, page.page_id);
    }
};
var NewNavigationItem = function(_param) {
    var data = _param.data, isLastListBox = _param.isLastListBox, _background = _param.background, background = _background === void 0 ? "#ffffff" : _background, closeParentContainer = _param.closeParentContainer, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(_param, [
        "data",
        "isLastListBox",
        "background",
        "closeParentContainer"
    ]);
    var ref, ref1;
    var headerBgColor = (props === null || props === void 0 ? void 0 : (ref = props.config) === null || ref === void 0 ? void 0 : (ref1 = ref.color_scheme) === null || ref1 === void 0 ? void 0 : ref1.bg_color) || "#ffffff";
    var ref2 = (0,_redux_ssrStore__WEBPACK_IMPORTED_MODULE_7__/* .useSSRSelector */ .kF)(function(state) {
        return {
            categories: state.catalogReducer.categories || [],
            productTags: state.catalogReducer.productTags || []
        };
    }), categories = ref2.categories, productTags = ref2.productTags;
    var ref3 = (0,_Widgets2_0_Header_utils__WEBPACK_IMPORTED_MODULE_14__/* .useHeaderLinksUtils */ .Tg)(), getDropdownList = ref3.getDropdownList, handleHeaderNavItemClick = ref3.handleHeaderNavItemClick, getHeaderNavInlineLink = ref3.getHeaderNavInlineLink;
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_8__.useState)(false), isDropdownOpened = ref4[0], setIsOpenDropdown = ref4[1];
    var isTypeDropdown = data.type === "dropdown";
    var allCategories = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)(categories).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)(productTags));
    var getNavElementStyle = (0,src_hooks_useNavlinkStyling__WEBPACK_IMPORTED_MODULE_11__/* .useNavlinkStyling */ .u)().getNavElementStyle;
    var navElementStyle = getNavElementStyle();
    var parentNavItemsRedirectData = getHeaderNavInlineLink(data);
    if (!data.showOnHeader) {
        return null;
    }
    var onNavItemClick = function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        // eslint-disable-next-line
        handleHeaderNavItemClick.apply(null, args);
        closeParentContainer === null || closeParentContainer === void 0 ? void 0 : closeParentContainer();
    };
    var navSubList = function(nav, isShopComponent) {
        var updatedNav = getDropdownList(isShopComponent, nav);
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "tw-mt-[22.5px] tw-max-h-[200px] tw-overflow-y-auto tw-font-dmSans",
            children: updatedNav.map(function(navLinkItem, idx, totalNavItems) {
                var ref;
                var navItemLatest = allCategories === null || allCategories === void 0 ? void 0 : allCategories.find(function(val) {
                    return (val === null || val === void 0 ? void 0 : val.id) === (navItem === null || navItem === void 0 ? void 0 : navItem.id);
                });
                var navItem = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)({}, navLinkItem), {
                    isShopComponent: isShopComponent
                });
                var childNavItemsRedirectData = getHeaderNavInlineLink(navItem);
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Widgets2_0_CommonLinkWrapper__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                    onClick: function() {
                        return closeParentContainer === null || closeParentContainer === void 0 ? void 0 : closeParentContainer();
                    },
                    handleCustomClick: (navItem === null || navItem === void 0 ? void 0 : navItem.redirectNewPage) ? function() {
                        return onNavItemClick(navItem);
                    } : undefined,
                    link: childNavItemsRedirectData.link,
                    target: childNavItemsRedirectData.target,
                    disableLink: navItem === null || navItem === void 0 ? void 0 : navItem.redirectNewPage,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: classnames__WEBPACK_IMPORTED_MODULE_10___default()("tw-m-0 tw-font-semibold ", (totalNavItems === null || totalNavItems === void 0 ? void 0 : totalNavItems.length) - 1 !== idx && "tw-mb-[17.5px] ", props.customItemClasses),
                        style: navElementStyle,
                        children: (ref = navItemLatest || navItem) === null || ref === void 0 ? void 0 : ref.name
                    })
                }, navItem === null || navItem === void 0 ? void 0 : navItem.page_id);
            })
        });
    };
    if (props === null || props === void 0 ? void 0 : props.showMegaMenu) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Headers_ShopComponent__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            page: props.megaMenuData,
            showIcon: false,
            baseClass: baseNavItemClass,
            fromMobileMenuDrawer: true,
            customItemClasses: props.customItemClasses,
            showMegaMenuMobileOnDesktopDrawer: props === null || props === void 0 ? void 0 : props.showMegaMenuMobileOnDesktopDrawer,
            closeParentContainer: closeParentContainer,
            style: navElementStyle,
            background: background
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
        className: " relative ".concat(baseNavItemClass, "  ").concat(isLastListBox ? "!tw-border-none" : "", " "),
        style: {
            borderColor: navElementStyle.borderColor
        },
        children: data.redirectionLink || (data === null || data === void 0 ? void 0 : data.isDefaultNavList) && !(data === null || data === void 0 ? void 0 : data.option) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Widgets2_0_CommonLinkWrapper__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
            onClick: function() {
                return closeParentContainer === null || closeParentContainer === void 0 ? void 0 : closeParentContainer();
            },
            handleCustomClick: (data === null || data === void 0 ? void 0 : data.redirectNewPage) ? function() {
                return onNavItemClick(data);
            } : undefined,
            link: parentNavItemsRedirectData.link,
            target: parentNavItemsRedirectData.target,
            disableLink: data === null || data === void 0 ? void 0 : data.redirectNewPage,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: classnames__WEBPACK_IMPORTED_MODULE_10___default()("tw-select-none tw-font-dmSans ", props.customItemClasses),
                style: {
                    color: "inherit",
                    textDecoration: "none"
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Headers_CommonNavbarText_CommonNavbarText__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                    page: {
                        page_name: data.name
                    },
                    bgColor: headerBgColor,
                    style: navElementStyle
                })
            })
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "flex items-center justify-between tw-cursor-pointer ",
                    onClick: function() {
                        return setIsOpenDropdown(!isDropdownOpened);
                    },
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "flex items-center",
                            style: {
                                flex: "1 1 auto"
                            },
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Headers_CommonNavbarText_CommonNavbarText__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                classes: props.customItemClasses,
                                page: {
                                    page_name: data.name
                                },
                                bgColor: headerBgColor,
                                style: navElementStyle
                            })
                        }),
                        isTypeDropdown && (isDropdownOpened ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_MegaMenuDrawerDesktop_svgIcons__WEBPACK_IMPORTED_MODULE_9__/* .AccordionCloseIcon */ .x$, {
                            secondaryColor: navElementStyle.color
                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_MegaMenuDrawerDesktop_svgIcons__WEBPACK_IMPORTED_MODULE_9__/* .AccordionOpenIcon */ .Be, {
                            secondaryColor: navElementStyle.color
                        }))
                    ]
                }),
                isDropdownOpened && navSubList(data.option, data === null || data === void 0 ? void 0 : data.isShopComponent)
            ]
        })
    });
};


/***/ }),

/***/ 932461:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ CommonNavbarText; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(785893);
/* harmony import */ var _utils_getCustomHeaderTextColor__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(956494);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(667294);



function CommonNavbarText(props) {
    var ref;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
        className: "\n      nav-name \n      ".concat((0,_utils_getCustomHeaderTextColor__WEBPACK_IMPORTED_MODULE_1__/* .getCustomHeaderTextColor */ .s)(props === null || props === void 0 ? void 0 : props.bgColor), " ").concat(props.classes),
        style: props.style || {},
        children: props === null || props === void 0 ? void 0 : (ref = props.page) === null || ref === void 0 ? void 0 : ref.page_name
    });
}


/***/ }),

/***/ 700634:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _redux_ssrStore__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(326706);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(667294);
/* harmony import */ var src_hooks_useStoreSubscriptionConfigs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(372988);



function useIsShopDropDownEnable() {
    var statuses = (0,src_hooks_useStoreSubscriptionConfigs__WEBPACK_IMPORTED_MODULE_2__/* .useStoreSubscriptionConfigs */ .D)();
    var ref = (0,_redux_ssrStore__WEBPACK_IMPORTED_MODULE_0__/* .useSSRSelector */ .kF)(function(state) {
        var ref, ref1, ref2, ref3, ref4, ref5;
        var storeTheme = (ref = state.storeReducer.store) === null || ref === void 0 ? void 0 : ref.theme;
        var ref6;
        return {
            collections: state.catalogReducer.collections,
            customStore: storeTheme === null || storeTheme === void 0 ? void 0 : storeTheme.custom_theme_flag,
            isCustomShopDropDownEnable: (ref6 = storeTheme === null || storeTheme === void 0 ? void 0 : (ref1 = storeTheme.components) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.Header) === null || ref2 === void 0 ? void 0 : (ref3 = ref2[0]) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.config) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.hidden_components) === null || ref5 === void 0 ? void 0 : ref5.isShopDropDownEnable) !== null && ref6 !== void 0 ? ref6 : true
        };
    }), collections = ref.collections, customStore = ref.customStore, isCustomShopDropDownEnable = ref.isCustomShopDropDownEnable;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isShopDropDownEnable = ref1[0], setIsShopDropDownEnable = ref1[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var ref;
        if (customStore || !(statuses === null || statuses === void 0 ? void 0 : (ref = statuses.subscriptionStatus) === null || ref === void 0 ? void 0 : ref.isOldSubscriptionActive) || !(collections === null || collections === void 0 ? void 0 : collections.length)) setIsShopDropDownEnable(true);
        else setIsShopDropDownEnable(false);
    }, [
        collections,
        customStore,
        isCustomShopDropDownEnable
    ]);
    return isShopDropDownEnable;
}
/* harmony default export */ __webpack_exports__["Z"] = (useIsShopDropDownEnable);


/***/ }),

/***/ 811525:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ ShopComponent_ShopComponent; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(626042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(269396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(629815);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(785893);
// EXTERNAL MODULE: ./src/utils/deviceWidth.js
var deviceWidth = __webpack_require__(186812);
// EXTERNAL MODULE: ./src/utils/isPLPRequiredSystem.js
var isPLPRequiredSystem = __webpack_require__(586423);
// EXTERNAL MODULE: ./src/utils/emoticonsStatus.js
var emoticonsStatus = __webpack_require__(218626);
// EXTERNAL MODULE: ./src/utils/routes.js + 1 modules
var routes = __webpack_require__(540190);
// EXTERNAL MODULE: ./src/assets/svgExports/SupermarketIcon.js
var SupermarketIcon = __webpack_require__(281431);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(667294);
// EXTERNAL MODULE: ./src/components/DesignSystem/Headers/CommonNavbarText/CommonNavbarText.js
var CommonNavbarText = __webpack_require__(932461);
// EXTERNAL MODULE: ./src/redux/ssrStore.ts + 1 modules
var ssrStore = __webpack_require__(326706);
// EXTERNAL MODULE: ./src/utils/showMegaMenu.js
var showMegaMenu = __webpack_require__(36408);
// EXTERNAL MODULE: ./src/utils/checkClientDeviceType.js
var checkClientDeviceType = __webpack_require__(313508);
// EXTERNAL MODULE: ./src/components/DesignSystem/Headers/HeaderUtils/useIsShopDropDownEnable.js
var useIsShopDropDownEnable = __webpack_require__(700634);
// EXTERNAL MODULE: ./src/components/MegaMenu/svgIcons.js
var svgIcons = __webpack_require__(120941);
// EXTERNAL MODULE: ./src/components/DesignSystem/Headers/ShopComponent/shopComponent.module.scss
var shopComponent_module = __webpack_require__(899214);
var shopComponent_module_default = /*#__PURE__*/__webpack_require__.n(shopComponent_module);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(693967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/@mui/material/ClickAwayListener/ClickAwayListener.js
var ClickAwayListener = __webpack_require__(607982);
// EXTERNAL MODULE: ./src/components/DesignSystem/Widgets2.0/CommonLinkWrapper/index.tsx
var CommonLinkWrapper = __webpack_require__(486353);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(505152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
;// CONCATENATED MODULE: ./src/components/DesignSystem/Headers/ShopComponent/ShopComponent.tsx









// import router from 'next/router';












var MegaMenuMobileView = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 574).then(__webpack_require__.bind(__webpack_require__, 880574)).then(function(mod) {
        return mod.default;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(880574)
            ];
        }
    },
    ssr: false
});
var isDesktop = deviceWidth/* deviceWidth */.o > 786;
var IS_SERVER = "object" === "undefined";
var showHeaderIcon = !(isDesktop || IS_SERVER);
var ShopComponent = /*#__PURE__*/ (0,react.forwardRef)(function ShopComponent(props, ref) {
    var getCategoryLink = function getCategoryLink(category) {
        var _$ref, _$ref1;
        return (0,routes.getRoute)("".concat((0,isPLPRequiredSystem/* isPLPRequiredSystem */.q)(storeData === null || storeData === void 0 ? void 0 : (_$ref = storeData.theme) === null || _$ref === void 0 ? void 0 : _$ref.theme_class) ? routes.PATH.SHOP : routes.PATH.PRODUCT, "?cid=").concat(category.id), storeData === null || storeData === void 0 ? void 0 : (_$ref1 = storeData.store_info) === null || _$ref1 === void 0 ? void 0 : _$ref1.domain);
    };
    var _$ref, _$ref1, _$ref2, _$ref3, _$ref4, _$ref5, _$ref6;
    var page = props.page, setOpenMegaMenu = props.setOpenMegaMenu, showMegaMenuDesktop = props.showMegaMenuDesktop, background = props.background, baseClass = props.baseClass, showMegaMenuMobileOnDesktopDrawer = props.showMegaMenuMobileOnDesktopDrawer, closeParentContainer = props.closeParentContainer;
    var headerBgColor = (props === null || props === void 0 ? void 0 : (_$ref = props.config) === null || _$ref === void 0 ? void 0 : (_$ref1 = _$ref.color_scheme) === null || _$ref1 === void 0 ? void 0 : _$ref1.bg_color) || "#ffffff";
    var shopCompRef = (0,react.useRef)(null);
    var _$ref7 = (0,ssrStore/* useSSRSelector */.kF)(function(state) {
        return {
            storeData: state.storeReducer.store,
            categories: state.catalogReducer.categories,
            collections: state.catalogReducer.collections,
            productTags: state.catalogReducer.productTags
        };
    }), storeData = _$ref7.storeData, categories = _$ref7.categories, productTags = _$ref7.productTags, collections = _$ref7.collections;
    var isShopDropDownEnable = (0,useIsShopDropDownEnable/* default */.Z)();
    var _$ref8 = (0,react.useState)(false), showMegaMenuMobile = _$ref8[0], setShowMegaMenuMobile = _$ref8[1];
    var _$ref9 = (0,react.useState)(false), setOpenCollections = _$ref9[1];
    var _$ref10 = (0,react.useState)(false), openShop = _$ref10[0], setOpenShop = _$ref10[1];
    var toggleMegaMenuMobile = function(bool) {
        return setShowMegaMenuMobile(bool !== null && bool !== void 0 ? bool : !showMegaMenuMobile);
    };
    var onShopClick = function(page) {
        if (document.querySelector("#CollectionCategoryProductWidget")) {
            document.querySelector("#CollectionCategoryProductWidget").scrollIntoView();
        } else {
        // router.push(getRoute(PATH.PRODUCT, storeData?.store_info?.domain));
        }
    };
    var handleShopClick = function(page, dropdownNav) {
        if ((0,showMegaMenu/* showMegaMenu */.G)()) {
            checkClientDeviceType/* IS_DESKTOP */.yn && !showMegaMenuMobileOnDesktopDrawer ? setOpenMegaMenu(function(prevState) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prevState), {
                    desktop: !prevState.desktop
                });
            }) : setShowMegaMenuMobile(function(v) {
                return !v;
            });
            return;
        }
        if (collections === null || collections === void 0 ? void 0 : collections.length) {
            if (dropdownNav) {
                setOpenCollections(true);
                setOpenShop(function(v) {
                    return !v;
                });
            } else {
                onShopClick(page);
            }
        } else {
            onShopClick(page);
            setOpenShop(function(v) {
                return !v;
            });
        }
    };
    // const onCategoriesLinkHandle = (category) => {
    //   router.push(getCategoryLink(category), undefined, { shallow: true });
    //   toggleMegaMenuMobile(false);
    // };
    var height = (((_$ref2 = shopCompRef.current) === null || _$ref2 === void 0 ? void 0 : _$ref2.getBoundingClientRect()) || {}).height;
    var textColor = (props === null || props === void 0 ? void 0 : (_$ref3 = props.style) === null || _$ref3 === void 0 ? void 0 : _$ref3.color) || "#000000";
    var renderDropdownNav = function() {
        var _$ref;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ClickAwayListener/* ClickAwayListener */.d, {
            onClickAway: function() {
                return setOpenShop(false);
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    top: !props.fromMobileMenuDrawer && "".concat(height + 6, "px")
                },
                className: !props.fromMobileMenuDrawer ? classnames_default()("tw-relative tw-p-[20px] ", (shopComponent_module_default())["cfe-dropdown-nav"]) : "tw-max-h-[220px] tw-overflow-y-auto tw-p-0 [&>div>p]:tw-text-[13px] [&>div>p]:tw-font-semibold [&>div>p]:tw-text-newBlack [&>div]:!tw-border-l-0 [&>div]:!tw-pl-0",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: !props.fromMobileMenuDrawer ? classnames_default()((shopComponent_module_default())["cfe-dropdown-nav__items"], "tw-max-h-[222px]") : "tw-mt-[22.5px]",
                    children: (_$ref = (0,_to_consumable_array/* default */.Z)(productTags).concat((0,_to_consumable_array/* default */.Z)(categories))) === null || _$ref === void 0 ? void 0 : _$ref.map(function(category, idx, renderArray) {
                        /*#__PURE__*/ return (0,jsx_runtime.jsx)(CommonLinkWrapper/* default */.Z, {
                            onClick: function() {
                                return closeParentContainer === null || closeParentContainer === void 0 ? void 0 : closeParentContainer();
                            },
                            link: getCategoryLink(category),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "tw-select-none tw-text-newBlack " + (!props.fromMobileMenuDrawer ? "tw-m-0 tw-text-[12px] tw-font-semibold tw-tracking-[0.8px] " + (idx !== renderArray.length - 1 ? "tw-pb-[16px]" : "") : "tw-m-0  " + (idx !== renderArray.length - 1 ? "tw-pb-[17.5px]" : "")),
                                children: (0,emoticonsStatus/* removeEmoticons */._)(category.name) || "Available Items"
                            }, category.id)
                        }, category.id);
                    })
                })
            })
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
        className: "relative " + (baseClass || "menu-item"),
        style: {
            borderColor: (_$ref4 = props.style) === null || _$ref4 === void 0 ? void 0 : _$ref4.borderColor
        },
        ref: ref,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                ref: shopCompRef,
                className: "flex items-center justify-between " + (showMegaMenuMobile && "tw-mb-[20px]"),
                onClick: function() {
                    return handleShopClick(page, isShopDropDownEnable);
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center",
                        children: [
                            props.showIcon && showHeaderIcon ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mr3",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SupermarketIcon/* SupermarketIcon */.N, {
                                    color: (storeData === null || storeData === void 0 ? void 0 : (_$ref5 = storeData.theme) === null || _$ref5 === void 0 ? void 0 : (_$ref6 = _$ref5.colors) === null || _$ref6 === void 0 ? void 0 : _$ref6.primary_color) !== "#ffffff" ? "#000000" : "#ffffff",
                                    width: 16,
                                    height: 16
                                })
                            }) : null,
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CommonNavbarText/* default */.Z, {
                                classes: props.customItemClasses,
                                bgColor: headerBgColor,
                                page: page,
                                class: "nav-name",
                                style: props.style || {}
                            })
                        ]
                    }),
                    isShopDropDownEnable ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "items-center tw-ml-[2px] tw-flex ",
                        children: openShop || showMegaMenuMobile || showMegaMenuDesktop ? /*#__PURE__*/ (0,jsx_runtime.jsx)(svgIcons/* AccordionCloseIcon */.x$, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(svgIcons/* AccordionOpenIcon */.Be, {})
                    }) : null
                ]
            }),
            showMegaMenuMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(MegaMenuMobileView, {
                open: showMegaMenuMobile,
                onClose: function() {
                    var _$ref;
                    toggleMegaMenuMobile(false);
                    (_$ref = props.closeParentContainer) === null || _$ref === void 0 ? void 0 : _$ref.call(props);
                },
                collectionItemWrapperClass: "tw-mb-[20px] [&.collectionName]:!tw-font-medium",
                primaryColor: background,
                secondaryColor: textColor
            }),
            !!isShopDropDownEnable && openShop && renderDropdownNav()
        ]
    }, page === null || page === void 0 ? void 0 : page.page_id);
});
/* harmony default export */ var ShopComponent_ShopComponent = (ShopComponent);

;// CONCATENATED MODULE: ./src/components/DesignSystem/Headers/ShopComponent/index.js



/***/ }),

/***/ 993080:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": function() { return /* binding */ btnActionHandler; }
/* harmony export */ });
/* harmony import */ var _components_WidgetMaker_WidgetsComponents_CMSConstants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(567306);

var redirectToNewLink = function(link, newTab) {
    if (!link) return;
    if (newTab) {
        window.open(link, "_blank");
    } else {
        window.location.href = link;
    }
};
var downloadButton = function(link) {
    if (!link) return;
    var downloadLink = document.createElement("a");
    downloadLink.href = "".concat(link, "?download=true");
    downloadLink.target = "_blank";
    downloadLink.rel = "noopener noreferrer";
    downloadLink.download = "file";
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
};
var scrollToElement = function(id) {
    if (!id) return;
    var elementContainer = document.getElementById(id);
    if (elementContainer) {
        window.scrollTo({
            behavior: "smooth",
            top: elementContainer.getBoundingClientRect().top - document.body.getBoundingClientRect().top - 5
        });
    }
};
var renderFormComponent = function(handler, callback) {
    callback && callback();
};
var btnActionHandler = function(param) {
    var type = param.type, handler = param.handler, newTab = param.newTab, callback = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : function() {};
    switch(type){
        case 1:
        case _components_WidgetMaker_WidgetsComponents_CMSConstants__WEBPACK_IMPORTED_MODULE_0__/* .REDIRECTION_TYPES.link */ .Qf.link:
            redirectToNewLink(handler, newTab);
            break;
        case 2:
            renderFormComponent(handler, callback);
            break;
        case 3:
        case _components_WidgetMaker_WidgetsComponents_CMSConstants__WEBPACK_IMPORTED_MODULE_0__/* .REDIRECTION_TYPES.scrollto */ .Qf.scrollto:
            scrollToElement(handler);
            break;
        case 4:
            downloadButton(handler);
            break;
        case 5:
            return;
    }
};


/***/ }),

/***/ 852746:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ProductItem; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(785893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(667294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(225617);
/* harmony import */ var _utils_deviceWidth__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(186812);
/* harmony import */ var _AtomicComponents_CartButton__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(891815);
/* harmony import */ var _utils_getStoreType__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(66871);
/* harmony import */ var _redux_actions__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(467936);
/* harmony import */ var _redux_actions__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(666162);
/* harmony import */ var _redux_actions__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(731024);
/* harmony import */ var _redux_actions__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(96031);
/* harmony import */ var _utils_routes__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(540190);
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(913886);
/* harmony import */ var _utils_mutateItemObjectWithCartData__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(822787);
/* harmony import */ var _utils_mutateVariantItemWithCartData__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(759186);
/* harmony import */ var _utils_getDiscountPercentage__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(153716);
/* harmony import */ var _redux_ssrStore__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(326706);
/* harmony import */ var _hooks_useCartHandler__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(491240);
/* harmony import */ var src_utils_productUtils__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(236913);
/**
 * Product Items
 */ 














function ProductItem(props) {
    var ref = props.data || {}, name = ref.name, price = ref.price, image_url = ref.image_url, discounted_price = ref.discounted_price, id = ref.id, quantity = ref.quantity, available = ref.available, item_schedule = ref.item_schedule;
    var ref1 = (0,_hooks_useCartHandler__WEBPACK_IMPORTED_MODULE_11__/* .useCartHandlers */ .u)(), handleSetProductData = ref1.handleSetProductData, handleIncreamentClick = ref1.handleIncreamentClick, handleDecreamentClick = ref1.handleDecreamentClick, handleSetProductCustomizationCount = ref1.handleSetProductCustomizationCount;
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0), discountPercent = ref2[0], setDiscountPercent = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), listDiscriptionExpanded = ref3[0], setlistDiscriptionExpanded = ref3[1];
    var ref4 = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function(state) {
        return {
            userData: state.userReducer,
            cartData: state.cartReducer
        };
    }), userData = ref4.userData, cartData = ref4.cartData;
    var ref5 = (0,_redux_ssrStore__WEBPACK_IMPORTED_MODULE_10__/* .useSSRSelector */ .kF)(function(state) {
        var ref;
        var storeData = state.storeReducer.store;
        return {
            storeData: storeData,
            oosStatus: storeData === null || storeData === void 0 ? void 0 : (ref = storeData.services) === null || ref === void 0 ? void 0 : ref.hide_out_of_stock
        };
    }), storeData = ref5.storeData, oosStatus = ref5.oosStatus;
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useDispatch */ .I0)();
    var isB2bStore = (0,_utils_getStoreType__WEBPACK_IMPORTED_MODULE_5__/* .getStoreType */ .K)(storeData) === _utils_constants__WEBPACK_IMPORTED_MODULE_7__/* .STORE_CUSTOMIZATION.B2B */ .DO.B2B;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var percent = (0,_utils_getDiscountPercentage__WEBPACK_IMPORTED_MODULE_13__/* .getDiscountPercentage */ .$)(price, discounted_price);
        setDiscountPercent(percent ? percent : 0);
    }, []);
    var toggleListItemDiscription = function() {
        setlistDiscriptionExpanded(!listDiscriptionExpanded);
    };
    var handleAddRemoveItem = function(type) {
        var ref, ref1, ref2;
        dispatch((0,_redux_actions__WEBPACK_IMPORTED_MODULE_14__/* .pushEventsLog */ .U)({
            event_name: "Cx_ATC",
            data: {
                store_id: storeData === null || storeData === void 0 ? void 0 : storeData.store_id,
                domain: storeData === null || storeData === void 0 ? void 0 : (ref = storeData.store_info) === null || ref === void 0 ? void 0 : ref.domain,
                page: window.location.href,
                device: _utils_deviceWidth__WEBPACK_IMPORTED_MODULE_3__/* .deviceWidth */ .o <= _utils_constants__WEBPACK_IMPORTED_MODULE_7__/* .MAX_MOBILE_WIDTH */ .Cf ? "Mobile" : "Desktop",
                cx_number: userData === null || userData === void 0 ? void 0 : (ref1 = userData.data) === null || ref1 === void 0 ? void 0 : ref1.phone
            }
        }));
        if (props.isCartItem && props.variant) {
            var newCart = (0,_utils_mutateVariantItemWithCartData__WEBPACK_IMPORTED_MODULE_9__/* .mutateVariantItemWithCartData */ .I)(type, props.data, props.variant, cartData);
            dispatch((0,_redux_actions__WEBPACK_IMPORTED_MODULE_15__/* .saveCart */ .FP)(newCart));
            return;
        }
        /** Check if variant present in this item */ if (((ref2 = props.data) === null || ref2 === void 0 ? void 0 : ref2.variants_count) > 0) {
            var ref3;
            dispatch((0,_redux_actions__WEBPACK_IMPORTED_MODULE_16__/* .saveProductLoaderId */ .XG)((ref3 = props.data) === null || ref3 === void 0 ? void 0 : ref3.id));
            /** find the item index in cart */ var itemIdxInCart = cartData.items.findIndex(function(el) {
                var ref;
                return el.id === ((ref = props.data) === null || ref === void 0 ? void 0 : ref.id);
            });
            /** check if item exist in cart */ if (itemIdxInCart !== -1) {
                switch(type){
                    case "inc":
                        dispatch((0,_redux_actions__WEBPACK_IMPORTED_MODULE_16__/* .setVariantModalVisibility */ .VZ)(true));
                        break;
                    case "dec":
                        dispatch((0,_redux_actions__WEBPACK_IMPORTED_MODULE_16__/* .setSelectedVariantModalVisibility */ .rV)(true));
                        break;
                }
            } else {
                var ref4;
                /** get the details item for this item id */ dispatch((0,_redux_actions__WEBPACK_IMPORTED_MODULE_17__/* .fetchCatalogItemById */ .eP)({
                    store_id: storeData.store_id,
                    item_id: (ref4 = props.data) === null || ref4 === void 0 ? void 0 : ref4.id,
                    src: "design_system_product_item"
                }, true, function(data) {
                    handleSetProductData(data);
                }));
            }
        } else {
            var ref5;
            if (props === null || props === void 0 ? void 0 : (ref5 = props.data) === null || ref5 === void 0 ? void 0 : ref5.product_personalization) {
                handleSetProductCustomizationCount(props === null || props === void 0 ? void 0 : props.data);
                handleSetProductData(props === null || props === void 0 ? void 0 : props.data);
                dispatch((0,_redux_actions__WEBPACK_IMPORTED_MODULE_17__/* .savePDPData */ .zP)(props === null || props === void 0 ? void 0 : props.data));
                switch(type){
                    case "add":
                        dispatch((0,_redux_actions__WEBPACK_IMPORTED_MODULE_17__/* .openProductPersonalizationPopUp */ .w4)());
                        break;
                    case "inc":
                        handleIncreamentClick(type, props === null || props === void 0 ? void 0 : props.data);
                        break;
                    case "dec":
                        handleDecreamentClick(type, props === null || props === void 0 ? void 0 : props.data);
                        break;
                    default:
                        break;
                }
            } else {
                var newState = (0,_utils_mutateItemObjectWithCartData__WEBPACK_IMPORTED_MODULE_8__/* .mutateItemObjectWithCartData */ .L)(type, props.data, cartData);
                dispatch((0,_redux_actions__WEBPACK_IMPORTED_MODULE_15__/* .saveCart */ .FP)(newState));
            }
        }
    };
    var renderName = function() {
        var ref, ref1;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
            style: {
                textDecoration: "none"
            },
            className: "".concat(props.isCardType ? "item-name" : "item-name-list mt0", " ph2"),
            href: (0,_utils_routes__WEBPACK_IMPORTED_MODULE_6__.getRoute)((0,src_utils_productUtils__WEBPACK_IMPORTED_MODULE_12__/* .getProductPathFromUrl */ .ts)((ref = props.data) === null || ref === void 0 ? void 0 : ref.link, false), storeData === null || storeData === void 0 ? void 0 : (ref1 = storeData.store_info) === null || ref1 === void 0 ? void 0 : ref1.domain),
            children: name
        });
    };
    var renderProductImage = function() {
        var ref;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "catalog-tem-img relative",
            onClick: function() {
                props.onItemClick && props.onItemClick();
            },
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                    src: "https://cdn.dotpe.in/longtail/themes/8073865/sPxbqDuh.webp",
                    className: "info-icon",
                    alt: "info icon"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                    src: image_url ? image_url : "https://cdn.dotpe.in/longtail/themes/8073865/O2QSeO0R.webp",
                    alt: "catalog item Image",
                    className: "image",
                    loading: "lazy"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "discountInfo-chip",
                    children: ((ref = props.data) === null || ref === void 0 ? void 0 : ref.available) !== 0 && discountPercent !== 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                        children: [
                            discountPercent,
                            "% Off"
                        ]
                    })
                })
            ]
        });
    };
    var renderProductPrice = function() {
        if (isB2bStore) {
            var ref, ref1;
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: "discounted-price",
                children: (props === null || props === void 0 ? void 0 : (ref = props.data) === null || ref === void 0 ? void 0 : (ref1 = ref.b2b_pricing_info) === null || ref1 === void 0 ? void 0 : ref1.price_range) || "Price on Request"
            });
        }
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "price",
            children: [
                discounted_price < price ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                            className: "discounted-price",
                            children: [
                                "₹",
                                renderDiscountPrice()
                            ]
                        }),
                        " ",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                            className: "amount-price",
                            children: [
                                " ",
                                "₹",
                                renderNormalPrice()
                            ]
                        })
                    ]
                }) : "₹".concat(renderNormalPrice()),
                " ",
                !props.isCardType && discountPercent > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                    className: "percent-off",
                    children: [
                        discountPercent,
                        "% Off"
                    ]
                })
            ]
        });
    };
    var renderDiscountPrice = function() {
        return props.isCartItem ? discounted_price * (quantity || 1) : discounted_price;
    };
    var renderNormalPrice = function() {
        return props.isCartItem ? price * (quantity || 1) : price;
    };
    var renderATCButton = function() {
        var ref;
        if (isB2bStore) return null;
        var itemIndexInCart = cartData.items.findIndex(function(el) {
            return (el.id || el.item_id) === id;
        });
        if ((storeData === null || storeData === void 0 ? void 0 : (ref = storeData.services) === null || ref === void 0 ? void 0 : ref.store_flag) === 0) return null;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_AtomicComponents_CartButton__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
            productItem: cartData.items[itemIndexInCart],
            quantity: itemIndexInCart >= 0 ? cartData.items[itemIndexInCart].quantity : 0,
            onChange: function(change) {
                return handleAddRemoveItem(change);
            },
            fontSize: 14,
            hasScheduler: !!item_schedule
        });
    };
    var renderImageItem = function() {
        var ref, ref1;
        /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "top-wrap",
                    children: [
                        renderProductImage(),
                        renderName()
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "bottom-wrap with-image-item",
                    children: available === 1 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex justify-between items-center ph2",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "left-wrap",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    children: renderProductPrice()
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "right-wrap ",
                                children: [
                                    renderATCButton(),
                                    ((ref = props.data) === null || ref === void 0 ? void 0 : ref.variants_count) > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "variant--count-icontext",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                src: "https://cdn.dotpe.in/longtail/themes/8073865/FcwGogkZ.webp"
                                            }),
                                            (ref1 = props.data) === null || ref1 === void 0 ? void 0 : ref1.variants_count,
                                            " options"
                                        ]
                                    })
                                ]
                            })
                        ]
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "flex justify-center items-center ph2 black-50 fw6 f7 pv2",
                        children: "Out Of Stock"
                    })
                })
            ]
        });
    };
    var productItemImage = function() {
        var ref, ref1;
        /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "item-image",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                src: ((ref = props.data) === null || ref === void 0 ? void 0 : ref.thumbnail_url) || ((ref1 = props.data) === null || ref1 === void 0 ? void 0 : ref1.image_url),
                alt: name
            })
        });
    };
    var renderSearchItem = function() {
        var ref, ref1;
        /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "bottom-wrap without-image-item flex justify-between",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "w-70 flex flex-column justify-between",
                    style: {
                        borderBottom: "1px dashed #bfbfbf"
                    },
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            children: [
                                renderName(),
                                renderItemDescription()
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "pb3 pl2",
                            children: renderProductPrice()
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "right-wrap relative",
                    children: [
                        productItemImage(),
                        available === 1 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "btn-comp",
                            children: [
                                renderATCButton(),
                                ((ref = props.data) === null || ref === void 0 ? void 0 : ref.variants_count) > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "variant--count-icontext",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                            src: "https://cdn.dotpe.in/longtail/themes/8073865/FcwGogkZ.webp"
                                        }),
                                        (ref1 = props.data) === null || ref1 === void 0 ? void 0 : ref1.variants_count,
                                        " options"
                                    ]
                                })
                            ]
                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "flex justify-center items-end ph2 black-50 fw6 f7 pb3 pt1",
                            children: "Out Of Stock"
                        })
                    ]
                })
            ]
        });
    };
    var renderItemDescription = function() {
        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8;
        var availableClass = ((ref = props.data) === null || ref === void 0 ? void 0 : ref.available) ? "" : " outofstock";
        return ((ref1 = props.data) === null || ref1 === void 0 ? void 0 : ref1.available) !== 0 && ((ref2 = props.data) === null || ref2 === void 0 ? void 0 : ref2.description) !== "" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "catalog-item-description".concat(availableClass),
            onClick: toggleListItemDiscription,
            children: !listDiscriptionExpanded && ((ref3 = props.data) === null || ref3 === void 0 ? void 0 : ref3.description) && ((ref4 = props.data) === null || ref4 === void 0 ? void 0 : ref4.description.length) > 60 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "catalog-item-description-text".concat(availableClass),
                children: [
                    (ref5 = props.data) === null || ref5 === void 0 ? void 0 : ref5.description.substr(0, 56),
                    "...",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "pointer catalog-item-description-readmore".concat(availableClass),
                        style: {
                            color: storeData === null || storeData === void 0 ? void 0 : (ref6 = storeData.theme) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.colors) === null || ref7 === void 0 ? void 0 : ref7.primary_color
                        },
                        children: "Read More+"
                    })
                ]
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "catalog-item-description-text".concat(availableClass),
                children: (ref8 = props.data) === null || ref8 === void 0 ? void 0 : ref8.description
            })
        }) : null;
    };
    return !available && oosStatus ? null : props.isDesktop ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("article", {
        className: "product-item-desktop",
        children: [
            image_url && props.isCartItem === false && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "product-image",
                style: {
                    backgroundImage: "url(".concat(image_url, ")"),
                    backgroundSize: "cover"
                },
                onClick: function() {
                    props.onItemClick && props.onItemClick();
                },
                children: [
                    discountPercent !== 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                        children: [
                            discountPercent,
                            "% Off"
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        src: "https://cdn.dotpe.in/longtail/themes/8073865/sPxbqDuh.webp",
                        alt: "info icon"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "product-info ".concat(available === 0 && "o-50"),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "product-info__name",
                        children: name
                    }),
                    props.isCartItem === false && renderItemDescription(),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "product-info__options",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                children: renderProductPrice()
                            }),
                            available === 1 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                children: renderATCButton()
                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "flex justify-center items-center ph2 black-50 fw6 f7 pv2",
                                children: "Out Of Stock"
                            })
                        ]
                    })
                ]
            })
        ]
    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "product-item".concat(props.isCardType ? " card-type" : "").concat(available === 0 ? " o-60" : "").concat(props.isCartItem ? " product-cart-type" : ""),
        children: props.isCartItem ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "left-wrap",
                    children: [
                        renderName(),
                        renderProductPrice()
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "right-wrap",
                    children: renderATCButton()
                })
            ]
        }) : props.isCardType ? // render cards
        renderImageItem() : // render search
        renderSearchItem()
    });
}


/***/ }),

/***/ 658619:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Cr": function() { return /* binding */ getHeight; },
/* harmony export */   "Tk": function() { return /* binding */ getButtonVariantsData; },
/* harmony export */   "Tm": function() { return /* binding */ getTextLineHeightBuilder; },
/* harmony export */   "X1": function() { return /* binding */ getBannerAnimationClass; },
/* harmony export */   "YG": function() { return /* binding */ getBannerImages; },
/* harmony export */   "ej": function() { return /* binding */ useUpgradeEditorBannerSelection; },
/* harmony export */   "ik": function() { return /* binding */ getBannerContainerStyles; },
/* harmony export */   "jN": function() { return /* binding */ getTopMarginByAnnouncement; },
/* harmony export */   "n3": function() { return /* binding */ getAspectRatio; },
/* harmony export */   "oF": function() { return /* binding */ WithLink; },
/* harmony export */   "pQ": function() { return /* binding */ useGetAlignments; },
/* harmony export */   "ry": function() { return /* binding */ DEFAULT_WIDGET_OPTIONS; },
/* harmony export */   "w_": function() { return /* binding */ useWindowResize; },
/* harmony export */   "yJ": function() { return /* binding */ BASE_WIDTH_FOR_ASPECT_RATIO; }
/* harmony export */ });
/* unused harmony exports sliderSettings, decodeAspectRatio, getInnerWidth, filterImages, StoreName */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(626042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(269396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(785893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(667294);
/* harmony import */ var tailwind_merge__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(798388);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(583060);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _context_WidgetDndContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(474151);
/* harmony import */ var src_utils_checkRenderEnv__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(506337);
/* harmony import */ var src_components_WidgetMaker_utils_buttonConstant__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(291850);
/* harmony import */ var _components_DesignSystem_AtomicDesignsUtilities_ContentAnimationStyles_module_scss__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(489429);
/* harmony import */ var _components_DesignSystem_AtomicDesignsUtilities_ContentAnimationStyles_module_scss__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(_components_DesignSystem_AtomicDesignsUtilities_ContentAnimationStyles_module_scss__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var src_constants_widgets__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(442381);
/* harmony import */ var src_components_WidgetMaker_WidgetDnD_WidgetProperties_HeaderBuilder_AnnouncementConfig__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(295817);
/* harmony import */ var _ListPresentation_components_utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(203310);
/* harmony import */ var src_components_WidgetMaker_WidgetDnD_WidgetProperties_NewAnnouncementBar_Constants__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(889489);














var BASE_WIDTH_FOR_ASPECT_RATIO = {
    desktop: 1366,
    mobile: 360
};
var DEFAULT_WIDGET_OPTIONS = {
    aspectRatio: "",
    aspectRatioMobile: "",
    autoplaySpeed: 5000,
    hideLogo: false,
    hideStoreName: false,
    showDescription: false,
    links: [],
    marginTop: 0,
    marginBottom: 0
};
var sliderSettings = {
    arrows: false,
    dots: true,
    infinite: true,
    speed: 800,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    pauseOnHover: false,
    autoplaySpeed: 3000,
    dotsClass: "herobanner_slider--icons"
};
var decodeAspectRatio = function(aspectRatio) {
    var splittedAR = aspectRatio ? (aspectRatio === null || aspectRatio === void 0 ? void 0 : aspectRatio.split(" / ")[0]) !== aspectRatio ? aspectRatio === null || aspectRatio === void 0 ? void 0 : aspectRatio.split(" / ") : aspectRatio === null || aspectRatio === void 0 ? void 0 : aspectRatio.split("/") : null;
    var width = +(splittedAR === null || splittedAR === void 0 ? void 0 : splittedAR[0]);
    var height = +(splittedAR === null || splittedAR === void 0 ? void 0 : splittedAR[1]);
    return {
        width: !Number.isNaN(width) ? width : 0,
        height: !Number.isNaN(height) ? height : 0
    };
};
var getInnerWidth = function() {
    var innerWidth = 0;
    if (src_utils_checkRenderEnv__WEBPACK_IMPORTED_MODULE_3__/* .IS_SERVER */ .W6) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        // const userAgent = useSSRSelector((state) => state.commonReducer.userAgent);
        // const isInitialRequestByMobile = isMobileByUA(userAgent);
        // innerWidth = isInitialRequestByMobile ? 719 : 721;
        innerWidth = 0;
    } else {
        innerWidth = window === null || window === void 0 ? void 0 : window.innerWidth;
    }
    return innerWidth;
};
var filterImages = function(widgetOptions, oldBannerImages, isDesktop, isBuilder) {
    // const innerWidth = getInnerWidth();
    var filteredImages = [];
    if (isDesktop) {
        var newBannerImages = widgetOptions === null || widgetOptions === void 0 ? void 0 : widgetOptions.images;
        if (newBannerImages === null || newBannerImages === void 0 ? void 0 : newBannerImages.length) {
            var ref;
            // filteredImages = widgetOptions.images.map((image) => ({ image_url: image.src }));
            filteredImages = (ref = widgetOptions.images) === null || ref === void 0 ? void 0 : ref.filter(function(img) {
                return !!img && img.is_visible !== false;
            });
        } else {
            filteredImages = oldBannerImages.filter(function(img) {
                return img && img.is_desktop && (isBuilder || img.is_visible !== false);
            }).sort(function(a, b) {
                return a.order - b.order;
            });
        }
    } else {
        var newBannerImages1 = widgetOptions.imagesMobile;
        if (newBannerImages1 === null || newBannerImages1 === void 0 ? void 0 : newBannerImages1.length) {
            var ref1;
            // filteredImages = widgetOptions.imagesMobile.map((image) => ({
            //   image_url: image.src,
            // }));
            filteredImages = (ref1 = widgetOptions.imagesMobile) === null || ref1 === void 0 ? void 0 : ref1.filter(function(img) {
                return img && (isBuilder || img.is_visible !== false);
            });
        } else {
            filteredImages = oldBannerImages.filter(function(img) {
                return img && !img.is_desktop && (isBuilder || img.is_visible !== false);
            }).sort(function(a, b) {
                return a.order - b.order;
            });
        }
    }
    return filteredImages;
};
var getHeight = function(widgetOptions, availableWidth, isNewCarousel) {
    var isMobile = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : undefined;
    var innerWidth = getInnerWidth();
    availableWidth = availableWidth || innerWidth;
    var shouldRenderDesktop = typeof isMobile === "boolean" && !isMobile;
    var height = "auto";
    if (availableWidth > 720 || shouldRenderDesktop) {
        var ref, ref1, ref2;
        var ref3 = decodeAspectRatio(widgetOptions === null || widgetOptions === void 0 ? void 0 : widgetOptions.aspectRatio), bannerWidthRatio = ref3.width, bannerHeightRatio = ref3.height;
        var defaultHeight = ((ref = widgetOptions.height) === null || ref === void 0 ? void 0 : (ref1 = ref.includes) === null || ref1 === void 0 ? void 0 : ref1.call(ref, "px")) ? (ref2 = widgetOptions.height) === null || ref2 === void 0 ? void 0 : ref2.split("px")[0] : widgetOptions.height;
        height = isNewCarousel && bannerHeightRatio && bannerWidthRatio ? "".concat(availableWidth / bannerWidthRatio * bannerHeightRatio, "px") : "".concat(defaultHeight ? "".concat(defaultHeight, "px") : bannerHeightRatio ? "".concat(availableWidth * bannerHeightRatio / bannerWidthRatio, "px") : "100vh");
    } else {
        var ref4, ref5, ref6;
        var ref7 = decodeAspectRatio(widgetOptions === null || widgetOptions === void 0 ? void 0 : widgetOptions.aspectRatioMobile), bannerWidthRatio1 = ref7.width, bannerHeightRatio1 = ref7.height;
        var defaultHeight1 = ((ref4 = widgetOptions.heightMobile) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.includes) === null || ref5 === void 0 ? void 0 : ref5.call(ref4, "px")) ? (ref6 = widgetOptions.heightMobile) === null || ref6 === void 0 ? void 0 : ref6.split("px")[0] : widgetOptions.heightMobile;
        height = isNewCarousel && bannerHeightRatio1 && bannerWidthRatio1 ? "".concat(availableWidth * bannerHeightRatio1 / bannerWidthRatio1, "px") : "".concat(defaultHeight1 ? "".concat(defaultHeight1, "px") : bannerHeightRatio1 ? "".concat(availableWidth * bannerHeightRatio1 / bannerWidthRatio1, "px") : "100vh");
    }
    return height;
};
var getAspectRatio = function(widgetOptions, availableWidth) {
    var innerWidth = getInnerWidth();
    availableWidth = availableWidth || innerWidth;
    var aspectRatio = "";
    if (availableWidth > 720) {
        // aspectRatio = widgetOptions.height ? 'unset' : widgetOptions.aspectRatio;
        aspectRatio = widgetOptions === null || widgetOptions === void 0 ? void 0 : widgetOptions.aspectRatio;
    } else {
        // aspectRatio = widgetOptions.heightMobile
        //   ? 'unset'
        //   : widgetOptions.aspectRatioMobile || widgetOptions.aspectRatio || aspectRatio;
        aspectRatio = widgetOptions === null || widgetOptions === void 0 ? void 0 : widgetOptions.aspectRatioMobile;
    }
    return aspectRatio;
};
var StoreName = function(props) {
    var ref, ref1, ref2;
    var widgetOptions = props.widgetOptions;
    if (widgetOptions.hideLogo && widgetOptions.hideStoreName && !widgetOptions.showDescription) {
        return null;
    }
    return /*#__PURE__*/ _jsxs("div", {
        className: "storeName-container",
        children: [
            !props.widgetOptions.hideLogo && /*#__PURE__*/ _jsx("div", {
                className: "storeName-image-container",
                children: /*#__PURE__*/ _jsx("img", {
                    alt: "Store logo",
                    src: props === null || props === void 0 ? void 0 : (ref = props.store) === null || ref === void 0 ? void 0 : ref.logo_image
                })
            }),
            !props.widgetOptions.hideStoreName && /*#__PURE__*/ _jsx("h2", {
                className: "storeName-name",
                children: (ref1 = props.store) === null || ref1 === void 0 ? void 0 : ref1.store_name
            }),
            props.widgetOptions.showDescription && /*#__PURE__*/ _jsx("p", {
                className: "storeName-description",
                children: (ref2 = props.store) === null || ref2 === void 0 ? void 0 : ref2.description
            })
        ]
    });
};
var WithLink = function(props) {
    if (props.redirectLink) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
            href: props.redirectLink,
            className: props.className,
            children: props.children
        });
    } else {
        return props.children;
    }
};
var getButtonVariantsData = function(buttonData) {
    var useDefaultStyles = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
    return {
        solid: {
            variant: src_components_WidgetMaker_utils_buttonConstant__WEBPACK_IMPORTED_MODULE_4__/* .BUTTON_VARIANT.SECONDARY */ .RN.SECONDARY,
            customClasses: " tw-w-[200px] ".concat(!(buttonData === null || buttonData === void 0 ? void 0 : (ref = buttonData.btnStyleConfig) === null || ref === void 0 ? void 0 : ref.textColor) ? "!tw-text-[#111C36]" : "", "\n       ").concat(!(buttonData === null || buttonData === void 0 ? void 0 : (ref1 = buttonData.btnStyleConfig) === null || ref1 === void 0 ? void 0 : ref1.backgroundColor) ? "!tw-bg-[#ffffff]" : "", " ").concat(useDefaultStyles ? "!tw-py-[18px]" : "", " ")
        },
        outline: {
            variant: src_components_WidgetMaker_utils_buttonConstant__WEBPACK_IMPORTED_MODULE_4__/* .BUTTON_VARIANT.SECONDARY */ .RN.SECONDARY,
            customClasses: " tw-w-[200px] ".concat(!(buttonData === null || buttonData === void 0 ? void 0 : (ref2 = buttonData.btnStyleConfig) === null || ref2 === void 0 ? void 0 : ref2.textColor) ? "!tw-text-[#ffffff]" : "", " ").concat(useDefaultStyles ? "!tw-py-[18px]" : "", " \n    ").concat(!(buttonData === null || buttonData === void 0 ? void 0 : (ref3 = buttonData.btnStyleConfig) === null || ref3 === void 0 ? void 0 : ref3.backgroundColor) ? "!tw-bg-[#0000001a] " : "", " ").concat(!(buttonData === null || buttonData === void 0 ? void 0 : (ref4 = buttonData.btnStyleConfig) === null || ref4 === void 0 ? void 0 : ref4.backgroundColor) ? "!tw-border-[#ffffff]" : "", " "),
            animationColor: " ".concat((buttonData === null || buttonData === void 0 ? void 0 : (ref5 = buttonData.buttonAnimationConfig) === null || ref5 === void 0 ? void 0 : ref5.classKey) && !((ref7 = buttonData === null || buttonData === void 0 ? void 0 : (ref6 = buttonData.buttonAnimationConfig) === null || ref6 === void 0 ? void 0 : ref6.classKey.toLowerCase()) === null || ref7 === void 0 ? void 0 : ref7.includes("move")) ? " hover:!tw-text-newBlack !tw-transition-[color] " : "", " ")
        },
        textual: {
            variant: src_components_WidgetMaker_utils_buttonConstant__WEBPACK_IMPORTED_MODULE_4__/* .BUTTON_VARIANT.TERTIARY */ .RN.TERTIARY,
            customClasses: (0,tailwind_merge__WEBPACK_IMPORTED_MODULE_9__/* .twMerge */ .m6)((_styles_module_scss__WEBPACK_IMPORTED_MODULE_10___default().tertiaryBtnCustomStyle)),
            animationColor: " !tw-py-0 tw-w-auto  !tw-text-[#ffffff] " + (buttonData === null || buttonData === void 0 ? void 0 : (ref8 = buttonData.btnStyleConfig) === null || ref8 === void 0 ? void 0 : ref8.textColor) ? "" : 0
        }
    };
};
var useUpgradeEditorBannerSelection = function(param) {
    var activeSlide2 = param.activeSlide2, setActiveSlide2 = param.setActiveSlide2, id = param.id, sliderRef = param.sliderRef, widgetOptions = param.widgetOptions, isBuilderChevronEnabled = param.isBuilderChevronEnabled;
    var ref = (0,_context_WidgetDndContext__WEBPACK_IMPORTED_MODULE_2__/* .useWidgetDndContextData */ .KX)(), _widgetContextState = ref.widgetContextState, widgets = _widgetContextState.widgets, widgetSettingsSectionState = _widgetContextState.widgetSettingsSectionState, activeWidgetId = _widgetContextState.activeWidgetId, setWidgetSettingsSectionState = ref.widgetContextActions.setWidgetSettingsSectionState;
    var selectedBannerEditor = widgetSettingsSectionState.singleBannerSettings;
    var activeWidget = widgets === null || widgets === void 0 ? void 0 : widgets[id];
    var activeWidgetProps = activeWidget === null || activeWidget === void 0 ? void 0 : activeWidget.props;
    var _autoPlay;
    var allSliderSettings = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({
        afterChange: function(current) {
            return setActiveSlide2(current);
        },
        onSwipe: function onSwipe(swipeDirection) {
            var newSelectedIndex = null;
            if (swipeDirection === "left") {
                var ref;
                newSelectedIndex = activeSlide2 === 0 ? (activeWidgetProps === null || activeWidgetProps === void 0 ? void 0 : (ref = activeWidgetProps.images) === null || ref === void 0 ? void 0 : ref.length) - 1 : activeSlide2 - 1;
                upgradeEditorBannerSelection("prev", newSelectedIndex);
            } else {
                var ref1;
                newSelectedIndex = activeSlide2 === (activeWidgetProps === null || activeWidgetProps === void 0 ? void 0 : (ref1 = activeWidgetProps.images) === null || ref1 === void 0 ? void 0 : ref1.length) - 1 ? 0 : activeSlide2 + 1;
                upgradeEditorBannerSelection("next", newSelectedIndex);
            }
        }
    }, sliderSettings), {
        autoplaySpeed: widgetOptions.autoplaySpeed / 1000 < 1 ? widgetOptions.autoplaySpeed * 1000 : widgetOptions.autoplaySpeed,
        autoplay: selectedBannerEditor.show ? false : (_autoPlay = widgetOptions.autoPlay) !== null && _autoPlay !== void 0 ? _autoPlay : true,
        dots: !isBuilderChevronEnabled,
        fade: (widgetOptions === null || widgetOptions === void 0 ? void 0 : widgetOptions.bannerAnimationName) === "fadeIn",
        waitForAnimate: (widgetOptions === null || widgetOptions === void 0 ? void 0 : widgetOptions.bannerAnimationName) === "fadeIn"
    });
    var upgradeEditorBannerSelection = function(type) {
        var activeSlide = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : activeSlide2;
        var ref, ref1, ref2, ref3;
        var bannerLength = (widgets === null || widgets === void 0 ? void 0 : (ref = widgets[activeWidgetId]) === null || ref === void 0 ? void 0 : (ref1 = ref.props) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.images) === null || ref2 === void 0 ? void 0 : ref2.length) - 1;
        if (!selectedBannerEditor.show) {
            return;
        }
        var newSelectedIndex = null;
        if (type === "next") {
            var ref4;
            newSelectedIndex = activeSlide === (activeWidgetProps === null || activeWidgetProps === void 0 ? void 0 : (ref4 = activeWidgetProps.images) === null || ref4 === void 0 ? void 0 : ref4.length) - 1 ? 0 : bannerLength === activeSlide ? 0 : activeSlide + 1;
        } else {
            newSelectedIndex = activeSlide === 0 ? bannerLength : activeSlide === 0 ? bannerLength : activeSlide - 1;
        }
        setWidgetSettingsSectionState({
            singleBannerSettings: {
                show: true,
                data: {
                    bannerData: activeWidgetProps === null || activeWidgetProps === void 0 ? void 0 : (ref3 = activeWidgetProps.images) === null || ref3 === void 0 ? void 0 : ref3[newSelectedIndex],
                    bannerIndex: newSelectedIndex
                },
                heading: "Banner ".concat(newSelectedIndex + 1)
            }
        });
        setTimeout(function() {
            setActiveSlide2(newSelectedIndex);
        }, 1200);
    };
    var handlePrevClick = function() {
        var ref, ref1;
        (ref = sliderRef.current) === null || ref === void 0 ? void 0 : (ref1 = ref.slickPrev) === null || ref1 === void 0 ? void 0 : ref1.call(ref);
        upgradeEditorBannerSelection("prev");
    };
    var handleNextClick = function() {
        var ref, ref1;
        (ref = sliderRef.current) === null || ref === void 0 ? void 0 : (ref1 = ref.slickNext) === null || ref1 === void 0 ? void 0 : ref1.call(ref);
        upgradeEditorBannerSelection("next");
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (selectedBannerEditor.show) {
            var ref, ref1, ref2, ref3;
            (ref = sliderRef.current) === null || ref === void 0 ? void 0 : (ref1 = ref.slickGoTo) === null || ref1 === void 0 ? void 0 : ref1.call(ref, selectedBannerEditor.data.bannerIndex);
            setActiveSlide2(selectedBannerEditor.data.bannerIndex);
            (ref2 = sliderRef.current) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.slickPause) === null || ref3 === void 0 ? void 0 : ref3.call(ref2);
        } else {
            var ref4, ref5, ref6, ref7;
            if (widgetOptions.autoPlay) (ref4 = sliderRef.current) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.slickPlay) === null || ref5 === void 0 ? void 0 : ref5.call(ref4);
            else (ref6 = sliderRef.current) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.slickPause) === null || ref7 === void 0 ? void 0 : ref7.call(ref6);
        }
    }, [
        selectedBannerEditor.show
    ]);
    return {
        allSliderSettings: allSliderSettings,
        handlePrevClick: handlePrevClick,
        handleNextClick: handleNextClick,
        setWidgetSettingsSectionState: setWidgetSettingsSectionState,
        upgradeEditorBannerSelection: upgradeEditorBannerSelection
    };
};
var useWindowResize = function(param) {
    var _dependencies = param.dependencies, dependencies = _dependencies === void 0 ? [] : _dependencies, executor = param.executor, widgetOptions = param.widgetOptions, props = param.props;
    var ref = (0,_context_WidgetDndContext__WEBPACK_IMPORTED_MODULE_2__/* .useWidgetDndContextData */ .KX)(), _widgetContextState = ref.widgetContextState, showPreview = _widgetContextState.showPreview, previewDevice = _widgetContextState.previewDevice;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useLayoutEffect)(function() {
        window.addEventListener("resize", executor);
        return function() {
            window.removeEventListener("resize", executor);
        };
    }, dependencies);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useLayoutEffect)(function() {
        executor();
    }, [
        props.update,
        widgetOptions.aspectRatio,
        widgetOptions.aspectRatioMobile,
        showPreview,
        previewDevice, 
    ]);
};
function getBannerImages(param) {
    var props = param.props, activeWidgetProps = param.activeWidgetProps, isDesktop = param.isDesktop, isBuilder = param.isBuilder;
    var ref, ref1, ref2, ref3;
    /** This is used as a fallback for old s3 widgets, which doesn't consume activeWidgetProps or props.widgetOptions
   * thus the images are directly pulled from the theme components of store */ var bodyComponent = ((ref = props.store) === null || ref === void 0 ? void 0 : (ref1 = ref.theme) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.components) === null || ref2 === void 0 ? void 0 : ref2.Body) || [];
    var oldBannerImages = ((ref3 = bodyComponent.find(function(component) {
        var ref;
        return (ref = [
            src_constants_widgets__WEBPACK_IMPORTED_MODULE_5__/* .ADMIN_WIDGETS.HERO_BANNER.type */ .Pe.HERO_BANNER.type,
            "HeroBanner"
        ]) === null || ref === void 0 ? void 0 : ref.includes(component.sub_type);
    })) === null || ref3 === void 0 ? void 0 : ref3.images) || [];
    var filteredImages = filterImages(activeWidgetProps || props.widgetOptions, oldBannerImages, isDesktop, isBuilder);
    return filteredImages;
}
var useGetAlignments = function(param) {
    var isDesktop = param.isDesktop, widgetOptions = param.widgetOptions;
    var getContentPosition = function() {
        if (isDesktop) {
            return widgetOptions === null || widgetOptions === void 0 ? void 0 : widgetOptions.contentPositionDesktop;
        }
        return widgetOptions === null || widgetOptions === void 0 ? void 0 : widgetOptions.contentPositionMobile;
    };
    var getButtonAlignment = function() {
        var classType = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "position";
        var position = getContentPosition();
        if (position === "left") return classType === "flex" ? isDesktop ? "tw-justify-start" : "tw-items-start" : "tw-right-[0px]";
        if (position === "right") return classType === "flex" ? isDesktop ? "tw-justify-end" : "tw-items-end" : "tw-left-[0px]";
        return classType === "flex" ? isDesktop ? "tw-justify-center" : "tw-items-center" : "tw-top-[50%] tw--translate-y-1/2";
    };
    var getContentAlignment = function() {
        var classType = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "position";
        var position = getContentPosition();
        if (position === "left") return classType === "flex" ? "tw-justify-start" : "tw-left-[0px]";
        if (position === "right") return classType === "flex" ? "tw-justify-end" : "tw-right-[0px]";
        return classType === "flex" ? "tw-justify-center" : "tw-left-[50%] tw-translate-x-1/2";
    };
    return {
        getContentAlignment: getContentAlignment,
        getButtonAlignment: getButtonAlignment,
        getContentPosition: getContentPosition
    };
};
var getBannerAnimationClass = function(param) {
    var widgetOptions = param.widgetOptions, isCurrentSlideActive = param.isCurrentSlideActive;
    switch(widgetOptions === null || widgetOptions === void 0 ? void 0 : widgetOptions.bannerAnimationName){
        case "fadeIn":
            return "";
        // twMerge(
        //   '!tw-duration-[900ms]',
        //   !isCurrentSlideActive ? contentAnimationStyle.imageZoomIn2 : '',
        //   isCurrentSlideActive ? contentAnimationStyle.imageZoomOut2 : ''
        // );
        case "slideFadeIn":
            return (0,tailwind_merge__WEBPACK_IMPORTED_MODULE_9__/* .twMerge */ .m6)("tw-opacity-0 ", isCurrentSlideActive ? (_components_DesignSystem_AtomicDesignsUtilities_ContentAnimationStyles_module_scss__WEBPACK_IMPORTED_MODULE_13___default().widgetContentFadeInZoomInWrapper) : "");
        default:
            return "";
    }
};
function getTextLineHeightBuilder(textSizeNum) {
    var LINE_HEIGHT_MULTIPLIER_BUILDER = 1.4;
    return textSizeNum * LINE_HEIGHT_MULTIPLIER_BUILDER;
}
function getTopMarginByAnnouncement(param) {
    var activeHeaderData = param.activeHeaderData, isMobile = param.isMobile, isBannerFirstWidget = param.isBannerFirstWidget, isTransparentHeader = param.isTransparentHeader;
    var ref, ref1;
    var ref2 = (activeHeaderData === null || activeHeaderData === void 0 ? void 0 : (ref = activeHeaderData.headerPropsConfig) === null || ref === void 0 ? void 0 : ref.announcementConfig) || {}, cardConfig = ref2.cardConfig, listConfig = ref2.listConfig;
    var isAutoScrollEnabled = (listConfig === null || listConfig === void 0 ? void 0 : (ref1 = listConfig.autoPlayConfig) === null || ref1 === void 0 ? void 0 : ref1.type) === src_components_WidgetMaker_WidgetDnD_WidgetProperties_NewAnnouncementBar_Constants__WEBPACK_IMPORTED_MODULE_8__/* .SCROLL_TYPE.AUTO_SCROLL */ .ej.AUTO_SCROLL;
    var ABOVE_HEADER = src_components_WidgetMaker_WidgetDnD_WidgetProperties_HeaderBuilder_AnnouncementConfig__WEBPACK_IMPORTED_MODULE_6__/* .ANNOUNCEMENT_BAR_POSITION.ABOVE_HEADER */ .IZ.ABOVE_HEADER;
    var ref3 = listConfig || {}, _isVisible = ref3.isVisible, isVisible = _isVisible === void 0 ? false : _isVisible, _position = ref3.position, position = _position === void 0 ? ABOVE_HEADER : _position, _fillType = ref3.fillType, fillType = _fillType === void 0 ? src_components_WidgetMaker_WidgetDnD_WidgetProperties_HeaderBuilder_AnnouncementConfig__WEBPACK_IMPORTED_MODULE_6__/* .WIDGET_BG_TYPE.COLOR */ .VE.COLOR : _fillType, _mobilePaddingY = ref3.mobilePaddingY, mobilePaddingY = _mobilePaddingY === void 0 ? 6 : _mobilePaddingY, _paddingY = ref3.paddingY, paddingY = _paddingY === void 0 ? 6 : _paddingY;
    var ref4 = cardConfig || {}, _textSizeMobile = ref4.textSizeMobile, textSizeMobile = _textSizeMobile === void 0 ? 12 : _textSizeMobile, _textSizeDesktop = ref4.textSizeDesktop, textSizeDesktop = _textSizeDesktop === void 0 ? 14 : _textSizeDesktop;
    var isAnnouncementOnTop = position === ABOVE_HEADER;
    var isColoredAnnouncement = fillType === src_components_WidgetMaker_WidgetDnD_WidgetProperties_HeaderBuilder_AnnouncementConfig__WEBPACK_IMPORTED_MODULE_6__/* .WIDGET_BG_TYPE.COLOR */ .VE.COLOR;
    var FIX_SEPERATOR_HEIGHT = 24;
    var announcementTextHeight = getTextLineHeightBuilder((0,_ListPresentation_components_utils__WEBPACK_IMPORTED_MODULE_7__/* .getTextSizeNum */ .fs)(isMobile ? textSizeMobile : textSizeDesktop));
    if (isAutoScrollEnabled) announcementTextHeight = Math.max(announcementTextHeight, FIX_SEPERATOR_HEIGHT);
    var announcementHeight = (isMobile ? mobilePaddingY : paddingY) * 2 + announcementTextHeight;
    var isBannerTopMarginAdjustmentRequired = isBannerFirstWidget && isTransparentHeader && isVisible && isAnnouncementOnTop && isColoredAnnouncement;
    return isBannerTopMarginAdjustmentRequired ? announcementHeight : 0;
}
var getBannerContainerStyles = function(param) {
    var isNewCarousel = param.isNewCarousel, widgetOptions = param.widgetOptions, useImageOriginalHeight = param.useImageOriginalHeight, height = param.height, isMobile = param.isMobile, adjustedMarginByAnnouncement = param.adjustedMarginByAnnouncement;
    var styles = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({
        height: isNewCarousel ? !useImageOriginalHeight ? height : "auto" : height,
        width: "100%"
    }, isNewCarousel ? (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({
        marginTop: (widgetOptions === null || widgetOptions === void 0 ? void 0 : widgetOptions.marginTop) + adjustedMarginByAnnouncement || "0px",
        marginBottom: (widgetOptions === null || widgetOptions === void 0 ? void 0 : widgetOptions.marginBottom) || "0px"
    }, (widgetOptions === null || widgetOptions === void 0 ? void 0 : widgetOptions.isBannerFullWidth) === false ? {
        marginLeft: isMobile ? "16px" : "80px",
        marginRight: isMobile ? "16px" : "80px"
    } : {}) : {});
    return styles;
};


/***/ }),

/***/ 486353:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(626042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(269396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(785893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(667294);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(693967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);





var CommonLinkWrapper = function(props) {
    var _wrapperType = props.wrapperType, wrapperType = _wrapperType === void 0 ? "a" : _wrapperType, _link = props.link, link = _link === void 0 ? "" : _link, _disableLink = props.disableLink, disableLink = _disableLink === void 0 ? false : _disableLink, handleCustomClick = props.handleCustomClick, openLinkInNewTab = props.openLinkInNewTab;
    var handleClick = function(e) {
        var ref;
        (ref = props.onClick) === null || ref === void 0 ? void 0 : ref.call(props, e);
        handleCustomClick === null || handleCustomClick === void 0 ? void 0 : handleCustomClick();
    };
    var sharedProps = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, props), {
        onClick: handleClick,
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("tw-text-inherit", props.className)
    });
    if (wrapperType === "a" && link) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, sharedProps), {
            className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("tw-flex tw-cursor-pointer tw-no-underline", sharedProps.className),
            href: !disableLink ? link : undefined,
            target: props.target || (openLinkInNewTab ? "_blank" : undefined),
            children: props.children
        }));
    }
    if (wrapperType === "div") {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, sharedProps), {
            children: props.children
        }));
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: props.children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CommonLinkWrapper);


/***/ }),

/***/ 637062:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ normalizeFooterConfig; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(626042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(269396);


var normalizeFooterConfig = function(config) {
    var currentConfig = Object.keys(config).reduce(function(all, keyName) {
        var ref;
        if ((keyName === null || keyName === void 0 ? void 0 : keyName.includes("layer")) && ((ref = config[keyName]) === null || ref === void 0 ? void 0 : ref.data)) {
            var ref1;
            all[keyName] = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, config[keyName]), {
                builder: (ref1 = config[keyName]) === null || ref1 === void 0 ? void 0 : ref1.data
            });
            delete all[keyName].data;
        } else all[keyName] = config[keyName];
        return all;
    }, {});
    return currentConfig;
};


/***/ }),

/***/ 738584:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ RenderNewSearch; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(785893);
/* harmony import */ var _components_DukaanCard__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(728364);
/* harmony import */ var _components_FlatList__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(155772);
/* harmony import */ var _redux_actions__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(96031);
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(913886);
/* harmony import */ var lodash_debounce__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(23279);
/* harmony import */ var lodash_debounce__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lodash_debounce__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(667294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(225617);
/* harmony import */ var _components_DesignSystem_ProductItem__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(852746);









var RenderNewSearch = function(props) {
    var handleSearchChange = function handleSearchChange(change) {
        var text = change.trim();
        if (text && text.length >= 3) {
            dispatch((0,_redux_actions__WEBPACK_IMPORTED_MODULE_8__/* .saveSearchedProductItems */ .J)({
                items: [],
                isNext: false
            }));
            dispatch((0,_redux_actions__WEBPACK_IMPORTED_MODULE_8__/* .searchProductItems */ .Xw)({
                store_id: storeInfo.store_id,
                search_text: text,
                page: 1
            }));
        } else if (text && text.length === 0) {
            dispatch((0,_redux_actions__WEBPACK_IMPORTED_MODULE_8__/* .saveSearchedProductItems */ .J)({
                items: [],
                isNext: 0
            }));
        }
    };
    var activeSearchedProductsItems = function activeSearchedProductsItems() {
        var ref;
        return (searchedProducts === null || searchedProducts === void 0 ? void 0 : (ref = searchedProducts.items) === null || ref === void 0 ? void 0 : ref.length) ? searchedProducts === null || searchedProducts === void 0 ? void 0 : searchedProducts.items.filter(function(item) {
            return (item === null || item === void 0 ? void 0 : item.is_active) === _utils_constants__WEBPACK_IMPORTED_MODULE_3__/* .ITEM_ACTIVE_STATUS.ACTIVE */ .p4.ACTIVE;
        }) : [];
    };
    var ref;
    var productQuery = props.productQuery, fullSearch = props.fullSearch;
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_6__/* .useDispatch */ .I0)();
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)(1), pageNo = ref1[0], setPageNo = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)(""), searchText = ref2[0], setSearchText = ref2[1];
    var storeInfo = (0,react_redux__WEBPACK_IMPORTED_MODULE_6__/* .useSelector */ .v9)(function(state) {
        return state.storeReducer.store;
    });
    var searchedProducts = (0,react_redux__WEBPACK_IMPORTED_MODULE_6__/* .useSelector */ .v9)(function(state) {
        return state.catalogReducer;
    }).searchedProducts;
    var loader = (0,react_redux__WEBPACK_IMPORTED_MODULE_6__/* .useSelector */ .v9)(function(state) {
        return state.commonReducer;
    }).loader;
    (0,react__WEBPACK_IMPORTED_MODULE_5__.useEffect)(function() {
        onSearchChangeHandle(productQuery);
    }, [
        productQuery
    ]);
    var debounceOnChange = (0,react__WEBPACK_IMPORTED_MODULE_5__.useCallback)(lodash_debounce__WEBPACK_IMPORTED_MODULE_4___default()(handleSearchChange, 500), []);
    var loadMoreInit = function() {
        if (!loader) {
            dispatch((0,_redux_actions__WEBPACK_IMPORTED_MODULE_8__/* .searchProductItems */ .Xw)({
                store_id: storeInfo.store_id,
                search_text: searchText,
                page: pageNo + 1
            }));
            setPageNo(pageNo + 1);
        }
    };
    var renderFilteredSearch = function() {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_FlatList__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            isLoaderVisible: loader ? true : false,
            LoaderComponent: _components_DukaanCard__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z,
            loaderProps: {
                isLoader: true
            },
            isNext: searchedProducts.isNext ? true : false,
            onScrollEnd: function() {
                return loadMoreInit();
            },
            renderList: function() {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "search-content__box",
                    style: {
                        width: fullSearch ? "700px" : "100%",
                        marginRight: "auto",
                        marginLeft: "auto",
                        transform: "none"
                    },
                    children: activeSearchedProductsItems().map(function(item, idx) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_DesignSystem_ProductItem__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                            data: item,
                            isCartItem: false,
                            isCardType: false
                        }, "search-item-".concat(idx));
                    })
                });
            }
        });
    };
    var onSearchChangeHandle = function(searchText) {
        var limitedString = searchText.substr(0, 255);
        setSearchText(searchText);
        debounceOnChange(limitedString);
    };
    var renderNotFound = function() {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "search-content__notfound",
            style: {
                display: "flex"
            },
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                children: "Sorry we couldn't find the item you searched"
            })
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "tw-w-[100%] tw-bg-[#ffffff]",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "tw-flex tw-items-center tw-justify-center",
            children: searchText.length > 0 ? (searchedProducts === null || searchedProducts === void 0 ? void 0 : (ref = searchedProducts.items) === null || ref === void 0 ? void 0 : ref.length) > 0 ? renderFilteredSearch() : renderNotFound() : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {})
        })
    });
};


/***/ }),

/***/ 658015:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B5": function() { return /* binding */ DynamicComponent; },
/* harmony export */   "hQ": function() { return /* binding */ crossIcon; },
/* harmony export */   "q7": function() { return /* binding */ getIcon; }
/* harmony export */ });
/* unused harmony export SearchIconComp */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(414924);
/* harmony import */ var _swc_helpers_src_throw_mjs__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(751351);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(785893);
/* harmony import */ var _WidgetMaker_WidgetDnD_WIdgetPropertiesBasic_components_Button__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(846976);
/* harmony import */ var _context_WidgetDndContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(474151);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(667294);
/* harmony import */ var _RenderNewSearch__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(738584);
/* harmony import */ var _newHeaderContext__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(192600);
/* harmony import */ var _assets_svgExports_SearchIcon__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(350127);
/* harmony import */ var _getSizeAccType__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(106790);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(811163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _utils_routes__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(540190);
/* harmony import */ var src_redux__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(268037);
/* harmony import */ var _hooks_useGetDeviceType__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(662946);
/* harmony import */ var src_utils_regex__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(936083);
/* harmony import */ var src_components_WidgetMaker_WidgetDnD_WIdgetPropertiesBasic_components_TextfieldBox__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(781477);

















var getIcon = function(size, color) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 28 28",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M21.0023 13.0012C21.0023 14.5837 20.533 16.1307 19.6538 17.4465C18.7746 18.7623 17.5249 19.7878 16.0628 20.3934C14.6007 20.9989 12.9919 21.1573 11.4398 20.8485C9.88771 20.5397 8.46204 19.7775 7.3431 18.6584C6.22416 17.5394 5.46221 16.1136 5.15361 14.5614C4.84501 13.0093 5.00361 11.4005 5.60937 9.93849C6.21512 8.47649 7.24082 7.22696 8.55675 6.34791C9.87268 5.46886 11.4197 4.99978 13.0023 5C15.1243 5 17.1594 5.84298 18.6599 7.34349C20.1604 8.84399 21.0034 10.8791 21.0034 13.0012H21.0023Z",
                stroke: color,
                "stroke-width": "1.4",
                strokeLinecap: "round",
                "stroke-linejoin": "round"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M23.0042 23L18.6538 18.6497",
                stroke: color,
                "stroke-width": "1.4",
                strokeLinecap: "round",
                "stroke-linejoin": "round"
            })
        ]
    });
};
var crossIcon = function(color) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        className: "tw-cursor-pointer",
        xmlns: "http://www.w3.org/2000/svg",
        width: "18",
        height: "18",
        viewBox: "0 0 18 18",
        fill: "none",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M16.5002 4.86641L15.2052 3.57141L10.0716 8.70498L4.93807 3.57141L3.64307 4.86641L8.77664 9.99998L3.64307 15.1336L4.93807 16.4286L10.0716 11.295L15.2052 16.4286L16.5002 15.1336L11.3666 9.99998L16.5002 4.86641Z",
            fill: color
        })
    });
};
var DynamicComponent = function(props) {
    var getStyleForText = function getStyleForText() {
        var changeColor = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
        var ref;
        return {
            color: changeColor ? currentClass === null || currentClass === void 0 ? void 0 : (ref = currentClass.base_config) === null || ref === void 0 ? void 0 : ref.defaultNavLinksColor : "",
            fontSize: (0,_getSizeAccType__WEBPACK_IMPORTED_MODULE_12__/* .getSizeAccType */ .IZ)(globalClass.staticClass.base_config.defaultTextFontSize, isMobile ? globalClass.staticClass.base_config.defaultFontSizeTypeMobile : globalClass.staticClass.base_config.defaultFontSizeType),
            fontWeight: globalClass.staticClass.base_config.defaultTextFontWeight,
            textTransform: globalClass.staticClass.base_config.defaultTextDecoration
        };
    };
    var renderSearchWithField = function renderSearchWithField() {
        var ref, ref1, ref2, ref3, ref4;
        var fullSearch = desktopHeader === "header4" && (base_config === null || base_config === void 0 ? void 0 : base_config.defaultPosition) === "center";
        var isTransparent = (currentClass === null || currentClass === void 0 ? void 0 : (ref = currentClass.base_config) === null || ref === void 0 ? void 0 : ref.defaultFillColorType) === "transparent";
        var isFilledWhite = (currentClass === null || currentClass === void 0 ? void 0 : (ref1 = currentClass.base_config) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.defaultBackgroundColor) === null || ref2 === void 0 ? void 0 : ref2.toLowerCase()) === "#ffffff";
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "tw-relative ".concat(fullSearch ? isCenterAlignedHeader ? "tw-flex-1" : "tw-w-[500px]" : "tw-w-[100%]", " "),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "tw-flex ".concat(!fullSearch ? "tw-w-[238px]" : "", "  tw-items-center"),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_WidgetMaker_WidgetDnD_WIdgetPropertiesBasic_components_TextfieldBox__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                        parentClass: "tw-w-[100%]",
                        placeholder: ((ref3 = base_config === null || base_config === void 0 ? void 0 : base_config.placeholder[placeholderIndex]) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.value) === null || ref4 === void 0 ? void 0 : ref4.trim()) || (base_config === null || base_config === void 0 ? void 0 : base_config.defaultPlaceholder),
                        placeholderColor: placeholderColor,
                        regexCheck: src_utils_regex__WEBPACK_IMPORTED_MODULE_13__/* .allowEverything */ .oe,
                        value: searchText,
                        showErrorBox: false,
                        customClass: "".concat(!isFilledWhite || isTransparent ? "!tw-text-[#ffffff]" : "", " !tw-py-[10] custom-input tw-ml-[8px] tw-w-[100%]\n             tw-font-dmSans tw-flex-grow tw-truncate tw-border-none tw-text-[14px]\n             tw-transition-opacity tw-duration-500 tw-ease-in-out \n             ").concat(fade ? "tw-opacity-100" : (searchText === null || searchText === void 0 ? void 0 : searchText.length) ? "tw-opacity-100" : "tw-opacity-0", " ").concat(!fullSearch ? "tw-w-[238px]" : ""),
                        handleChange: function(value) {
                            return setSearchText(value);
                        },
                        rows: 1,
                        iconComponent: function() {
                            var ref;
                            /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "tw-ml-[14px] tw-flex tw-items-center tw-justify-center",
                                children: getIcon("24", currentClass === null || currentClass === void 0 ? void 0 : (ref = currentClass.base_config) === null || ref === void 0 ? void 0 : ref.defaultNavLinksColor)
                            });
                        },
                        borderColor: isTransparent ? "#ffffff99" : !isFilledWhite ? placeholderColor + 40 : "#111C361F",
                        customPadding: "10px 0px",
                        inputColor: isTransparent ? "#ffffff" : !isFilledWhite ? placeholderColor : "#000000",
                        rightIconCompo: function() {
                            var ref;
                            /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                onClick: function(e) {
                                    e.stopPropagation();
                                    setSearchText("");
                                },
                                className: "tw-mr-[14px] tw-flex tw-items-center tw-justify-center",
                                children: (searchText === null || searchText === void 0 ? void 0 : searchText.length) > 0 && crossIcon(currentClass === null || currentClass === void 0 ? void 0 : (ref = currentClass.base_config) === null || ref === void 0 ? void 0 : ref.defaultNavLinksColor)
                            });
                        }
                    })
                }),
                (searchText === null || searchText === void 0 ? void 0 : searchText.length) > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    style: {
                        boxShadow: "0px 2px 8px 0px rgba(0, 0, 0, 0.08)",
                        border: "1px solid #111C361F"
                    },
                    className: "tw-absolute tw-z-[100] ".concat(fullSearch ? "tw-min-w-[100%]" : "tw-min-w-[585px]", " tw-bg-[#ffffff]\n       ").concat((base_config === null || base_config === void 0 ? void 0 : base_config.defaultPosition) === "left" ? "tw-left-0" : "tw-right-0", " tw-mt-[5px] tw-max-h-[500px] tw-overflow-scroll tw-px-20 tw-py-[30px]"),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_RenderNewSearch__WEBPACK_IMPORTED_MODULE_4__/* .RenderNewSearch */ .l, {
                        productQuery: searchText,
                        fullSearch: false
                    })
                })
            ]
        });
    };
    var handleClick = function handleClick() {
        if (isMobile) {
            var ref;
            next_router__WEBPACK_IMPORTED_MODULE_7___default().push((0,_utils_routes__WEBPACK_IMPORTED_MODULE_8__.getRoute)("search", storeData === null || storeData === void 0 ? void 0 : (ref = storeData.store_info) === null || ref === void 0 ? void 0 : ref.domain));
        } else {
            setShowSearch(function(prev) {
                return !prev;
            });
        }
    };
    var _RenderSearchLayout = function _RenderSearchLayout() {
        var ref, ref1, ref2, ref3;
        var desktopIconConfig = globalClass === null || globalClass === void 0 ? void 0 : (ref = globalClass.staticClass) === null || ref === void 0 ? void 0 : (ref1 = ref.base_config) === null || ref1 === void 0 ? void 0 : ref1.defaultFontSizeType;
        var mobileIconConfig = globalClass.staticClass.base_config.defaultFontSizeTypeMobile;
        var sizeDetails = (0,_getSizeAccType__WEBPACK_IMPORTED_MODULE_12__/* .getIconSizeAccToConfig */ .hE)(isMobile ? mobileIconConfig : desktopIconConfig);
        var typeAccHeader = isCenterAlignedHeader ? "field" : defaultType;
        var isTransparent = (currentClass === null || currentClass === void 0 ? void 0 : (ref2 = currentClass.base_config) === null || ref2 === void 0 ? void 0 : ref2.defaultFillColorType) === "transparent";
        var isFilledWhite = (currentClass === null || currentClass === void 0 ? void 0 : (ref3 = currentClass.base_config) === null || ref3 === void 0 ? void 0 : ref3.defaultBackgroundColor) === "#ffffff" || isTransparent;
        switch(typeAccHeader){
            case "icon":
                var ref4;
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    style: {
                        width: Number(sizeDetails) + 4,
                        height: Number(sizeDetails) + 4
                    },
                    className: "".concat(defaultHoverIconState === "zoomin" ? "tw-transition-transform tw-duration-500 hover:tw-scale-[1.2]" : defaultHoverIconState === "background" ? "".concat(!isFilledWhite ? "hover:tw-bg-[#ffffff4d]" : "hover:tw-bg-[#111C360F]") : "", " tw-flex tw-cursor-pointer tw-items-center tw-justify-center"),
                    onClick: handleClick,
                    children: getIcon(sizeDetails, currentClass === null || currentClass === void 0 ? void 0 : (ref4 = currentClass.base_config) === null || ref4 === void 0 ? void 0 : ref4.defaultNavLinksColor)
                });
            case "field":
                return renderSearchWithField();
            case "labelIcon":
                var ref5;
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    onClick: handleClick,
                    className: "tw-flex tw-cursor-pointer tw-items-center",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            style: {
                                width: Number(sizeDetails) + 4,
                                height: Number(sizeDetails) + 4
                            },
                            className: "".concat(defaultHoverIconState === "zoomin" ? "tw-transition-transform tw-duration-500 hover:tw-scale-[1.2]" : defaultHoverIconState === "background" ? "".concat(!isFilledWhite ? "hover:tw-bg-[#ffffff4d]" : "hover:tw-bg-[#111C360F]") : "", " tw-mb-[2px] tw-flex tw-items-center tw-justify-center"),
                            children: getIcon(sizeDetails, currentClass === null || currentClass === void 0 ? void 0 : (ref5 = currentClass.base_config) === null || ref5 === void 0 ? void 0 : ref5.defaultNavLinksColor)
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            style: getStyleForText(true),
                            className: "tw-m-0 tw-ml-[8px] tw-cursor-pointer tw-select-none tw-font-dmSans",
                            children: "Search"
                        })
                    ]
                });
            default:
                return null;
        }
    };
    var ref;
    var currentClass = props.currentClass, globalClass = props.globalClass;
    var ref1 = currentClass || {}, tmp = ref1.base_config, defaultHoverIconState = (tmp === void 0 ? {} : tmp).defaultHoverIconState;
    var setShowSearch = (0,react__WEBPACK_IMPORTED_MODULE_3__.useContext)(_newHeaderContext__WEBPACK_IMPORTED_MODULE_5__/* .NewHeaderContext */ .x).setShowSearch;
    var deviceType = (0,_hooks_useGetDeviceType__WEBPACK_IMPORTED_MODULE_10__/* .useGetDeviceType */ .n)().deviceType;
    var isMobile = deviceType === "mobile";
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(""), searchText = ref2[0], setSearchText = ref2[1];
    var getWidgetSSRState = (0,_context_WidgetDndContext__WEBPACK_IMPORTED_MODULE_2__/* .useWidgetDndContextData */ .KX)().getWidgetSSRState;
    var activeHeaderData = getWidgetSSRState().activeHeaderData;
    var _headerPropsConfig = activeHeaderData.headerPropsConfig, _dynamic_section = _headerPropsConfig.dynamic_section, _componentData = _dynamic_section.componentData, _componentData = _componentData !== null ? _componentData : (0,_swc_helpers_src_throw_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)(new TypeError("Cannot destructure undefined")), base_config = _dynamic_section.base_config, desktopHeader = _headerPropsConfig.desktopHeader;
    var storeData = (0,src_redux__WEBPACK_IMPORTED_MODULE_9__/* .useSSRSelector */ .kF)(function(state) {
        return {
            storeData: state.storeReducer.store
        };
    }).storeData;
    var searchAlignment = base_config.searchAlignment, defaultPosition = base_config.defaultPosition, defaultType = base_config.defaultType;
    var isCenterAlignedHeader = desktopHeader === "header4" && (base_config === null || base_config === void 0 ? void 0 : base_config.defaultPosition) === "center";
    var placeholderColor = (currentClass === null || currentClass === void 0 ? void 0 : (ref = currentClass.base_config) === null || ref === void 0 ? void 0 : ref.defaultNavLinksColor) || "";
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(0), placeholderIndex = ref3[0], setPlaceholderIndex = ref3[1];
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(true), fade = ref4[0], setFade = ref4[1];
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function() {
        var intervalId;
        if (defaultType === "field" && (base_config === null || base_config === void 0 ? void 0 : base_config.placeholder.length) > 1) {
            intervalId = setInterval(function() {
                setFade(false);
                setTimeout(function() {
                    setPlaceholderIndex(function(prevIndex) {
                        return (prevIndex + 1) % (base_config === null || base_config === void 0 ? void 0 : base_config.placeholder.length);
                    });
                    setFade(true);
                }, 500);
            }, 3000);
        }
        if (defaultType !== "field") {
            clearInterval(intervalId);
        }
        return function() {
            return clearInterval(intervalId);
        };
    }, [
        base_config === null || base_config === void 0 ? void 0 : base_config.placeholder.length,
        defaultType
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        style: (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)({}, defaultPosition, searchAlignment[defaultPosition]),
        className: "".concat(isCenterAlignedHeader ? "tw-relative tw-flex tw-flex-grow tw-justify-center" // tw-right-[2.5%] !tw-max-w-[42%]
         : ""),
        children: base_config.showSearch && _RenderSearchLayout()
    });
};
function SearchIconComp(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, _dimensions = param.dimensions, dimensions = _dimensions === void 0 ? {
        width: 19,
        height: 19
    } : _dimensions, _handleClick = param.handleClick, handleClick = _handleClick === void 0 ? function() {} : _handleClick;
    return /*#__PURE__*/ _jsx(CustomizedButton, {
        variant: "tertiary",
        className: "tw-min-w-0 " + className,
        backgroundColor: "#fff",
        onClick: handleClick,
        children: /*#__PURE__*/ _jsx(SearchIcon, _object_spread({
            color: "tw-text-newBlack"
        }, dimensions))
    });
/**
   const {
    widgetContextState: { activeHeaderData },
  } = useWidgetDndContextData();
  const {
    headerPropsConfig: {
      navIcons_section: { componentData },
    },
  } = activeHeaderData;
  const canRenderText = componentData?.appearanceType?.includes('text');
  const canRenderImage = componentData?.appearanceType?.includes('icon');

  const searchIconConfig = componentData?.iconsList?.find(
    (item) => item.name === 'search'
  );

  return (
    <CustomizedButton
      variant="tertiary"
      className={
        '!tw-text-uppercase !tw-m-0 !tw-flex tw-min-w-0 !tw-items-center !tw-gap-[4px] !tw-text-[10px] !tw-font-light !tw-text-newBlack ' +
        className
      }
      backgroundColor="#fff"
      onClick={handleClick}
      image={
        canRenderImage && (
          <searchIconConfig.ImageComponent
            width={canRenderText ? 12 : 24}
            height={canRenderText ? 12 : 24}
          />
        )
      }
    >
      {canRenderText && (
        <p className="tw-text-[10px] tw-uppercase tw-leading-[1] tw-tracking-[1.48px]">
          {searchIconConfig?.label}
        </p>
      )}
    </CustomizedButton>
  );
   */ }


/***/ }),

/***/ 106790:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "IZ": function() { return /* binding */ getSizeAccType; },
/* harmony export */   "hE": function() { return /* binding */ getIconSizeAccToConfig; }
/* harmony export */ });
/* unused harmony export getIconSize */
var getSizeAccType = function() {
    var currentSize = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", configSize = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    if (configSize === "n") {
        return currentSize;
    } else {
        var currentConfig = configSize;
        var currentSizeInNumber = Number(currentSize.replace("px", ""));
        switch(currentConfig){
            case "n-3":
                return "".concat(currentSizeInNumber - 3, "px");
            case "n-1":
                return "".concat(currentSizeInNumber - 1, "px");
            case "n+1":
                return "".concat(currentSizeInNumber + 1, "px");
            case "n+3":
                return "".concat(currentSizeInNumber + 3, "px");
        }
    }
};
var getIconSize = function() {
    var configSize = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    switch(configSize){
        case "n-3":
            return "spriteDetail1";
        case "n-1":
            return "spriteDetail2";
        case "n":
            return "spriteDetail";
        case "n+1":
            return "spriteDetail3";
        case "n+3":
            return "spriteDetail4";
    }
};
var getIconSizeAccToConfig = function() {
    var configSize = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    switch(configSize){
        case "n-3":
            return "16";
        case "n-1":
            return "20";
        case "n":
            return "24";
        case "n+1":
            return "28";
        case "n+3":
            return "32";
    }
};


/***/ }),

/***/ 950479:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "NewHeaderComponent": function() { return /* reexport */ NewHeaderComponent; },
  "NewHeaderWrapper": function() { return /* reexport */ Header_NewHeaderWrapper; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(626042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(269396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(785893);
// EXTERNAL MODULE: ./src/context/WidgetDndContext/index.ts
var WidgetDndContext = __webpack_require__(474151);
// EXTERNAL MODULE: ./src/redux/ssrStore.ts + 1 modules
var ssrStore = __webpack_require__(326706);
// EXTERNAL MODULE: ./src/components/DesignSystem/Widgets2.0/Header/components/dynamicComponent.tsx
var dynamicComponent = __webpack_require__(658015);
// EXTERNAL MODULE: ./src/components/DesignSystem/Widgets2.0/Header/components/getSizeAccType.ts
var getSizeAccType = __webpack_require__(106790);
// EXTERNAL MODULE: ./src/hooks/useGetDeviceType.tsx
var useGetDeviceType = __webpack_require__(662946);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(693967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/tailwind-merge/dist/bundle-mjs.mjs
var bundle_mjs = __webpack_require__(798388);
// EXTERNAL MODULE: ./src/utils/routes.js + 1 modules
var routes = __webpack_require__(540190);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(811163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(667294);
// EXTERNAL MODULE: ./src/components/DesignSystem/Widgets2.0/CommonLinkWrapper/index.tsx
var CommonLinkWrapper = __webpack_require__(486353);
// EXTERNAL MODULE: ./src/utils/useCheckIfHomePage.ts
var useCheckIfHomePage = __webpack_require__(576609);
;// CONCATENATED MODULE: ./src/components/DesignSystem/Widgets2.0/Header/components/LogoRenderer.tsx













var LogoRenderer = function(props) {
    var getNavElementStyle = function getNavElementStyle() {
        return {
            fontSize: (0,getSizeAccType/* getSizeAccType */.IZ)(globalClass.staticClass.base_config.defaultTextFontSize, isMobile ? globalClass.staticClass.base_config.defaultFontSizeTypeMobile : globalClass.staticClass.base_config.defaultFontSizeType),
            fontWeight: globalClass.staticClass.base_config.defaultTextFontWeight,
            color: selectedClass === null || selectedClass === void 0 ? void 0 : selectedClass.base_config.defaultNavLinksColor,
            textTransform: globalClass.staticClass.base_config.defaultTextDecoration
        };
    };
    var getImageLayoutSize = function getImageLayoutSize() {
        var ref, ref1, ref2;
        var splitAspectRatio = logo_section === null || logo_section === void 0 ? void 0 : (ref = logo_section.staticLogo) === null || ref === void 0 ? void 0 : (ref1 = ref.componentData) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.aspectRatio) === null || ref2 === void 0 ? void 0 : ref2.split(" / ");
        if (!splitAspectRatio) {
            return {};
        }
        var aspectRatio = splitAspectRatio[0] / splitAspectRatio[1];
        var width = currentSize;
        return {
            width: "".concat(width, "px"),
            height: "".concat(width * (1 / aspectRatio), "px")
        };
    };
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
    var router = (0,next_router.useRouter)();
    var isHomePage = (0,useCheckIfHomePage/* useCheckIfHomePage */.t)();
    var deviceType = (0,useGetDeviceType/* useGetDeviceType */.n)().deviceType;
    var isMobile = deviceType === "mobile";
    var activeHeaderData = props.activeHeaderData, _showDynamicSection = props.showDynamicSection, showDynamicSection = _showDynamicSection === void 0 ? false : _showDynamicSection, _isScroll = props.isScroll, isScroll = _isScroll === void 0 ? false : _isScroll, currentClass = props.currentClass, globalClass = props.globalClass, isHeaderHovered = props.isHeaderHovered;
    var _headerPropsConfig = activeHeaderData.headerPropsConfig, logo_section = _headerPropsConfig.logo_section, desktopHeader = _headerPropsConfig.desktopHeader, mobileHeader = _headerPropsConfig.mobileHeader, dynamic_section = _headerPropsConfig.dynamic_section;
    var staticLogo = logo_section.staticLogo, scrollLogo = logo_section.scrollLogo;
    var currentType = isScroll || isHeaderHovered ? scrollLogo : staticLogo;
    var isTransparent = (globalClass === null || globalClass === void 0 ? void 0 : (ref = globalClass.staticClass) === null || ref === void 0 ? void 0 : (ref1 = ref.base_config) === null || ref1 === void 0 ? void 0 : ref1.defaultFillColorType) === "transparent";
    var ref8 = (scrollLogo === null || scrollLogo === void 0 ? void 0 : (ref2 = scrollLogo.componentData) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.url) === null || ref3 === void 0 ? void 0 : ref3.length) > 0 && isTransparent ? currentType : staticLogo, base_config = ref8.base_config, url = ref8.componentData.url;
    var currentSize = isMobile ? base_config.defaultMobileSize : base_config.defaultDesktopSize;
    var selectedClass = isTransparent ? currentClass : globalClass === null || globalClass === void 0 ? void 0 : globalClass.staticClass;
    var store = (0,ssrStore/* useSSRSelector */.kF)(function(state) {
        return state.storeReducer.store;
    });
    var storeName = store === null || store === void 0 ? void 0 : (ref4 = store.store_info) === null || ref4 === void 0 ? void 0 : ref4.name;
    var routeName = (0,react.useMemo)(function() {
        var ref;
        return (0,routes.getRoute)(routes.PATH.PRODUCT, store === null || store === void 0 ? void 0 : (ref = store.store_info) === null || ref === void 0 ? void 0 : ref.domain);
    }, []);
    var handleLogoClick = function() {
        var ref;
        return router.push((0,routes.getRoute)(routes.PATH.PRODUCT, store === null || store === void 0 ? void 0 : (ref = store.store_info) === null || ref === void 0 ? void 0 : ref.domain));
    };
    var Wrapper = isHomePage ? "h1" : "div";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classnames_default()("tw-flex", !base_config.showLogo && !base_config.showStoreName && "tw-w-0 tw-overflow-hidden"),
        style: {
            scrollbarWidth: "none"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            style: {
                justifyContent: base_config.defaultPosition,
                cursor: "pointer"
            },
            className: "tw-flex tw-items-start tw-gap-[10px] ".concat(logo_section.customClass),
            children: [
                !!base_config.showLogo && !!url && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    style: (0,_object_spread/* default */.Z)({}, getImageLayoutSize()),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
                        style: {
                            margin: 0,
                            fontWeight: "inherit",
                            fontSize: "inherit"
                        },
                        children: [
                            isHomePage && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "visually-hidden",
                                children: storeName
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CommonLinkWrapper/* default */.Z, {
                                link: routeName,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    onClick: handleLogoClick,
                                    src: url,
                                    height: getImageLayoutSize().height,
                                    className: "tw-object-contain ".concat(isMobile ? mobileHeader === "header6" ? "tw-relative ".concat(!!(base_config === null || base_config === void 0 ? void 0 : (ref5 = base_config.showStoreName) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.trim) === null || ref6 === void 0 ? void 0 : ref6.call(ref5)) ? "!tw-right-[10px]" : "", " !tw-max-w-[144px]") : "tw-relative !tw-left-[0px] !tw-max-w-[144px]" : ""),
                                    style: desktopHeader === "header3" && (dynamic_section === null || dynamic_section === void 0 ? void 0 : (ref7 = dynamic_section.base_config) === null || ref7 === void 0 ? void 0 : ref7.defaultPosition) === "right" && !isMobile ? {
                                        position: "relative",
                                        left: "9.9px"
                                    } : {}
                                })
                            })
                        ]
                    })
                }),
                base_config.showStoreName && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    style: getNavElementStyle(),
                    className: (0,bundle_mjs/* twMerge */.m6)("tw-flex tw-flex-col tw-justify-center tw-h-[100%]", // ' tw-w-[160px]',
                    !!base_config.showLogo && !!url && "tw-ml-[8px]"),
                    children: storeName
                }),
                showDynamicSection && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "tw-ml-[20px]",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dynamicComponent/* DynamicComponent */.B5, {
                        currentClass: selectedClass,
                        globalClass: globalClass
                    })
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./node_modules/@mui/base/ClickAwayListener/ClickAwayListener.js + 3 modules
var ClickAwayListener = __webpack_require__(956334);
// EXTERNAL MODULE: ./src/components/MegaMenu/svgIcons.js
var svgIcons = __webpack_require__(120941);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(999534);
// EXTERNAL MODULE: ./src/components/DesignSystem/Drawer/NewDropdown/shopComponent.module.scss
var shopComponent_module = __webpack_require__(132780);
var shopComponent_module_default = /*#__PURE__*/__webpack_require__.n(shopComponent_module);
// EXTERNAL MODULE: ./src/utils/checkRenderEnv.js
var checkRenderEnv = __webpack_require__(506337);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/esm/KeyboardArrowRight.js
var KeyboardArrowRight = __webpack_require__(626602);
// EXTERNAL MODULE: ./src/components/DesignSystem/Widgets2.0/Header/utils.tsx + 2 modules
var utils = __webpack_require__(545588);
// EXTERNAL MODULE: ./src/utils/smartWordBreakStyle.ts
var smartWordBreakStyle = __webpack_require__(451959);
// EXTERNAL MODULE: ./src/utils/appendSlashToUrl.js
var appendSlashToUrl = __webpack_require__(789393);
;// CONCATENATED MODULE: ./src/components/DesignSystem/Drawer/NewDropdown/DropdownOption.tsx










var Option = function(param) {
    var option = param.option, idx = param.idx, renderArray = param.renderArray, isShopComponent = param.isShopComponent, customItemConfigs = param.customItemConfigs, fromMobileMenuDrawer = param.fromMobileMenuDrawer, handleMouseAction = param.handleMouseAction, isSubNavListActive = param.isSubNavListActive;
    var ref = (0,utils/* useHeaderLinksUtils */.Tg)(), handleHeaderNavItemClick = ref.handleHeaderNavItemClick, getHeaderNavInlineLink = ref.getHeaderNavInlineLink;
    // Exact match the URL in the browser with the redirection link to prevent partial matching cases like : /blog, /blog/slug-url. Since these 2 are different links and should be treated as separate routes.
    var isNavLinkActive = !checkRenderEnv/* IS_SERVER */.W6 && !!option.redirectionLink ? window.location.pathname === (0,appendSlashToUrl/* appendSlashToUrl */.f)(option === null || option === void 0 ? void 0 : option.redirectionLink) : false;
    var ref1 = customItemConfigs || {}, onLinkHoverEnter = ref1.onLinkHoverEnter, onLinkHoverLeave = ref1.onLinkHoverLeave, getNavElementStyle = ref1.getNavElementStyle;
    var isLastOption = idx === renderArray.length - 1;
    var hasSubNavList = (option === null || option === void 0 ? void 0 : option.type) === "dropdown";
    var OptionName = /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "tw-flex tw-w-full tw-items-center tw-justify-between",
        children: [
            option.name,
            hasSubNavList && /*#__PURE__*/ (0,jsx_runtime.jsx)(KeyboardArrowRight/* default */.Z, {
                fontSize: "small"
            })
        ]
    });
    var inlineRedirectionLinkData = getHeaderNavInlineLink((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, option), {
        isShopComponent: isShopComponent
    }));
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CommonLinkWrapper/* default */.Z, {
        className: classnames_default()("tw-relative tw-px-[20px] [&>.underline-comp]:hover:tw-block", (!(option === null || option === void 0 ? void 0 : option.redirectionLink) || isNavLinkActive) && !isShopComponent && !Object.hasOwn(option, "id") && !hasSubNavList ? "tw-pointer-events-none" : " "),
        onMouseOver: function(e) {
            return handleMouseAction === null || handleMouseAction === void 0 ? void 0 : handleMouseAction(e.target);
        },
        link: inlineRedirectionLinkData.link,
        target: inlineRedirectionLinkData.target,
        disableLink: option.redirectNewPage || hasSubNavList,
        handleCustomClick: function() {
            if (option.redirectNewPage && !hasSubNavList) handleHeaderNavItemClick((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, option), {
                isShopComponent: isShopComponent
            }));
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
            onMouseEnter: function() {
                return onLinkHoverEnter(idx);
            },
            onMouseLeave: onLinkHoverLeave,
            style: (0,_object_spread/* default */.Z)({}, getNavElementStyle ? getNavElementStyle(idx) : {}, smartWordBreakStyle/* smartWordBreakStyle */.t),
            className: "tw-relative tw-w-fit tw-max-w-[150px] tw-select-none tw-whitespace-normal tw-leading-normal hover:!tw-font-semibold [&_.underline-comp]:hover:tw-block " + (!fromMobileMenuDrawer ? "tw-m-0 tw-text-[12px] tw-tracking-[0.95px] " + (!isLastOption ? "tw-pb-[16px]" : "") : "tw-m-0  " + (!isLastOption ? "tw-pb-[17.5px]" : "")) + (isSubNavListActive ? " !tw-font-semibold" : "") + (hasSubNavList ? " !tw-w-full" : ""),
            children: OptionName
        }, idx.id)
    }, option.name);
};

// EXTERNAL MODULE: ./node_modules/@mui/material/Popper/Popper.js + 2 modules
var Popper = __webpack_require__(46939);
;// CONCATENATED MODULE: ./src/components/DesignSystem/Drawer/NewDropdown/NestedLinks.tsx


var NestedLinksPopper = function(props) {
    var anchorEl = props.anchorEl, onClose = props.onClose;
    var open = Boolean(anchorEl);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Popper/* default */.Z, {
        open: open,
        onBlur: onClose,
        anchorEl: anchorEl,
        placement: "right",
        modifiers: [
            {
                name: "preventOverflow",
                options: {
                    boundary: "window"
                }
            },
            {
                name: "flip",
                options: {
                    fallbackPlacements: [
                        "left"
                    ]
                }
            }, 
        ],
        className: "tw-z-[9999] tw-h-fit",
        children: props.children
    });
};
/* harmony default export */ var NestedLinks = (NestedLinksPopper);

// EXTERNAL MODULE: ./src/hooks/useNavlinkStyling.ts
var useNavlinkStyling = __webpack_require__(177137);
;// CONCATENATED MODULE: ./src/components/DesignSystem/Drawer/NewDropdown/NewDropdown.tsx











var NavigationDropdown = function(_param) {
    var handleMouseAction = function handleMouseAction(target, index) {
        var ref;
        setCurrentIndex(index);
        if ((visibleOptionList === null || visibleOptionList === void 0 ? void 0 : (ref = visibleOptionList[index]) === null || ref === void 0 ? void 0 : ref.type) === "dropdown") {
            setAnchorEl(target);
        } else {
            anchorEl && setAnchorEl(null);
        }
    };
    var _isNested = _param.isNested, isNested = _isNested === void 0 ? false : _isNested, top = _param.top, optionsList = _param.optionsList, isHeaderHovered = _param.isHeaderHovered, _setShowDropdownIndex = _param.setShowDropdownIndex, setShowDropdownIndex = _setShowDropdownIndex === void 0 ? null : _setShowDropdownIndex, isScroll = _param.isScroll, props = (0,_object_without_properties/* default */.Z)(_param, [
        "isNested",
        "top",
        "optionsList",
        "isHeaderHovered",
        "setShowDropdownIndex",
        "isScroll"
    ]);
    var ref, ref1, ref2;
    var visibleOptionList = optionsList.filter(function(item) {
        return item.showOnHeader;
    });
    var _isShopComponent = props.isShopComponent, isShopComponent = _isShopComponent === void 0 ? false : _isShopComponent;
    var ref3 = (0,react.useState)(null), anchorEl = ref3[0], setAnchorEl = ref3[1];
    var ref4 = (0,react.useState)(-1), currentIndex = ref4[0], setCurrentIndex = ref4[1];
    var subNavItemsConfig = (0,useNavlinkStyling/* useNavlinkStyling */.u)({
        isScrollable: isScroll
    });
    (0,react.useEffect)(function() {
        !isHeaderHovered && setShowDropdownIndex && setShowDropdownIndex(-1);
    }, [
        isHeaderHovered
    ]);
    if (!(optionsList === null || optionsList === void 0 ? void 0 : optionsList.length)) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            style: (0,_object_spread/* default */.Z)({
                top: "".concat(top, "px"),
                color: "#000"
            }, props.dropDownStyle || {}, isNested ? {
                position: "static",
                transform: "none"
            } : {}),
            className: classnames_default()(props.wrapperClass, "tw-z-[101] ", !props.fromMobileMenuDrawer ? classnames_default()("tw-relative  ", (shopComponent_module_default())["cfe-dropdown-nav"]) : " tw-overflow-y-auto tw-p-0 [&>div>p]:tw-text-[13px] [&>div>p]:tw-font-semibold [&>div>p]:tw-text-newBlack [&>div]:!tw-border-l-0 [&>div]:!tw-pl-0"),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    style: {
                        maxHeight: "360px"
                    },
                    className: classnames_default()(!props.fromMobileMenuDrawer ? classnames_default()((shopComponent_module_default())["cfe-dropdown-nav__items"], "tw-py-[20px]") : "tw-mt-[22.5px]"),
                    children: visibleOptionList.map(function(option, idx, renderArray) {
                        var ref;
                        /*#__PURE__*/ return (0,jsx_runtime.jsx)(Option, {
                            option: option,
                            idx: idx,
                            renderArray: renderArray,
                            isShopComponent: isShopComponent,
                            customItemConfigs: props === null || props === void 0 ? void 0 : props.customItemConfigs,
                            fromMobileMenuDrawer: props === null || props === void 0 ? void 0 : props.fromMobileMenuDrawer,
                            handleMouseAction: function(target) {
                                return handleMouseAction(target, idx);
                            },
                            isSubNavListActive: idx === currentIndex && (visibleOptionList === null || visibleOptionList === void 0 ? void 0 : (ref = visibleOptionList[currentIndex]) === null || ref === void 0 ? void 0 : ref.type) === "dropdown"
                        }, idx);
                    })
                }),
                !!anchorEl && (visibleOptionList === null || visibleOptionList === void 0 ? void 0 : (ref = visibleOptionList[currentIndex]) === null || ref === void 0 ? void 0 : (ref1 = ref.option) === null || ref1 === void 0 ? void 0 : ref1.length) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(NestedLinks, {
                    anchorEl: anchorEl,
                    onClose: function() {
                        setAnchorEl(null);
                        setCurrentIndex(-1);
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NavigationDropdown, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                        top: top,
                        optionsList: visibleOptionList === null || visibleOptionList === void 0 ? void 0 : (ref2 = visibleOptionList[currentIndex]) === null || ref2 === void 0 ? void 0 : ref2.option,
                        isNested: true,
                        isHeaderHovered: isHeaderHovered,
                        customItemConfigs: subNavItemsConfig,
                        isScroll: isScroll
                    }))
                }) : null
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/components/DesignSystem/Drawer/NewDropdown/index.ts


// EXTERNAL MODULE: ./src/components/DesignSystem/Drawer/MenuDrawerMobile/index.ts + 1 modules
var MenuDrawerMobile = __webpack_require__(586361);
// EXTERNAL MODULE: ./src/components/DesignSystem/Drawer/MegaMenuDrawerDesktop/index.ts + 2 modules
var MegaMenuDrawerDesktop = __webpack_require__(99650);
// EXTERNAL MODULE: ./src/components/Common/ReactHamburger/index.js + 1 modules
var ReactHamburger = __webpack_require__(70440);
// EXTERNAL MODULE: ./src/utils/showMegaMenu.js
var showMegaMenu = __webpack_require__(36408);
// EXTERNAL MODULE: ./src/redux/index.ts
var redux = __webpack_require__(268037);
// EXTERNAL MODULE: ./src/hooks/useStoreContactDetails.tsx
var useStoreContactDetails = __webpack_require__(299375);
// EXTERNAL MODULE: ./src/utils/getWhatsAppRedirectionUrl.js
var getWhatsAppRedirectionUrl = __webpack_require__(230066);
;// CONCATENATED MODULE: ./src/components/DesignSystem/Widgets2.0/Header/components/NavLinkRenderer.tsx























var TWO_LINE_HEADER = [
    "header3",
    "header4"
];
function hamburgerIcon() {
    var color = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", size = arguments.length > 1 ? arguments[1] : void 0;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M21 6.75H3C2.80109 6.75 2.61032 6.67098 2.46967 6.53033C2.32902 6.38968 2.25 6.19891 2.25 6C2.25 5.80109 2.32902 5.61032 2.46967 5.46967C2.61032 5.32902 2.80109 5.25 3 5.25H21C21.1989 5.25 21.3897 5.32902 21.5303 5.46967C21.671 5.61032 21.75 5.80109 21.75 6C21.75 6.19891 21.671 6.38968 21.5303 6.53033C21.3897 6.67098 21.1989 6.75 21 6.75ZM21.75 12C21.75 11.8011 21.671 11.6103 21.5303 11.4697C21.3897 11.329 21.1989 11.25 21 11.25H3C2.80109 11.25 2.61032 11.329 2.46967 11.4697C2.32902 11.6103 2.25 11.8011 2.25 12C2.25 12.1989 2.32902 12.3897 2.46967 12.5303C2.61032 12.671 2.80109 12.75 3 12.75H21C21.1989 12.75 21.3897 12.671 21.5303 12.5303C21.671 12.3897 21.75 12.1989 21.75 12ZM12.75 18C12.75 17.8011 12.671 17.6103 12.5303 17.4697C12.3897 17.329 12.1989 17.25 12 17.25H3C2.80109 17.25 2.61032 17.329 2.46967 17.4697C2.32902 17.6103 2.25 17.8011 2.25 18C2.25 18.1989 2.32902 18.3897 2.46967 18.5303C2.61032 18.671 2.80109 18.75 3 18.75H12C12.1989 18.75 12.3897 18.671 12.5303 18.5303C12.671 18.3897 12.75 18.1989 12.75 18Z",
            fill: color
        })
    });
}
var NavLinkRenderer = function(props) {
    var getUrl = function getUrl() {
        var ref, ref1;
        if (!(pathName === null || pathName === void 0 ? void 0 : pathName.includes(store === null || store === void 0 ? void 0 : (ref = store.store_info) === null || ref === void 0 ? void 0 : ref.domain))) return pathName;
        var updatedPathName = pathName === null || pathName === void 0 ? void 0 : pathName.split(store === null || store === void 0 ? void 0 : (ref1 = store.store_info) === null || ref1 === void 0 ? void 0 : ref1.domain);
        return updatedPathName[1] || "/";
    };
    var getHoverTextColor = function getHoverTextColor() {
        var type = currentClass.base_config.defaulthoverType;
        switch(type){
            case "Underline":
                return currentClass.base_config.defaultUnderlineTextColor;
            case "Background Box":
                return currentClass.base_config.defaultBoxTextColor;
            case "None":
                var ref;
                return currentClass === null || currentClass === void 0 ? void 0 : (ref = currentClass.base_config) === null || ref === void 0 ? void 0 : ref.defaultNavLinksColor;
        }
    };
    var checkForUnderline = function checkForUnderline() {
        if (currentClass.base_config.defaulthoverType === "Underline") {
            if (currentClass.base_config.defaultUnderLineType === "above") {
                return "above";
            } else {
                return "below";
            }
        }
        return "";
    };
    var renderLinks = function renderLinks() {
        var hamburgerMenu = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            style: {
                justifyContent: base_config.defaultPosition
            },
            className: "nav-links tw-flex tw-cursor-pointer tw-items-center ".concat(hamburgerMenu ? "tw-flex-col tw-gap-y-[20px]" : "", " hover:tw-text-[red]"),
            children: navlinkList === null || navlinkList === void 0 ? void 0 : navlinkList.map(function(item, index) {
                var ref, ref1, ref2, ref3, ref4;
                var id = item.id, name = item.name, redirectionLink = item.redirectionLink, showOnHeader = item.showOnHeader, type = item.type, option = item.option, isShopComponent = item.isShopComponent, _redirectNewPage = item.redirectNewPage, redirectNewPage = _redirectNewPage === void 0 ? false : _redirectNewPage;
                var isTypeDropdown = type === "dropdown";
                var dropDownList = getDropdownList(isShopComponent, option);
                var isDropdownOpened = isShopComponent && (0,showMegaMenu/* showMegaMenu */.G)() ? state.openMegaMenuOnDesktop : showDropdownIndex === index;
                var updatedLink = (redirectionLink === null || redirectionLink === void 0 ? void 0 : redirectionLink.startsWith("/")) ? redirectionLink : "/".concat(redirectionLink);
                var isHomePageActive = [
                    routes.PATH.DOMAIN_HOME,
                    routes.PATH.PRODUCT
                ].includes(getUrl());
                var isNavLinkActive = !checkRenderEnv/* IS_SERVER */.W6 ? !isHomePageActive && getUrl() === updatedLink && !isTypeDropdown : false;
                var updatedNavLink = (redirectionLink === null || redirectionLink === void 0 ? void 0 : redirectionLink.startsWith("/")) ? redirectionLink === null || redirectionLink === void 0 ? void 0 : redirectionLink.slice(1) : redirectionLink;
                var inlineRedirectionLinkData = getHeaderNavInlineLink(item);
                var newPageLink = inlineRedirectionLinkData.link;
                var navLinkPointerEventsDisabled = isTypeDropdown ? !(dropDownList === null || dropDownList === void 0 ? void 0 : dropDownList.length) : !!redirectionLink && isNavLinkActive;
                var OptionName = /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "tw-m-0 tw-select-none tw-whitespace-nowrap tw-break-keep tw-tracking-[0.9px] ",
                    style: {
                        color: "inherit",
                        textDecoration: "none"
                    },
                    children: name
                });
                return showOnHeader && /*#__PURE__*/ (0,jsx_runtime.jsx)(ClickAwayListener/* ClickAwayListener */.d, {
                    onClickAway: function() {
                        return setShowDropdownIndex(-1);
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        onMouseOver: function(e) {
                            e.stopPropagation();
                            if (isTypeDropdown) {
                                if (isShopComponent && (0,showMegaMenu/* showMegaMenu */.G)()) {
                                    setShowDropdownIndex(-1);
                                    setState(function(oldState) {
                                        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, oldState), {
                                            openMegaMenuOnDesktop: true
                                        });
                                    });
                                } else {
                                    setShowDropdownIndex(index);
                                    setState(function(oldState) {
                                        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, oldState), {
                                            openMegaMenuOnDesktop: false
                                        });
                                    });
                                }
                            } else {
                                setShowDropdownIndex(-1);
                                setState(function(oldState) {
                                    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, oldState), {
                                        openMegaMenuOnDesktop: false
                                    });
                                });
                            }
                        },
                        ref: function(ref) {
                            return linkListRefs.current[index] = ref;
                        },
                        style: getNavElementStyle(index),
                        className: classnames_default()("tw-relative tw-m-[10px] tw-flex tw-items-center [&>.underline-comp]:hover:tw-block", (isDropdownOpened || isNavLinkActive) && "[&>.underline-comp]:tw-block", navLinkPointerEventsDisabled && "tw-pointer-events-none"),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: " tw-flex tw-items-center tw-px-[5px] tw-py-[6px]",
                                onMouseEnter: function() {
                                    return onLinkHoverEnter(index);
                                },
                                onMouseLeave: onLinkHoverLeave,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CommonLinkWrapper/* default */.Z, {
                                        disableLink: redirectNewPage || isTypeDropdown,
                                        handleCustomClick: function() {
                                            if (!redirectNewPage || isTypeDropdown) return;
                                            onCustomNavItemClick({
                                                link: redirectNewPage ? newPageLink : (0,utils/* getRedirectLinkForSlug */.ys)(navigationList, updatedNavLink, id),
                                                openInNewTab: redirectNewPage,
                                                isTypeDropdown: isTypeDropdown
                                            });
                                        },
                                        target: inlineRedirectionLinkData.target,
                                        link: newPageLink,
                                        children: OptionName
                                    }),
                                    isTypeDropdown ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "tw-ml-[7px] tw-flex tw-items-center ",
                                        children: isDropdownOpened ? /*#__PURE__*/ (0,jsx_runtime.jsx)(svgIcons/* AccordionCloseIcon */.x$, {
                                            secondaryColor: hoverIndex === index ? getHoverTextColor() : currentClass.base_config.defaultNavLinksColor
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(svgIcons/* AccordionOpenIcon */.Be, {
                                            secondaryColor: hoverIndex === index ? getHoverTextColor() : currentClass.base_config.defaultNavLinksColor
                                        })
                                    }) : null
                                ]
                            }),
                            isTypeDropdown && isDropdownOpened && !(isShopComponent && (0,showMegaMenu/* showMegaMenu */.G)()) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(NavigationDropdown, {
                                optionsList: dropDownList,
                                isShopComponent: isShopComponent,
                                wrapperClass: "tw-font-dmSans ",
                                dropDownStyle: {
                                    background: currentClass === null || currentClass === void 0 ? void 0 : (ref = currentClass.base_config) === null || ref === void 0 ? void 0 : ref.defaultBackgroundColor
                                },
                                customItemConfigs: customItemConfigs,
                                top: isTransparent ? (headerRef === null || headerRef === void 0 ? void 0 : (ref1 = headerRef.current) === null || ref1 === void 0 ? void 0 : ref1.clientHeight) - (((ref2 = linkListRefs.current[index]) === null || ref2 === void 0 ? void 0 : ref2.offsetTop) + ((TWO_LINE_HEADER === null || TWO_LINE_HEADER === void 0 ? void 0 : TWO_LINE_HEADER.includes(headerName)) ? 3 : 0)) : (headerRef === null || headerRef === void 0 ? void 0 : (ref3 = headerRef.current) === null || ref3 === void 0 ? void 0 : ref3.clientHeight) - ((ref4 = linkListRefs.current[index]) === null || ref4 === void 0 ? void 0 : ref4.offsetTop),
                                isHeaderHovered: isHeaderHovered,
                                setShowDropdownIndex: setShowDropdownIndex,
                                isScroll: isScroll
                            }) : null,
                            _RenderUnderlineComponent === null || _RenderUnderlineComponent === void 0 ? void 0 : _RenderUnderlineComponent(index)
                        ]
                    }, name)
                });
            })
        });
    };
    var canShowItem = function canShowItem(item) {
        var ref;
        return (item === null || item === void 0 ? void 0 : (ref = item.action) === null || ref === void 0 ? void 0 : ref.actionType) !== "whatsapp" || !!storePhone;
    };
    var renderHamBurgerMenu = function renderHamBurgerMenu() {
        var desktopIconConfig = globalClass.staticClass.base_config.defaultFontSizeType;
        var mobileIconConfig = globalClass.staticClass.base_config.defaultFontSizeTypeMobile;
        var sizeDetails = (0,getSizeAccType/* getIconSizeAccToConfig */.hE)(isMobile ? mobileIconConfig : desktopIconConfig);
        var customItemsList = (0,utils/* getHamburgerCustomList */.R0)(activeHeaderData, onMenuDrawerItemClick, closeMenuDrawerOnMobile, canShowItem);
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "tw-min-w-max tw-flex-shrink-0",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    style: {
                        width: 30
                    },
                    className: "tw-cursor-pointer",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ReactHamburger["default"], {
                        style: {
                            width: 23
                        },
                        open: state.openMenuDrawerOnMobile,
                        setOpen: openMenuDrawerOnMobile,
                        theme: "#111C36",
                        showIcon: function() {
                            var ref;
                            return hamburgerIcon(currentClass === null || currentClass === void 0 ? void 0 : (ref = currentClass.base_config) === null || ref === void 0 ? void 0 : ref.defaultNavLinksColor, sizeDetails);
                        },
                        showDiffIcon: true
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuDrawerMobile/* MenuDrawerMobile */.R, {
                    isVisible: state.openMenuDrawerOnMobile,
                    closeDrawer: closeMenuDrawerOnMobile,
                    renderList: componentData,
                    fromNewHeader: true,
                    customItemList: customItemsList,
                    isScroll: isScroll,
                    isHeaderHovered: isHeaderHovered
                })
            ]
        });
    };
    var ref;
    var activeHeaderData = props.activeHeaderData, dynamicSectionData = props.dynamicSectionData, headerNodeRef = props.headerNodeRef, isBuilder = props.isBuilder, componentData = props.componentData, base_config = props.base_config, currentClass = props.currentClass, globalClass = props.globalClass, _showDynamicSection = props.showDynamicSection, showDynamicSection = _showDynamicSection === void 0 ? false : _showDynamicSection, headerRef = props.headerRef, headerName = props.headerName, // globalStyleObject,
    isScroll = props.isScroll, isHeaderHovered = props.isHeaderHovered, isTransparent = props.isTransparent;
    var deviceType = (0,useGetDeviceType/* useGetDeviceType */.n)().deviceType;
    var isMobile = deviceType === "mobile";
    var ref1 = (0,react.useState)(-1), showDropdownIndex = ref1[0], setShowDropdownIndex = ref1[1];
    var ref2 = (0,react.useState)({
        openMenuDrawerOnMobile: false,
        openDropdownOnDesktop: false,
        openMegaMenuOnDesktop: false
    }), state = ref2[0], setState = ref2[1];
    var ref3 = (0,redux/* useSSRSelector */.kF)(function(state) {
        return {
            store: state.storeReducer.store,
            navigationList: state.additionalPagesReducer.navigationList,
            pathName: state.commonReducer.path || checkRenderEnv/* IS_SERVER */.W6 ? "" : window.location.pathname
        };
    }), store = ref3.store, navigationList = ref3.navigationList, pathName = ref3.pathName;
    var ref4 = (0,utils/* useHeaderLinksUtils */.Tg)(), getDropdownList = ref4.getDropdownList, onCustomNavItemClick = ref4.onCustomNavItemClick, getHeaderNavInlineLink = ref4.getHeaderNavInlineLink;
    var linkListRefs = (0,react.useRef)([]);
    var containerRef = (0,react.useRef)(null);
    var megaMenuStyles = {
        background: currentClass === null || currentClass === void 0 ? void 0 : (ref = currentClass.base_config) === null || ref === void 0 ? void 0 : ref.defaultBackgroundColor
    };
    var navlinkList = (0,utils/* useGetNavlinkList */.qd)({
        activeHeaderData: activeHeaderData,
        dynamicSectionData: dynamicSectionData,
        headerNodeRef: headerNodeRef,
        isBuilder: isBuilder,
        componentData: componentData,
        headerName: headerName,
        containerRef: containerRef,
        isMobile: isMobile
    }).navlinkList;
    // For parent
    var ref5 = (0,useNavlinkStyling/* useNavlinkStyling */.u)({
        isScrollable: isScroll,
        isHeaderHovered: isHeaderHovered
    }), onLinkHoverEnter = ref5.onLinkHoverEnter, onLinkHoverLeave = ref5.onLinkHoverLeave, getNavElementStyle = ref5.getNavElementStyle, hoverIndex = ref5.hoverIndex;
    // For dropdown
    var customItemConfigs = (0,useNavlinkStyling/* useNavlinkStyling */.u)();
    var storePhone = (0,useStoreContactDetails/* default */.Z)().storePhone;
    var openMenuDrawerOnMobile = function() {
        setState(function(x) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, x), {
                openMenuDrawerOnMobile: true
            });
        });
    };
    var closeMenuDrawerOnMobile = function() {
        setState(function(x) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, x), {
                openMenuDrawerOnMobile: false
            });
        });
    };
    var onMenuDrawerItemClick = function(action, page) {
        switch(action){
            case "whatsapp":
                (0,getWhatsAppRedirectionUrl/* openWhatsAppLeadModal */.iM)();
                break;
            case "redirect":
                onCustomNavItemClick({
                    link: page
                });
                break;
            default:
                break;
        }
        closeMenuDrawerOnMobile();
    };
    var _RenderUnderlineComponent = function() {
        var index = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : -1, customStyle = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        var ref, ref1;
        /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
            className: "".concat(checkForUnderline() ? "underline-comp" : "", " tw-absolute tw-z-10 tw-hidden tw-h-[1px] tw-rounded-[0.5px]"),
            style: (0,_object_spread/* default */.Z)({
                width: "calc(100% - 10px)",
                left: "50%",
                transform: "translateX(-50%)",
                backgroundColor: currentClass === null || currentClass === void 0 ? void 0 : currentClass.base_config.defaultUnderlineColor,
                height: checkForUnderline() === "below" ? "3px" : "1px",
                bottom: checkForUnderline() === "above" ? -1 : "",
                top: checkForUnderline() === "below" ? (headerRef === null || headerRef === void 0 ? void 0 : (ref = headerRef.current) === null || ref === void 0 ? void 0 : ref.clientHeight) - ((ref1 = linkListRefs.current[index]) === null || ref1 === void 0 ? void 0 : ref1.offsetTop) - 3 : ""
            }, customStyle)
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        ref: containerRef,
        className: "tw-flex tw-items-center ".concat(isMobile ? "tw-gap-[16px]" : "tw-gap-[20px]", " ").concat(base_config.customClass, " !tw-w-[auto] ").concat(base_config.type === "hamburger" ? "" : "tw-justify-center"),
        children: [
            base_config.type === "hamburger" ? renderHamBurgerMenu() : renderLinks(),
            showDynamicSection && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dynamicComponent/* DynamicComponent */.B5, {
                    currentClass: currentClass,
                    globalClass: globalClass
                })
            }),
            state.openMegaMenuOnDesktop && /*#__PURE__*/ (0,jsx_runtime.jsx)(MegaMenuDrawerDesktop/* MegaMenuDrawerDesktop */.G, {
                open: state.openMegaMenuOnDesktop,
                onClose: function() {
                    return setState(function(x) {
                        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, x), {
                            openMegaMenuOnDesktop: false
                        });
                    });
                },
                forNewHeader: true,
                customStylist: {
                    megaMenuStyles: megaMenuStyles,
                    isScroll: isScroll
                },
                _RenderUnderlineComponent: _RenderUnderlineComponent
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(225617);
// EXTERNAL MODULE: ./src/utils/constants/index.js
var constants = __webpack_require__(913886);
// EXTERNAL MODULE: ./src/components/LoginAndDropdownComponent/index.js
var LoginAndDropdownComponent = __webpack_require__(629492);
// EXTERNAL MODULE: ./src/components/WidgetMaker/WidgetDnD/WIdgetPropertiesBasic/components/Button/index.tsx + 1 modules
var Button = __webpack_require__(846976);
// EXTERNAL MODULE: ./src/components/WidgetMaker/utils/buttonConstant.ts
var buttonConstant = __webpack_require__(291850);
// EXTERNAL MODULE: ./src/components/DesignSystem/ModernTheme/utils/btnUtils.js
var btnUtils = __webpack_require__(993080);
// EXTERNAL MODULE: ./src/components/DesignSystem/Widgets2.0/Carousel/utils.tsx
var Carousel_utils = __webpack_require__(658619);
;// CONCATENATED MODULE: ./src/components/DesignSystem/Widgets2.0/Header/components/subComponents/HeaderButtonsLayout.tsx







function HeaderButtonsLayout(param) {
    var isMobile = param.isMobile, activeHeaderData = param.activeHeaderData;
    var ref, ref1, ref2, ref3;
    if (isMobile || !(activeHeaderData === null || activeHeaderData === void 0 ? void 0 : (ref = activeHeaderData.headerPropsConfig) === null || ref === void 0 ? void 0 : (ref1 = ref.buttons) === null || ref1 === void 0 ? void 0 : ref1.length)) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (0,bundle_mjs/* twMerge */.m6)("tw-flex tw-items-center tw-gap-[24px]"),
        children: activeHeaderData === null || activeHeaderData === void 0 ? void 0 : (ref2 = activeHeaderData.headerPropsConfig) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.buttons) === null || ref3 === void 0 ? void 0 : ref3.map(function(buttonData, btnIndex) {
            var buttonVariant = (0,Carousel_utils/* getButtonVariantsData */.Tk)(buttonData);
            var selectedButtonType = buttonVariant[buttonData.type];
            return buttonData.isShow ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                size: buttonConstant/* BUTTON_SIZE_TYPE.SMALL */.n6.SMALL,
                btnType: buttonData.type,
                buttonData: buttonData,
                selectedButtonData: selectedButtonType,
                variant: selectedButtonType.variant,
                onClick: function() {
                    return (0,btnUtils/* btnActionHandler */.c)(buttonData === null || buttonData === void 0 ? void 0 : buttonData.actions, function() {});
                },
                className: (0,bundle_mjs/* twMerge */.m6)("!tw-w-auto tw-rounded-[0px] !tw-py-[16px] !tw-pb-[10px] !tw-pt-[10px] !tw-text-[14px] !tw-font-medium !tw-leading-[20px] tw-text-newBlack [&>p]:!tw-text-ellipsis [&>p]:!tw-whitespace-nowrap ".concat(buttonData.type === buttonConstant/* BUTTON_TYPE.TEXTUAL */.JB.TEXTUAL ? "!tw-pb-[0px] !tw-pt-[0px]" : "")),
                children: buttonData === null || buttonData === void 0 ? void 0 : buttonData.text
            }, btnIndex) : null;
        })
    });
}

// EXTERNAL MODULE: ./src/redux/actions/storeInfo.js
var storeInfo = __webpack_require__(117321);
// EXTERNAL MODULE: ./src/utils/isStoreB2B.js
var isStoreB2B = __webpack_require__(43935);
// EXTERNAL MODULE: ./src/assets/svgExports/WishlistHeartBuilderIcon.js
var WishlistHeartBuilderIcon = __webpack_require__(973664);
;// CONCATENATED MODULE: ./src/components/DesignSystem/Widgets2.0/Header/components/NavIconRenderer.tsx



















var getIcon = function(type, size, color) {
    switch(type){
        case "loginLogout":
            {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                    width: size,
                    height: size,
                    viewBox: "0 0 28 28",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M23.3332 24.5V22.1667C23.3332 20.929 22.8415 19.742 21.9663 18.8668C21.0912 17.9917 19.9042 17.5 18.6665 17.5H9.33317C8.09549 17.5 6.90851 17.9917 6.03334 18.8668C5.15817 19.742 4.6665 20.929 4.6665 22.1667V24.5M18.6665 8.16667C18.6665 10.744 16.5772 12.8333 13.9998 12.8333C11.4225 12.8333 9.33317 10.744 9.33317 8.16667C9.33317 5.58934 11.4225 3.5 13.9998 3.5C16.5772 3.5 18.6665 5.58934 18.6665 8.16667Z",
                        stroke: color,
                        "stroke-width": "1.4",
                        strokeLinecap: "round",
                        "stroke-linejoin": "round"
                    })
                });
            }
        case "cart":
            {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                    width: size,
                    height: size,
                    viewBox: "0 0 28 28",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M4.55029 7.7L7.70029 3.5H20.3003L23.4503 7.7M4.55029 7.7V22.4C4.55029 22.957 4.77154 23.4911 5.16537 23.8849C5.5592 24.2787 6.09334 24.5 6.65029 24.5H21.3503C21.9072 24.5 22.4414 24.2787 22.8352 23.8849C23.229 23.4911 23.4503 22.957 23.4503 22.4V7.7M4.55029 7.7H23.4503M18.2003 11.9C18.2003 13.0139 17.7578 14.0822 16.9701 14.8698C16.1825 15.6575 15.1142 16.1 14.0003 16.1C12.8864 16.1 11.8181 15.6575 11.0304 14.8698C10.2428 14.0822 9.80029 13.0139 9.80029 11.9",
                        stroke: color,
                        "stroke-width": "1.4",
                        strokeLinecap: "round",
                        "stroke-linejoin": "round"
                    })
                });
            }
        case "contact":
            {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: size,
                    height: size,
                    viewBox: "0 0 28 28",
                    fill: "none",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M24.4991 13.9666C24.4628 11.206 23.341 8.59728 21.3405 6.62107C19.3031 4.60844 16.6138 3.5 13.7678 3.5C11.0205 3.5 8.45041 4.54427 6.5309 6.44038C4.82756 8.12301 3.78253 10.3672 3.58814 12.7595C3.40378 15.0293 3.98871 17.3263 5.23775 19.2576L3.53214 23.8119C3.46056 24.003 3.51083 24.218 3.66013 24.3587C3.75823 24.4512 3.88674 24.5 4.01726 24.5C4.08532 24.5 4.15399 24.4805 4.2191 24.4532L8.66124 22.5859C10.357 23.6285 12.2961 24.1659 14.2872 24.1659C17.034 24.1659 19.6042 23.134 21.5234 21.2381C23.4786 19.3067 24.5354 16.7323 24.4991 13.9666ZM20.792 20.5281C19.068 22.2312 16.7578 23.169 14.2871 23.169C12.4061 23.1689 10.5761 22.6251 8.9948 21.5961C8.90905 21.5404 8.80997 21.512 8.71032 21.512C8.6419 21.512 8.57323 21.5253 8.50843 21.5525L4.91765 23.057L6.2984 19.3701C6.35616 19.2158 6.33517 19.0434 6.24203 18.9071C3.70414 15.193 4.1332 10.2538 7.26224 7.16287C8.98637 5.45971 11.2967 4.52169 13.7678 4.52169C16.3375 4.52169 18.7671 5.52382 20.6091 7.34351C22.4179 9.13025 23.4321 11.4871 23.4649 13.9799C23.4976 16.4676 22.5484 18.7932 20.792 20.5281Z",
                            fill: color
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M16.5124 15.8314C16.3512 15.8562 16.2481 16.0114 16.0869 16.2535C15.9193 16.5143 15.7259 16.8123 15.3519 16.9116C15.1521 16.9675 14.7781 16.9675 13.8949 16.3591C13.3727 15.999 12.7538 15.4775 12.1993 14.9311C11.3096 14.0557 11.2967 13.8385 11.2967 13.7577C11.2774 13.3977 11.574 13.0997 11.8383 12.8389C11.9995 12.6837 12.1606 12.5223 12.2122 12.3857C12.2316 12.2864 12.0962 11.8393 11.7287 11.2061C11.3612 10.5728 11.0324 10.2252 10.9293 10.1879C10.9164 10.1817 10.8906 10.1817 10.8648 10.1817C10.6778 10.1817 10.2201 10.2872 9.82036 10.6411C9.40775 11.0136 8.99514 11.7338 9.37551 13.0376C10.0782 15.4651 12.2896 17.4269 15.6034 18.5506C16.4802 18.8486 17.2022 18.8486 17.7373 18.5382C18.4852 18.1036 18.7109 17.191 18.7689 16.8185C18.7753 16.7874 18.7624 16.7564 18.7431 16.7316C18.2982 16.2846 16.9186 15.7631 16.5124 15.8314Z",
                            fill: color
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M24.4991 13.9666C24.4628 11.206 23.341 8.59728 21.3405 6.62107C19.3031 4.60844 16.6138 3.5 13.7678 3.5C11.0205 3.5 8.45041 4.54427 6.5309 6.44038C4.82756 8.12301 3.78253 10.3672 3.58814 12.7595C3.40378 15.0293 3.98871 17.3263 5.23775 19.2576L3.53214 23.8119C3.46056 24.003 3.51083 24.218 3.66013 24.3587C3.75823 24.4512 3.88674 24.5 4.01726 24.5C4.08532 24.5 4.15399 24.4805 4.2191 24.4532L8.66124 22.5859C10.357 23.6285 12.2961 24.1659 14.2872 24.1659C17.034 24.1659 19.6042 23.134 21.5234 21.2381C23.4786 19.3067 24.5354 16.7323 24.4991 13.9666ZM20.792 20.5281C19.068 22.2312 16.7578 23.169 14.2871 23.169C12.4061 23.1689 10.5761 22.6251 8.9948 21.5961C8.90905 21.5404 8.80997 21.512 8.71032 21.512C8.6419 21.512 8.57323 21.5253 8.50843 21.5525L4.91765 23.057L6.2984 19.3701C6.35616 19.2158 6.33517 19.0434 6.24203 18.9071C3.70414 15.193 4.1332 10.2538 7.26224 7.16287C8.98637 5.45971 11.2967 4.52169 13.7678 4.52169C16.3375 4.52169 18.7671 5.52382 20.6091 7.34351C22.4179 9.13025 23.4321 11.4871 23.4649 13.9799C23.4976 16.4676 22.5484 18.7932 20.792 20.5281Z",
                            stroke: color,
                            "stroke-width": "0.2"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M16.5124 15.8314C16.3512 15.8562 16.2481 16.0114 16.0869 16.2535C15.9193 16.5143 15.7259 16.8123 15.3519 16.9116C15.1521 16.9675 14.7781 16.9675 13.8949 16.3591C13.3727 15.999 12.7538 15.4775 12.1993 14.9311C11.3096 14.0557 11.2967 13.8385 11.2967 13.7577C11.2774 13.3977 11.574 13.0997 11.8383 12.8389C11.9995 12.6837 12.1606 12.5223 12.2122 12.3857C12.2316 12.2864 12.0962 11.8393 11.7287 11.2061C11.3612 10.5728 11.0324 10.2252 10.9293 10.1879C10.9164 10.1817 10.8906 10.1817 10.8648 10.1817C10.6778 10.1817 10.2201 10.2872 9.82036 10.6411C9.40775 11.0136 8.99514 11.7338 9.37551 13.0376C10.0782 15.4651 12.2896 17.4269 15.6034 18.5506C16.4802 18.8486 17.2022 18.8486 17.7373 18.5382C18.4852 18.1036 18.7109 17.191 18.7689 16.8185C18.7753 16.7874 18.7624 16.7564 18.7431 16.7316C18.2982 16.2846 16.9186 15.7631 16.5124 15.8314Z",
                            stroke: color,
                            "stroke-width": "0.2"
                        })
                    ]
                });
            }
        case "wishlist":
            {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(WishlistHeartBuilderIcon/* default */.Z, {
                    size: size,
                    color: color
                });
            }
        default:
            return null;
    }
};
var NavIconRenderer = function(props) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6;
    var router = (0,next_router.useRouter)();
    var dispatch = (0,es/* useDispatch */.I0)();
    var componentData = props.componentData, _showDynamicSection = props.showDynamicSection, showDynamicSection = _showDynamicSection === void 0 ? false : _showDynamicSection, currentClass = props.currentClass, globalClass = props.globalClass, activeHeaderData = props.activeHeaderData, dynamicSectionConfig = props.dynamicSectionConfig;
    var ref7 = (0,ssrStore/* useSSRSelector */.kF)(function(state) {
        return {
            storeData: state.storeReducer.store,
            items: state.cartReducer.items
        };
    }), storeData = ref7.storeData, items = ref7.items;
    var ref8 = currentClass || {}, tmp = ref8.base_config, defaultHoverIconState = (tmp === void 0 ? {} : tmp).defaultHoverIconState;
    var canRenderText = componentData === null || componentData === void 0 ? void 0 : (ref = componentData.appearanceType) === null || ref === void 0 ? void 0 : ref.includes("text");
    var canRenderImage = componentData === null || componentData === void 0 ? void 0 : (ref1 = componentData.appearanceType) === null || ref1 === void 0 ? void 0 : ref1.includes("icon");
    var deviceType = (0,useGetDeviceType/* useGetDeviceType */.n)().deviceType;
    var isMobile = deviceType === "mobile";
    var LINK_ICON_MAP = (0,react.useMemo)(function() {
        var ref;
        return {
            cart: (0,isStoreB2B/* isB2BStore */.h)() ? (0,routes.getRoute)("cart", storeData === null || storeData === void 0 ? void 0 : (ref = storeData.store_info) === null || ref === void 0 ? void 0 : ref.domain) : ""
        };
    }, []);
    var iconRenderList = componentData === null || componentData === void 0 ? void 0 : (ref2 = componentData.iconsList) === null || ref2 === void 0 ? void 0 : ref2.reduce(function(total, item) {
        var name = item.name, visibility = item.visibility;
        var visibilityDeviceKey = isMobile ? "mobileHeader" : "desktopHeader";
        var isWebFrame = (0,utils/* isWebFrameRoute */.RA)();
        // Equality for false is used to handles 'undefined' case, where the visibility config may not be present in initially saved config, so icon will be shown in that case
        var showIcon = (visibility === null || visibility === void 0 ? void 0 : visibility[visibilityDeviceKey]) === false ? false : true;
        // id = 3 is for cart
        if ((item === null || item === void 0 ? void 0 : item.id) === 3 && isWebFrame) {
            showIcon = false;
        }
        // On mobile icon can only be visible in hamburger menu or mobile header at a time
        if (isMobile && (visibility === null || visibility === void 0 ? void 0 : visibility["hamburger"])) showIcon = false;
        if (!showIcon) return total;
        if (name === "search") return total;
        if (name === "loginLogout" && isMobile) return total;
        total.push(item);
        return total;
    }, []);
    var navItemClick = function(link) {
        var openInNewTab = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        if (link === "/".concat(routes.PATH.CART) && (0,isStoreB2B/* isB2BStore */.h)()) {
            dispatch((0,storeInfo/* toggleRfqFormModal */.H4)());
            return;
        }
        if (openInNewTab) {
            window.open(link, "_blank");
        } else {
            var ref;
            router.push((0,routes.getRoute)(link, storeData === null || storeData === void 0 ? void 0 : (ref = storeData.store_info) === null || ref === void 0 ? void 0 : ref.domain));
        }
    };
    var getCartNumberPosition = function(currentSize) {
        var updatedCurrSize = Number(currentSize);
        return updatedCurrSize - updatedCurrSize / 100 * 31;
    };
    var onItemClick = function(action) {
        switch(action.actionType){
            case "whatsapp":
                (0,getWhatsAppRedirectionUrl/* openWhatsAppLeadModal */.iM)();
                break;
            case "redirect":
                navItemClick(action.actionData);
                break;
            default:
                break;
        }
    };
    var _RenderImage = function(item) {
        var ref, ref1, ref2, ref3, ref4, ref5;
        var Image = item.ImageComponent, spriteDetail = item.spriteDetail, label = item.label, name = item.name;
        var desktopIconConfig = globalClass === null || globalClass === void 0 ? void 0 : (ref = globalClass.staticClass) === null || ref === void 0 ? void 0 : (ref1 = ref.base_config) === null || ref1 === void 0 ? void 0 : ref1.defaultFontSizeType;
        var mobileIconConfig = globalClass === null || globalClass === void 0 ? void 0 : (ref2 = globalClass.staticClass) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.base_config) === null || ref3 === void 0 ? void 0 : ref3.defaultFontSizeTypeMobile;
        var sizeDetails = (0,getSizeAccType/* getIconSizeAccToConfig */.hE)(isMobile ? mobileIconConfig : desktopIconConfig);
        // const isTransparent = currentClass?.base_config?.defaultFillColorType === 'transparent'
        var isFilledWhite = (currentClass === null || currentClass === void 0 ? void 0 : (ref4 = currentClass.base_config) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.defaultBackgroundColor) === null || ref5 === void 0 ? void 0 : ref5.toLowerCase()) === "#ffffff";
        if (spriteDetail) {
            var ref6, ref7, ref8;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    width: Number(sizeDetails) + 4,
                    height: Number(sizeDetails) + 4
                },
                className: "tw-relative tw-flex tw-items-center tw-justify-center tw-gap-[4px]  ".concat(defaultHoverIconState === "zoomin" ? "tw-transition-transform tw-duration-500 hover:tw-scale-[1.2]" : defaultHoverIconState === "background" ? "".concat(!isFilledWhite ? "hover:tw-bg-[#ffffff4d]" : "hover:tw-bg-[#111C360F]", " hover:tw-rounded-[5px]") : ""),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                    children: [
                        canRenderImage && /*#__PURE__*/ (0,jsx_runtime.jsx)(CommonLinkWrapper/* default */.Z, {
                            link: LINK_ICON_MAP[name],
                            children: getIcon(name, sizeDetails, currentClass === null || currentClass === void 0 ? void 0 : (ref6 = currentClass.base_config) === null || ref6 === void 0 ? void 0 : ref6.defaultNavLinksColor)
                        }),
                        (name === "cart" && (items === null || items === void 0 ? void 0 : items.length)) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            style: {
                                background: currentClass === null || currentClass === void 0 ? void 0 : (ref7 = currentClass.base_config) === null || ref7 === void 0 ? void 0 : ref7.defaultNavLinksColor,
                                color: currentClass === null || currentClass === void 0 ? void 0 : (ref8 = currentClass.base_config) === null || ref8 === void 0 ? void 0 : ref8.defaultBackgroundColor,
                                bottom: getCartNumberPosition(sizeDetails) + "px",
                                left: getCartNumberPosition(sizeDetails) + "px"
                            },
                            className: "tw-absolute tw-h-[20px] tw-w-[20px] tw-rounded-[50%] ",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "tw-text-center tw-text-[12px]",
                                children: items === null || items === void 0 ? void 0 : items.length
                            })
                        }),
                        canRenderText && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "tw-m-0 tw-text-[10px] tw-uppercase tw-tracking-[1.48px]",
                            children: label
                        })
                    ]
                })
            });
        }
        if (typeof Image == "function") {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "tw-m-0 tw-flex tw-items-center tw-gap-[4px] tw-p-[5px] ".concat(defaultHoverIconState === "zoomin" ? "tw-transition-transform tw-duration-500 hover:tw-scale-[1.2]" : defaultHoverIconState === "background" ? "".concat(!isFilledWhite ? "hover:tw-bg-[#ffffff4d]" : "hover:tw-bg-[#111C360F]", " hover:tw-rounded-[5px]") : ""),
                children: [
                    canRenderImage && /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                        width: canRenderText ? 12 : 24,
                        height: canRenderText ? 12 : 24,
                        decoding: "async"
                    }),
                    canRenderText && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "tw-text-[10px] tw-uppercase tw-leading-[1] tw-tracking-[1.48px]",
                        children: label
                    })
                ]
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "tw-flex tw-items-center tw-gap-[4px]",
            children: [
                canRenderImage && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: Image,
                    width: canRenderText ? 12 : 24,
                    height: canRenderText ? 12 : 24
                }),
                canRenderText && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "tw-m-0 tw-text-[10px] tw-uppercase tw-tracking-[1.48px]",
                    children: label
                })
            ]
        });
    };
    if (!(dynamicSectionConfig === null || dynamicSectionConfig === void 0 ? void 0 : dynamicSectionConfig.showSearch) && !(iconRenderList === null || iconRenderList === void 0 ? void 0 : iconRenderList.length) && (!(activeHeaderData === null || activeHeaderData === void 0 ? void 0 : (ref3 = activeHeaderData.headerPropsConfig) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.buttons) === null || ref4 === void 0 ? void 0 : ref4.length) || isMobile && (activeHeaderData === null || activeHeaderData === void 0 ? void 0 : (ref5 = activeHeaderData.headerPropsConfig) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.buttons) === null || ref6 === void 0 ? void 0 : ref6.length))) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {});
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "tw-flex tw-items-center ".concat(isMobile ? "tw-gap-[16px]" : "tw-gap-[24px]"),
        children: [
            showDynamicSection && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dynamicComponent/* DynamicComponent */.B5, {
                    currentClass: currentClass,
                    globalClass: globalClass
                })
            }),
            !!(iconRenderList === null || iconRenderList === void 0 ? void 0 : iconRenderList.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "tw-flex " + (canRenderText ? "tw-items-center tw-gap-[17px]" : isMobile ? "tw-gap-[16px]" : "tw-gap-[24px]"),
                children: iconRenderList === null || iconRenderList === void 0 ? void 0 : iconRenderList.map(function(item, index) {
                    var name = item.name, action = item.action;
                    var StaticComponentRender = /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        onClick: function() {
                            return onItemClick(action);
                        },
                        className: constants/* btnReset */.eH,
                        children: _RenderImage(item)
                    });
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: classnames_default()("tw-cursor-pointer"),
                        children: action.actionType == "login-logout" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(LoginAndDropdownComponent/* default */.Z // headerBgColor={headerBgColor}
                        , {
                            children: StaticComponentRender
                        }) : StaticComponentRender
                    }, name + index);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderButtonsLayout, {
                isMobile: isMobile,
                activeHeaderData: activeHeaderData
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/components/DesignSystem/ModernTheme/utils/common.js + 9 modules
var common = __webpack_require__(720901);
// EXTERNAL MODULE: ./src/components/DesignSystem/Widgets2.0/Header/newHeaderContext.ts
var newHeaderContext = __webpack_require__(192600);
// EXTERNAL MODULE: ./src/utils/regex.js
var regex = __webpack_require__(936083);
// EXTERNAL MODULE: ./src/components/WidgetMaker/WidgetDnD/WIdgetPropertiesBasic/components/TextfieldBox/index.tsx
var TextfieldBox = __webpack_require__(781477);
// EXTERNAL MODULE: ./src/components/DesignSystem/Widgets2.0/Header/components/RenderNewSearch.tsx
var RenderNewSearch = __webpack_require__(738584);
;// CONCATENATED MODULE: ./src/components/DesignSystem/Widgets2.0/Header/components/RenderFullSearch.tsx







var crossIcon = function(color) {
    var className = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        className: "tw-cursor-pointer ".concat(className),
        xmlns: "http://www.w3.org/2000/svg",
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M16.5002 4.86641L15.2052 3.57141L10.0716 8.70498L4.93807 3.57141L3.64307 4.86641L8.77664 9.99998L3.64307 15.1336L4.93807 16.4286L10.0716 11.295L15.2052 16.4286L16.5002 15.1336L11.3666 9.99998L16.5002 4.86641Z",
            fill: color
        })
    });
};
var RenderFullSearch = function(param) {
    var activeHeaderData = param.activeHeaderData, currentClass = param.currentClass, isBuilder = param.isBuilder, isHeaderHovered = param.isHeaderHovered, setIsHeaderHovered = param.setIsHeaderHovered;
    var getHeightData = function getHeightData() {
        if (isBuilder) {
            return window.innerHeight / 100 * 60;
        } else {
            return window.innerHeight / 100 * 70;
        }
    };
    var ref, ref1, ref2, ref3, ref4, ref5, ref6;
    var ref7 = activeHeaderData === null || activeHeaderData === void 0 ? void 0 : activeHeaderData.headerPropsConfig, base_config = ref7.dynamic_section.base_config;
    var setShowSearch = (0,react.useContext)(newHeaderContext/* NewHeaderContext */.x).setShowSearch;
    var ref8 = (0,react.useState)(""), searchValue = ref8[0], setSearchValue = ref8[1];
    var ref9 = (0,react.useState)(0), placeholderIndex = ref9[0], setPlaceholderIndex = ref9[1];
    var ref10 = (0,react.useState)(true), fade = ref10[0], setFade = ref10[1];
    var isFilledWhite = (currentClass === null || currentClass === void 0 ? void 0 : (ref = currentClass.base_config) === null || ref === void 0 ? void 0 : (ref1 = ref.defaultBackgroundColor) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase()) === "#ffffff";
    var isTransparent = (currentClass === null || currentClass === void 0 ? void 0 : (ref2 = currentClass.base_config) === null || ref2 === void 0 ? void 0 : ref2.defaultFillColorType) === "transparent";
    var defaultColor = currentClass.base_config.defaultFillColorType !== "transparent" || isHeaderHovered ? currentClass.base_config.defaultBackgroundColor : "transparent";
    var placeholderColor = (currentClass === null || currentClass === void 0 ? void 0 : (ref3 = currentClass.base_config) === null || ref3 === void 0 ? void 0 : ref3.defaultNavLinksColor) || "";
    (0,react.useEffect)(function() {
        if (searchValue === null || searchValue === void 0 ? void 0 : searchValue.length) {
            document.body.classList.add("tw-overflow-y-hidden");
        } else {
            document.body.classList.remove("tw-overflow-y-hidden");
        }
        return function() {
            document.body.classList.remove("tw-overflow-y-hidden");
        };
    }, [
        searchValue === null || searchValue === void 0 ? void 0 : searchValue.length
    ]);
    (0,react.useEffect)(function() {
        var intervalId;
        if ((base_config === null || base_config === void 0 ? void 0 : base_config.placeholder.length) > 1) {
            intervalId = setInterval(function() {
                setFade(false);
                setTimeout(function() {
                    setPlaceholderIndex(function(prevIndex) {
                        return (prevIndex + 1) % (base_config === null || base_config === void 0 ? void 0 : base_config.placeholder.length);
                    });
                    setFade(true);
                }, 500);
            }, 3000);
        }
        return function() {
            return clearInterval(intervalId);
        };
    }, [
        base_config === null || base_config === void 0 ? void 0 : base_config.placeholder.length
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        onMouseEnter: function() {
            return setIsHeaderHovered === null || setIsHeaderHovered === void 0 ? void 0 : setIsHeaderHovered(true);
        },
        onMouseLeave: function() {
            return setIsHeaderHovered === null || setIsHeaderHovered === void 0 ? void 0 : setIsHeaderHovered(false);
        },
        style: {
            background: defaultColor,
            borderTop: "1px solid #111C361F"
        },
        className: "tw-relative tw-bg-[#ffff] tw-px-[40px] tw-py-[19px]",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "search-component tw-flex tw-w-[100%] tw-items-center tw-justify-between",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "tw-flex tw-w-[100%] tw-items-center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextfieldBox/* default */.Z, {
                            parentClass: "tw-w-[100%]",
                            placeholder: ((ref4 = base_config === null || base_config === void 0 ? void 0 : base_config.placeholder[placeholderIndex]) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.value) === null || ref5 === void 0 ? void 0 : ref5.trim()) || (base_config === null || base_config === void 0 ? void 0 : base_config.defaultPlaceholder),
                            regexCheck: regex/* allowEverything */.oe,
                            value: searchValue,
                            showErrorBox: false,
                            customClass: "!tw-px-[9px] !tw-py-0 tw-border-none hover:tw-shadow-none tw-outline-none tw-w-[100%] tw-transition-opacity tw-duration-500 tw-ease-in-out ".concat(fade ? "tw-opacity-100" : (searchValue === null || searchValue === void 0 ? void 0 : searchValue.length) ? "tw-opacity-100" : "tw-opacity-0"),
                            handleChange: function(value) {
                                return setSearchValue(value);
                            },
                            rows: 1,
                            isFocus: true,
                            hideBorder: true,
                            hideInputPadding: true,
                            iconComponent: function() {
                                var ref;
                                /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                                    className: "tw-relative tw-top-[1.5px]",
                                    children: (0,dynamicComponent/* getIcon */.q7)(20, currentClass === null || currentClass === void 0 ? void 0 : (ref = currentClass.base_config) === null || ref === void 0 ? void 0 : ref.defaultNavLinksColor)
                                });
                            },
                            inputColor: isTransparent ? "#ffffff" : !isFilledWhite ? placeholderColor : "#000000",
                            placeholderColor: placeholderColor
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        onClick: function() {
                            return setShowSearch(false);
                        },
                        className: "",
                        children: crossIcon(currentClass === null || currentClass === void 0 ? void 0 : (ref6 = currentClass.base_config) === null || ref6 === void 0 ? void 0 : ref6.defaultNavLinksColor, "tw-relative tw-top-[1.5px]")
                    })
                ]
            }),
            (searchValue === null || searchValue === void 0 ? void 0 : searchValue.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    maxHeight: getHeightData() + "px"
                },
                className: "tw-absolute tw-left-0 tw-z-[100] tw-mt-[14px] tw-w-[100%] tw-overflow-scroll tw-bg-[#ffffff] tw-px-[40px] tw-py-[30px]",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RenderNewSearch/* RenderNewSearch */.l, {
                    productQuery: searchValue,
                    sectionClass: "tw-w-[100%]",
                    fullSearch: true
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/redux/actions/additionalPages.js
var additionalPages = __webpack_require__(792516);
// EXTERNAL MODULE: ./src/hooks/useNavConfigs.ts
var useNavConfigs = __webpack_require__(232876);
// EXTERNAL MODULE: ./src/hooks/useSaveHeaderHeight.js
var useSaveHeaderHeight = __webpack_require__(953395);
// EXTERNAL MODULE: ./src/components/WidgetMaker/WidgetDnD/WidgetProperties/HeaderBuilder/AnnouncementConfig.ts
var AnnouncementConfig = __webpack_require__(295817);
// EXTERNAL MODULE: ./src/components/DesignSystem/Widgets2.0/NewAnnouncementBar/index.tsx + 3 modules
var NewAnnouncementBar = __webpack_require__(990807);
;// CONCATENATED MODULE: ./src/components/DesignSystem/Widgets2.0/Header/components/AnnouncementBarHeader/index.tsx




function AnnouncementBarHeader(param) {
    var isBuilder = param.isBuilder, listConfig = param.listConfig, cardConfig = param.cardConfig, showAnnouncementOnTop = param.showAnnouncementOnTop, seperatorLineStyles = param.seperatorLineStyles, _isScroll = param.isScroll, isScroll = _isScroll === void 0 ? false : _isScroll, _canHideHeaderAnnouncement = param.canHideHeaderAnnouncement, canHideHeaderAnnouncement = _canHideHeaderAnnouncement === void 0 ? false : _canHideHeaderAnnouncement;
    var ref;
    var isHomePage = (0,useCheckIfHomePage/* useCheckIfHomePage */.t)();
    var isOnlyVisibleOnHomePage = (listConfig === null || listConfig === void 0 ? void 0 : (ref = listConfig.visibilty) === null || ref === void 0 ? void 0 : ref.type) === AnnouncementConfig/* VISIBILITY_TYPE.HOME_PAGE */.Jx.HOME_PAGE;
    var canShowAnnouncementBar = !isOnlyVisibleOnHomePage || isHomePage || isBuilder;
    return canShowAnnouncementBar && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(NewAnnouncementBar/* NewAnnouncementBar */.g, {
                fromHeader: true,
                widgetOptions: {
                    // listPresentation: getAnnouncementAdjustedConfig(),
                    listPresentation: listConfig,
                    cardFrame: cardConfig
                },
                isPositionTop: showAnnouncementOnTop,
                isScroll: isScroll,
                canHideHeaderAnnouncement: canHideHeaderAnnouncement
            }),
            showAnnouncementOnTop && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: seperatorLineStyles,
                className: " tw-w-[100%]"
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/components/DesignSystem/Widgets2.0/Header/NewHeaderComponent.tsx







// import { cloneDeep } from "lodash";
















var ABOVE_NAVLINKS_TYPE = [
    "header3",
    "header4"
];
var LOGO_CONFIG_DESKTOP = [
    "header1",
    "header4",
    "header5"
];
var LOGO_CONFIG_MOBILE = [
    "header1",
    "header4"
];
var NAV_CONFIG_DESKTOP = [
    "header2",
    "header6"
];
var NAV_CONFIG_MOBILE = [
    "header2",
    "header5",
    "header6"
];
var NewHeaderComponent = function(props) {
    var getGlobalStyle = function getGlobalStyle(currentClass) {
        var ref, ref1, ref2, ref3, ref4;
        return {
            backgroundColor: !showTransparentBgHeader ? currentClass === null || currentClass === void 0 ? void 0 : (ref = currentClass.base_config) === null || ref === void 0 ? void 0 : ref.defaultBackgroundColor : "",
            borderBottom: (currentClass === null || currentClass === void 0 ? void 0 : (ref1 = currentClass.base_config) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.defaultSeparatorLine) === null || ref2 === void 0 ? void 0 : ref2.includes("BELOW_HEADER")) ? "1px solid ".concat((0,common/* hexToRgba */.a7)(currentClass === null || currentClass === void 0 ? void 0 : (ref3 = currentClass.base_config) === null || ref3 === void 0 ? void 0 : ref3.defaultSeparator1Color, (currentClass === null || currentClass === void 0 ? void 0 : (ref4 = currentClass.base_config) === null || ref4 === void 0 ? void 0 : ref4.defaultSeparator1Opacity) / 100)) : "",
            borderRadius: isBuilder ? "18px 18px 0 0" : ""
        };
    };
    var getStyleForSeparator = function getStyleForSeparator(currentClass) {
        var ref = currentClass || {}, tmp = ref.base_config, ref1 = tmp === void 0 ? {} : tmp, defaultSeparator2Color = ref1.defaultSeparator2Color, defaultSeparator2Opacity = ref1.defaultSeparator2Opacity;
        return {
            borderTop: "1px solid ".concat((0,common/* hexToRgba */.a7)(defaultSeparator2Color, defaultSeparator2Opacity / 100))
        };
    };
    var getGlobalClassName = function getGlobalClassName(currentHeaderType) {
        var ref, ref1, ref2, ref3, ref4;
        var navlinksPosition = activeHeaderData === null || activeHeaderData === void 0 ? void 0 : (ref = activeHeaderData.headerPropsConfig) === null || ref === void 0 ? void 0 : (ref1 = ref.navLinks_section) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.base_config) === null || ref2 === void 0 ? void 0 : ref2.defaultPosition;
        var searchInterfaceType = activeHeaderData === null || activeHeaderData === void 0 ? void 0 : (ref3 = activeHeaderData.headerPropsConfig) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.dynamic_section) === null || ref4 === void 0 ? void 0 : ref4.base_config.defaultType;
        switch(currentHeaderType){
            case "header1":
                {
                    return (0,bundle_mjs/* twMerge */.m6)(" [&>:first-child:nth-last-child(2)]:!tw-relative \n                 [&>:first-child:nth-last-child(2)]:!tw-left-[50%] \n                 [&>:first-child:nth-last-child(2)]:!tw-translate-x-[-50%] \n                 [&>:first-child:nth-last-child(2)]:!tw-justify-center", navlinksPosition === "left" && "[&>*:nth-child(even)]:!tw-max-w-[70%] !tw-justify-start [&>:first-child]:!tw-flex-grow-0 [&>:last-child]:!tw-ml-auto [&>*:nth-child(even)]:!tw-flex-grow-0 [&>:last-child]:!tw-max-w-[50%]", navlinksPosition === "right" && "[&>*:nth-child(even)]:!tw-max-w-[70%] !tw-justify-start [&>:last-child]:!tw-flex-grow-0 [&>:nth-child(2)]:!tw-ml-auto [&>*:nth-child(even)]:!tw-flex-grow-0", navlinksPosition === "right" && searchInterfaceType === "field" && "[&>:last-child]:!tw-max-w-[48%]");
                }
            case "header2":
                {
                    var // ` [&>:last-child]:!tw-overflow-hidden`,
                    ref5;
                    return (0,bundle_mjs/* twMerge */.m6)(" [&>*:nth-child(2)]:!tw-justify-center", ((ref5 = (0,utils/* logoSectionConfigDetails */.Cy)(activeHeaderData, isScroll)) === null || ref5 === void 0 ? void 0 : ref5.hidden) && " [&>:last-child]:!tw-max-w-[80%]");
                }
            case "header5":
                {
                    return " !tw-justify-start \n                 [&>*:nth-child(1)]:!tw-w-max \n                 [&>:first-child]:!tw-flex-grow-0 \n                 [&>:last-child]:!tw-max-w-[50%]\n                 [&>:last-child]:!tw-ml-auto\n                  ";
                }
            case "header4":
                {
                    // [&>*:nth-child(odd)]:!tw-w-[24%]
                    return (0,bundle_mjs/* twMerge */.m6)("    [&>*:nth-child(odd)]:!tw-flex-grow-0 \n                 [&>*:nth-child(even)]:!tw-max-w-[50%]", currentHeaderType !== "header4" || isMobile ? "[&>*:nth-child(odd)]:!tw-w-[45%]" : "", !isMobile && currentHeaderType === "header4" ? "[&>*:nth-child(odd)]:!tw-w-[45%] [&>*:nth-child(odd)]:!tw-max-w-[250px]" : "");
                }
            case "header3":
                {
                    return "[&>:first-child:nth-last-child(2)]:!tw-relative \n                [&>:first-child:nth-last-child(2)]:!tw-left-[calc(50%_-_10px)] \n                [&>:first-child:nth-last-child(2)]:!tw-translate-x-[-50%] \n                [&>:first-child:nth-last-child(2)]:!tw-justify-center\n                [&>*:nth-child(even)]:!tw-justify-center\n                ";
                }
            case "header6":
                {
                    return "[&>*:nth-child(2)]:!tw-justify-center";
                }
            default:
                return "";
        }
    };
    var renderAnnouncementBar = function renderAnnouncementBar() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(AnnouncementBarHeader, {
            isBuilder: isBuilder,
            listConfig: listConfig,
            cardConfig: cardConfig,
            showAnnouncementOnTop: showAnnouncementOnTop,
            seperatorLineStyles: getStyleForSeparator(currentClass),
            isScroll: isScroll,
            canHideHeaderAnnouncement: canHideHeaderAnnouncement
        });
    };
    var renderCustomiseHeader = function renderCustomiseHeader() {
        var ref, ref1, ref2, ref3;
        var ref4 = activeHeaderData || {}, _headerPropsConfig = ref4.headerPropsConfig, headerPropsConfig = _headerPropsConfig === void 0 ? {} : _headerPropsConfig;
        var globalClass = headerPropsConfig.globalClass, desktopHeader = headerPropsConfig.desktopHeader, mobileHeader = headerPropsConfig.mobileHeader, dynamic_section = headerPropsConfig.dynamic_section;
        var currentHeaderType = isMobile ? mobileHeader : desktopHeader;
        var staticClass = (globalClass || {}).staticClass;
        var headerData = generateHeaderDataAccToType(currentHeaderType, headerPropsConfig);
        var globalStyleObject = getGlobalStyle(currentClass);
        var styleForSeparator = getStyleForSeparator(currentClass);
        var wrapperClassName = getGlobalClassName(currentHeaderType);
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(newHeaderContext/* NewHeaderContext.Provider */.x.Provider, {
            value: {
                showSearch: showSearch,
                setShowSearch: setShowSearch
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    onMouseEnter: function() {
                        return setIsHeaderHovered(true);
                    },
                    onMouseLeave: function() {
                        return setIsHeaderHovered(false);
                    },
                    style: globalStyleObject,
                    ref: headerRef,
                    className: (0,bundle_mjs/* twMerge */.m6)("tw-relative tw-flex tw-transition-all ".concat(isMobile ? "tw-min-h-[52px]" : "tw-min-h-[68px]", " tw-w-[100%] tw-flex-col tw-border-[1px] tw-border-[#111C361F] tw-border-solid")),
                    children: [
                        showAnnouncement && showAnnouncementOnTop && renderAnnouncementBar(),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (0,bundle_mjs/* twMerge */.m6)("tw-flex tw-w-[100%] tw-items-center tw-justify-between tw-gap-[12px] ".concat(!isMobile ? "tw-px-[40px]" : "tw-px-[16px]", " ").concat((ABOVE_NAVLINKS_TYPE === null || ABOVE_NAVLINKS_TYPE === void 0 ? void 0 : ABOVE_NAVLINKS_TYPE.includes(currentHeaderType)) ? "tw-py-[16px]" : isMobile ? "tw-py-[14px]" : "tw-py-[20px]"), // Odd siblings
                            " [&>*:nth-child(odd)]:!tw-flex-grow [&>:last-child]:tw-max-w-[calc(50%_-_18%)]", // Even siblings
                            "[&>*:nth-child(even)]:!tw-flex-grow", // Even siblings
                            !isMobile ? "[&>*:nth-child(even)]:tw-max-w-[33%] " : !isMobile || isMobile && mobileHeader !== "header5" ? "[&>*:nth-child(even)]:tw-max-w-[54%]" : "", "[&>:last-child]:!tw-flex [&>:last-child]:!tw-justify-end", // For first element /3, not consequential to other layout siblings
                            "[&>:first-child]:!tw-flex [&>:first-child]:!tw-justify-start", function() {
                                var ref, ref1;
                                if (currentHeaderType === "header3" && (dynamic_section === null || dynamic_section === void 0 ? void 0 : (ref = dynamic_section.base_config) === null || ref === void 0 ? void 0 : ref.showSearch) && (dynamic_section === null || dynamic_section === void 0 ? void 0 : (ref1 = dynamic_section.base_config) === null || ref1 === void 0 ? void 0 : ref1.defaultPosition) !== "center") {
                                    return "[&>:first-child]:!tw-max-w-[calc(50%_-_18%)]";
                                }
                                if (currentHeaderType !== "header4" && currentHeaderType !== "header3") {
                                    return "[&>:first-child]:!tw-max-w-[calc(50%_-_18%)]";
                                }
                            }(), currentHeaderType !== "header2" && " [&>:first-child]:!tw-overflow-x-hidden", // currentHeaderType !== 'header2' &&
                            //   currentHeaderType !== 'header1' &&
                            //   ' [&>:last-child]:!tw-overflow-x-hidden',
                            currentHeaderType == "header1" && " [&>:first-child]:!tw-overflow-hidden", wrapperClassName),
                            children: headerData === null || headerData === void 0 ? void 0 : (ref = headerData.row1) === null || ref === void 0 ? void 0 : ref.map(function(param) {
                                var componentName = param.componentName, _componentData = param.componentData, componentData = _componentData === void 0 ? [] : _componentData, _base_config = param.base_config, base_config = _base_config === void 0 ? {} : _base_config;
                                var ref;
                                return getCurrentComponentName(componentName, componentData, base_config, currentClass, globalClass, currentHeaderType, headerPropsConfig === null || headerPropsConfig === void 0 ? void 0 : (ref = headerPropsConfig.dynamic_section) === null || ref === void 0 ? void 0 : ref.base_config, headerData, globalStyleObject);
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "tw-relative",
                            children: ((ref1 = staticClass.base_config.defaultSeparatorLine) === null || ref1 === void 0 ? void 0 : ref1.includes("ABOVE_NAVLINKS")) && ABOVE_NAVLINKS_TYPE.includes(currentHeaderType) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                style: styleForSeparator,
                                className: "tw-absolute tw-mb-[50px] tw-w-[100%]"
                            })
                        }),
                        (headerData === null || headerData === void 0 ? void 0 : (ref2 = headerData.row2) === null || ref2 === void 0 ? void 0 : ref2.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "tw-px-[40px]",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "tw-mt-[0px] tw-w-[100%]",
                                children: headerData === null || headerData === void 0 ? void 0 : (ref3 = headerData.row2) === null || ref3 === void 0 ? void 0 : ref3.map(function(param) {
                                    var componentName = param.componentName, componentData = param.componentData, base_config = param.base_config;
                                    return getCurrentComponentName(componentName, componentData, base_config, currentClass, globalClass, currentHeaderType, globalStyleObject);
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: showSearch && dynamic_section.base_config.defaultType !== "field" && !isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(RenderFullSearch, {
                        activeHeaderData: activeHeaderData,
                        currentClass: currentClass,
                        isBuilder: isBuilder,
                        isHeaderHovered: isHeaderHovered,
                        setIsHeaderHovered: setIsHeaderHovered
                    })
                }),
                showAnnouncement && !showAnnouncementOnTop && renderAnnouncementBar()
            ]
        });
    };
    var ref, ref1, ref2, ref3;
    var isScroll = props.isScroll, _isBuilder = props.isBuilder, isBuilder = _isBuilder === void 0 ? false : _isBuilder, activeHeaderDataFromProps = props.activeHeaderData, _canHideHeaderAnnouncement = props.canHideHeaderAnnouncement, canHideHeaderAnnouncement = _canHideHeaderAnnouncement === void 0 ? false : _canHideHeaderAnnouncement;
    var ref4 = (0,WidgetDndContext/* useWidgetDndContextData */.KX)(), _widgetContextState = ref4.widgetContextState, activeHeaderDataFromContext = _widgetContextState.activeHeaderData, setActiveHeaderData = ref4.widgetContextActions.setActiveHeaderData;
    var activeHeaderData = activeHeaderDataFromProps || activeHeaderDataFromContext;
    var isHeaderPropsConfigPresent = !!((ref = Object.keys((activeHeaderData === null || activeHeaderData === void 0 ? void 0 : activeHeaderData.headerPropsConfig) || {})) === null || ref === void 0 ? void 0 : ref.length);
    var ref5 = (activeHeaderData === null || activeHeaderData === void 0 ? void 0 : activeHeaderData.headerPropsConfig) || {}, tmp = ref5.announcementConfig, ref6 = tmp === void 0 ? {} : tmp, listConfig = ref6.listConfig, cardConfig = ref6.cardConfig;
    var ANNOUNCEMENT_ABOVE_HEADER = AnnouncementConfig/* ANNOUNCEMENT_BAR_POSITION.ABOVE_HEADER */.IZ.ABOVE_HEADER;
    var ref7 = listConfig || {}, tmp1 = ref7.isVisible, isAnnouncementVisible = tmp1 === void 0 ? false : tmp1, tmp2 = ref7.position, announcementPosition = tmp2 === void 0 ? ANNOUNCEMENT_ABOVE_HEADER : tmp2;
    var ref8 = cardConfig || {}, _announcementList = ref8.announcementList, announcementList = _announcementList === void 0 ? [] : _announcementList;
    var showAnnouncement = isAnnouncementVisible && !!(announcementList === null || announcementList === void 0 ? void 0 : announcementList.length);
    var showAnnouncementOnTop = announcementPosition === ANNOUNCEMENT_ABOVE_HEADER;
    var ref9 = (0,redux/* useSSRSelector */.kF)(function(state) {
        return {
            storeData: state.storeReducer.store,
            navigationList: state.additionalPagesReducer.navigationList
        };
    }), storeData = ref9.storeData, navigationList = ref9.navigationList;
    var headerRef = (0,react.useRef)(null);
    var ref10 = (0,react.useState)(false), showSearch = ref10[0], setShowSearch = ref10[1];
    var ref11 = (0,react.useState)(null), headerNodeRef = ref11[0], setHeaderNodeRef = ref11[1];
    var ref12 = (0,react.useState)(false), isHeaderHovered = ref12[0], setIsHeaderHovered = ref12[1];
    var deviceType = (0,useGetDeviceType/* useGetDeviceType */.n)().deviceType;
    var isMobile = deviceType === "mobile";
    var headerWidgetId = activeHeaderData === null || activeHeaderData === void 0 ? void 0 : (ref1 = activeHeaderData.headerPropsConfig) === null || ref1 === void 0 ? void 0 : ref1.widget_id;
    var ref13 = (0,useNavConfigs/* useNavConfigs */.Z)(isScroll, isHeaderHovered), isTransparent = ref13.isTransparent, showTransparentBgHeader = ref13.showTransparentBgHeader, currentClass = ref13.currentClass;
    var isHomePage = (0,useCheckIfHomePage/* useCheckIfHomePage */.t)();
    var dispatch = (0,es/* useDispatch */.I0)();
    (0,useSaveHeaderHeight/* default */.Z)(headerRef);
    (0,react.useEffect)(function() {
        if ((storeData === null || storeData === void 0 ? void 0 : storeData.store_id) && !(navigationList === null || navigationList === void 0 ? void 0 : navigationList.length)) {
            dispatch((0,additionalPages/* getNavigationPagesList */.A7)({
                storeId: storeData === null || storeData === void 0 ? void 0 : storeData.store_id,
                isPublished: true
            }));
        }
    }, [
        storeData === null || storeData === void 0 ? void 0 : storeData.store_id,
        navigationList
    ]);
    (0,react.useLayoutEffect)(function() {
        var config = (props === null || props === void 0 ? void 0 : props.config) || (activeHeaderData === null || activeHeaderData === void 0 ? void 0 : activeHeaderData.headerPropsConfig) || (activeHeaderDataFromContext === null || activeHeaderDataFromContext === void 0 ? void 0 : activeHeaderDataFromContext.headerPropsConfig);
        if (config && !isHeaderPropsConfigPresent) {
            setActiveHeaderData(function(prevData) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prevData), {
                    headerPropsConfig: props.config
                });
            });
        }
    }, [
        props === null || props === void 0 ? void 0 : props.config
    ]);
    (0,react.useEffect)(function() {
        setShowSearch(false);
    }, [
        activeHeaderData === null || activeHeaderData === void 0 ? void 0 : (ref2 = activeHeaderData.headerPropsConfig) === null || ref2 === void 0 ? void 0 : ref2.desktopHeader
    ]);
    var headerWrapRef = (0,react.useCallback)(function(node) {
        if (!node) {
            return;
        }
        setHeaderNodeRef(node);
    }, []);
    if (!isHeaderPropsConfigPresent) {
        return null;
    }
    var generateHeaderDataAccToType = function(headerName, headerPropsConfig) {
        switch(headerName){
            case "header1":
                {
                    var logo_section = headerPropsConfig.logo_section, navLinks_section = headerPropsConfig.navLinks_section, navIcons_section = headerPropsConfig.navIcons_section, dynamic_section = headerPropsConfig.dynamic_section;
                    logo_section.customClass = "tw-justify-left";
                    navLinks_section.base_config.type = "flatElement";
                    navLinks_section.base_config.customClass = "tw-w-[100%]";
                    dynamic_section.base_config.defaultPosition = "right";
                    return {
                        row1: [
                            logo_section,
                            navLinks_section,
                            navIcons_section
                        ],
                        row2: []
                    };
                }
            case "header2":
                {
                    var logo_section1 = headerPropsConfig.logo_section, navLinks_section1 = headerPropsConfig.navLinks_section, navIcons_section1 = headerPropsConfig.navIcons_section, dynamic_section1 = headerPropsConfig.dynamic_section;
                    logo_section1.customClass = "tw-justify-center";
                    navLinks_section1.base_config.type = "flatElement";
                    navLinks_section1.base_config.customClass = "tw-w-max";
                    navLinks_section1.base_config.defaultPosition = "left";
                    dynamic_section1.base_config.defaultPosition = "right";
                    return {
                        row1: [
                            navLinks_section1,
                            logo_section1,
                            navIcons_section1
                        ],
                        row2: []
                    };
                }
            case "header3":
                {
                    var ref;
                    var logo_section2 = headerPropsConfig.logo_section, navLinks_section2 = headerPropsConfig.navLinks_section, navIcons_section2 = headerPropsConfig.navIcons_section, dynamic_section2 = headerPropsConfig.dynamic_section;
                    logo_section2.customClass = (dynamic_section2 === null || dynamic_section2 === void 0 ? void 0 : (ref = dynamic_section2.base_config) === null || ref === void 0 ? void 0 : ref.defaultPosition) === "left" ? "tw-w-[calc(50%+25px)] tw-justify-center" : "tw-w-[calc(62%+25px)] tw-justify-center";
                    navLinks_section2.base_config.type = "flatElement";
                    navLinks_section2.base_config.customClass = "tw-w-[100%]";
                    navLinks_section2.base_config.defaultPosition = "center";
                    dynamic_section2.base_config.defaultPosition = dynamic_section2.base_config.defaultPosition === "center" ? "right" : dynamic_section2.base_config.defaultPosition;
                    return {
                        row1: [
                            dynamic_section2,
                            logo_section2,
                            navIcons_section2
                        ],
                        row2: [
                            navLinks_section2
                        ]
                    };
                }
            case "header4":
                {
                    var logo_section3 = headerPropsConfig.logo_section, navLinks_section3 = headerPropsConfig.navLinks_section, navIcons_section3 = headerPropsConfig.navIcons_section, dynamic_section3 = headerPropsConfig.dynamic_section;
                    logo_section3.customClass = "tw-justify-start"; // tw-w-[50%]
                    navLinks_section3.base_config.type = "flatElement";
                    navLinks_section3.base_config.defaultPosition = "center";
                    navLinks_section3.base_config.customClass = "tw-w-[100%]";
                    navLinks_section3.base_config.defaultPosition = "center";
                    dynamic_section3.base_config.defaultPosition = dynamic_section3.base_config.defaultPosition === "left" ? "right" : dynamic_section3.base_config.defaultPosition;
                    return {
                        row1: dynamic_section3.base_config.defaultPosition === "center" ? [
                            logo_section3,
                            dynamic_section3,
                            navIcons_section3
                        ] : [
                            logo_section3,
                            navIcons_section3
                        ],
                        row2: [
                            navLinks_section3
                        ]
                    };
                }
            case "header5":
                {
                    var logo_section4 = headerPropsConfig.logo_section, navLinks_section4 = headerPropsConfig.navLinks_section, navIcons_section4 = headerPropsConfig.navIcons_section, dynamic_section4 = headerPropsConfig.dynamic_section;
                    logo_section4.customClass = isMobile ? "" : "tw-relative tw-left-[30px]";
                    navLinks_section4.base_config.type = "hamburger";
                    navLinks_section4.base_config.customClass = "tw-w-max";
                    navLinks_section4.base_config.defaultPosition = navLinks_section4.base_config.defaultPosition;
                    dynamic_section4.base_config.defaultPosition = isMobile ? "right" : "right";
                    dynamic_section4.base_config.defaultType = isMobile ? "icon" : dynamic_section4.base_config.defaultType;
                    dynamic_section4.base_config.showSearch = dynamic_section4.base_config.showSearch;
                    // dynamic_section.base_config.defaultPosition = isMobile ? 'icon' : dynamic_section.base_config.defaultPosition
                    // dynamic_section.base_config.showSearch = isMobile ? true : dynamic_section.base_config.showSearch
                    return {
                        row1: [
                            navLinks_section4,
                            logo_section4,
                            navIcons_section4
                        ],
                        row2: []
                    };
                }
            case "header6":
                {
                    var logo_section5 = headerPropsConfig.logo_section, navLinks_section5 = headerPropsConfig.navLinks_section, navIcons_section5 = headerPropsConfig.navIcons_section, dynamic_section5 = headerPropsConfig.dynamic_section;
                    // logo_section.customClass = dynamic_section?.base_config?.defaultPosition === 'left' ? `tw-mr-[250px]` : 'tw-ml-[300px]';;
                    logo_section5.customClass = "tw-justify-center";
                    navLinks_section5.base_config.type = "hamburger";
                    navLinks_section5.base_config.customClass = "tw-w-max";
                    navLinks_section5.base_config.defaultPosition = navLinks_section5.base_config.defaultPosition;
                    dynamic_section5.base_config.defaultPosition = isMobile ? "left" : dynamic_section5.base_config.defaultPosition;
                    dynamic_section5.base_config.defaultType = isMobile ? "icon" : dynamic_section5.base_config.defaultType;
                    dynamic_section5.base_config.showSearch = dynamic_section5.base_config.showSearch;
                    // dynamic_section.base_config.defaultPosition = isMobile ? 'icon' : dynamic_section.base_config.defaultPosition
                    // dynamic_section.base_config.showSearch = isMobile ? true : dynamic_section.base_config.showSearch
                    return {
                        row1: [
                            navLinks_section5,
                            logo_section5,
                            navIcons_section5
                        ],
                        row2: []
                    };
                }
        }
    };
    var showDynamicSection = function(type, base_config, headerName) {
        switch(type){
            case "logo":
                return (isMobile ? LOGO_CONFIG_MOBILE : LOGO_CONFIG_DESKTOP).includes(headerName) && base_config.defaultPosition === "left";
            case "link":
                return (isMobile ? NAV_CONFIG_MOBILE : NAV_CONFIG_DESKTOP).includes(headerName) && base_config.defaultPosition === "left";
            case "icon":
                return base_config.defaultPosition === "right";
        }
    };
    var getCurrentComponentName = function(componentName, componentData, base_config, currentClass, globalClass) {
        var headerName = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : "", dynamicSectionConfig = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : {}, headerData = arguments.length > 7 && arguments[7] !== void 0 ? arguments[7] : {}, globalStyleObject = arguments.length > 8 && arguments[8] !== void 0 ? arguments[8] : {};
        switch(componentName){
            case "LogoRenderer":
                {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LogoRenderer, {
                        activeHeaderData: activeHeaderData,
                        currentClass: currentClass,
                        globalClass: globalClass,
                        isHeaderHovered: isHeaderHovered && (isHomePage || isBuilder),
                        showDynamicSection: showDynamicSection("logo", dynamicSectionConfig, headerName),
                        isScroll: isScroll,
                        globalStyleObject: globalStyleObject
                    });
                }
            case "NavLinkRenderer":
                {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(NavLinkRenderer, {
                        activeHeaderData: activeHeaderData,
                        componentData: componentData,
                        base_config: base_config,
                        currentClass: currentClass,
                        showHamburger: true,
                        globalClass: globalClass,
                        headerRef: headerRef,
                        showDynamicSection: showDynamicSection("link", dynamicSectionConfig, headerName),
                        headerNodeRef: headerNodeRef,
                        headerName: headerName,
                        dynamicSectionData: activeHeaderData.headerPropsConfig.dynamic_section,
                        globalStyleObject: globalStyleObject,
                        isScroll: isScroll,
                        isHeaderHovered: isHeaderHovered,
                        isMobile: isMobile,
                        isBuilder: isBuilder,
                        isTransparent: isTransparent
                    });
                }
            case "NavIconRenderer":
                {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(NavIconRenderer, {
                        componentData: componentData,
                        base_config: base_config,
                        currentClass: currentClass,
                        globalClass: globalClass,
                        showDynamicSection: showDynamicSection("icon", dynamicSectionConfig, headerName),
                        globalStyleObject: globalStyleObject,
                        activeHeaderData: activeHeaderData
                    });
                }
            case "dynamicComponent":
                {
                    return (dynamicSectionConfig.defaultPosition === "left" || headerName === "header4") && /*#__PURE__*/ (0,jsx_runtime.jsx)(dynamicComponent/* DynamicComponent */.B5, {
                        currentClass: currentClass,
                        globalClass: globalClass,
                        globalStyleObject: globalStyleObject
                    });
                }
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("header", {
        id: headerWidgetId === null || headerWidgetId === void 0 ? void 0 : (ref3 = headerWidgetId.toString) === null || ref3 === void 0 ? void 0 : ref3.call(headerWidgetId),
        className: "tw-relative",
        ref: headerWrapRef,
        children: renderCustomiseHeader()
    });
};

// EXTERNAL MODULE: ./src/components/DesignSystem/Widgets2.0/NewAnnouncementBar/Hooks/useHeaderAnnoucementHeight.tsx
var useHeaderAnnoucementHeight = __webpack_require__(238020);
;// CONCATENATED MODULE: ./src/components/DesignSystem/Widgets2.0/Header/NewHeaderWrapper.tsx









var header_common_class = {
    top: 0,
    zIndex: 500,
    width: "100%",
    opacity: 1,
    transition: "top .3s ease-in-out"
};
var NewHeaderWrapper = function(props) {
    var handleScroll = function handleScroll(e) {
        var val = window.scrollY;
        setCanHideHeaderAnnouncement(val > (!canHideHeaderAnnouncement ? headerAnnouncementHeight : 0));
        if (val > 20) {
            setIsScroll(true);
        } else {
            setIsScroll(false);
        }
        if (lastScrollVal.current - val > 180) {
            setIsScrollUp(true);
            lastScrollVal.current = val;
        } else if (val - lastScrollVal.current > 180) {
            setIsScrollUp(false);
            lastScrollVal.current = val;
        }
    };
    var ref, ref1, ref2, ref3, ref4;
    var isHomePage = (0,useCheckIfHomePage/* useCheckIfHomePage */.t)();
    var ref5 = (0,react.useState)(false), isScroll = ref5[0], setIsScroll = ref5[1];
    var ref6 = (0,react.useState)(false), isScrollUp = ref6[0], setIsScrollUp = ref6[1];
    var ref7 = (0,react.useState)(false), canHideHeaderAnnouncement = ref7[0], setCanHideHeaderAnnouncement = ref7[1];
    var headerAnnouncementHeight = (0,useHeaderAnnoucementHeight/* useHeaderAnnouncementHeight */.Q)().headerAnnouncementHeight;
    var headerRef = (0,react.useRef)();
    var lastScrollVal = (0,react.useRef)(0);
    var ref8 = (0,WidgetDndContext/* useWidgetDndContextData */.KX)(), getWidgetSSRState = ref8.getWidgetSSRState, setActiveHeaderData = ref8.widgetContextActions.setActiveHeaderData;
    var activeHeaderData = getWidgetSSRState().activeHeaderData;
    if (props === null || props === void 0 ? void 0 : props.config) {
        if (checkRenderEnv/* IS_SERVER */.W6) activeHeaderData.headerPropsConfig = props.config;
    // else {
    //   if (isInitialRender.current) {
    //     setActiveHeaderData((prevData) => ({
    //       ...prevData,
    //       headerPropsConfig: props.config,
    //     }));
    //     isInitialRender.current = false;
    //   }
    // }
    }
    (0,react.useLayoutEffect)(function() {
        if (props === null || props === void 0 ? void 0 : props.config) {
            setActiveHeaderData(function(prevData) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prevData), {
                    headerPropsConfig: props.config
                });
            });
        }
    }, [
        props === null || props === void 0 ? void 0 : props.config
    ]);
    var scrollType = (activeHeaderData === null || activeHeaderData === void 0 ? void 0 : (ref = activeHeaderData.headerPropsConfig) === null || ref === void 0 ? void 0 : (ref1 = ref.globalClass) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.scrollClass) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.base_config) === null || ref3 === void 0 ? void 0 : ref3.defaultScrollType) || "";
    var customProps = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        isScroll: scrollType === "hide" ? false : isScroll && isHomePage,
        isScrollUp: isScrollUp
    });
    (0,react.useEffect)(function() {
        if (!isScroll && isScrollUp) {
            setIsScrollUp(false);
        }
    }, [
        isScroll
    ]);
    (0,react.useEffect)(function() {
        window.addEventListener("scroll", handleScroll);
        return function() {
            window.removeEventListener("scroll", handleScroll);
        };
    }, [
        headerAnnouncementHeight,
        canHideHeaderAnnouncement
    ]);
    if (!((ref4 = Object.keys(activeHeaderData === null || activeHeaderData === void 0 ? void 0 : activeHeaderData.headerPropsConfig)) === null || ref4 === void 0 ? void 0 : ref4.length)) {
        return null;
    }
    var getStyleForTransparent = function() {
        var ref, ref1, ref2, ref3;
        if (!isHomePage) {
            return {};
        }
        var type = activeHeaderData === null || activeHeaderData === void 0 ? void 0 : (ref = activeHeaderData.headerPropsConfig) === null || ref === void 0 ? void 0 : (ref1 = ref.globalClass) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.staticClass) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.base_config) === null || ref3 === void 0 ? void 0 : ref3.defaultFillColorType;
        if (type === "transparent") {
            return (0,_object_spread/* default */.Z)({
                position: "fixed"
            }, header_common_class);
        }
        return (0,_object_spread/* default */.Z)({
            position: "sticky"
        }, header_common_class);
    };
    var getScrollStyling = function() {
        var ref, ref1, ref2, ref3, ref4;
        var type = activeHeaderData === null || activeHeaderData === void 0 ? void 0 : (ref = activeHeaderData.headerPropsConfig) === null || ref === void 0 ? void 0 : (ref1 = ref.globalClass) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.staticClass) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.base_config) === null || ref3 === void 0 ? void 0 : ref3.defaultFillColorType;
        var commonClass = (0,_object_spread/* default */.Z)({
            position: type === "transparent" ? "fixed" : "sticky"
        }, header_common_class);
        var hideClass = {
            position: type === "transparent" ? "fixed" : "sticky",
            top: -((ref4 = (headerRef === null || headerRef === void 0 ? void 0 : headerRef.current) || {}) === null || ref4 === void 0 ? void 0 : ref4.clientHeight),
            zIndex: 5000,
            width: "100%",
            transition: "top .3s ease-in-out"
        };
        var scrollUpClass = isScrollUp ? commonClass : hideClass;
        switch(scrollType){
            case "hide":
                return (0,_object_spread/* default */.Z)({}, hideClass);
            case "sticky":
                return (0,_object_spread/* default */.Z)({}, commonClass);
            case "scrollUp":
                {
                    return (0,_object_spread/* default */.Z)({}, scrollUpClass);
                }
            default:
                return {};
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        ref: headerRef,
        style: (0,_object_spread/* default */.Z)({}, isScroll ? getScrollStyling() : getStyleForTransparent()),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NewHeaderComponent, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, customProps), {
            isHomePage: isHomePage,
            activeHeaderData: activeHeaderData,
            canHideHeaderAnnouncement: canHideHeaderAnnouncement
        }))
    });
};
/* harmony default export */ var Header_NewHeaderWrapper = (NewHeaderWrapper);

;// CONCATENATED MODULE: ./src/components/DesignSystem/Widgets2.0/Header/index.ts




/***/ }),

/***/ 192600:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ NewHeaderContext; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(667294);

var NewHeaderContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({});


/***/ }),

/***/ 545588:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "R0": function() { return /* binding */ getHamburgerCustomList; },
  "ys": function() { return /* binding */ getRedirectLinkForSlug; },
  "RA": function() { return /* binding */ isWebFrameRoute; },
  "Cy": function() { return /* binding */ logoSectionConfigDetails; },
  "qd": function() { return /* binding */ useGetNavlinkList; },
  "Tg": function() { return /* binding */ useHeaderLinksUtils; }
});

// UNUSED EXPORTS: getMaxCharactersAllowedInNavLinks, useGetDropdownListforShopComponent

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(626042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(269396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(629815);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(785893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(667294);
// EXTERNAL MODULE: ./src/components/LoginAndDropdownComponent/index.js
var LoginAndDropdownComponent = __webpack_require__(629492);
// EXTERNAL MODULE: ./src/redux/store/index.js + 44 modules
var store = __webpack_require__(167261);
// EXTERNAL MODULE: ./src/utils/checkRenderEnv.js
var checkRenderEnv = __webpack_require__(506337);
// EXTERNAL MODULE: ./src/components/DesignSystem/ModernTheme/utils/btnUtils.js
var btnUtils = __webpack_require__(993080);
// EXTERNAL MODULE: ./node_modules/lodash/cloneDeep.js
var cloneDeep = __webpack_require__(150361);
var cloneDeep_default = /*#__PURE__*/__webpack_require__.n(cloneDeep);
// EXTERNAL MODULE: ./src/utils/routes.js + 1 modules
var routes = __webpack_require__(540190);
// EXTERNAL MODULE: ./src/components/WidgetMaker/WidgetDnD/WidgetProperties/HeaderBuilder/components/utils.ts
var utils = __webpack_require__(101813);
// EXTERNAL MODULE: ./src/context/WidgetDndContext/index.ts
var WidgetDndContext = __webpack_require__(474151);
// EXTERNAL MODULE: ./src/redux/index.ts
var redux = __webpack_require__(268037);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(811163);
var router_default = /*#__PURE__*/__webpack_require__.n(router);
// EXTERNAL MODULE: ./src/utils/isPLPRequiredSystem.js
var isPLPRequiredSystem = __webpack_require__(586423);
;// CONCATENATED MODULE: ./src/utils/validateLink.ts
var validateLink = function(link) {
    return (link === null || link === void 0 ? void 0 : link.startsWith("/")) ? link === null || link === void 0 ? void 0 : link.slice(1) : link;
};

;// CONCATENATED MODULE: ./src/utils/checkIfUrlHasExternalLink.js
function checkIfUrlHasExternalLink(url) {
    if (url) {
        return (url === null || url === void 0 ? void 0 : url.includes(".")) || (url === null || url === void 0 ? void 0 : url.includes("https://")) || (url === null || url === void 0 ? void 0 : url.includes("www."));
    }
    return false;
}

// EXTERNAL MODULE: ./src/utils/isWebsiteInternallyRouted.ts + 1 modules
var isWebsiteInternallyRouted = __webpack_require__(119997);
;// CONCATENATED MODULE: ./src/components/DesignSystem/Widgets2.0/Header/utils.tsx



















var logoSectionConfigDetails = function(activeHeaderData, isScroll) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6;
    var headerPropsConfig = (activeHeaderData || {}).headerPropsConfig;
    var ref7 = headerPropsConfig || {}, logo_section = ref7.logo_section, globalClass = ref7.globalClass;
    var ref8 = logo_section || {}, staticLogo = ref8.staticLogo, scrollLogo = ref8.scrollLogo;
    var currentType = isScroll ? scrollLogo : staticLogo;
    var isTransparent = (globalClass === null || globalClass === void 0 ? void 0 : (ref = globalClass.staticClass) === null || ref === void 0 ? void 0 : (ref1 = ref.base_config) === null || ref1 === void 0 ? void 0 : ref1.defaultFillColorType) === "transparent";
    var ref9 = (scrollLogo === null || scrollLogo === void 0 ? void 0 : (ref2 = scrollLogo.componentData) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.url) === null || ref3 === void 0 ? void 0 : ref3.length) > 0 && isTransparent ? currentType : staticLogo, base_config = ref9.base_config, url = ref9.componentData.url;
    var storeName = (ref4 = store/* default.getState */.Z.getState().storeReducer.store) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.store_info) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.name) === null || ref6 === void 0 ? void 0 : ref6.trim();
    return {
        hidden: !(base_config.showLogo || base_config.showStoreName),
        onlyLogo: base_config.showLogo && url && !(base_config.showStoreName && storeName),
        onlyStoreName: base_config.showStoreName && storeName && !(base_config.showLogo && url),
        logoAndName: base_config.showStoreName && storeName && base_config.showLogo && url
    };
};
function getApproxCharLengthAllowed(param) {
    var _preferredWidth = param.preferredWidth, preferredWidth = _preferredWidth === void 0 ? 720 : _preferredWidth, _charLengthAllowed = param.charLengthAllowed, charLengthAllowed = _charLengthAllowed === void 0 ? 56 : _charLengthAllowed, maxCharactersLimit = param.maxCharactersLimit;
    var calculatedChar = Math.floor(charLengthAllowed * (preferredWidth / 720));
    return calculatedChar > maxCharactersLimit ? maxCharactersLimit : calculatedChar;
}
function getMaxCharactersAllowedInNavLinks(param) {
    var containerRef = param.containerRef, headerName = param.headerName, isBuilder = param.isBuilder, headerWidth = param.headerWidth, navlinksPosition = param.navlinksPosition, searchBarType = param.searchBarType;
    var ref;
    var sectionWidth = (ref = containerRef.current) === null || ref === void 0 ? void 0 : ref.clientWidth;
    var preferredWidth = (isBuilder ? sectionWidth : headerWidth) - 18;
    var charLengthAllowed = "unset";
    if (headerName === "header1") {
        if (preferredWidth <= 720) {
            if (searchBarType === "field") charLengthAllowed = navlinksPosition === "left" ? 17 : 7;
            if (searchBarType === "icon") charLengthAllowed = 21;
            if (searchBarType === "labelIcon") charLengthAllowed = 21;
        }
        if (preferredWidth > 720 && preferredWidth < 1280) {
            if (searchBarType === "field") charLengthAllowed = navlinksPosition === "left" ? 17 : 7;
            if (searchBarType === "icon") charLengthAllowed = 21;
            if (searchBarType === "labelIcon") charLengthAllowed = 21;
        }
        if (preferredWidth >= 1280 && preferredWidth < 1366) {
            if (searchBarType === "field") charLengthAllowed = 15;
            if (searchBarType === "icon") charLengthAllowed = 40;
            if (searchBarType === "labelIcon") charLengthAllowed = 35;
        }
        if (preferredWidth >= 1366 && preferredWidth < 1420) {
            if (searchBarType === "field") charLengthAllowed = 17;
            if (searchBarType === "icon") charLengthAllowed = 45;
            if (searchBarType === "labelIcon") charLengthAllowed = 40;
        }
        if (preferredWidth >= 1420 && preferredWidth < 1500) {
            if (searchBarType === "field") charLengthAllowed = 17;
            if (searchBarType === "icon") charLengthAllowed = 50;
            if (searchBarType === "labelIcon") charLengthAllowed = 45;
        }
        if (preferredWidth >= 1500 && preferredWidth <= 1800) {
            if (searchBarType === "field") charLengthAllowed = 34;
            if (searchBarType === "icon") charLengthAllowed = 77;
            if (searchBarType === "labelIcon") charLengthAllowed = 64;
        }
        if (preferredWidth > 1800) {
            if (searchBarType === "field") charLengthAllowed = 70;
            if (searchBarType === "icon") charLengthAllowed = 92;
            if (searchBarType === "labelIcon") charLengthAllowed = 81;
        }
    }
    if (headerName === "header2") {
        if (preferredWidth <= 720) {
            charLengthAllowed = 16;
        }
        if (preferredWidth > 720 && preferredWidth <= 1100) {
            charLengthAllowed = 15;
        }
        if (preferredWidth > 1100 && preferredWidth <= 1500) {
            charLengthAllowed = 31;
        }
        if (preferredWidth > 1500 && preferredWidth <= 1800) {
            charLengthAllowed = 35;
        }
        if (preferredWidth > 1800) {
            charLengthAllowed = 49;
        }
    }
    if (headerName === "header3" || headerName === "header4") {
        if (preferredWidth > 720 && preferredWidth <= 999) {
            charLengthAllowed = 56;
            charLengthAllowed = getApproxCharLengthAllowed({
                preferredWidth: preferredWidth,
                charLengthAllowed: charLengthAllowed,
                maxCharactersLimit: 100
            });
        }
        if (preferredWidth >= 1000 && preferredWidth <= 1262) {
            charLengthAllowed = 70;
            charLengthAllowed = getApproxCharLengthAllowed({
                preferredWidth: preferredWidth,
                charLengthAllowed: charLengthAllowed,
                maxCharactersLimit: 100
            });
        }
        if (preferredWidth > 1262 && preferredWidth <= 1347) {
            charLengthAllowed = 70;
            charLengthAllowed = getApproxCharLengthAllowed({
                preferredWidth: preferredWidth,
                charLengthAllowed: charLengthAllowed,
                maxCharactersLimit: 104
            });
        }
        if (preferredWidth > 1347 && preferredWidth <= 1421) {
            charLengthAllowed = 104;
            charLengthAllowed = getApproxCharLengthAllowed({
                preferredWidth: preferredWidth,
                charLengthAllowed: charLengthAllowed,
                maxCharactersLimit: 133
            });
        }
        if (preferredWidth > 1421 && preferredWidth <= 1517) {
            charLengthAllowed = 111;
            charLengthAllowed = getApproxCharLengthAllowed({
                preferredWidth: preferredWidth,
                charLengthAllowed: charLengthAllowed,
                maxCharactersLimit: 140
            });
        }
        if (preferredWidth > 1517 && preferredWidth <= 1581) {
            charLengthAllowed = 116;
            charLengthAllowed = getApproxCharLengthAllowed({
                preferredWidth: preferredWidth,
                charLengthAllowed: charLengthAllowed,
                maxCharactersLimit: 140
            });
        }
        if (preferredWidth > 1581 && preferredWidth <= 1782) {
            charLengthAllowed = 132;
            charLengthAllowed = getApproxCharLengthAllowed({
                preferredWidth: preferredWidth,
                charLengthAllowed: charLengthAllowed,
                maxCharactersLimit: 160
            });
        }
        if (preferredWidth > 1782) {
            charLengthAllowed = 140;
            charLengthAllowed = getApproxCharLengthAllowed({
                preferredWidth: preferredWidth,
                charLengthAllowed: charLengthAllowed,
                maxCharactersLimit: 170
            });
        }
    }
    return charLengthAllowed;
}
function checkForShopComponent(linksData) {
    linksData === null || linksData === void 0 ? void 0 : linksData.forEach(function(data) {
        var ref;
        if ((data === null || data === void 0 ? void 0 : data.isShopComponent) && (data === null || data === void 0 ? void 0 : (ref = data.option) === null || ref === void 0 ? void 0 : ref.length) && (data === null || data === void 0 ? void 0 : data.type) === "text") {
            data.type = "dropdown";
            data.redirectionLink = "";
        }
    });
    return cloneDeep_default()(linksData);
}
var useGetNavlinkList = function(param) {
    var activeHeaderData = param.activeHeaderData, dynamicSectionData = param.dynamicSectionData, headerNodeRef = param.headerNodeRef, isBuilder = param.isBuilder, componentData = param.componentData, headerName = param.headerName, containerRef = param.containerRef, isMobile = param.isMobile;
    var checkIfMoreAlreadyThere = function checkIfMoreAlreadyThere(visibleLinks) {
        var moreIndex = -1;
        for(var i = 0; i < (visibleLinks === null || visibleLinks === void 0 ? void 0 : visibleLinks.length); i++){
            var ref, ref1;
            if (((ref = visibleLinks[i]) === null || ref === void 0 ? void 0 : (ref1 = ref.name) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase()) === "more") {
                moreIndex = i;
                break;
            }
        }
        return moreIndex;
    };
    var removeMoreOption = function removeMoreOption(restElements) {
        return restElements === null || restElements === void 0 ? void 0 : restElements.filter(function(data) {
            var ref;
            return (data === null || data === void 0 ? void 0 : (ref = data.name) === null || ref === void 0 ? void 0 : ref.toLowerCase()) !== "more";
        });
    };
    var getNavLinkSliceCount = function getNavLinkSliceCount() {
        var charLengthAllowed = getMaxCharactersAllowedInNavLinks({
            containerRef: containerRef,
            headerName: headerName,
            isBuilder: isBuilder,
            headerWidth: headerWidth,
            navlinksPosition: navlinksPosition,
            searchBarType: searchBarType
        });
        var sliceCount = 0;
        if (charLengthAllowed === "unset") {
            return sliceCount;
        }
        var currentCharacterCount = 0;
        for(var currentIndex = 0; currentIndex <= visibleLinks.length - 1; currentIndex++){
            currentCharacterCount = currentCharacterCount + visibleLinks[currentIndex].name.length;
            if (currentCharacterCount > charLengthAllowed) {
                break;
            } else {
                ++sliceCount;
            }
        }
        return sliceCount;
    };
    var ref, ref1, ref2;
    var headerWidth = (headerNodeRef === null || headerNodeRef === void 0 ? void 0 : headerNodeRef.clientWidth) || (!checkRenderEnv/* IS_SERVER */.W6 ? window.innerWidth : isMobile ? 481 : 781);
    var navlinksPosition = activeHeaderData === null || activeHeaderData === void 0 ? void 0 : (ref = activeHeaderData.headerPropsConfig) === null || ref === void 0 ? void 0 : (ref1 = ref.navLinks_section) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.base_config) === null || ref2 === void 0 ? void 0 : ref2.defaultPosition;
    var visibleLinks = componentData === null || componentData === void 0 ? void 0 : componentData.filter(function(data) {
        return data === null || data === void 0 ? void 0 : data.showOnHeader;
    });
    var dynamicSectionBaseConfig = dynamicSectionData.base_config;
    var searchBarType = dynamicSectionBaseConfig.defaultType;
    var getNavLinkItems = (0,react.useCallback)(function() {
        var sliceCount = 1;
        sliceCount = getNavLinkSliceCount();
        var newComponentData = [];
        if (sliceCount > (visibleLinks === null || visibleLinks === void 0 ? void 0 : visibleLinks.length)) {
            newComponentData = visibleLinks;
        } else {
            var currentData = visibleLinks === null || visibleLinks === void 0 ? void 0 : visibleLinks.slice(0, sliceCount);
            var restElements = visibleLinks === null || visibleLinks === void 0 ? void 0 : visibleLinks.slice(sliceCount, visibleLinks === null || visibleLinks === void 0 ? void 0 : visibleLinks.length);
            var newData = [];
            var moreIndex = checkIfMoreAlreadyThere(visibleLinks);
            if (restElements === null || restElements === void 0 ? void 0 : restElements.length) {
                var ref;
                newData = {
                    name: "More",
                    type: "dropdown",
                    option: moreIndex >= 0 ? (0,_to_consumable_array/* default */.Z)(removeMoreOption(restElements)).concat((0,_to_consumable_array/* default */.Z)(visibleLinks === null || visibleLinks === void 0 ? void 0 : (ref = visibleLinks[moreIndex]) === null || ref === void 0 ? void 0 : ref.option)) : (0,_to_consumable_array/* default */.Z)(restElements),
                    showOnHeader: true,
                    elementLevelClass: ""
                };
            }
            newComponentData = (0,_to_consumable_array/* default */.Z)((restElements === null || restElements === void 0 ? void 0 : restElements.length) > 0 ? removeMoreOption(currentData) : currentData).concat([
                newData, 
            ]);
        }
        return newComponentData;
    }, [
        headerNodeRef,
        visibleLinks
    ]);
    var updatedNavLinks = checkForShopComponent(getNavLinkItems());
    return {
        navlinkList: updatedNavLinks
    };
};
var getHamburgerCustomList = function(activeHeaderData, onMenuDrawerItemClick, closeMenuDrawerOnMobile, canShowItem) {
    var ref, ref1, ref2, ref3, ref4;
    var drawerCustomList = ((ref = activeHeaderData.headerPropsConfig.navIcons_section) === null || ref === void 0 ? void 0 : (ref1 = ref.componentData) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.iconsList) === null || ref2 === void 0 ? void 0 : ref2.filter(function(item) {
        var ref;
        return ((ref = item.visibility) === null || ref === void 0 ? void 0 : ref.hamburger) === true;
    }).reverse().map(function(item) {
        return canShowItem(item) && item.name === "loginLogout" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(LoginAndDropdownComponent/* default */.Z, {
            disableDropdown: true,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: item.label
            })
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
            className: "tw-m-0 ",
            onClick: function() {
                return onMenuDrawerItemClick(item.action.actionType, item.action.actionData);
            },
            children: item.label
        }, item.label);
    })) || [];
    var visibleButtons = activeHeaderData === null || activeHeaderData === void 0 ? void 0 : (ref3 = activeHeaderData.headerPropsConfig) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.buttons) === null || ref4 === void 0 ? void 0 : ref4.filter(function(item) {
        var ref;
        return !!(item === null || item === void 0 ? void 0 : item.isShow) && !!(item === null || item === void 0 ? void 0 : (ref = item.text) === null || ref === void 0 ? void 0 : ref.trim());
    });
    var buttonList = (visibleButtons === null || visibleButtons === void 0 ? void 0 : visibleButtons.map(function(item) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
            className: "tw-m-0 ",
            onClick: function() {
                closeMenuDrawerOnMobile();
                (0,btnUtils/* btnActionHandler */.c)(item === null || item === void 0 ? void 0 : item.actions, function() {});
            },
            children: item.text
        }, item.text);
    })) || [];
    return (drawerCustomList === null || drawerCustomList === void 0 ? void 0 : drawerCustomList.concat(buttonList)) || [];
};
/**
 * webFrame is the route which only has CFE header and the body is loaded in iFrame
 * @returns if the route is an iFrame route
 */ var isWebFrameRoute = function() {
    if (checkRenderEnv/* IS_SERVER */.W6) {
        return false;
    }
    return window.location.pathname.includes("/webFrame");
};
/**
 *
 * @param redirectionLink
 * @param navigationList
 * @returns updated slug URL
 */ function getRedirectLinkForSlug() {
    var navigationList = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], redirectionLink = arguments.length > 1 ? arguments[1] : void 0, id = arguments.length > 2 ? arguments[2] : void 0;
    var DEFAULT_PAGE_TYPES = [
        "social_media",
        "faqs",
        "testimonial"
    ];
    // If the link is blog type, redirect it to /blog URL
    var matchingNavItem = navigationList.find(function(navItem) {
        return navItem.page_id === id;
    });
    if ((matchingNavItem === null || matchingNavItem === void 0 ? void 0 : matchingNavItem.page_type) === "ai-blog" || (redirectionLink === null || redirectionLink === void 0 ? void 0 : redirectionLink.includes("/blog"))) {
        return routes.PATH.BLOG;
    }
    // If the link is of type DEFAULT_PAGE_TYPES, then append /p infront of URL if not already appended.
    if (DEFAULT_PAGE_TYPES.includes(matchingNavItem === null || matchingNavItem === void 0 ? void 0 : matchingNavItem.page_type) && !(redirectionLink === null || redirectionLink === void 0 ? void 0 : redirectionLink.includes("p/"))) {
        return "".concat(routes.PATH.additionalPage(redirectionLink));
    }
    return redirectionLink;
}
var useGetDropdownListforShopComponent = function() {
    var getShopComponentLinks = function getShopComponentLinks(option) {
        var categories = Object.values(categoriesList);
        // Updating details of category item (such as name)
        categories.forEach(function(newOption) {
            var oldItemIdx = option.findIndex(function(oldItem) {
                return oldItem.id === newOption.id;
            });
            if (oldItemIdx === -1) return null;
            option[oldItemIdx] = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, option[oldItemIdx]), {
                name: newOption.name
            });
        });
        // Extracting newly added categories
        var newCatList = categories === null || categories === void 0 ? void 0 : categories.filter(function(item) {
            var isOldCat = !!option.find(function(cat) {
                return item.id && cat.id === item.id || cat.name === item.name;
            });
            return !isOldCat;
        });
        return option === null || option === void 0 ? void 0 : option.concat(newCatList).filter(function(item) {
            return item.showOnHeader !== false && item.showOnHeader !== 0;
        });
    };
    var getDropdownList = function getDropdownList(isShopComponent) {
        var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
        var option = options || [];
        if (isBuilder) {
            return option;
        }
        if (!isShopComponent) {
            return option.filter(function(item) {
                return item.showOnHeader !== false && item.showOnHeader !== 0;
            });
        }
        var shopLinks = getShopComponentLinks(options);
        return shopLinks;
    };
    var ref = (0,WidgetDndContext/* useWidgetDndContextData */.KX)(), isBuilder = ref.widgetContextState.isBuilder;
    var categoriesList = (0,utils/* useGetCategoriesList */.s)();
    return {
        getDropdownList: getDropdownList,
        categoriesList: categoriesList
    };
};
var useHeaderLinksUtils = function() {
    var extractPathFromInternalLink = /* We have found cases where merchants type in https://domain.in/path, www.domain.in/path, domain.in/path in link section.
   * This we will now extract path from them */ function extractPathFromInternalLink(link) {
        if (checkRenderEnv/* IS_SERVER */.W6) return link;
        if ((0,isWebsiteInternallyRouted/* isWebsiteInternallyRouted */.G)(window.location.host)) return link;
        var redirectLink = link;
        if (domainName && (redirectLink === null || redirectLink === void 0 ? void 0 : redirectLink.includes(domainName))) {
            redirectLink = redirectLink === null || redirectLink === void 0 ? void 0 : redirectLink.split(domainName)[1];
        }
        return redirectLink;
    };
    var getRouteLink = // Curries a function with pre-added argument to remove redundant code writing
    function getRouteLink(link) {
        return (0,routes.getRoute)(link, domainName);
    };
    var getUpdatedCategory = // Fetches the category details from store->catalogReducer as there might be stale values in Header Link if category is deleted.
    function getUpdatedCategory(category) {
        var matchingCategoryInStore = Object.values(categoriesList || {}).find(function(val) {
            return (val === null || val === void 0 ? void 0 : val.id) === (category === null || category === void 0 ? void 0 : category.id) || (val === null || val === void 0 ? void 0 : val.name) === (category === null || category === void 0 ? void 0 : category.name);
        });
        return matchingCategoryInStore;
    };
    var getCategoryLink = function getCategoryLink(currentCategory) {
        var ref;
        var updatedCategory = getUpdatedCategory(currentCategory);
        return getRouteLink("".concat((0,isPLPRequiredSystem/* isPLPRequiredSystem */.q)(store === null || store === void 0 ? void 0 : (ref = store.theme) === null || ref === void 0 ? void 0 : ref.theme_class) ? routes.PATH.SHOP : routes.PATH.PRODUCT, "?cid=").concat((updatedCategory === null || updatedCategory === void 0 ? void 0 : updatedCategory.id) || ""));
    };
    var generatePathForInternalRedirection = function generatePathForInternalRedirection(linkInfo) {
        var redirectLink = getAdditionalPagesRedirectLink(linkInfo);
        return extractPathFromInternalLink(redirectLink);
    };
    var ref;
    var ref1 = (0,redux/* useSSRSelector */.kF)(function(state) {
        return {
            store: state.storeReducer.store,
            navigationList: state.additionalPagesReducer.navigationList || []
        };
    }), store = ref1.store, navigationList = ref1.navigationList;
    var ref2 = useGetDropdownListforShopComponent(), getDropdownList = ref2.getDropdownList, categoriesList = ref2.categoriesList;
    var domainName = store === null || store === void 0 ? void 0 : (ref = store.store_info) === null || ref === void 0 ? void 0 : ref.domain;
    // Read function doc, in short, this handles additional pages linking
    var getAdditionalPagesRedirectLink = function(linkInfo) {
        return getRedirectLinkForSlug(navigationList, validateLink(linkInfo === null || linkInfo === void 0 ? void 0 : linkInfo.redirectionLink), linkInfo === null || linkInfo === void 0 ? void 0 : linkInfo.id);
    };
    // Used for final redirections, no logic takes place here
    var onCustomNavItemClick = function(param) {
        var link = param.link, openInNewTab = param.openInNewTab, isTypeDropdown = param.isTypeDropdown;
        if (isTypeDropdown) return;
        if (openInNewTab) {
            window.open(link, "_blank");
            return;
        }
        router_default().push(getRouteLink(link || "/"));
    };
    // Main redirection logic handler -> takes in a link object that can be standalone or nested in a dropdown
    var handleHeaderNavItemClick = function(linkInfo) {
        if (!linkInfo) return;
        var isShopComponent = linkInfo.isShopComponent, openInNewTab = linkInfo.redirectNewPage, customRedirectLink = linkInfo.redirectionLink;
        /**
     * 1. Only unique case is that if that link is a child of a Shop dropdown,
     * 2. In that case we are sure the dropdown will contain categories & tags, thus we handle that.
     * 3. When collection are present, we use mega menu in desktop, but in desktop there is two layer nesting, Shop -> Collection (non-clickable) -> Category (clickable)
     */ if (isShopComponent && !customRedirectLink) {
            var currentCategory = getUpdatedCategory(linkInfo);
            if (currentCategory === null || currentCategory === void 0 ? void 0 : currentCategory.id) {
                router_default().push(getCategoryLink(currentCategory), undefined, {
                    shallow: false
                });
            }
            return;
        }
        var redLink = getAdditionalPagesRedirectLink(linkInfo);
        var link = extractPathFromInternalLink(validateLink(redLink));
        var isExternalLinkPresent = checkIfUrlHasExternalLink(link);
        if (openInNewTab && !isExternalLinkPresent) link = getRouteLink(link);
        onCustomNavItemClick({
            link: link,
            openInNewTab: isExternalLinkPresent || openInNewTab
        });
    };
    var getHeaderNavInlineLink = function(linkInfo) {
        if (linkInfo.isShopComponent && !(linkInfo === null || linkInfo === void 0 ? void 0 : linkInfo.redirectionLink)) {
            return {
                link: getCategoryLink(linkInfo)
            };
        }
        var redirectLink = getAdditionalPagesRedirectLink(linkInfo);
        var isExternalLinkPresent = checkIfUrlHasExternalLink(redirectLink);
        return {
            link: extractPathFromInternalLink(!isExternalLinkPresent ? getRouteLink(redirectLink) : redirectLink),
            target: isExternalLinkPresent ? "_blank" : undefined
        };
    };
    return {
        handleHeaderNavItemClick: handleHeaderNavItemClick,
        getDropdownList: getDropdownList,
        getHeaderNavInlineLink: getHeaderNavInlineLink,
        onCustomNavItemClick: onCustomNavItemClick,
        generatePathForInternalRedirection: generatePathForInternalRedirection
    };
};


/***/ }),

/***/ 16902:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "UF": function() { return /* binding */ DEFAULT_IMAGE; },
/* harmony export */   "ej": function() { return /* binding */ SCROLL_TYPE; },
/* harmony export */   "eu": function() { return /* binding */ TESTIMONIAL_IMAGE_POSITION; },
/* harmony export */   "o_": function() { return /* binding */ COMMON_LAYOUT_TYPE; },
/* harmony export */   "v5": function() { return /* binding */ IMAGE_TYPES; },
/* harmony export */   "w_": function() { return /* binding */ MEDIA_TYPES; }
/* harmony export */ });
/* unused harmony exports ORDER_DATA_IDS, CARD_DEFAULT_CONFIGS, IMAGE_LIMIT_L4, TESTIMONIAL_IMAGE_SHAPES, CARD_ANIMATION_CLASSES, REMOVE_GLOBAL_STYLE, IMAGE_SIZE_L4 */
var COMMON_LAYOUT_TYPE = {
    ZERO: "layout0",
    ONE: "layout1",
    TWO: "layout2",
    THREE: "layout3",
    FOUR: "layout4",
    FIVE: "layout5",
    SIX: "layout6"
};
var IMAGE_TYPES = {
    CIRCLE: "circle",
    SQUARE: "square",
    RECT: "rectangle"
};
var ORDER_DATA_IDS = {
    RATING: "rating",
    REVIEW: "review",
    AUTHOR_INFO: "authorInfo"
};
var MEDIA_TYPES = {
    IMAGE: "image",
    VIDEO: "video"
};
var SCROLL_TYPE = {
    MANUAL: "manual",
    AUTO_SCROLL: "autoScroll",
    AUTO_ROTATE: "autoRotate"
};
// will be removed later
var CARD_DEFAULT_CONFIGS = {
    layout1: {
        cardWrapperConfig: {
            showBorder: false,
            padding: "35px 28px"
        },
        imageConfig: {
            showImage: true,
            showImageWithAuthorInfo: true,
            imageType: IMAGE_TYPES.CIRCLE,
            width: 40,
            height: 40
        },
        infoWrapperConfig: {
            gap: 24
        },
        reviewConfig: {},
        authorInfoConfig: {
            gap: 0,
            authornameConfig: {
                fontSize: 14,
                lineHeight: "20px",
                fontWeight: 600
            },
            authorProfileConfig: {
                fontWeight: 400
            }
        }
    },
    layout2: {
        cardWrapperConfig: {
            showBorder: false,
            padding: "35px 28px"
        },
        imageConfig: {
            showImage: true,
            showImageWithAuthorInfo: true,
            imageType: IMAGE_TYPES.CIRCLE,
            width: 40,
            height: 40
        },
        infoWrapperConfig: {
            gap: 24
        },
        reviewConfig: {},
        authorInfoConfig: {
            gap: 0,
            authornameConfig: {
                fontSize: 14,
                lineHeight: "20px",
                fontWeight: 600
            },
            authorProfileConfig: {
                fontWeight: 400
            }
        }
    },
    layout3: {
        cardWrapperConfig: {
            showBorder: false,
            flexDirection: "column",
            gap: 18
        },
        imageConfig: {
            showImage: true,
            showImageWithAuthorInfo: false,
            imageType: IMAGE_TYPES.CIRCLE,
            width: 76,
            height: 76
        },
        infoWrapperConfig: {
            gap: 10.5
        },
        reviewConfig: {},
        authorInfoConfig: {
            gap: 0,
            alignItems: "center",
            authornameConfig: {
                fontSize: 14,
                lineHeight: "20px",
                fontWeight: 600
            },
            authorProfileConfig: {
                fontWeight: 400
            }
        }
    },
    layout4: {
        showAuthorImageList: true,
        cardWrapperConfig: {
            showBorder: false,
            paddingBottom: 100
        },
        imageConfig: {
            showImage: false,
            showImageWithAuthorInfo: false,
            imageType: IMAGE_TYPES.CIRCLE,
            width: 40,
            height: 40
        },
        infoWrapperConfig: {
            gap: 16
        },
        reviewConfig: {
            marginTop: 8,
            gap: 16
        },
        authorInfoConfig: {}
    },
    layout5: {
        cardWrapperConfig: {
            showBorder: false,
            gap: 34,
            padding: 0
        },
        imageConfig: {
            showImage: true,
            showImageWithAuthorInfo: false,
            imageType: IMAGE_TYPES.RECT,
            width: 236,
            height: 316,
            flex: "none"
        },
        infoWrapperConfig: {
            gap: 24,
            alignItems: "start"
        },
        reviewConfig: {},
        authorInfoConfig: {
            gap: 9,
            authornameConfig: {
                fontSize: 16,
                lineHeight: "20px",
                fontWeight: 700
            },
            authorProfileConfig: {
                fontWeight: 400
            }
        }
    },
    layout6: {
        cardWrapperConfig: {
            showBorder: true,
            borderColor: "#111C3633",
            gap: 32,
            flexDirection: "column",
            padding: "32px 48px"
        },
        imageConfig: {
            showImage: true,
            showImageWithAuthorInfo: false,
            imageType: IMAGE_TYPES.CIRCLE,
            width: 180,
            height: 180
        },
        infoWrapperConfig: {
            gap: 20
        },
        reviewConfig: {},
        authorInfoConfig: {
            gap: 8,
            alignItems: "center",
            authornameConfig: {
                fontSize: 16,
                lineHeight: "20px",
                fontWeight: 700
            },
            authorProfileConfig: {
                fontWeight: 400
            }
        }
    }
};
var DEFAULT_IMAGE = "https://cdn.dotpe.in/longtail/themes/8697974/VUkpiiUx.webp";
var IMAGE_LIMIT_L4 = {
    DESKTOP: 7,
    MOBILE: 5,
    MOBILE_XS: 3
};
var TESTIMONIAL_IMAGE_POSITION = {
    WITH_AUTHOR_INFO: "withAuthorInfo",
    LEFT: "left",
    TOP: "top",
    BOTTOM: "bottom"
};
var TESTIMONIAL_IMAGE_SHAPES = {
    SMART: "smart",
    CIRCLE: "circle",
    SQUARE: "square"
};
var CARD_ANIMATION_CLASSES = {
    BASE: "tw-relative tw-transition-all tw-ease-in-out tw-duration-1000 ",
    INACTIVE: "tw-top-[20px] tw-opacity-0",
    ACTIVE: "tw-top-0 tw-opacity-100"
};
var REMOVE_GLOBAL_STYLE = (/* unused pure expression or super */ null && ([
    "circle",
    "arch",
    "blob"
]));
var IMAGE_SIZE_L4 = {
    imageSizeActive: 48,
    imageSizeInactive: 40
};


/***/ }),

/***/ 203310:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Im": function() { return /* binding */ getMappedproductsTextSize; },
/* harmony export */   "TI": function() { return /* binding */ getMappedProductCasing; },
/* harmony export */   "aA": function() { return /* binding */ getMappedProductTextThickness; },
/* harmony export */   "fs": function() { return /* binding */ getTextSizeNum; }
/* harmony export */ });
/* unused harmony exports getMappedProductTextAlign, commonApiHeader */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(667294);

function getMappedproductsTextSize(sizeString) {
    var style = {};
    switch(sizeString){
        case "extraSmall":
            style.fontSize = "12px";
            style.lineHeight = "1.4";
            break;
        case "small":
            style.fontSize = "13px";
            style.lineHeight = "1.4";
            break;
        case "regular":
            style.fontSize = "14px";
            style.lineHeight = "1.4";
            break;
        case "medium":
            style.fontSize = "16px";
            style.lineHeight = "1.4";
            break;
        case "large":
            style.fontSize = "18px";
            style.lineHeight = "1.4";
            break;
        case "extraLarge":
            style.fontSize = "20px";
            style.lineHeight = "1.4";
            break;
        default:
            style.fontSize = "14px";
            style.lineHeight = "1.4";
            break;
    }
    return style;
}
function getMappedProductTextAlign(xAlignment) {
    var styles = {};
    switch(xAlignment){
        case "left":
            styles.textAlign = "left";
            break;
        case "center":
            styles.textAlign = "center";
            break;
        case "right":
            styles.textAlign = "right";
            break;
    }
    return styles;
}
function getMappedProductTextThickness(textThicness) {
    var styles = {};
    switch(textThicness){
        case "thin":
            styles.fontWeight = "300";
            break;
        case "regular":
            styles.fontWeight = "400";
            break;
        case "medium":
            styles.fontWeight = "500";
            break;
        case "semiBold":
            styles.fontWeight = "600";
            break;
        case "bold":
            styles.fontWeight = "700";
            break;
        default:
            styles.fontWeight = "400";
            break;
    }
    return styles;
}
function getMappedProductCasing(titleTextCase) {
    var style = {};
    switch(titleTextCase){
        case "none":
            style.textTransform = "none";
            break;
        case "capitalize":
            style.textTransform = "capitalize";
            break;
        case "uppercase":
            style.textTransform = "uppercase";
            break;
    }
    return style;
}
function getTextSizeNum(sizeString) {
    var textSizeStr = getMappedproductsTextSize(sizeString).fontSize;
    return Number(textSizeStr.replace("px", ""));
}
function commonApiHeader(authToken) {
    return {
        headers: {
            auth_token: authToken,
            app_os: "cfe",
            app_version: "0.1.0",
            "Content-Type": "application/json"
        }
    };
}


/***/ }),

/***/ 673861:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ InfiniteAutoScroller; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(785893);
/* harmony import */ var tailwind_merge__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(798388);
/* harmony import */ var _ListPresentation_ListPresentation_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(981673);
/* harmony import */ var _ListPresentation_ListPresentation_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_ListPresentation_ListPresentation_module_scss__WEBPACK_IMPORTED_MODULE_2__);



var InfiniteAutoScroller = function(props) {
    var gap = props.gap, _children = props.children, children = _children === void 0 ? [] : _children, scrollSpeedInSec = props.scrollSpeedInSec, totalItems = props.totalItems, _customClasses = props.customClasses, customClasses = _customClasses === void 0 ? "" : _customClasses, wrapperClasses = props.wrapperClasses, _maxWidth = props.maxWidth, maxWidth = _maxWidth === void 0 ? "100%" : _maxWidth;
    var finalChildren = totalItems > 1 ? children : children.concat(children);
    totalItems = totalItems > 1 ? totalItems : 2 * totalItems;
    var groupWrapperStyles = {
        gap: gap,
        paddingRight: gap,
        animationDuration: scrollSpeedInSec * totalItems + "s"
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        style: {
            maxWidth: maxWidth
        },
        className: (0,tailwind_merge__WEBPACK_IMPORTED_MODULE_1__/* .twMerge */ .m6)((_ListPresentation_ListPresentation_module_scss__WEBPACK_IMPORTED_MODULE_2___default().carousel), customClasses),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(GroupWrapper, {
                style: groupWrapperStyles,
                className: wrapperClasses,
                children: finalChildren
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(GroupWrapper, {
                style: groupWrapperStyles,
                className: wrapperClasses,
                children: finalChildren
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(GroupWrapper, {
                style: groupWrapperStyles,
                className: wrapperClasses,
                children: finalChildren
            })
        ]
    });
};
function GroupWrapper(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        style: props.style,
        className: (0,tailwind_merge__WEBPACK_IMPORTED_MODULE_1__/* .twMerge */ .m6)((_ListPresentation_ListPresentation_module_scss__WEBPACK_IMPORTED_MODULE_2___default().group), props.className),
        children: props.children
    });
}


/***/ }),

/***/ 250212:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ HEADER_ANNOUNCEMENT_ID; }
/* harmony export */ });
var HEADER_ANNOUNCEMENT_ID = "header-announcement";


/***/ }),

/***/ 238020:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ useHeaderAnnouncementHeight; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(667294);
/* harmony import */ var _Constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(250212);
/* harmony import */ var src_context_WidgetDndContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(474151);
/* harmony import */ var _Utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(156729);
/* harmony import */ var src_components_WidgetMaker_WidgetDnD_hooks_useDeviceType__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(171468);





var useHeaderAnnouncementHeight = function() {
    var ref = (0,src_context_WidgetDndContext__WEBPACK_IMPORTED_MODULE_1__/* .useWidgetDndContextData */ .KX)(), activeHeaderData = ref.widgetContextState.activeHeaderData;
    var isMobile = (0,src_components_WidgetMaker_WidgetDnD_hooks_useDeviceType__WEBPACK_IMPORTED_MODULE_3__/* .useDeviceType */ .h)().isMobile;
    var maxAnnouncementHeight = (0,_Utils__WEBPACK_IMPORTED_MODULE_2__/* .getMaxAnnouncementHeight */ .v)({
        activeHeaderData: activeHeaderData,
        isMobile: isMobile
    }).maxAnnouncementHeight;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(maxAnnouncementHeight), headerAnnouncementHeight = ref1[0], setHeaderAnnouncementHeight = ref1[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        setTimeout(function() {
            var headerAnnouncement = document.getElementById(_Constants__WEBPACK_IMPORTED_MODULE_4__/* .HEADER_ANNOUNCEMENT_ID */ .L);
            if (headerAnnouncement) {
                setHeaderAnnouncementHeight(headerAnnouncement.clientHeight || maxAnnouncementHeight);
            }
        }, 1500);
    }, []);
    return {
        headerAnnouncementHeight: headerAnnouncementHeight
    };
};


/***/ }),

/***/ 156729:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ getAnnouncementBarStyles; },
/* harmony export */   "v": function() { return /* binding */ getMaxAnnouncementHeight; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(626042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(269396);
/* harmony import */ var _Carousel_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(658619);
/* harmony import */ var _ListPresentation_components_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(203310);




var TEXT_SIZE_DESKTOP_KEY = "textSizeDesktop";
var TEXT_SIZE_MOBILE_KEY = "textSizeMobile";
function getAnnouncementBarStyles(param) {
    var isMobile = param.isMobile, cardFrameConfig = param.cardFrameConfig, listPresentationConfig = param.listPresentationConfig;
    var ref = listPresentationConfig === null || listPresentationConfig === void 0 ? void 0 : listPresentationConfig.colors, selectedColorSchemeIndex = ref.selectedColorSchemeIndex, colorSchemes = ref.colorSchemes;
    var mobilePaddingY = listPresentationConfig.mobilePaddingY, paddingY = listPresentationConfig.paddingY;
    var _selectedColorSchemeIndex = colorSchemes[selectedColorSchemeIndex], _text = _selectedColorSchemeIndex.text, text = _text === void 0 ? "#000000" : _text, _background = _selectedColorSchemeIndex.background, background = _background === void 0 ? "#ffffff" : _background;
    var announcementStyles = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, (0,_ListPresentation_components_utils__WEBPACK_IMPORTED_MODULE_1__/* .getMappedproductsTextSize */ .Im)(cardFrameConfig === null || cardFrameConfig === void 0 ? void 0 : cardFrameConfig[!isMobile ? TEXT_SIZE_DESKTOP_KEY : TEXT_SIZE_MOBILE_KEY]), (0,_ListPresentation_components_utils__WEBPACK_IMPORTED_MODULE_1__/* .getMappedProductCasing */ .TI)(cardFrameConfig === null || cardFrameConfig === void 0 ? void 0 : cardFrameConfig.textCase), (0,_ListPresentation_components_utils__WEBPACK_IMPORTED_MODULE_1__/* .getMappedProductTextThickness */ .aA)(cardFrameConfig === null || cardFrameConfig === void 0 ? void 0 : cardFrameConfig.textThickness)), {
        color: text,
        textAlign: "center"
    });
    var containersStyles = {
        padding: "".concat(isMobile ? mobilePaddingY : paddingY, "px 0px"),
        background: background
    };
    return {
        announcementStyles: announcementStyles,
        containersStyles: containersStyles
    };
}
function getMaxAnnouncementHeight(param) {
    var activeHeaderData = param.activeHeaderData, isMobile = param.isMobile;
    var ref;
    var ref1 = (activeHeaderData === null || activeHeaderData === void 0 ? void 0 : (ref = activeHeaderData.headerPropsConfig) === null || ref === void 0 ? void 0 : ref.announcementConfig) || {}, cardConfig = ref1.cardConfig, listConfig = ref1.listConfig;
    var ref2 = listConfig || {}, _mobilePaddingY = ref2.mobilePaddingY, mobilePaddingY = _mobilePaddingY === void 0 ? 6 : _mobilePaddingY, _paddingY = ref2.paddingY, paddingY = _paddingY === void 0 ? 8 : _paddingY;
    var ref3 = cardConfig || {}, _textSizeMobile = ref3.textSizeMobile, textSizeMobile = _textSizeMobile === void 0 ? 12 : _textSizeMobile, _textSizeDesktop = ref3.textSizeDesktop, textSizeDesktop = _textSizeDesktop === void 0 ? 14 : _textSizeDesktop;
    var announcementTextHeight = (0,_Carousel_utils__WEBPACK_IMPORTED_MODULE_0__/* .getTextLineHeightBuilder */ .Tm)((0,_ListPresentation_components_utils__WEBPACK_IMPORTED_MODULE_1__/* .getTextSizeNum */ .fs)(isMobile ? textSizeMobile : textSizeDesktop));
    // announcement text can go upto 3 line only
    var maxAnnouncementHeight = (isMobile ? mobilePaddingY : paddingY) * 2 + 3 * announcementTextHeight;
    return {
        maxAnnouncementHeight: maxAnnouncementHeight
    };
}


/***/ }),

/***/ 990807:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "g": function() { return /* binding */ NewAnnouncementBar; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(626042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(269396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(785893);
// EXTERNAL MODULE: ./src/components/WidgetMaker/WidgetDnD/WidgetProperties/NewAnnouncementBar/Constants/index.tsx
var Constants = __webpack_require__(889489);
// EXTERNAL MODULE: ./src/components/DesignSystem/Widgets2.0/NewAnnouncementBar/Utils/index.ts
var Utils = __webpack_require__(156729);
// EXTERNAL MODULE: ./src/components/WidgetMaker/WidgetDnD/WidgetProperties/NewAnnouncementBar/Utils/index.tsx + 1 modules
var NewAnnouncementBar_Utils = __webpack_require__(154697);
// EXTERNAL MODULE: ./src/components/BasicSlider/index.tsx + 2 modules
var BasicSlider = __webpack_require__(9997);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(693967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./src/components/DesignSystem/ModernTheme/utils/btnUtils.js
var btnUtils = __webpack_require__(993080);
// EXTERNAL MODULE: ./src/components/DesignSystem/AtomicDesignsUtilities/ContentAnimationStyles.module.scss
var ContentAnimationStyles_module = __webpack_require__(489429);
var ContentAnimationStyles_module_default = /*#__PURE__*/__webpack_require__.n(ContentAnimationStyles_module);
// EXTERNAL MODULE: ./src/components/DesignSystem/Widgets2.0/CommonLinkWrapper/index.tsx
var CommonLinkWrapper = __webpack_require__(486353);
;// CONCATENATED MODULE: ./src/components/DesignSystem/Widgets2.0/NewAnnouncementBar/Components/AnnouncementStrip.tsx







var AnnouncementStrip = function(props) {
    var handleAnnoumcementClick = function handleAnnoumcementClick() {
        if (redirectUrl && !isBuilder) {
            var actionObj = {
                type: redirectionType || "",
                handler: redirectUrl || "",
                newTab: isOpenInNewTab || ""
            };
            (0,btnUtils/* btnActionHandler */.c)(actionObj);
        }
    };
    var ref;
    var announcementData = props.announcementData, announcementStyle = props.announcementStyle, isAutoScroll = props.isAutoScroll, animationType = props.animationType, isActive = props.isActive, showAnimation = props.showAnimation, isBuilder = props.isBuilder;
    var animationClassByConfig = (ContentAnimationStyles_module_default())[(ref = Constants/* ANIMATION_TYPE_MAP */.ot[animationType]) === null || ref === void 0 ? void 0 : ref.animeClassName] || "";
    var isFadeInAnimation = animationType === Constants/* ANIMATION_TYPE.FADE_IN */.vR.FADE_IN;
    var announcementText = announcementData.announcementText, redirectUrl = announcementData.redirectUrl, redirectionType = announcementData.redirectionType, isOpenInNewTab = announcementData.isOpenInNewTab;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CommonLinkWrapper/* default */.Z, {
        link: redirectUrl,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: classnames_default()("tw-my-auto tw-flex tw-h-full tw-flex-nowrap tw-items-center tw-justify-center", !isAutoScroll ? "tw-w-full" : "", redirectUrl ? "tw-cursor-pointer" : "", showAnimation ? isActive ? animationClassByConfig : "tw-invisible" : ""),
            onClick: handleAnnoumcementClick,
            style: (0,_object_spread/* default */.Z)({}, announcementStyle, isFadeInAnimation ? {
                animationTimingFunction: "ease-in-out"
            } : {}),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AnnouncementText, {
                announcementText: announcementText,
                isAutoScroll: isAutoScroll
            })
        })
    });
};
function AnnouncementText(param) {
    var announcementText = param.announcementText, isAutoScroll = param.isAutoScroll;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        dangerouslySetInnerHTML: {
            __html: announcementText
        },
        className: classnames_default()("tw-line-clamp-3 tw-max-w-[90vw] !tw-space-y-0 tw-whitespace-nowrap tw-text-wrap tw-text-center [&>p]:tw-m-0", !isAutoScroll ? "tw-px-[24px]" : "")
    });
}

// EXTERNAL MODULE: ./src/context/WidgetDndContext/index.ts
var WidgetDndContext = __webpack_require__(474151);
// EXTERNAL MODULE: ./src/components/WidgetMaker/WidgetDnD/utils.tsx
var utils = __webpack_require__(844369);
// EXTERNAL MODULE: ./src/components/DesignSystem/Widgets2.0/NewAnnouncementBar/Components/InfiniteAutoScroller.tsx
var InfiniteAutoScroller = __webpack_require__(673861);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(667294);
// EXTERNAL MODULE: ./src/components/DesignSystem/Widgets2.0/ListPresentation/components/Testimonials/Constants/index.tsx
var Testimonials_Constants = __webpack_require__(16902);
;// CONCATENATED MODULE: ./src/components/DesignSystem/Widgets2.0/ListPresentation/hooks/useAutoScrollOrRotation.tsx

var useAutoScrollOrRotation = function(param) {
    var listPresentationConfig = param.listPresentationConfig;
    var ref, ref1, ref2, ref3;
    var isAutoRotateEnabled = (listPresentationConfig === null || listPresentationConfig === void 0 ? void 0 : (ref = listPresentationConfig.autoPlayConfig) === null || ref === void 0 ? void 0 : ref.type) === Testimonials_Constants/* SCROLL_TYPE.AUTO_ROTATE */.ej.AUTO_ROTATE;
    var autoRotateTimer = (listPresentationConfig === null || listPresentationConfig === void 0 ? void 0 : (ref1 = listPresentationConfig.autoPlayConfig) === null || ref1 === void 0 ? void 0 : ref1.autoRotateTimer) || 5;
    var isAutoScrollEnabled = (listPresentationConfig === null || listPresentationConfig === void 0 ? void 0 : (ref2 = listPresentationConfig.autoPlayConfig) === null || ref2 === void 0 ? void 0 : ref2.type) === Testimonials_Constants/* SCROLL_TYPE.AUTO_SCROLL */.ej.AUTO_SCROLL;
    var autoScrollTimer = (listPresentationConfig === null || listPresentationConfig === void 0 ? void 0 : (ref3 = listPresentationConfig.autoPlayConfig) === null || ref3 === void 0 ? void 0 : ref3.autoplayTimer) || 5;
    return {
        isAutoRotateEnabled: isAutoRotateEnabled,
        autoRotateTimer: autoRotateTimer,
        isAutoScrollEnabled: isAutoScrollEnabled,
        autoScrollTimer: autoScrollTimer
    };
};

// EXTERNAL MODULE: ./src/components/WidgetMaker/WidgetDnD/WidgetProperties/HeaderBuilder/Hooks/useActiveHeaderSection.tsx
var useActiveHeaderSection = __webpack_require__(708261);
// EXTERNAL MODULE: ./src/components/WidgetMaker/WidgetDnD/hooks/useDeviceType.tsx
var useDeviceType = __webpack_require__(171468);
// EXTERNAL MODULE: ./src/components/WidgetMaker/WidgetDnD/WidgetProperties/HeaderBuilder/constants/index.tsx
var constants = __webpack_require__(565286);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_throw.mjs
var _throw = __webpack_require__(751351);
// EXTERNAL MODULE: ./node_modules/lodash/cloneDeep.js
var cloneDeep = __webpack_require__(150361);
var cloneDeep_default = /*#__PURE__*/__webpack_require__.n(cloneDeep);
;// CONCATENATED MODULE: ./src/components/DesignSystem/Widgets2.0/NewAnnouncementBar/Hooks/useActiveAnnouncement.tsx







var useActiveAnnouncementAdjustment = function(param) {
    var isAnnouncementBarHeader = param.isAnnouncementBarHeader, cardFrame = param.cardFrame, listPresentation = param.listPresentation, announcementWidgetId = param.announcementWidgetId;
    var ref;
    var ref1 = (0,WidgetDndContext/* useWidgetDndContextData */.KX)(), _widgetContextState = ref1.widgetContextState, widgets = _widgetContextState.widgets, activeWidgetId = _widgetContextState.activeWidgetId, _widgetContextActions = ref1.widgetContextActions, _widgetContextActions = _widgetContextActions !== null ? _widgetContextActions : (0,_throw/* default */.Z)(new TypeError("Cannot destructure undefined"));
    var isAnnouncementWidgetActive = !!announcementWidgetId && activeWidgetId === announcementWidgetId;
    var subWidgetIndex = ((widgets === null || widgets === void 0 ? void 0 : (ref = widgets[activeWidgetId]) === null || ref === void 0 ? void 0 : ref.props) || {}).subWidgetIndex;
    var isAnnouncementSubWidgetActive = isAnnouncementWidgetActive && subWidgetIndex >= 0;
    var ref2 = (0,useActiveHeaderSection/* useActiveHeaderSection */.f)(), showAnnouncementItem = ref2.showAnnouncementItem, activeSubWidgetHeaderIndex = ref2.activeSubWidgetHeaderIndex;
    var isAnnouncementItemActive = isAnnouncementBarHeader ? showAnnouncementItem : isAnnouncementSubWidgetActive;
    var activeAnnouncementIndex = isAnnouncementBarHeader ? activeSubWidgetHeaderIndex : subWidgetIndex;
    var cardFrameConfigAdjusted = isAnnouncementItemActive ? cloneDeep_default()(cardFrame) : cardFrame;
    var listPresentationConfigAdjusted = isAnnouncementItemActive ? cloneDeep_default()(listPresentation) : listPresentation;
    if (isAnnouncementItemActive) {
        listPresentationConfigAdjusted = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, listPresentationConfigAdjusted), {
            autoPlayConfig: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (listPresentationConfigAdjusted === null || listPresentationConfigAdjusted === void 0 ? void 0 : listPresentationConfigAdjusted.autoPlayConfig) || {}), {
                type: Testimonials_Constants/* SCROLL_TYPE.MANUAL */.ej.MANUAL
            })
        });
    }
    return {
        cardFrameConfigAdjusted: cardFrameConfigAdjusted,
        listPresentationConfigAdjusted: listPresentationConfigAdjusted,
        activeSlideIndex: isAnnouncementItemActive ? activeAnnouncementIndex : -1
    };
};

// EXTERNAL MODULE: ./src/hooks/useNavConfigs.ts
var useNavConfigs = __webpack_require__(232876);
// EXTERNAL MODULE: ./src/components/DesignSystem/Widgets2.0/NewAnnouncementBar/Constants/index.tsx
var NewAnnouncementBar_Constants = __webpack_require__(250212);
;// CONCATENATED MODULE: ./src/components/DesignSystem/Widgets2.0/NewAnnouncementBar/index.tsx




















// import { useState } from 'react';
var HEADER_SCROLL_BEHAVIOUR_STICKY = "sticky";
var ARROW_CLASS = "tw-flex tw-items-center tw-justify-center tw-h-[28px] tw-w-[28px]";
var NewAnnouncementBar = function(props) {
    var handleAnnouncementBarClick = function handleAnnouncementBarClick(e) {
        if (!isBuilder || !fromHeader) return;
        e.stopPropagation();
        (0,utils.setLastActiveWidget)(utils.NEW_HEADER_ID);
        setIsHeaderFooterPropertyActive({
            status: true,
            type: "Header",
            subWidgetType: "announcementList",
            subWidgetIndex: null,
            initiator: constants/* HEADER_INITIATOR_TYPE.HEADER */.p.HEADER
        });
        setActiveWidget(null);
        toggleSidePanelState("widgetProperty");
    };
    var renderAnnouncements = function renderAnnouncements() {
        return announcementList === null || announcementList === void 0 ? void 0 : announcementList.map(function(announcementData, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AnnouncementStrip, {
                        isAutoScroll: isAutoScrollEnabled,
                        announcementData: announcementData,
                        announcementStyle: announcementStyles,
                        isActive: activeAnnouncement === index,
                        animationType: animationType,
                        showAnimation: showAnimation,
                        autoRotateTimer: autoRotateTimer,
                        isBuilder: isBuilder
                    }),
                    showAutoScroll && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "tw-flex",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SeperatorComponent, {
                            className: "tw-my-auto tw-text-[24px]",
                            color: announcementStyles.color
                        })
                    })
                ]
            });
        });
    };
    var ref, ref1;
    // const [activeSlide, setActiveSlide] = useState(0);
    var ref2 = (props === null || props === void 0 ? void 0 : props.widgetOptions) || {}, cardFrame = ref2.cardFrame, listPresentation = ref2.listPresentation;
    var fromHeader = (props === null || props === void 0 ? void 0 : props.fromHeader) || false;
    var isPositionTop = (props === null || props === void 0 ? void 0 : props.isPositionTop) || false;
    var announcementWidgetId = props === null || props === void 0 ? void 0 : props.id;
    var announcementRef = (0,react.useRef)(null);
    var ref3 = (0,WidgetDndContext/* useWidgetDndContextData */.KX)(), _widgetContextActions = ref3.widgetContextActions, setIsHeaderFooterPropertyActive = _widgetContextActions.setIsHeaderFooterPropertyActive, setActiveWidget = _widgetContextActions.setActiveWidget, toggleSidePanelState = ref3.widgetContextHelpers.toggleSidePanelState, isBuilder = ref3.widgetContextState.isBuilder;
    var isMobile = (0,useDeviceType/* useDeviceType */.h)().isMobile;
    var ref4 = (0,useNavConfigs/* useNavConfigs */.Z)(props === null || props === void 0 ? void 0 : props.isScroll, false), isTransparent = ref4.isTransparent, scrollType = ref4.scrollType;
    var isStickyHeader = scrollType === HEADER_SCROLL_BEHAVIOUR_STICKY;
    var hideHeaderAnnouncement = fromHeader && isStickyHeader && (isTransparent ? props === null || props === void 0 ? void 0 : props.isScroll : props === null || props === void 0 ? void 0 : props.canHideHeaderAnnouncement);
    var ref5 = useActiveAnnouncementAdjustment({
        isAnnouncementBarHeader: fromHeader,
        cardFrame: cardFrame,
        listPresentation: listPresentation,
        announcementWidgetId: announcementWidgetId
    }), cardFrameConfigAdjusted = ref5.cardFrameConfigAdjusted, listPresentationConfigAdjusted = ref5.listPresentationConfigAdjusted, activeSlideIndex = ref5.activeSlideIndex;
    var isHeaderAnnouncementActive = (0,useActiveHeaderSection/* useActiveHeaderSection */.f)().isHeaderAnnouncementActive;
    var ref6 = useAutoScrollOrRotation({
        listPresentationConfig: listPresentationConfigAdjusted
    }), isAutoRotateEnabled = ref6.isAutoRotateEnabled, isAutoScrollEnabled = ref6.isAutoScrollEnabled, autoRotateTimer = ref6.autoRotateTimer, autoScrollTimer = ref6.autoScrollTimer;
    var ref7 = (0,react.useState)(0), activeAnnouncement = ref7[0], setActiveAnnouncement = ref7[1];
    var activeWidgetBorderStyle = (0,_object_spread/* default */.Z)({
        border: "2px solid blue"
    }, isPositionTop ? {
        borderTopLeftRadius: "20px",
        borderTopRightRadius: "20px"
    } : {});
    var ref8 = (0,Utils/* getAnnouncementBarStyles */._)({
        isMobile: isMobile,
        cardFrameConfig: cardFrameConfigAdjusted,
        listPresentationConfig: listPresentationConfigAdjusted
    }), announcementStyles = ref8.announcementStyles, containersStyles = ref8.containersStyles;
    var announcementList = (cardFrameConfigAdjusted === null || cardFrameConfigAdjusted === void 0 ? void 0 : (ref = cardFrameConfigAdjusted.announcementList) === null || ref === void 0 ? void 0 : ref.filter(function(announcement) {
        return announcement === null || announcement === void 0 ? void 0 : announcement.isVisible;
    })) || [];
    var totalItems = announcementList === null || announcementList === void 0 ? void 0 : announcementList.length;
    var ref9;
    var showArrow = (ref9 = listPresentationConfigAdjusted === null || listPresentationConfigAdjusted === void 0 ? void 0 : listPresentationConfigAdjusted.showArrow) !== null && ref9 !== void 0 ? ref9 : true;
    var ref10, ref11;
    var colGapForAutoScroll = isMobile ? (ref10 = listPresentationConfigAdjusted === null || listPresentationConfigAdjusted === void 0 ? void 0 : listPresentationConfigAdjusted.colGapMobile) !== null && ref10 !== void 0 ? ref10 : 20 : (ref11 = listPresentationConfigAdjusted === null || listPresentationConfigAdjusted === void 0 ? void 0 : listPresentationConfigAdjusted.colGap) !== null && ref11 !== void 0 ? ref11 : 24;
    var showAutoRotation = isAutoRotateEnabled && !!autoRotateTimer;
    var showAutoScroll = isAutoScrollEnabled && !!autoScrollTimer;
    var animationType = cardFrameConfigAdjusted === null || cardFrameConfigAdjusted === void 0 ? void 0 : cardFrameConfigAdjusted.textAnimationType;
    var showAnimation = animationType !== Constants/* ANIMATION_TYPE.NONE */.vR.NONE && isAutoRotateEnabled;
    // it's a seperator component which will be be rendered in between texts
    var SeperatorComponent = (0,NewAnnouncementBar_Utils/* getSeperatorByType */.W)(listPresentationConfigAdjusted === null || listPresentationConfigAdjusted === void 0 ? void 0 : listPresentationConfigAdjusted.seperator);
    var SETTINGS = {
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        speed: showAnimation ? 0 : 1000,
        autoplay: showAutoRotation,
        autoplaySpeed: autoRotateTimer * 1000,
        pauseOnHover: true,
        afterChange: function(current) {
            return setActiveAnnouncement(current);
        }
    };
    if (!totalItems) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        ref: announcementRef,
        style: (0,_object_spread/* default */.Z)({}, containersStyles, fromHeader && isHeaderAnnouncementActive ? activeWidgetBorderStyle : {}, announcementRef.current ? (ref1 = (announcementRef === null || announcementRef === void 0 ? void 0 : announcementRef.current) || {}) === null || ref1 === void 0 ? void 0 : ref1.clientHeight : {}),
        onClick: handleAnnouncementBarClick,
        className: classnames_default()("tw-overflow-hidden tw-transition-all tw-duration-300 tw-ease-in-out", hideHeaderAnnouncement ? "tw-h-0 !tw-p-0" : "")
    }, fromHeader ? {
        id: NewAnnouncementBar_Constants/* HEADER_ANNOUNCEMENT_ID */.L
    } : {}), {
        children: !isAutoScrollEnabled ? /*#__PURE__*/ (0,jsx_runtime.jsx)(BasicSlider/* default */.Z, {
            arrowColor: announcementStyles.color,
            showArrows: !showAutoScroll && totalItems > 1 && showArrow && activeSlideIndex === -1,
            removeArrowDefault: true,
            arrowCommonClasses: "tw-absolute tw-top-1/2 -tw-translate-y-1/2 tw-z-10 tw-cursor-pointer",
            arrowLeftClasses: classnames_default()("tw-left-0 md:tw-left-[8px]", ARROW_CLASS),
            arrowRightClasses: classnames_default()("tw-right-0 md:tw-right-[8px]", ARROW_CLASS),
            showDots: false,
            customSettings: SETTINGS,
            activeIndex: activeSlideIndex,
            customStyles: "\n          .slick-track {\n            display: flex !important; \n            align-items: center !important; \n          }\n          ",
            children: renderAnnouncements()
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(InfiniteAutoScroller/* InfiniteAutoScroller */.k, {
            gap: colGapForAutoScroll,
            scrollSpeedInSec: autoScrollTimer,
            totalItems: announcementList === null || announcementList === void 0 ? void 0 : announcementList.length,
            wrapperClasses: "!tw-flex-none",
            children: renderAnnouncements()
        })
    }));
};


/***/ }),

/***/ 728364:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(785893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(667294);
/**
 * Dukaan Card
 */ 

var DukaanCard = function(props) {
    var renderLoaderView = function() {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "dukaanCard-loader",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "dukaanCard-loader__img animate"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "dukaanCard-loader__wrap",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            className: "dukaanCard-loader__name animate"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            className: "dukaanCard-loader__type animate"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            className: "dukaanCard-loader__address animate"
                        })
                    ]
                })
            ]
        });
    };
    var renderDataView = function() {
        var categories = props.bussinessTypes.filter(function(types) {
            return props.category.includes(types.business_id);
        }) || [];
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "dukaanCard",
            onClick: props.onClick,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "dukaanCard-wrap",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "dukaanCard__image",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                src: props.icon ? props.icon.includes("cdn.dotpe.in") ? props.icon : "https://cdn.dotpe.in/".concat(props.icon) : "https://cdn.dotpe.in/longtail/themes/8073865/opY4PPbh.webp",
                                alt: "demo dukaan image",
                                loading: "lazy"
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "dukaanCard__body",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: "dukaanCard__name",
                                    children: props.name || ""
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "dukaanCard__categoryDistance",
                                    children: categories.map(function(category, index) {
                                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                                className: "dukaanCard__categoryDistance--name",
                                                children: [
                                                    category.business_name || "",
                                                    " ",
                                                    categories.length !== index + 1 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                        className: "dukaanCard__categoryDistance--dot"
                                                    }),
                                                    " "
                                                ]
                                            })
                                        }, "".concat(index, "-category-names-").concat(category.business_id));
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "dukaanCard__address",
                                    children: props.address || ""
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "dukaanCard__bottom-line"
                })
            ]
        });
    };
    return props.isLoader ? renderLoaderView() : renderDataView();
};
/* harmony default export */ __webpack_exports__["Z"] = (DukaanCard);


/***/ }),

/***/ 155772:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(626042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(269396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(785893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(667294);
/**
 * This is the flat list component
 * Use cases : Used for the auto scroll pagination lists
 * WARNING: THIS COMPONENT SHOULD NOT BE CHANGED UNLESS ABSOLUTELY NECESSARY. IF CHANGES ARE NECESSARY, DISCUSS IT WITH THE TEAM PRIOR
 * @param {boolean} renderInsideFragment - this is used as most of our codebase is using the original section tag for wrapper,
 *                                but in the case of Middlebody 5 which uses a reusable styled component used in multiple places,
 *                                to style it's direct underlying children directly, therefore fragment is used for such case
 */ 




var FlatList = function(param) {
    var isLoaderVisible = param.isLoaderVisible, onScrollEnd = param.onScrollEnd, isNext = param.isNext, _LoaderComponent = param.LoaderComponent, LoaderComponent = _LoaderComponent === void 0 ? null : _LoaderComponent, _loaderComponentCount = param.loaderComponentCount, loaderComponentCount = _loaderComponentCount === void 0 ? 3 : _loaderComponentCount, renderList = param.renderList, _loaderProps = param.loaderProps, loaderProps = _loaderProps === void 0 ? {} : _loaderProps, _renderInsideFragment = param.renderInsideFragment, renderInsideFragment = _renderInsideFragment === void 0 ? false : _renderInsideFragment;
    var observer = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)();
    var lastStoreElementRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(node) {
        if (isLoaderVisible) return;
        if (observer.current) observer.current.disconnect();
        observer.current = new IntersectionObserver(function(entries) {
            if (entries[0].isIntersecting) {
                onScrollEnd === null || onScrollEnd === void 0 ? void 0 : onScrollEnd();
            }
        });
        if (node) {
            observer.current.observe(node);
        }
    }, [
        isLoaderVisible,
        onScrollEnd,
        isNext
    ]);
    var _RenderChildren = function() {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                renderList(),
                isLoaderVisible && LoaderComponent && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: new Array(loaderComponentCount).fill(0).map(function(el, index) {
                        return /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createElement)(LoaderComponent, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, loaderProps), {
                            key: "".concat(index, "-loaderComponent")
                        }));
                    })
                }),
                isNext === true && !isLoaderVisible && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "show-more",
                    ref: lastStoreElementRef
                })
            ]
        });
    };
    return renderInsideFragment ? _RenderChildren() : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        children: _RenderChildren()
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (FlatList);


/***/ }),

/***/ 141771:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _redux_actions__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(731024);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(225617);


function useInstallAppOverlayActions() {
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_0__/* .useDispatch */ .I0)();
    var showInstallAppOverlay = (0,react_redux__WEBPACK_IMPORTED_MODULE_0__/* .useSelector */ .v9)(function(state) {
        var ref;
        return {
            showInstallAppOverlay: (ref = state.commonReducer) === null || ref === void 0 ? void 0 : ref.showInstallAppOverlay
        };
    }).showInstallAppOverlay;
    var openIntallAppOverlay = function() {
        dispatch((0,_redux_actions__WEBPACK_IMPORTED_MODULE_1__/* .setShowInstallAppOverlay */ .wD)(true));
    };
    var closeIntallAppOverlay = function() {
        dispatch((0,_redux_actions__WEBPACK_IMPORTED_MODULE_1__/* .setShowInstallAppOverlay */ .wD)(false));
    };
    return {
        showInstallAppOverlay: showInstallAppOverlay,
        openIntallAppOverlay: openIntallAppOverlay,
        closeIntallAppOverlay: closeIntallAppOverlay
    };
}
/* harmony default export */ __webpack_exports__["Z"] = (useInstallAppOverlayActions);


/***/ }),

/***/ 629492:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(785893);
/* harmony import */ var _utils_getContrastingColor__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(833104);
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(913886);
/* harmony import */ var _utils_excuteLogout__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(385126);
/* harmony import */ var _utils_routes__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(540190);
/* harmony import */ var _assets_svgExports_UserIconDark__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(252514);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(811163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(667294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(225617);
/* harmony import */ var _utils_orderDropdownList__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(20503);
/* harmony import */ var _LogoutModal__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(821448);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(607982);












var LoginComponent = function(props) {
    var toggleShowDesktopDropdown = function toggleShowDesktopDropdown() {
        setShowDropdown(!showDropdown);
    };
    var toggleLogoutModal = function toggleLogoutModal() {
        setShowLogoutModal(!showLogoutModal);
    };
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(false), showDropdown = ref[0], setShowDropdown = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(false), showLogoutModal = ref1[0], setShowLogoutModal = ref1[1];
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_5__.useRouter)();
    // const { headerHeight } = useSSRSelector((state) => ({
    //   headerHeight: state.commonReducer?.heightCalculation.headerHeight,
    // }));
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(null), node = ref2[0], setNode = ref2[1];
    var ref3 = (0,react_redux__WEBPACK_IMPORTED_MODULE_7__/* .useSelector */ .v9)(function(state) {
        return {
            user: state.userReducer,
            storeData: state.storeReducer.store
        };
    }), user = ref3.user, storeData = ref3.storeData;
    (0,react__WEBPACK_IMPORTED_MODULE_6__.useEffect)(function() {
        setShowLogoutModal(false);
    }, [
        user.isLogin
    ]);
    var ordersDropdownList = (0,_utils_orderDropdownList__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)();
    var iconRef = (0,react__WEBPACK_IMPORTED_MODULE_6__.useCallback)(function(node) {
        if (!node) {
            return;
        }
        setNode(node);
    }, []);
    var loginClick = function() {
        var ref;
        if ((user === null || user === void 0 ? void 0 : user.isLogin) && !props.disableDropdown) {
            setShowDropdown(!showDropdown);
        } else if ((ref = router.asPath) === null || ref === void 0 ? void 0 : ref.includes("/".concat(_utils_routes__WEBPACK_IMPORTED_MODULE_3__.PATH.ORDERS))) router.reload();
        else {
            var ref1;
            router.push((0,_utils_routes__WEBPACK_IMPORTED_MODULE_3__.getRoute)(_utils_routes__WEBPACK_IMPORTED_MODULE_3__.PATH.ORDERS, storeData === null || storeData === void 0 ? void 0 : (ref1 = storeData.store_info) === null || ref1 === void 0 ? void 0 : ref1.domain));
        }
    };
    var onHandleOrdersDropdown = function(item) {
        var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
        var ref;
        switch(item.action){
            case _utils_constants__WEBPACK_IMPORTED_MODULE_1__/* .ORDERS_DROPDOWN_LIST.MY_ORDERS */ .Bm.MY_ORDERS:
                {
                    var ref1;
                    toggleShowDesktopDropdown();
                    router.push((0,_utils_routes__WEBPACK_IMPORTED_MODULE_3__.getRoute)(_utils_routes__WEBPACK_IMPORTED_MODULE_3__.PATH.ORDERS, storeData === null || storeData === void 0 ? void 0 : (ref1 = storeData.store_info) === null || ref1 === void 0 ? void 0 : ref1.domain));
                    break;
                }
            case _utils_constants__WEBPACK_IMPORTED_MODULE_1__/* .ORDERS_DROPDOWN_LIST.LOGOUT */ .Bm.LOGOUT:
                {
                    toggleLogoutModal();
                    setShowDropdown(false);
                    break;
                }
            case _utils_constants__WEBPACK_IMPORTED_MODULE_1__/* .ORDERS_DROPDOWN_LIST.DEFAULT_PHONE */ .Bm.DEFAULT_PHONE:
                {
                    break;
                }
            default:
                {
                    break;
                }
        }
        (ref = props.closeParentContainer) === null || ref === void 0 ? void 0 : ref.call(props);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* .ClickAwayListener */ .d, {
                onClickAway: function() {
                    return setShowDropdown(false);
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    ref: iconRef,
                    className: "relative login-component tw-select-none tw-font-dmSans",
                    style: props.style || {},
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "flex items-center",
                            onClick: loginClick,
                            children: props.children
                        }),
                        showDropdown && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: " absolute z-999 login-component__dropdown",
                            style: {
                                top: node ? (node === null || node === void 0 ? void 0 : node.offsetTop) + (node === null || node === void 0 ? void 0 : node.offsetHeight) : undefined
                            },
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "login-component__dropdown--arrow"
                                }),
                                ordersDropdownList === null || ordersDropdownList === void 0 ? void 0 : ordersDropdownList.map(function(item) {
                                    var ref;
                                    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "login-component__dropdown--item flex items-center z-5 tw-px-[20px] tw-py-[16px] \n                ".concat((props === null || props === void 0 ? void 0 : props.headerBgColor) && (0,_utils_getContrastingColor__WEBPACK_IMPORTED_MODULE_11__/* .getContrastingColor */ .Q)(props === null || props === void 0 ? void 0 : props.headerBgColor) === "#ffffff" && item.id !== 3 ? "filter-invert-1" : "filter-invert-0", " ").concat(item.id === 3 ? "red " : "", " ").concat(item.id !== 1 && "pointer"),
                                        onClick: function(e) {
                                            return onHandleOrdersDropdown(item, e);
                                        },
                                        children: [
                                            item.id === 1 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "tw-mr-[10px]",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_assets_svgExports_UserIconDark__WEBPACK_IMPORTED_MODULE_4__/* .UserIconDark */ .q, {
                                                    color: storeData === null || storeData === void 0 ? void 0 : (ref = storeData.theme) === null || ref === void 0 ? void 0 : ref.primary_color,
                                                    width: "33",
                                                    height: "33"
                                                })
                                            }),
                                            item.name
                                        ]
                                    }, item.id);
                                })
                            ]
                        })
                    ]
                })
            }),
            showLogoutModal && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_LogoutModal__WEBPACK_IMPORTED_MODULE_9__["default"], {
                toggleLogoutModal: toggleLogoutModal,
                executeLogout: _utils_excuteLogout__WEBPACK_IMPORTED_MODULE_2__/* .executeLogout */ .q,
                showLogoutConfirmation: showLogoutModal
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (LoginComponent);


/***/ }),

/***/ 821448:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(626042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(269396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(785893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(667294);
/* harmony import */ var _Common_Modal__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(672651);
/* harmony import */ var _utils_deviceWidth__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(186812);
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(913886);
/* harmony import */ var _redux_ssrStore__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(326706);








function LogoutModal(props) {
    var showLogoutConfirmationModal = (0,_redux_ssrStore__WEBPACK_IMPORTED_MODULE_5__/* .useSSRSelector */ .kF)(function(state) {
        return {
            showLogoutConfirmationModal: state.commonReducer.showLogoutConfirmationModal
        };
    }).showLogoutConfirmationModal;
    return _utils_deviceWidth__WEBPACK_IMPORTED_MODULE_3__/* .deviceWidth */ .o > _utils_constants__WEBPACK_IMPORTED_MODULE_4__/* .MAX_MOBILE_WIDTH */ .Cf ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(LogoutDesktopModal, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, props), {
        showLogoutConfirmationModal: showLogoutConfirmationModal || props.showLogoutConfirmation
    })) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(LogoutMobileModal, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, props), {
        showLogoutConfirmationModal: showLogoutConfirmationModal || props.showLogoutConfirmation
    }));
}
function LogoutMobileModal(props) {
    var executeLogout = function() {
        props.executeLogout();
        props === null || props === void 0 ? void 0 : props.toggleLogoutModal();
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Common_Modal__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            visible: props.showLogoutConfirmationModal,
            className: "mobile-center-modal margin-top-modal-0 !tw-z-[700]",
            animation: "slideUp",
            width: 85,
            height: 150,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "logout-modal-content-container flex flex-column !tw-z-[700]",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "flex justify-center fw7",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            style: {
                                color: "black",
                                fontSize: 16,
                                transform: "translate(10px , 11px)",
                                whiteSpace: "nowrap"
                            },
                            children: "Are you sure you want to Logout?"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex flex-row justify-end",
                        style: {
                            marginTop: 16,
                            transform: "translateY(24px)"
                        },
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "flex no-container items-center justify-center bg-black-90 br4",
                                onClick: props === null || props === void 0 ? void 0 : props.toggleLogoutModal,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: "white fw6",
                                    children: "No"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "flex yes-container items-center justify-center br4 bg-white-90",
                                onClick: executeLogout,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: "br4 black fw6",
                                    children: "Yes"
                                })
                            })
                        ]
                    })
                ]
            })
        })
    });
}
function LogoutDesktopModal(props) {
    var executeLogout = function() {
        props.executeLogout();
        props === null || props === void 0 ? void 0 : props.toggleLogoutModal();
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Common_Modal__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            visible: props.showLogoutConfirmationModal,
            className: "bottom-modal",
            animation: "slideUp",
            width: 30,
            height: 150,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "logout-modal-content-container flex flex-column",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "flex justify-start",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                            style: {
                                color: "black",
                                marginLeft: 10
                            },
                            children: "Are you sure you want to Logout?"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex flex-row justify-end mt4",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "flex no-container items-center justify-center bg-black-90 br4",
                                onClick: props === null || props === void 0 ? void 0 : props.toggleLogoutModal,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: "white fw6",
                                    children: "No"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "flex yes-container items-center justify-center br4 bg-white-90",
                                onClick: executeLogout,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: "br4 black fw6",
                                    children: "Yes"
                                })
                            })
                        ]
                    })
                ]
            })
        })
    });
}
/* harmony default export */ __webpack_exports__["default"] = (LogoutModal);


/***/ }),

/***/ 120941:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Be": function() { return /* binding */ AccordionOpenIcon; },
/* harmony export */   "MK": function() { return /* binding */ MoreCarat; },
/* harmony export */   "TD": function() { return /* binding */ CollectionWithNoImageMobile; },
/* harmony export */   "gO": function() { return /* binding */ LessCarat; },
/* harmony export */   "p3": function() { return /* binding */ CollectionWithNoImage; },
/* harmony export */   "vT": function() { return /* binding */ LeftCaratIcon; },
/* harmony export */   "x$": function() { return /* binding */ AccordionCloseIcon; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(785893);

function LeftCaratIcon() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "11",
        height: "11",
        viewBox: "0 0 11 11",
        fill: "none",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M3.28956 2.03627C3.25196 1.99649 3.22258 1.9497 3.20307 1.89856C3.18356 1.84742 3.17432 1.79295 3.17587 1.73824C3.17742 1.68353 3.18972 1.62966 3.21209 1.57971C3.23446 1.52975 3.26644 1.4847 3.30622 1.44711C3.346 1.40951 3.3928 1.38013 3.44393 1.36062C3.49507 1.34111 3.54955 1.33187 3.60426 1.33342C3.65897 1.33497 3.71283 1.34727 3.76279 1.36964C3.81274 1.39201 3.8578 1.42399 3.89539 1.46377L7.43706 5.21377C7.5102 5.29113 7.55095 5.39356 7.55095 5.50002C7.55095 5.60649 7.5102 5.70891 7.43706 5.78627L3.89539 9.53669C3.85805 9.57734 3.813 9.61017 3.76286 9.63326C3.71273 9.65635 3.6585 9.66925 3.60334 9.67121C3.54817 9.67317 3.49317 9.66415 3.44152 9.64468C3.38987 9.6252 3.34261 9.59565 3.30247 9.55776C3.26234 9.51986 3.23014 9.47436 3.20773 9.42391C3.18533 9.37347 3.17318 9.31907 3.17197 9.26388C3.17077 9.2087 3.18055 9.15382 3.20073 9.10245C3.22092 9.05107 3.25111 9.00422 3.28956 8.96461L6.56122 5.50002L3.28956 2.03627Z",
            fill: "#414141"
        })
    });
}
function CollectionWithNoImage() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: "211",
        height: "210",
        viewBox: "0 0 211 210",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                width: "210",
                height: "210",
                transform: "translate(0.253906)",
                fill: "#DFDFDF"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M95.2539 113.333H115.254L109.004 105L104.004 111.667L100.254 106.667L95.2539 113.333ZM90.2539 120V90H120.254V120H90.2539Z",
                fill: "#5E5E5E"
            })
        ]
    });
}
function CollectionWithNoImageMobile() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                width: "32",
                height: "32",
                rx: "2",
                fill: "#DFDFDF"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M11.7598 18.6592H19.2832L16.9321 15.5244L15.0513 18.0322L13.6406 16.1514L11.7598 18.6592ZM9.87891 21.167V9.88184H21.1641V21.167H9.87891Z",
                fill: "#5E5E5E"
            })
        ]
    });
}
function AccordionCloseIcon(props) {
    var secondaryColor = props.secondaryColor, height = props.height, width = props.width;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: width || "16",
        height: height || "16",
        viewBox: "0 0 16 16",
        fill: "none",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M2.45686 11.1452C2.39322 11.2054 2.31835 11.2524 2.23653 11.2836C2.15471 11.3148 2.06754 11.3296 1.98001 11.3271C1.89247 11.3246 1.80628 11.3049 1.72636 11.2692C1.64644 11.2334 1.57434 11.1822 1.5142 11.1185C1.45405 11.0549 1.40703 10.98 1.37582 10.8982C1.34461 10.8164 1.32982 10.7292 1.3323 10.6417C1.33477 10.5542 1.35447 10.468 1.39025 10.388C1.42604 10.3081 1.47722 10.236 1.54086 10.1759L7.54086 4.50921C7.66464 4.39218 7.82852 4.32698 7.99886 4.32698C8.16921 4.32698 8.33309 4.39218 8.45686 4.50921L14.4575 10.1759C14.5226 10.2356 14.5751 10.3077 14.612 10.3879C14.649 10.4681 14.6696 10.5549 14.6728 10.6432C14.6759 10.7314 14.6615 10.8194 14.6303 10.9021C14.5991 10.9847 14.5519 11.0603 14.4912 11.1245C14.4306 11.1888 14.3578 11.2403 14.2771 11.2761C14.1964 11.312 14.1093 11.3314 14.021 11.3333C13.9327 11.3353 13.8449 11.3196 13.7627 11.2873C13.6805 11.255 13.6056 11.2067 13.5422 11.1452L7.99886 5.91054L2.45686 11.1452Z",
            fill: secondaryColor || "#414141"
        })
    });
}
function AccordionOpenIcon(props) {
    var secondaryColor = props.secondaryColor, height = props.height, width = props.width;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: width || "16",
        height: height || "16",
        viewBox: "0 0 16 16",
        fill: "none",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M13.5431 4.85479C13.6068 4.79465 13.6817 4.74763 13.7635 4.71642C13.8453 4.68521 13.9325 4.67042 14.02 4.67289C14.1075 4.67537 14.1937 4.69506 14.2736 4.73085C14.3536 4.76663 14.4257 4.81781 14.4858 4.88146C14.5459 4.94511 14.593 5.01998 14.6242 5.1018C14.6554 5.18362 14.6702 5.27078 14.6677 5.35831C14.6652 5.44585 14.6455 5.53204 14.6097 5.61196C14.574 5.69189 14.5228 5.76398 14.4591 5.82413L8.45914 11.4908C8.33536 11.6078 8.17148 11.673 8.00114 11.673C7.83079 11.673 7.66691 11.6078 7.54314 11.4908L1.54247 5.82413C1.47743 5.76438 1.42491 5.6923 1.38796 5.61208C1.35101 5.53186 1.33036 5.4451 1.32723 5.35684C1.32409 5.26858 1.33853 5.18057 1.36969 5.09793C1.40085 5.0153 1.44813 4.93967 1.50876 4.87546C1.5694 4.81125 1.64219 4.75972 1.72291 4.72388C1.80363 4.68803 1.89066 4.66858 1.97896 4.66666C2.06726 4.66474 2.15506 4.68038 2.23726 4.71268C2.31946 4.74497 2.39443 4.79328 2.4578 4.85479L8.00114 10.0895L13.5431 4.85479Z",
            fill: secondaryColor || "#414141"
        })
    });
}
function MoreCarat() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "25",
        height: "24",
        viewBox: "0 0 25 24",
        fill: "none",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M16.778 10.2099C16.926 10.3499 17 10.528 17 10.7443C17 10.9606 16.926 11.1387 16.778 11.2786L13.065 14.7901C12.9843 14.8664 12.8969 14.9204 12.8027 14.9519C12.7085 14.9835 12.6076 14.9995 12.5 15C12.3924 15 12.288 14.9809 12.1868 14.9427C12.0857 14.9046 12.0017 14.8537 11.935 14.7901L8.22197 11.2786C8.07399 11.1387 8 10.9606 8 10.7443C8 10.528 8.07399 10.3499 8.22197 10.2099C8.36996 10.07 8.5583 10 8.787 10C9.0157 10 9.20404 10.07 9.35202 10.2099L12.5 13.187L15.648 10.2099C15.796 10.07 15.9843 10 16.213 10C16.4417 10 16.63 10.07 16.778 10.2099Z",
            fill: "black"
        })
    });
}
function LessCarat() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "25",
        height: "24",
        viewBox: "0 0 25 24",
        fill: "none",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M8.88604 13.7901C8.73805 13.6501 8.66406 13.472 8.66406 13.2557C8.66406 13.0394 8.73805 12.8613 8.88604 12.7214L12.599 9.20992C12.6798 9.13359 12.7672 9.07964 12.8614 9.04809C12.9555 9.01654 13.0564 9.00051 13.1641 9C13.2717 9 13.3761 9.01908 13.4772 9.05725C13.5784 9.09542 13.6624 9.14631 13.7291 9.20992L17.4421 12.7214C17.5901 12.8613 17.6641 13.0394 17.6641 13.2557C17.6641 13.472 17.5901 13.6501 17.4421 13.7901C17.2941 13.93 17.1058 14 16.8771 14C16.6484 14 16.46 13.93 16.312 13.7901L13.1641 10.813L10.0161 13.7901C9.8681 13.93 9.67976 14 9.45106 14C9.22236 14 9.03402 13.93 8.88604 13.7901Z",
            fill: "black"
        })
    });
}


/***/ }),

/***/ 837210:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$n": function() { return /* binding */ ResizeIcon; },
/* harmony export */   "Ag": function() { return /* binding */ RulerIcon; },
/* harmony export */   "L9": function() { return /* binding */ DeleteRedIcon; },
/* harmony export */   "Ni": function() { return /* binding */ InfoBlackIcon; },
/* harmony export */   "Pz": function() { return /* binding */ ErrorIcon; },
/* harmony export */   "S5": function() { return /* binding */ AnimationSelectCustomCheckboxIcon; },
/* harmony export */   "Wi": function() { return /* binding */ EmptyImageIcon; },
/* harmony export */   "l1": function() { return /* binding */ ReplaceIcon; },
/* harmony export */   "lb": function() { return /* binding */ ThumbsUpIcon; },
/* harmony export */   "le": function() { return /* binding */ CONTENT_ANIMATION_ICONS; },
/* harmony export */   "pJ": function() { return /* binding */ DeleteIcon; },
/* harmony export */   "rG": function() { return /* binding */ UploadIcon; },
/* harmony export */   "tf": function() { return /* binding */ NoAnimationIcon; }
/* harmony export */ });
/* unused harmony export PlusOutlineIcon */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(626042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(269396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(785893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(667294);




function DeleteRedIcon(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        fill: "none",
        viewBox: "0 0 16 16"
    }, props), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fill: "#E04E4E",
                d: "M12.667 4.666a.667.667 0 00-.667.667v7.46A1.28 1.28 0 0110.66 14H5.34A1.28 1.28 0 014 12.793v-7.46a.667.667 0 10-1.333 0v7.46a2.612 2.612 0 002.673 2.54h5.32a2.612 2.612 0 002.674-2.54v-7.46a.667.667 0 00-.667-.667zM13.333 2.667h-2.666V1.334A.667.667 0 0010 .667H6a.667.667 0 00-.667.667v1.333H2.667a.667.667 0 000 1.333h10.666a.667.667 0 100-1.333zm-6.666 0V2h2.666v.667H6.667z"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fill: "#E04E4E",
                d: "M7.333 11.333V6.667a.667.667 0 10-1.333 0v4.666a.667.667 0 101.333 0zM10 11.333V6.667a.667.667 0 10-1.333 0v4.666a.667.667 0 101.333 0z"
            })
        ]
    }));
}
function DeleteIcon(param) {
    var _style = param.style, style = _style === void 0 ? {} : _style, _className = param.className, className = _className === void 0 ? "" : _className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        fill: "none",
        viewBox: "0 0 16 16",
        style: style,
        className: className,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fill: "#111C36",
                d: "M12.667 4.667a.667.667 0 00-.667.666v7.46A1.28 1.28 0 0110.66 14H5.34A1.28 1.28 0 014 12.794v-7.46a.667.667 0 10-1.333 0v7.46a2.612 2.612 0 002.673 2.54h5.32a2.612 2.612 0 002.674-2.54v-7.46a.667.667 0 00-.667-.667zM13.333 2.667h-2.666V1.333A.667.667 0 0010 .667H6a.667.667 0 00-.667.666v1.334H2.667a.667.667 0 000 1.333h10.666a.667.667 0 100-1.333zm-6.666 0V2h2.666v.667H6.667z"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fill: "#111C36",
                d: "M7.333 11.333V6.667a.667.667 0 10-1.333 0v4.666a.667.667 0 101.333 0zM10 11.333V6.667a.667.667 0 10-1.333 0v4.666a.667.667 0 101.333 0z"
            })
        ]
    });
}
function ResizeIcon(param) {
    var _style = param.style, style = _style === void 0 ? {} : _style, _className = param.className, className = _className === void 0 ? "" : _className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "13",
        height: "10",
        fill: "none",
        viewBox: "0 0 13 10",
        style: style,
        className: className,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            fill: "#111C36",
            d: "M10.636 2.5L8.273 5h1.773c0 2.069-1.59 3.75-3.546 3.75a3.32 3.32 0 01-1.655-.438l-.862.913C4.71 9.713 5.573 10 6.5 10c2.612 0 4.727-2.237 4.727-5H13l-2.364-2.5zM2.955 5c0-2.069 1.59-3.75 3.545-3.75a3.32 3.32 0 011.655.438l.862-.913A4.502 4.502 0 006.5 0C3.888 0 1.773 2.237 1.773 5H0l2.364 2.5L4.727 5H2.955z"
        })
    });
}
function ReplaceIcon(param) {
    var _style = param.style, style = _style === void 0 ? {} : _style, _className = param.className, className = _className === void 0 ? "" : _className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "12",
        height: "12",
        fill: "none",
        viewBox: "0 0 12 12",
        style: style,
        className: className,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            fill: "#111C36",
            d: "M8.727 7.636h1.091V3.273c0-.6-.49-1.091-1.09-1.091H4.363v1.09h4.363v4.364zM3.273 8.727V0H2.182v2.182H0v1.09h2.182v5.455c0 .6.49 1.091 1.09 1.091h5.455V12h1.091V9.818H12v-1.09H3.273z"
        })
    });
}
function UploadIcon(param) {
    var _style = param.style, style = _style === void 0 ? {} : _style, _className = param.className, className = _className === void 0 ? "" : _className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "14",
        height: "14",
        fill: "none",
        viewBox: "0 0 14 14",
        style: style,
        className: className,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            fill: "#111C36",
            d: "M4.697 3.995L6.3 2.385v6.714a.7.7 0 101.4 0V2.384l1.603 1.61a.7.7 0 001.147-.227.7.7 0 00-.153-.767L7.497.2a.7.7 0 00-.231-.147.7.7 0 00-.532 0A.7.7 0 006.503.2L3.703 3a.703.703 0 00.994.995zM13.3 6.998a.7.7 0 00-.7.7V11.9a.7.7 0 01-.7.7H2.1a.7.7 0 01-.7-.7V7.7a.7.7 0 10-1.4 0v4.2A2.1 2.1 0 002.1 14h9.8a2.1 2.1 0 002.1-2.1V7.697a.7.7 0 00-.7-.7z"
        })
    });
}
function ErrorIcon(param) {
    var _style = param.style, style = _style === void 0 ? {} : _style, _className = param.className, className = _className === void 0 ? "" : _className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "14",
        height: "14",
        fill: "none",
        viewBox: "0 0 14 14",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            fill: "#E24848",
            d: "M6.305 3.5h1.4v4.2h-1.4V3.5zm.7 10.5a7 7 0 11-.01-14 7 7 0 01.01 14zm0-12.6A5.6 5.6 0 1012.604 7a5.607 5.607 0 00-5.6-5.6zm-.7 7.7h1.4v1.4h-1.4V9.1z"
        })
    });
}
function PlusOutlineIcon(param) {
    var _style = param.style, style = _style === void 0 ? {} : _style, _className = param.className, className = _className === void 0 ? "" : _className;
    return /*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "17",
        fill: "none",
        viewBox: "0 0 16 17",
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "15",
                height: "15",
                x: "0.5",
                y: "1",
                stroke: "#2B74D8",
                rx: "3.5"
            }),
            /*#__PURE__*/ _jsx("path", {
                fill: "#2B74D8",
                d: "M8.5 8V4.5h-1V8H4v1h3.5v3.5h1V9H12V8H8.5z"
            })
        ]
    });
}
function AnimationSelectCustomCheckboxIcon() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "18",
        height: "18",
        fill: "none",
        viewBox: "0 0 18 18",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    fill: "#2B74D8",
                    stroke: "#2B74D8",
                    d: "M1 .5H.5V11A6.5 6.5 0 007 17.5h10.5V7A6.5 6.5 0 0011 .5H1z"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    stroke: "#fff",
                    strokeWidth: "1.3",
                    d: "M5 8.562L7.695 11 13 6"
                })
            ]
        })
    });
}
function NoAnimationIcon() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "32",
        height: "32",
        fill: "none",
        viewBox: "0 0 32 32",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            fill: "#606577",
            d: "M16 32c-2.213 0-4.293-.42-6.24-1.26-1.947-.84-3.64-1.98-5.08-3.42s-2.58-3.133-3.42-5.08C.42 20.293 0 18.213 0 16s.42-4.293 1.26-6.24c.84-1.947 1.98-3.64 3.42-5.08S7.813 2.1 9.76 1.26C11.707.42 13.787 0 16 0s4.293.42 6.24 1.26c1.947.84 3.64 1.98 5.08 3.42s2.58 3.133 3.42 5.08C31.58 11.707 32 13.787 32 16s-.42 4.293-1.26 6.24c-.84 1.947-1.98 3.64-3.42 5.08s-3.133 2.58-5.08 3.42C20.293 31.58 18.213 32 16 32zm0-3.2a12.5 12.5 0 004.16-.7 12.721 12.721 0 003.68-2.02L5.92 8.16a12.72 12.72 0 00-2.02 3.68c-.467 1.333-.7 2.72-.7 4.16 0 3.573 1.24 6.6 3.72 9.08C9.4 27.56 12.427 28.8 16 28.8zm10.08-4.96a12.721 12.721 0 002.02-3.68 12.5 12.5 0 00.7-4.16c0-3.573-1.24-6.6-3.72-9.08C22.6 4.44 19.573 3.2 16 3.2c-1.44 0-2.827.233-4.16.7a12.72 12.72 0 00-3.68 2.02l17.92 17.92z",
            opacity: "0.6"
        })
    });
}
var CONTENT_ANIMATION_ICONS = {
    Expand: function Expand() {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "16",
            height: "16",
            fill: "none",
            viewBox: "0 0 16 16",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    stroke: "#111C36",
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    d: "M2.5 2.5v3m0-3h3m-3 0L6 6m-3.5 7.5v-3m0 3h3m-3 0L6 10m7.5-7.5h-3m3 0v3m0-3L10 6m3.5 7.5h-3m3 0v-3m0 3L10 10"
                })
            })
        });
    },
    Up: function Up() {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "16",
            height: "16",
            fill: "none",
            viewBox: "0 0 16 16",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    stroke: "#111C36",
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    d: "M2 5V3.5A1.5 1.5 0 013.5 2h9A1.5 1.5 0 0114 3.5V5m-3 3L8 5m0 0L5 8m3-3v9"
                })
            })
        });
    },
    Down: function Down() {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "16",
            height: "16",
            fill: "none",
            viewBox: "0 0 16 16",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    stroke: "#111C36",
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    d: "M2 11v1.5A1.5 1.5 0 003.5 14h9a1.5 1.5 0 001.5-1.5V11m-3-3l-3 3m0 0L5 8m3 3V2"
                })
            })
        });
    },
    Right: function Right() {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "16",
            height: "16",
            fill: "none",
            viewBox: "0 0 16 16",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    stroke: "#111C36",
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    d: "M11 14h1.5a1.5 1.5 0 001.5-1.5v-9A1.5 1.5 0 0012.5 2H11M8 5l3 3m0 0l-3 3m3-3H2"
                })
            })
        });
    },
    Left: function Left() {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "16",
            height: "16",
            fill: "none",
            viewBox: "0 0 16 16",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    stroke: "#111C36",
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    d: "M5 14H3.5A1.5 1.5 0 012 12.5v-9A1.5 1.5 0 013.5 2H5m3 3L5 8m0 0l3 3M5 8h9"
                })
            })
        });
    }
};
function InfoBlackIcon() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "15",
        height: "16",
        fill: "none",
        viewBox: "0 0 15 16",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                    cx: "7.2",
                    cy: "8",
                    r: "6.4",
                    fill: "#111C36"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    fill: "#F2F9FF",
                    d: "M6.493 5.103a.714.714 0 11.709.692.694.694 0 01-.71-.692zm.048 1.236h1.32v4.988H6.54V6.34z"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    fill: "#111C36",
                    d: "M7.204 1.773a6.23 6.23 0 11-4.41 1.82A6.19 6.19 0 017.2 1.77m0-.97a7.2 7.2 0 100 14.4A7.2 7.2 0 007.2.8z"
                })
            ]
        })
    });
}
function EmptyImageIcon() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "20",
        height: "20",
        fill: "none",
        viewBox: "0 0 20 20",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fill: "#111C36",
                d: "M15.95 18.125H4.05a2.175 2.175 0 01-2.175-2.175V4.05A2.175 2.175 0 014.05 1.875h11.9a2.175 2.175 0 012.175 2.175v11.9a2.176 2.176 0 01-2.175 2.175zm-11.9-15a.925.925 0 00-.925.925v11.9a.925.925 0 00.925.925h11.9a.925.925 0 00.925-.925V4.05a.925.925 0 00-.925-.925H4.05z"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fill: "#111C36",
                d: "M2.5 15.675a.631.631 0 01-.475-.217.625.625 0 01.075-.883l4.267-3.6a1.667 1.667 0 012.25.092l2.025 2.025a.416.416 0 00.541 0l1.967-1.425a1.667 1.667 0 012.033 0l2.709 2.158a.627.627 0 01-.321 1.116.629.629 0 01-.463-.133l-2.7-2.166a.417.417 0 00-.508 0l-1.967 1.525a1.667 1.667 0 01-2.175-.15L7.733 11.95a.417.417 0 00-.558 0L2.9 15.533a.6.6 0 01-.4.142zM12.5 9.792a2.292 2.292 0 110-4.584 2.292 2.292 0 010 4.584zm0-3.334a1.042 1.042 0 100 2.084 1.042 1.042 0 000-2.084z"
            })
        ]
    });
}
var RulerIcon = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "14",
        height: "14",
        fill: "none",
        viewBox: "0 0 14 14",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                fill: "#586072",
                stroke: "#586072",
                strokeWidth: "0.2",
                clipPath: "url(#clip0_32_4676)",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M10.522.192c.103 0 .203.04.276.113l2.897 2.897a.39.39 0 0 1 .049.493l-.05.06-9.94 9.94a.4.4 0 0 1-.278.113.4.4 0 0 1-.274-.113L.305 10.798a.39.39 0 0 1 0-.552l9.94-9.94a.4.4 0 0 1 .277-.114Zm-9.387 10.33 2.341 2.342 9.388-9.388-2.341-2.34z"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M2.248 8.481a.4.4 0 0 1 .21.052l.06.042.005.005 1.24 1.237.05.06a.391.391 0 0 1-.049.491.4.4 0 0 1-.258.118H3.5a.4.4 0 0 1-.277-.116L1.972 9.134l-.006-.006a.393.393 0 0 1 .282-.647ZM3.906 6.799a.4.4 0 0 1 .276.13h.001l.826.826.038.044a.393.393 0 0 1-.098.56.39.39 0 0 1-.496-.053v.001l-.822-.825a.391.391 0 0 1 .275-.683ZM5.556 5.164c.104 0 .204.04.278.114v.001L7.07 6.52a.393.393 0 0 1 0 .551v.001a.4.4 0 0 1-.278.113.4.4 0 0 1-.215-.065l-.06-.048L5.28 5.834a.393.393 0 0 1 .277-.67ZM7.205 3.5a.4.4 0 0 1 .276.13h.001l.825.823.038.044a.391.391 0 0 1-.59.512l-.826-.826a.39.39 0 0 1 .276-.683ZM8.853 1.858a.4.4 0 0 1 .22.064l.059.048 1.237 1.238.038.043a.392.392 0 0 1-.213.612v.028h-.1a.4.4 0 0 1-.277-.113L8.58 2.531v-.001a.39.39 0 0 1-.089-.426.4.4 0 0 1 .362-.247Z"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                    id: "clip0_32_4676",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        fill: "#fff",
                        d: "M0 0h14v14H0z"
                    })
                })
            })
        ]
    });
};
var ThumbsUpIcon = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "17",
        fill: "none",
        viewBox: "0 0 16 17",
        className: props.className,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                fill: "#000",
                clipPath: "url(#clip0_30_4394)",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M14.672 10.406a1.408 1.408 0 0 0-1.047-2.344h-2.73c.27-.82.386-1.908.386-2.375V5.22a1.877 1.877 0 0 0-1.875-1.875h-.469a.47.47 0 0 0-.454.355L8.227 4.72C7.87 6.15 6.734 7.73 5.558 8.016a1.41 1.41 0 0 0-1.308-.891H1.438a.47.47 0 0 0-.47.469v8.437c0 .259.21.469.47.469H4.25c.56 0 1.043-.328 1.27-.802l1.61.537a5.2 5.2 0 0 0 1.63.265h3.928a1.408 1.408 0 0 0 1.307-1.924 1.41 1.41 0 0 0 1.036-1.357c0-.36-.136-.689-.359-.938a1.4 1.4 0 0 0 0-1.875M4.72 15.094a.47.47 0 0 1-.469.469H1.906v-7.5H4.25a.47.47 0 0 1 .469.468zm7.969-4.219h.937a.47.47 0 0 1 0 .938h-.937a.469.469 0 0 0 0 .937h.937a.47.47 0 0 1 0 .938h-.937a.469.469 0 0 0 0 .937.47.47 0 0 1 0 .938H8.76c-.455 0-.904-.073-1.335-.217l-1.77-.59v-5.8c.736-.14 1.455-.606 2.105-1.368.634-.744 1.149-1.731 1.376-2.64l.166-.667h.103c.517 0 .938.42.938.938v.468c0 .63-.197 1.837-.449 2.375h-.957a.469.469 0 0 0 0 .938h4.687a.47.47 0 0 1 0 .938h-.937a.469.469 0 0 0 0 .937"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M3.313 14.625a.469.469 0 1 0 0-.938.469.469 0 0 0 0 .938M9.875.5a.47.47 0 0 0-.469.469v.969a.469.469 0 0 0 .938 0v-.97A.47.47 0 0 0 9.875.5M7.886 2.567l-.662-.663a.469.469 0 1 0-.663.663l.663.663a.469.469 0 0 0 .662-.663M13.19 1.904a.47.47 0 0 0-.663 0l-.663.663a.469.469 0 1 0 .663.663l.663-.663a.47.47 0 0 0 0-.663"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                    id: "clip0_30_4394",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        fill: "#fff",
                        d: "M0 .5h16v16H0z"
                    })
                })
            })
        ]
    });
};


/***/ }),

/***/ 846976:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ CustomizedButton; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(626042);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(785893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(667294);
// EXTERNAL MODULE: ./node_modules/@mui/material/Button/Button.js + 3 modules
var Button = __webpack_require__(669417);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js
var styled = __webpack_require__(690948);
// EXTERNAL MODULE: ./node_modules/tailwind-merge/dist/bundle-mjs.mjs
var bundle_mjs = __webpack_require__(798388);
// EXTERNAL MODULE: ./src/components/WidgetMaker/utils/buttonConstant.ts
var buttonConstant = __webpack_require__(291850);
// EXTERNAL MODULE: ./src/components/DesignSystem/AtomicDesignsUtilities/ButtonAnimationStyles.module.scss
var ButtonAnimationStyles_module = __webpack_require__(9844);
var ButtonAnimationStyles_module_default = /*#__PURE__*/__webpack_require__.n(ButtonAnimationStyles_module);
// EXTERNAL MODULE: ./src/context/WidgetDndContext/index.ts
var WidgetDndContext = __webpack_require__(474151);
;// CONCATENATED MODULE: ./src/components/WidgetMaker/WidgetDnD/WIdgetPropertiesBasic/components/Button/utils.ts
function getBackgroundColorForOutline(currentColor) {
    switch(currentColor === null || currentColor === void 0 ? void 0 : currentColor.toLowerCase()){
        case "#ffffff":
            return {
                background: "#ffffff",
                text: "#000000"
            };
        case "#000000":
            return {
                background: "#000000",
                text: "#ffffff"
            };
        default:
            return {
                background: currentColor,
                text: "#ffffff"
            };
    }
}

;// CONCATENATED MODULE: ./src/components/WidgetMaker/WidgetDnD/WIdgetPropertiesBasic/components/Button/index.tsx



// eslint-disable-next-line import/named

// import { twMerge } from 'tailwind-merge';






var CustomButton = (0,styled/* default */.ZP)(Button/* default */.Z)(function(param) {
    var customVariant = param.customVariant, customBgColor = param.customBgColor;
    var ref;
    return {
        transition: "all 250ms ",
        transitionDuration: "250ms",
        transitionTimingFunction: "ease-in",
        fontFamily: "inherit",
        // minWidth: 'unset',
        "&:hover": {
            opacity: 0.96,
            backgroundColor: customBgColor || ((ref = defaultColors[Object.keys(defaultColors).find(function(key) {
                return customVariant === key;
            })]) === null || ref === void 0 ? void 0 : ref.backgroundColor)
        }
    };
});
var defaultStyleAttributes = {
    textTransform: "none",
    padding: 0
};
var defaultColors = {
    primary: {
        backgroundColor: "#2B74D8",
        color: "#ffffff"
    },
    secondary: {
        backgroundColor: "#ffffff",
        color: "#2B74D8",
        border: "1px solid #111C361F"
    },
    "secondary-2": {
        backgroundColor: "#ffffff",
        color: "#111C36",
        border: "1px solid #111C361F"
    },
    secondaryFilled: {
        backgroundColor: "#111C360F",
        color: "#2B74D8",
        border: "1px solid #111C361F"
    },
    "secondaryFilled-2": {
        backgroundColor: "#111C360F",
        color: "#111c36",
        border: "1px solid #111C361F"
    },
    "tertiary:": {
        textColor: "#2B74D8"
    }
};
var defaultGeometry = {
    small: {
        fontSize: 10,
        padding: "4px 18px"
    },
    medium: {
        fontSize: 14,
        padding: "8px 24px"
    },
    large: {
        fontSize: 18,
        padding: "12px 30px"
    }
};
function CustomizedButton(props) {
    var ref, ref1, ref2, ref3, ref4, ref5;
    var _imageDirection = props.imageDirection, imageDirection = _imageDirection === void 0 ? "left" : _imageDirection, _size = props.size, size = _size === void 0 ? buttonConstant/* BUTTON_SIZE_TYPE.MEDIUM */.n6.MEDIUM : _size, _variant = props.variant, variant = _variant === void 0 ? "primary" : _variant, removeHoverBg = props.removeHoverBg, btnType = props.btnType, buttonData = props.buttonData, selectedButtonData = props.selectedButtonData, _textualAlignment = props.textualAlignment, textualAlignment = _textualAlignment === void 0 ? "" : _textualAlignment, getHoverColor = props.getHoverColor, // Replaces original colors scheme with the reverse ones that show up during animation
    useReversedColors = props.useReversedColors;
    var ref6 = (0,WidgetDndContext/* useWidgetDndContextData */.KX)(), globalStyle = ref6.widgetContextState.globalStyle;
    // const isMobile = isMobileDevice() || (isBuilder && previewDevice === 'mobile');
    var stripButtonDefaults = variant === buttonConstant/* BUTTON_VARIANT.TERTIARY */.RN.TERTIARY;
    var ref7 = (0,react.useState)(false), isHover = ref7[0], setIsHover = ref7[1];
    var customBtnRef = (0,react.useRef)(null);
    var colorFromButtonData = buttonData === null || buttonData === void 0 ? void 0 : (ref = buttonData.btnStyleConfig) === null || ref === void 0 ? void 0 : ref.textColor;
    var bgColorFromButtonData = btnType === buttonConstant/* BUTTON_TYPE.SOLID */.JB.SOLID ? buttonData === null || buttonData === void 0 ? void 0 : (ref1 = buttonData.btnStyleConfig) === null || ref1 === void 0 ? void 0 : ref1.backgroundColor : btnType === buttonConstant/* BUTTON_TYPE.OUTLINE */.JB.OUTLINE ? buttonConstant/* TRANSPARENT */.Fs : "";
    var borderColorFromButtonData = btnType === buttonConstant/* BUTTON_TYPE.OUTLINE */.JB.OUTLINE ? buttonData === null || buttonData === void 0 ? void 0 : (ref2 = buttonData.btnStyleConfig) === null || ref2 === void 0 ? void 0 : ref2.backgroundColor : "";
    var btnColor = colorFromButtonData ? colorFromButtonData : props === null || props === void 0 ? void 0 : props.color;
    var btnBgColor = bgColorFromButtonData ? bgColorFromButtonData : props === null || props === void 0 ? void 0 : props.backgroundColor;
    var borderColor = borderColorFromButtonData ? borderColorFromButtonData : props === null || props === void 0 ? void 0 : props.borderColor;
    var animationClass = buttonData === null || buttonData === void 0 ? void 0 : (ref3 = buttonData.buttonAnimationConfig) === null || ref3 === void 0 ? void 0 : ref3.classKey;
    var hideOverlfowBasedOnAnimation = animationClass ? !((ref4 = [
        "widgetBtnShadowWrapper",
        "widgetProductBtnShadowWrapper",
        "widgetBtnUnderlineRightWrapper",
        "widgetBtnUnderlineRightWrapper2", 
    ]) === null || ref4 === void 0 ? void 0 : ref4.includes(animationClass)) : false;
    var isMoveAnimation = animationClass && btnType !== buttonConstant/* BUTTON_TYPE.SOLID */.JB.SOLID && ((ref5 = animationClass === null || animationClass === void 0 ? void 0 : animationClass.toLowerCase()) === null || ref5 === void 0 ? void 0 : ref5.includes("move"));
    var reversedColors = getBackgroundColorForOutline(btnColor);
    var isReverseColorsEligible = [
        buttonConstant/* BUTTON_TYPE.OUTLINE */.JB.OUTLINE,
        buttonConstant/* BUTTON_TYPE.SOLID */.JB.SOLID
    ].includes(btnType);
    (0,react.useEffect)(function() {
        if (getHoverColor) {
            getHoverColor(isHover && btnType === buttonConstant/* BUTTON_TYPE.OUTLINE */.JB.OUTLINE ? reversedColors : null);
        }
    }, [
        isHover
    ]);
    (0,react.useEffect)(function() {
        if (btnType === buttonConstant/* BUTTON_TYPE.OUTLINE */.JB.OUTLINE && (customBtnRef === null || customBtnRef === void 0 ? void 0 : customBtnRef.current)) {
            var ref, ref1, ref2, ref3, ref4;
            var updatedRadius = globalStyle === null || globalStyle === void 0 ? void 0 : (ref = globalStyle.buttons) === null || ref === void 0 ? void 0 : (ref1 = ref.style) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.borderRadius) === null || ref2 === void 0 ? void 0 : ref2.replace("!important", "");
            var backgroundColor = reversedColors.background;
            (ref3 = customBtnRef.current) === null || ref3 === void 0 ? void 0 : ref3.style.setProperty("--before-bg", backgroundColor);
            if (globalStyle === null || globalStyle === void 0 ? void 0 : (ref4 = globalStyle.buttons) === null || ref4 === void 0 ? void 0 : ref4.isEnabled) {
                var ref5;
                (ref5 = customBtnRef.current) === null || ref5 === void 0 ? void 0 : ref5.style.setProperty("--border-radius", updatedRadius);
            } else {
                var ref6;
                (ref6 = customBtnRef.current) === null || ref6 === void 0 ? void 0 : ref6.style.setProperty("--border-radius", "0px");
            }
        } else if (btnType === buttonConstant/* BUTTON_TYPE.TEXTUAL */.JB.TEXTUAL && (customBtnRef === null || customBtnRef === void 0 ? void 0 : customBtnRef.current)) {
            var ref7;
            (ref7 = customBtnRef.current) === null || ref7 === void 0 ? void 0 : ref7.style.setProperty("--textual-bg", btnColor);
        }
    }, [
        btnType,
        btnColor,
        globalStyle === null || globalStyle === void 0 ? void 0 : globalStyle.buttons
    ]);
    var dropShadow = function() {
        if (!props.showShadow) {
            return "";
        }
        switch(variant){
            case buttonConstant/* BUTTON_VARIANT.SECONDARY */.RN.SECONDARY:
            case buttonConstant/* BUTTON_VARIANT.SECONDARY2 */.RN.SECONDARY2:
                return " !tw-shadow-[0px_2px_6px_0px_#0000001F] ";
            case buttonConstant/* BUTTON_VARIANT.SECONDARYFILLED */.RN.SECONDARYFILLED:
            case buttonConstant/* BUTTON_VARIANT.SECONDARYFILLED2 */.RN.SECONDARYFILLED2:
                return " !tw-shadow-[0px_2px_6px_0px_#0000001F] ";
        }
    }();
    var getCustomBgColor = function() {
        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11;
        if (removeHoverBg) {
            return buttonConstant/* TRANSPARENT */.Fs;
        }
        return ((ref = props.className) === null || ref === void 0 ? void 0 : (ref1 = ref.split) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.call(ref, " tw-bg-[")) === null || ref2 === void 0 ? void 0 : (ref3 = ref2[1]) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.split) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.call(ref3, "]")) === null || ref5 === void 0 ? void 0 : ref5[0]) || ((ref6 = props.className) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.split) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.call(ref6, " !tw-bg-[")) === null || ref8 === void 0 ? void 0 : (ref9 = ref8[1]) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.split) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.call(ref9, "]")) === null || ref11 === void 0 ? void 0 : ref11[0]) || btnBgColor;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CustomButton, {
        customVariant: variant,
        customBgColor: getCustomBgColor(),
        onClick: function(event) {
            event.stopPropagation();
            (props === null || props === void 0 ? void 0 : props.onClick) && (props === null || props === void 0 ? void 0 : props.onClick(event));
        },
        ref: customBtnRef,
        onMouseDown: props.onMouseDown,
        onMouseUp: props.onMouseUp,
        disabled: props.disabled,
        onTouchStart: !props.disableHoverAnimation ? function() {
            return setIsHover(true);
        } : undefined,
        onTouchEnd: !props.disableHoverAnimation ? function() {
            return setIsHover(false);
        } : null,
        onMouseEnter: !props.disableHoverAnimation ? function() {
            return setIsHover(true);
        } : null,
        onMouseLeave: !props.disableHoverAnimation ? function() {
            return setIsHover(false);
        } : null,
        sx: (0,_object_spread/* default */.Z)({}, defaultStyleAttributes, defaultColors[variant], !stripButtonDefaults ? defaultGeometry[size] : {}, btnType === buttonConstant/* BUTTON_TYPE.TEXTUAL */.JB.TEXTUAL ? {
            backgroundColor: "transparent !important"
        } : {}),
        className: (0,bundle_mjs/* twMerge */.m6)("tw-relative tw-flex tw-items-center tw-justify-center tw-gap-[10px] tw-font-semibold tw-leading-[1] tw-tracking-normal", imageDirection === "left" ? "!tw-flex-row " : "!tw-flex-row-reverse ", dropShadow, props.className, (selectedButtonData === null || selectedButtonData === void 0 ? void 0 : selectedButtonData.animationColor) ? selectedButtonData === null || selectedButtonData === void 0 ? void 0 : selectedButtonData.animationColor : "", (selectedButtonData === null || selectedButtonData === void 0 ? void 0 : selectedButtonData.customClasses) ? selectedButtonData.customClasses : "", !props.disableHoverAnimation && animationClass && !props.disabled ? (ButtonAnimationStyles_module_default())[animationClass] : "", hideOverlfowBasedOnAnimation && "tw-overflow-hidden"),
        style: (0,_object_spread/* default */.Z)({
            borderColor: !useReversedColors ? borderColor : isReverseColorsEligible ? reversedColors.text : borderColor,
            backgroundColor: variant !== buttonConstant/* BUTTON_VARIANT.TERTIARY */.RN.TERTIARY ? !useReversedColors ? btnBgColor : isReverseColorsEligible ? reversedColors.background : btnBgColor : ""
        }, variant === buttonConstant/* BUTTON_VARIANT.TERTIARY */.RN.TERTIARY && textualAlignment ? {
            justifyContent: textualAlignment
        } : {}),
        children: [
            props.image ? typeof props.image === "object" ? props.image : /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                src: props.image
            }) : null,
            props.children ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                style: {
                    color: isReverseColorsEligible && useReversedColors && !isMoveAnimation || !props.disableHoverAnimation && isHover && btnType === buttonConstant/* BUTTON_TYPE.OUTLINE */.JB.OUTLINE && !isMoveAnimation ? reversedColors.text : btnColor
                },
                className: (0,bundle_mjs/* twMerge */.m6)("!tw-z-[2] !tw-m-0", props.textWrapperClass),
                children: props.children
            }) : null
        ]
    });
}


/***/ }),

/***/ 781477:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(626042);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(785893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(667294);
/* harmony import */ var _Tooltip__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(110406);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(561903);
/* harmony import */ var src_context_WidgetDndContext__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(474151);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(693967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_4__);







var CustomTextField = function(props) {
    var getInputBoxBorderClass = function getInputBoxBorderClass() {
        if (buttonConfig.left && buttonConfig.right) return "tw-rounded-[0px] tw-bg-[#fff] tw-text-center";
        else if (buttonConfig.left) return "tw-rounded-r-lg tw-bg-[#fff] tw-text-center";
        else if (buttonConfig.right) return "tw-rounded-l-lg tw-bg-[#fff] tw-text-center";
        return "tw-rounded-[6px]";
    };
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
    var textBoxLabel = props.textBoxLabel, placeholder = props.placeholder, handleChange = props.handleChange, _customClass = props.customClass, customClass = _customClass === void 0 ? "" : _customClass, parentClass = props.parentClass, _value = props.value, value = _value === void 0 ? "" : _value, _rows = props.rows, rows = _rows === void 0 ? 1 : _rows, _regexCheck = props.regexCheck, regexCheck = _regexCheck === void 0 ? "" : _regexCheck, _errorMessage = props.errorMessage, errorMessage = _errorMessage === void 0 ? "" : _errorMessage, _isMandatory = props.isMandatory, isMandatory = _isMandatory === void 0 ? false : _isMandatory, _maxLength = props.maxLength, maxLength = _maxLength === void 0 ? 100 : _maxLength, _buttonConfig = props.buttonConfig, buttonConfig = _buttonConfig === void 0 ? {} : _buttonConfig, _isDisabled = props.isDisabled, isDisabled = _isDisabled === void 0 ? false : _isDisabled, _iconClass = props.iconClass, iconClass = _iconClass === void 0 ? "" : _iconClass, onIconClick = props.onIconClick, _showErrorBox = props.showErrorBox, showErrorBox = _showErrorBox === void 0 ? true : _showErrorBox, _isIconPositionRight = props.isIconPositionRight, isIconPositionRight = _isIconPositionRight === void 0 ? false : _isIconPositionRight, _subDescription = props.subDescription, subDescription = _subDescription === void 0 ? "" : _subDescription, _labelInfoIcon = props.labelInfoIcon, labelInfoIcon = _labelInfoIcon === void 0 ? {
        show: false,
        description: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {})
    } : _labelInfoIcon, handleFocusOut = props.handleFocusOut, _showCharLimit = props.showCharLimit, showCharLimit = _showCharLimit === void 0 ? false : _showCharLimit, _hideBorder = props.hideBorder, hideBorder = _hideBorder === void 0 ? false : _hideBorder, _hideInputPadding = props.hideInputPadding, hideInputPadding = _hideInputPadding === void 0 ? false : _hideInputPadding, _isFocus = props.isFocus, isFocus = _isFocus === void 0 ? false : _isFocus, _inputColor = props.inputColor, inputColor = _inputColor === void 0 ? "" : _inputColor, _isCapitalize = props.isCapitalize, isCapitalize = _isCapitalize === void 0 ? true : _isCapitalize, iconComponent = props.iconComponent, borderColor = props.borderColor, _borderRadiusClass = props.borderRadiusClass, borderRadiusClass = _borderRadiusClass === void 0 ? "" : _borderRadiusClass, rightIconCompo = props.rightIconCompo, customPadding = props.customPadding, inputType = props.inputType, _placeholderColor = props.placeholderColor, placeholderColor = _placeholderColor === void 0 ? "" : _placeholderColor, _isMultiLine = props.isMultiLine, isMultiLine = _isMultiLine === void 0 ? true : _isMultiLine;
    var ref8 = (0,src_context_WidgetDndContext__WEBPACK_IMPORTED_MODULE_3__/* .useWidgetDndContextData */ .KX)(), globalStyle = ref8.widgetContextState.globalStyle;
    var handleInputValue = function(e) {
        if (regexCheck) {
            handleChange(regexCheck(e.target.value));
        } else {
            handleChange(e.target.value);
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
        className: "".concat(parentClass, " ").concat(isDisabled && "tw-pointer-events-none"),
        children: [
            textBoxLabel ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "tw-mb-10",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "tw-flex tw-items-center tw-justify-between",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                className: "tw-my-[0px] tw-text-14 tw-font-medium ".concat(isCapitalize ? "tw-capitalize" : "", " tw-text-newBlack"),
                                children: [
                                    textBoxLabel,
                                    " ",
                                    isMandatory && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: "tw-text-[#9A3131]",
                                        children: "*"
                                    })
                                ]
                            }),
                            (labelInfoIcon === null || labelInfoIcon === void 0 ? void 0 : labelInfoIcon.show) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Tooltip__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                title: labelInfoIcon === null || labelInfoIcon === void 0 ? void 0 : labelInfoIcon.description,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "wb-sprite ic-info-grey"
                                })
                            }),
                            showCharLimit && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "tw-text-12 tw-font-normal tw-text-newBlack tw-opacity-60",
                                children: [
                                    value === null || value === void 0 ? void 0 : value.length,
                                    "/",
                                    maxLength
                                ]
                            })
                        ]
                    }),
                    subDescription ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: "tw-mb-[0px] tw-mt-[6px] tw-text-12 tw-font-normal tw-capitalize tw-text-newBlack tw-opacity-60",
                        children: subDescription
                    }) : null
                ]
            }) : null,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "tw-flex",
                children: [
                    buttonConfig.left ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                        onClick: function() {
                            var ref, ref1;
                            return ((ref = buttonConfig.left) === null || ref === void 0 ? void 0 : ref.onClick) && ((ref1 = buttonConfig.left) === null || ref1 === void 0 ? void 0 : ref1.onClick());
                        },
                        className: "tw-bg-[#fafafa] tw-py-8 ".concat((ref = buttonConfig.left) === null || ref === void 0 ? void 0 : ref.customClass, " tw-flex tw-items-center tw-justify-center tw-rounded-l-lg tw-border-y-[1px] tw-border-l-[1px] tw-border-[#EBEBEB] tw-text-16"),
                        children: ((ref1 = buttonConfig.left) === null || ref1 === void 0 ? void 0 : ref1.textHtml) ? "" : buttonConfig.left.text
                    }) : null,
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: classnames__WEBPACK_IMPORTED_MODULE_4___default()("tw-relative tw-flex tw-grow tw-rounded-[6px]", borderRadiusClass),
                        style: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                            border: !hideBorder ? "1px solid ".concat(borderColor || "rgba(17, 28, 54, 0.12)") : ""
                        }, (globalStyle === null || globalStyle === void 0 ? void 0 : (ref2 = globalStyle.inputs) === null || ref2 === void 0 ? void 0 : ref2.isEnabled) ? {
                            borderRadius: globalStyle === null || globalStyle === void 0 ? void 0 : (ref3 = globalStyle.inputs) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.style) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.borderRadius) === null || ref5 === void 0 ? void 0 : ref5.replace("!important", "")
                        } : {}),
                        children: [
                            iconClass && !isIconPositionRight || iconComponent ? iconClass ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                onClick: onIconClick,
                                className: "rista-sprite ".concat(iconClass, " tw-absolute tw-left-[10px] tw-top-1/2 tw--translate-y-1/2 ") + (onIconClick ? "tw-cursor-pointer" : "")
                            }) : iconComponent() : null,
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                id: "filled-multiline-flexible",
                                placeholder: !value && placeholder,
                                type: inputType,
                                multiline: isMultiLine,
                                autoFocus: isFocus,
                                onBlur: handleFocusOut,
                                value: value || "",
                                inputProps: {
                                    style: {
                                        fontSize: 15
                                    },
                                    maxLength: maxLength,
                                    color: inputColor
                                },
                                rows: rows,
                                onChange: function(e) {
                                    return handleInputValue(e);
                                },
                                sx: {
                                    wordBreak: "keep-all",
                                    whiteSpace: "pre-wrap",
                                    padding: "0.6px",
                                    boxShadow: "none",
                                    ".MuiInputBase-root": {
                                        padding: hideInputPadding ? "0px" : customPadding || "12px",
                                        color: (inputColor === null || inputColor === void 0 ? void 0 : inputColor.length) ? inputColor : "",
                                        border: "none",
                                        "&:hover": {
                                            boxShadow: "none",
                                            border: "none"
                                        },
                                        "& fieldset": {
                                            boxShadow: "none",
                                            border: "none"
                                        },
                                        "&:hover fieldset": {
                                            boxShadow: "none",
                                            border: "none"
                                        },
                                        "&.Mui-focused fieldset": {
                                            boxShadow: "none",
                                            border: "none"
                                        },
                                        " .MuiInputBase-input": {
                                            width: isIconPositionRight ? "calc(100% - 20px)" : "100%",
                                            boxShadow: "none",
                                            border: "none"
                                        },
                                        ".MuiOutlinedInput-notchedOutline": {
                                            border: hideBorder ? "none" : ""
                                        }
                                    },
                                    "& .MuiInputBase-input::placeholder": {
                                        color: placeholderColor,
                                        opacity: 0.7
                                    }
                                },
                                className: "tw-relative tw-z-10 tw-w-[calc(100%_-_30px)] tw-shadow-none ".concat(iconClass ? isIconPositionRight ? "tw-mr-36" : "tw-ml-36" : "", " ").concat(customClass, " tw-resize-none ").concat(errorMessage ? "tw-border-[#9A3131]" : "tw-border-borderGrey", " tw-border-[1px]  tw-font-normal tw-text-newBlack\n              ").concat(getInputBoxBorderClass(), " tw-overflow-hidden tw-text-ellipsis tw-whitespace-break-spaces ")
                            }),
                            iconClass && isIconPositionRight || rightIconCompo ? iconClass ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                onClick: onIconClick,
                                className: "wb-sprite ".concat(iconClass, " tw-absolute tw-right-[10px] tw-top-1/2 tw--translate-y-1/2 ") + (onIconClick ? "tw-cursor-pointer" : "")
                            }) : rightIconCompo() : null
                        ]
                    }),
                    buttonConfig.right ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                        onClick: function() {
                            var ref, ref1;
                            return ((ref = buttonConfig.right) === null || ref === void 0 ? void 0 : ref.onClick) && ((ref1 = buttonConfig.right) === null || ref1 === void 0 ? void 0 : ref1.onClick());
                        },
                        className: "tw-bg-[#fafafa] tw-py-8 ".concat((ref6 = buttonConfig.right) === null || ref6 === void 0 ? void 0 : ref6.customClass, " tw-flex tw-items-center tw-justify-center tw-rounded-r-lg tw-border-y-[1px] tw-border-r-[1px] tw-border-[#EBEBEB] tw-text-16"),
                        children: ((ref7 = buttonConfig.right) === null || ref7 === void 0 ? void 0 : ref7.textHtml) ? "" : buttonConfig.right.text
                    }) : null
                ]
            }),
            showErrorBox ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: "tw-mt-4 tw-h-[18px] tw-text-12 tw-font-normal tw-text-[#9A3131]",
                children: errorMessage ? errorMessage : ""
            }) : null
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CustomTextField);


/***/ }),

/***/ 110406:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ CustomizedTooltips; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(414924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(626042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(269396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(999534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(785893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(667294);
/* harmony import */ var _mui_material_styles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(690948);
/* harmony import */ var _mui_material_Tooltip__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(721023);
/* harmony import */ var _mui_material_Tooltip__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(348999);







// eslint-disable-next-line import/named

var BootstrapTooltip = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(function(_param) /*#__PURE__*/ {
    var className = _param.className, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "className"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Tooltip__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, props), {
        arrow: true,
        classes: {
            popper: className
        }
    }));
})(function(param) {
    var theme = param.theme;
    var _obj;
    return _obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, "& .".concat(_mui_material_Tooltip__WEBPACK_IMPORTED_MODULE_8__/* ["default"].arrow */ .Z.arrow), {
        color: "rgba(17, 28, 54, 0.90)"
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, "& .".concat(_mui_material_Tooltip__WEBPACK_IMPORTED_MODULE_8__/* ["default"].tooltip */ .Z.tooltip), {
        backgroundColor: "rgba(12, 21, 42, 1)",
        borderRadius: "8px"
    }), _obj;
});
function CustomizedTooltips(props) {
    var _diableHover;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(BootstrapTooltip, {
        disableHoverListener: (_diableHover = props.diableHover) !== null && _diableHover !== void 0 ? _diableHover : false,
        title: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "tw-text-12 tw-max-w-[274px] tw-p-12 tw-font-normal tw-text-white",
                children: props.title
            })
        }),
        children: props.children
    });
}


/***/ }),

/***/ 577682:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ADD_ELEMENT_TYPE": function() { return /* binding */ ADD_ELEMENT_TYPE; },
/* harmony export */   "ADMIN_FOOTERS_LIST": function() { return /* binding */ ADMIN_FOOTERS_LIST; },
/* harmony export */   "COLUMN_WISE_ELEMENTS": function() { return /* binding */ COLUMN_WISE_ELEMENTS; },
/* harmony export */   "FOOTER_CHILDREN_SECTION_CONFIGS": function() { return /* binding */ FOOTER_CHILDREN_SECTION_CONFIGS; },
/* harmony export */   "FOOTER_DATA": function() { return /* binding */ FOOTER_DATA; },
/* harmony export */   "FOOTER_LINK_SORT_TYPES": function() { return /* binding */ FOOTER_LINK_SORT_TYPES; },
/* harmony export */   "FOOTER_LINK_TYPES": function() { return /* binding */ FOOTER_LINK_TYPES; },
/* harmony export */   "NEW_FOOTER_COLOR_SCHEME": function() { return /* binding */ NEW_FOOTER_COLOR_SCHEME; },
/* harmony export */   "NEW_FOOTER_LAYER_CONFIG": function() { return /* binding */ NEW_FOOTER_LAYER_CONFIG; },
/* harmony export */   "PLACEHOLDER_FILED": function() { return /* binding */ PLACEHOLDER_FILED; },
/* harmony export */   "ROW_WISE_ELEMENTS": function() { return /* binding */ ROW_WISE_ELEMENTS; },
/* harmony export */   "SUBSCRIBE_FIELD": function() { return /* binding */ SUBSCRIBE_FIELD; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(414924);
/* harmony import */ var src_components_WidgetMaker_utils_common__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(737179);
/* harmony import */ var _constant__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(671346);
/* harmony import */ var src_constants_widgets__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(442381);
/* harmony import */ var src_constants_builderConstants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(779834);





var FOOTER_DATA = {
    isNewAdminFooter: true,
    type: src_constants_widgets__WEBPACK_IMPORTED_MODULE_2__/* .ADMIN_WIDGETS.FOOTER.type */ .Pe.FOOTER.type,
    footerConfig: {
        colorSchemes: [
            {
                background: "#ffffff",
                text: "#000000",
                isDefault: true
            },
            {
                background: "#000000",
                text: "#ffffff",
                isDefault: false
            }, 
        ],
        selectedColorSchemeIndex: 0,
        showGoToTop: false,
        subscription: [
            src_constants_builderConstants__WEBPACK_IMPORTED_MODULE_3__/* .SUBSCRIPTION_NAMES.PRO */ .An.PRO,
            src_constants_builderConstants__WEBPACK_IMPORTED_MODULE_3__/* .SUBSCRIPTION_NAMES.ELITE */ .An.ELITE
        ]
    },
    layer1: {
        heading: "",
        isSortable: true,
        isAddElement: true,
        actualLayer: "layer1",
        elementList: [
            ""
        ],
        builder: [
            {
                type: _constant__WEBPACK_IMPORTED_MODULE_1__/* .SECTION_TYPE.LOGO_ABOUTUS */ .Pd.LOGO_ABOUTUS,
                displayText: "Store details and utilities",
                sectionHeading: "",
                isSortable: false,
                isDefault: true,
                isVisible: true,
                isEditable: true,
                section: [
                    {
                        type: "logo",
                        logoUrl: "",
                        logoSrc: "",
                        aspectRatio: "",
                        zoom: "",
                        manualUpdate: true,
                        desktopSize: "60px",
                        mobileSize: "20px",
                        hideLogo: false,
                        hideStoreName: true,
                        showAppDownload: true,
                        showSocialMedia: true
                    },
                    {
                        type: "aboutUs",
                        content: "<p>Tell something about your company here in brief.</p>",
                        contentCharCount: 0,
                        showMoreLink: true,
                        linkText: "Learn more",
                        redirectionType: "link",
                        redirectUrl: "",
                        isOpenInNewTab: true,
                        linkColor: "#000000"
                    },
                    {
                        type: "appStore",
                        selectedType: "type1",
                        isVisible: false,
                        showAppStore: true,
                        showGooglePlay: true,
                        playStoreLink: "",
                        appStoreLink: "",
                        newTabPlayStore: true,
                        newTabAppStore: true,
                        columnType: "logoAboutUs"
                    },
                    {
                        type: "social",
                        isVisible: true,
                        selectedType: "type1",
                        columnType: "logoAboutUs"
                    }, 
                ],
                style: {
                    // width: '22%',
                    minWidth: "210px",
                    maxWidth: "336px"
                }
            },
            {
                type: _constant__WEBPACK_IMPORTED_MODULE_1__/* .SECTION_TYPE.QUICK_LINKS */ .Pd.QUICK_LINKS,
                subType: "info",
                isDefault: true,
                displayText: "Information",
                content: "<p>Information</p>",
                contentCharCount: 11,
                isSortable: false,
                isVisible: true,
                isEditable: true,
                section: [],
                style: {
                    // width: '13%',
                    minWidth: "120px",
                    maxWidth: "180px"
                }
            },
            {
                type: _constant__WEBPACK_IMPORTED_MODULE_1__/* .SECTION_TYPE.QUICK_LINKS */ .Pd.QUICK_LINKS,
                displayText: "Shop",
                subType: "shop",
                content: "<p>Shop</p>",
                isDefault: true,
                contentCharCount: 4,
                isSortable: false,
                isVisible: true,
                isEditable: true,
                section: [],
                style: {
                    // width: '13%',
                    minWidth: "120px",
                    maxWidth: "180px"
                }
            },
            {
                type: _constant__WEBPACK_IMPORTED_MODULE_1__/* .SECTION_TYPE.CONTACTUS_LOCATION */ .Pd.CONTACTUS_LOCATION,
                subType: "contactUs",
                displayText: "Contact us and location",
                contentContact: "<p>Contact us</p>",
                isDefault: true,
                contentLocation: "<p>Location</p>",
                contactCharCount: 10,
                locationCharCount: 8,
                isSortable: false,
                isVisible: true,
                showContact: true,
                showLocation: true,
                isEditable: true,
                showMap: false,
                showAppDownload: false,
                showSocialMedia: false,
                button: [
                    (0,src_components_WidgetMaker_utils_common__WEBPACK_IMPORTED_MODULE_0__/* .getDefaultConfig */ ._K)("footerButton", "#FFFFFF", "#000000")
                ],
                section: [],
                style: {
                    // width: '15%',
                    minWidth: "140px",
                    maxWidth: "220px"
                }
            },
            {
                type: _constant__WEBPACK_IMPORTED_MODULE_1__/* .SECTION_TYPE.NEWS_LETTER */ .Pd.NEWS_LETTER,
                subType: "newsLetter",
                displayText: "Newsletter",
                contentHeading: "<h2>Subscribe to our newsletter</h2>",
                isDefault: true,
                contentDescription: "<h5>Be the first to see our latest products, hottest sales and member exclusive discount codes. Sign up below to get your 10% off coupon.</h5>",
                headingCharCount: 10,
                descriptionCharCount: 8,
                newsLetterType: "type4",
                isSortable: false,
                isVisible: true,
                isEditable: true,
                placeholder: "Enter your e-mail id",
                subscribeText: "Subscribe",
                section: [],
                subscription: [
                    src_constants_builderConstants__WEBPACK_IMPORTED_MODULE_3__/* .SUBSCRIPTION_NAMES.ELITE */ .An.ELITE
                ],
                style: {
                    // width: '24%',
                    minWidth: "220px",
                    maxWidth: "340px"
                }
            }, 
        ],
        style: {}
    },
    layer2: {
        heading: "",
        isSortable: false,
        isAddElement: true,
        isStaticSection: true,
        actualLayer: "layer3",
        elementList: [
            ""
        ],
        builder: [
            {
                type: _constant__WEBPACK_IMPORTED_MODULE_1__/* .SECTION_TYPE.COPYRIGHT */ .Pd.COPYRIGHT,
                subType: "copyright",
                isDefault: true,
                displayText: "Copyright",
                placeholder: "Enter copyright info",
                content: "\xa9 ".concat(new Date().getFullYear(), " — Copyright, All Rights reserved"),
                contentCharCount: 100,
                isSortable: false,
                isVisible: true,
                isEditable: true,
                section: [],
                style: {}
            },
            {
                type: _constant__WEBPACK_IMPORTED_MODULE_1__/* .SECTION_TYPE.PAYMENT_MODES */ .Pd.PAYMENT_MODES,
                subType: "paymentModes",
                isDefault: true,
                displayText: "Payment Modes",
                content: "",
                contentCharCount: 100,
                isSortable: false,
                isVisible: true,
                isEditable: true,
                section: [],
                style: {}
            }, 
        ]
    }
};
var ADD_ELEMENT_TYPE = {
    quickLinks: {
        type: _constant__WEBPACK_IMPORTED_MODULE_1__/* .SECTION_TYPE.QUICK_LINKS */ .Pd.QUICK_LINKS,
        displayText: "Quick link",
        subType: "quick link",
        content: "<p>Quick link</p>",
        isDefault: false,
        contentCharCount: 10,
        isSortable: false,
        isVisible: true,
        section: [],
        style: {
        }
    },
    categoriesCollections: {
        type: _constant__WEBPACK_IMPORTED_MODULE_1__/* .SECTION_TYPE.CATEGORIES_COLLECTIONS */ .Pd.CATEGORIES_COLLECTIONS,
        displayText: "Shop store",
        subType: "categories collections",
        content: "<p>Shop Categories</p>",
        isContentEdited: false,
        placeholder: "Shop Categories",
        isDefault: false,
        selectedLinkType: "",
        linksList: [],
        oldSelectedLinksList: [],
        listSortType: "default",
        contentCharCount: 100,
        isSortable: false,
        isVisible: true,
        section: [],
        subscription: [
            src_constants_builderConstants__WEBPACK_IMPORTED_MODULE_3__/* .SUBSCRIPTION_NAMES.PRO */ .An.PRO,
            src_constants_builderConstants__WEBPACK_IMPORTED_MODULE_3__/* .SUBSCRIPTION_NAMES.ELITE */ .An.ELITE
        ],
        style: {
            width: "100%"
        }
    },
    customHTML: {
        type: _constant__WEBPACK_IMPORTED_MODULE_1__/* .SECTION_TYPE.CUSTOM_HTML */ .Pd.CUSTOM_HTML,
        displayText: "Custom HTML",
        subType: "custom html",
        content: "",
        contentProps: {
            justifyContent: "flex-start",
            alignItems: "flex-start",
            border: "",
            margin: "",
            padding: "",
            background: "",
            mobileHidden: false,
            desktopHidden: false,
            height: "",
            openInNewTab: false,
            link: "",
            maxWidth: ""
        },
        isDefault: false,
        contentCharCount: 10000,
        isSortable: false,
        isVisible: true,
        section: [],
        style: {
            width: "100%"
        }
    },
    textGroup: {
        type: _constant__WEBPACK_IMPORTED_MODULE_1__/* .SECTION_TYPE.TEXT_GROUP */ .Pd.TEXT_GROUP,
        displayText: "Text group",
        subType: "custom html",
        content: {
            heading: "<p>About</p>",
            description: "<p>Use this text area to share your brand story and vision with your customers here.</p>"
        },
        placeholder: "Your text goes here....",
        isDefault: false,
        contentCharCount: {
            heading: 100,
            description: 1000
        },
        isSortable: false,
        isVisible: true,
        section: [],
        subscription: [
            src_constants_builderConstants__WEBPACK_IMPORTED_MODULE_3__/* .SUBSCRIPTION_NAMES.PRO */ .An.PRO,
            src_constants_builderConstants__WEBPACK_IMPORTED_MODULE_3__/* .SUBSCRIPTION_NAMES.ELITE */ .An.ELITE
        ],
        style: {
            width: "100%"
        }
    }
};
var NEW_FOOTER_COLOR_SCHEME = {
    background: "#0C1518",
    text: "#ffffff",
    isDefault: false
};
var NEW_FOOTER_LAYER_CONFIG = {
    heading: "",
    isSortable: true,
    isAddElement: true,
    actualLayer: "layer2",
    elementList: [
        ""
    ],
    builder: [],
    style: {}
};
var FOOTER_LINK_TYPES = {
    CATEGORIES: "categories",
    COLLECTIONS: "collections",
    CAT_COLLECTION: "categoriesCollections",
    CUSTOM_LINKS: "customLinks"
};
var FOOTER_LINK_SORT_TYPES = {
    DEFAULT: "default",
    ALPHABETICAL: "alphabetical",
    ITEM_COUNT: "itemCount",
    RANKING: "ranking"
};
var COLUMN_WISE_ELEMENTS = [
    {
        title: "Quick links",
        limit: 2,
        seoBoost: false,
        uid: _constant__WEBPACK_IMPORTED_MODULE_1__/* .SECTION_TYPE.QUICK_LINKS */ .Pd.QUICK_LINKS
    }, 
];
var ROW_WISE_ELEMENTS = [
    {
        title: "Text Group",
        limit: 2,
        seoBoost: true,
        uid: _constant__WEBPACK_IMPORTED_MODULE_1__/* .SECTION_TYPE.TEXT_GROUP */ .Pd.TEXT_GROUP,
        subscription: [
            src_constants_builderConstants__WEBPACK_IMPORTED_MODULE_3__/* .SUBSCRIPTION_NAMES.PRO */ .An.PRO,
            src_constants_builderConstants__WEBPACK_IMPORTED_MODULE_3__/* .SUBSCRIPTION_NAMES.ELITE */ .An.ELITE
        ]
    },
    {
        title: "Categories list/Collections, custom links",
        limit: 2,
        seoBoost: true,
        uid: _constant__WEBPACK_IMPORTED_MODULE_1__/* .SECTION_TYPE.CATEGORIES_COLLECTIONS */ .Pd.CATEGORIES_COLLECTIONS,
        subscription: [
            src_constants_builderConstants__WEBPACK_IMPORTED_MODULE_3__/* .SUBSCRIPTION_NAMES.PRO */ .An.PRO,
            src_constants_builderConstants__WEBPACK_IMPORTED_MODULE_3__/* .SUBSCRIPTION_NAMES.ELITE */ .An.ELITE
        ]
    },
    {
        title: "Custom HTML",
        limit: 1,
        seoBoost: false,
        uid: _constant__WEBPACK_IMPORTED_MODULE_1__/* .SECTION_TYPE.CUSTOM_HTML */ .Pd.CUSTOM_HTML
    }, 
];
var ADMIN_FOOTERS_LIST = [
    {
        title: src_constants_widgets__WEBPACK_IMPORTED_MODULE_2__/* .ADMIN_WIDGETS.FOOTER.type */ .Pe.FOOTER.type,
        name: src_constants_widgets__WEBPACK_IMPORTED_MODULE_2__/* .ADMIN_WIDGETS.FOOTER.type */ .Pe.FOOTER.type,
        imgUrl: "https://cdn.dotpe.in/longtail/themes/8073865/amm30kQR.webp",
        propsConfig: {
            isAdminFooter: true,
            footerNumber: 1,
            configChanges: [
                {
                    subType: _constant__WEBPACK_IMPORTED_MODULE_1__/* .SECTION_TYPE.SHOP */ .Pd.SHOP,
                    isVisible: true
                },
                {
                    subType: _constant__WEBPACK_IMPORTED_MODULE_1__/* .SECTION_TYPE.NEWS_LETTER */ .Pd.NEWS_LETTER,
                    isVisible: false
                }, 
            ]
        }
    },
    {
        title: src_constants_widgets__WEBPACK_IMPORTED_MODULE_2__/* .ADMIN_WIDGETS.FOOTER.type */ .Pe.FOOTER.type,
        name: src_constants_widgets__WEBPACK_IMPORTED_MODULE_2__/* .ADMIN_WIDGETS.FOOTER.type */ .Pe.FOOTER.type,
        imgUrl: "https://cdn.dotpe.in/longtail/themes/8073865/d18bG3Q5.webp",
        propsConfig: {
            isAdminFooter: true,
            footerNumber: 2,
            configChanges: [
                {
                    subType: _constant__WEBPACK_IMPORTED_MODULE_1__/* .SECTION_TYPE.SHOP */ .Pd.SHOP,
                    isVisible: false
                },
                {
                    subType: _constant__WEBPACK_IMPORTED_MODULE_1__/* .SECTION_TYPE.NEWS_LETTER */ .Pd.NEWS_LETTER,
                    isVisible: true
                }, 
            ]
        }
    }, 
];
var PLACEHOLDER_FILED = {
    label: "Placeholder text",
    placeholder: "Enter text",
    key: "placeholder"
};
var SUBSCRIBE_FIELD = {
    label: "Text over button",
    placeholder: "Enter text",
    key: "subscribeText"
};
var _obj;
var FOOTER_CHILDREN_SECTION_CONFIGS = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, _constant__WEBPACK_IMPORTED_MODULE_1__/* .SECTION_TYPE.NEWS_LETTER */ .Pd.NEWS_LETTER, {
    style: {
        // width: '24%',
        minWidth: "238px",
        maxWidth: "340px"
    }
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, _constant__WEBPACK_IMPORTED_MODULE_1__/* .SECTION_TYPE.QUICK_LINKS */ .Pd.QUICK_LINKS, {
    style: {
        // width: '13%',
        minWidth: "120px",
        maxWidth: "180px"
    }
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, _constant__WEBPACK_IMPORTED_MODULE_1__/* .SECTION_TYPE.CONTACTUS_LOCATION */ .Pd.CONTACTUS_LOCATION, {
    style: {
        // width: '15%',
        minWidth: "140px",
        maxWidth: "220px"
    }
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, _constant__WEBPACK_IMPORTED_MODULE_1__/* .SECTION_TYPE.LOGO_ABOUTUS */ .Pd.LOGO_ABOUTUS, {
    style: {
        // width: '15%',
        minWidth: "140px",
        maxWidth: "220px"
    }
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, _constant__WEBPACK_IMPORTED_MODULE_1__/* .SECTION_TYPE.CATEGORIES_COLLECTIONS */ .Pd.CATEGORIES_COLLECTIONS, {
    style: {
        width: "100%"
    }
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, _constant__WEBPACK_IMPORTED_MODULE_1__/* .SECTION_TYPE.CUSTOM_HTML */ .Pd.CUSTOM_HTML, {
    style: {
        width: "100%"
    }
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, _constant__WEBPACK_IMPORTED_MODULE_1__/* .SECTION_TYPE.TEXT_GROUP */ .Pd.TEXT_GROUP, {
    style: {
        width: "100%"
    }
}), _obj);


/***/ }),

/***/ 295817:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "IZ": function() { return /* binding */ ANNOUNCEMENT_BAR_POSITION; },
/* harmony export */   "Jn": function() { return /* binding */ AnnouncementConfig; },
/* harmony export */   "Jx": function() { return /* binding */ VISIBILITY_TYPE; },
/* harmony export */   "VE": function() { return /* binding */ WIDGET_BG_TYPE; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(626042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(269396);
/* harmony import */ var _NewAnnouncementBar_Config__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(935789);



var WIDGET_BG_TYPE = {
    COLOR: "color",
    TRANSPARENT: "transparent"
};
var ANNOUNCEMENT_BAR_POSITION = {
    ABOVE_HEADER: "aboveHeader",
    BELOW_HEADER: "belowHeader"
};
var VISIBILITY_TYPE = {
    ALL: "all",
    HOME_PAGE: "homepage"
};
var AnnouncementConfig = {
    listConfig: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, _NewAnnouncementBar_Config__WEBPACK_IMPORTED_MODULE_0__.NEW_ANNOUNCEMENT_BAR_PRESENTATION_CONFIG), {
        isVisible: false,
        position: ANNOUNCEMENT_BAR_POSITION.ABOVE_HEADER,
        visibilty: {
            type: VISIBILITY_TYPE.ALL
        },
        fillType: WIDGET_BG_TYPE.COLOR
    }),
    cardConfig: _NewAnnouncementBar_Config__WEBPACK_IMPORTED_MODULE_0__.NEW_ANNOUNCEMENT_CARD_CONFIG
};


/***/ }),

/***/ 708261:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ useActiveHeaderSection; }
/* harmony export */ });
/* harmony import */ var src_context_WidgetDndContext__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(474151);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(565286);


var useActiveHeaderSection = function() {
    var ref = (0,src_context_WidgetDndContext__WEBPACK_IMPORTED_MODULE_0__/* .useWidgetDndContextData */ .KX)(), isHeaderFooterPropertyActive = ref.widgetContextState.isHeaderFooterPropertyActive;
    var ref1 = isHeaderFooterPropertyActive || {}, subWidgetType = ref1.subWidgetType, subWidgetIndex = ref1.subWidgetIndex, initiator = ref1.initiator, type = ref1.type, status = ref1.status;
    var initiatedFromHeaderOutline = initiator === _constants__WEBPACK_IMPORTED_MODULE_1__/* .HEADER_INITIATOR_TYPE.HEADER */ .p.HEADER;
    var initiatedFromHeaderAnnouncementOutline = initiator === _constants__WEBPACK_IMPORTED_MODULE_1__/* .HEADER_INITIATOR_TYPE.ANNOUNCEMENT */ .p.ANNOUNCEMENT;
    var isHeaderActive = status && type === "Header";
    var showAnnouncementSections = isHeaderActive && (initiatedFromHeaderOutline || initiatedFromHeaderAnnouncementOutline) && subWidgetType === "announcementList";
    var showAnnouncementItem = isHeaderActive && showAnnouncementSections && (subWidgetIndex || subWidgetIndex === 0);
    var isHeaderAnnouncementActive = showAnnouncementItem || showAnnouncementSections;
    return {
        showAnnouncementItem: showAnnouncementItem,
        showAnnouncementSections: showAnnouncementSections,
        initiatedFromHeaderOutline: initiatedFromHeaderOutline,
        initiatedFromHeaderAnnouncementOutline: initiatedFromHeaderAnnouncementOutline,
        isHeaderAnnouncementActive: isHeaderAnnouncementActive,
        isHeaderActive: isHeaderActive,
        activeSubWidgetHeaderIndex: subWidgetIndex
    };
};


/***/ }),

/***/ 436303:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "m": function() { return /* binding */ HEADER_CONFIG; },
  "G": function() { return /* binding */ POSITIONS_DATA; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(626042);
// EXTERNAL MODULE: ./src/components/WidgetMaker/WidgetDnD/WidgetProperties/HeaderBuilder/AnnouncementConfig.ts
var AnnouncementConfig = __webpack_require__(295817);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(269396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(785893);
// EXTERNAL MODULE: ./src/assets/svgExports/WishlistHeartBuilderIcon.js
var WishlistHeartBuilderIcon = __webpack_require__(973664);
;// CONCATENATED MODULE: ./src/components/WidgetMaker/WidgetDnD/WidgetProperties/HeaderBuilder/components/Svgs.tsx




function UserIconV1(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        xmlns: "http://www.w3.org/2000/svg",
        width: "18",
        height: "22",
        fill: "none",
        viewBox: "0 0 18 22"
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            stroke: "#111C36",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: "1.5",
            d: "M12.75 5a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0zM1.501 19.118a7.5 7.5 0 0114.998 0A17.933 17.933 0 019 20.75c-2.676 0-5.216-.584-7.499-1.632z"
        })
    }));
}
function UserIconV2(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        xmlns: "http://www.w3.org/2000/svg",
        width: "18",
        height: "20",
        fill: "none",
        viewBox: "0 0 18 20"
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            stroke: "#111C36",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: "1.5",
            d: "M17 19v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2M13 5a4 4 0 11-8 0 4 4 0 018 0z"
        })
    }));
}
function CartIconV1(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        xmlns: "http://www.w3.org/2000/svg",
        width: "18",
        height: "20",
        fill: "none",
        viewBox: "0 0 18 20"
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            stroke: "#111C36",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: "1.5",
            d: "M.9 4.6L3.6 1h10.8l2.7 3.6M.9 4.6v12.6A1.8 1.8 0 002.7 19h12.6a1.8 1.8 0 001.8-1.8V4.6M.9 4.6h16.2m-4.5 3.6a3.6 3.6 0 01-7.2 0"
        })
    }));
}
function WishlistIcon(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(WishlistHeartBuilderIcon/* default */.Z, {
        size: 24,
        color: "#111C36"
    });
}
function CartIconV2(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        xmlns: "http://www.w3.org/2000/svg",
        width: "20",
        height: "18",
        fill: "none",
        viewBox: "0 0 20 18"
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fill: "#111C36",
            d: "M8.213 13.29c-1.256 0-2.278 1.056-2.278 2.355S6.957 18 8.213 18s2.278-1.056 2.278-2.355S9.47 13.29 8.213 13.29zm0 3.501c-.611 0-1.108-.514-1.108-1.146 0-.632.497-1.147 1.108-1.147.612 0 1.109.515 1.109 1.147s-.497 1.146-1.109 1.146zm6.968-3.501c-1.256 0-2.278 1.056-2.278 2.355S13.925 18 15.181 18s2.278-1.056 2.278-2.355-1.022-2.355-2.278-2.355zm0 3.501c-.611 0-1.108-.514-1.108-1.146 0-.632.497-1.147 1.108-1.147.612 0 1.109.515 1.109 1.147s-.497 1.146-1.109 1.146zm4.764-12.109l-1.476 6.424c-.21.917-.995 1.558-1.908 1.558H7.378c-.91 0-1.693-.637-1.907-1.55l-1.34-5.752-.97-4.153H.586A.595.595 0 010 .604C0 .271.262 0 .585 0h3.037c.27 0 .505.191.569.463l1.077 4.616 1.34 5.75a.786.786 0 00.77.627h9.183a.785.785 0 00.77-.63l1.476-6.423a.794.794 0 00-.15-.697.74.74 0 00-.621-.311H7.15a.595.595 0 01-.585-.605c0-.333.262-.604.585-.604h10.886c.612 0 1.158.274 1.538.77.38.497.512 1.11.37 1.726z"
        })
    }));
}
function CartIconV3(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        xmlns: "http://www.w3.org/2000/svg",
        width: "20",
        height: "20",
        fill: "none",
        viewBox: "0 0 20 20"
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fill: "#111C36",
            d: "M6.154 19.558c-.486 0-.9-.17-1.24-.511-.34-.34-.51-.753-.51-1.24 0-.485.17-.898.51-1.239.34-.34.754-.51 1.24-.51s.899.17 1.24.51c.34.34.51.754.51 1.24s-.17.899-.51 1.239c-.341.34-.754.51-1.24.51zm9.692 0c-.486 0-.899-.17-1.24-.511-.34-.34-.51-.753-.51-1.24 0-.485.17-.898.51-1.239.341-.34.754-.51 1.24-.51s.9.17 1.24.51c.34.34.51.754.51 1.24s-.17.899-.51 1.239c-.34.34-.754.51-1.24.51zM5.016 3.75L7.55 9.058h6.817a.28.28 0 00.154-.043.377.377 0 00.115-.12l2.683-4.876c.039-.07.042-.133.01-.187-.032-.055-.087-.082-.164-.082H5.015zm-.72-1.5h13.885c.409 0 .718.174.927.522.21.348.22.704.03 1.067l-3.204 5.803c-.163.289-.38.513-.65.674a1.7 1.7 0 01-.888.242H7.1l-1.158 2.115c-.051.077-.053.16-.005.25s.12.135.217.135h11.442v1.5H6.154c-.667 0-1.168-.288-1.503-.863-.335-.575-.347-1.149-.035-1.722l1.426-2.565L2.404 1.75H.5V.25h2.846l.95 2z"
        })
    }));
}
function SearchIconV1(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        xmlns: "http://www.w3.org/2000/svg",
        width: "18",
        height: "18",
        fill: "none",
        viewBox: "0 0 18 18"
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            stroke: "#111C36",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: "1.5",
            d: "M15.223 8.111a7.111 7.111 0 11-14.224 0 7.111 7.111 0 0114.225 0h-.001zM17 16.998l-3.867-3.867"
        })
    }));
}
function SearchIconV2(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        xmlns: "http://www.w3.org/2000/svg",
        width: "18",
        height: "18",
        fill: "none",
        viewBox: "0 0 18 18"
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fill: "#111C36",
            fillRule: "evenodd",
            d: "M7.615 1.385a6.23 6.23 0 100 12.461 6.23 6.23 0 000-12.461zM0 7.615a7.615 7.615 0 1113.468 4.874l4.33 4.33a.692.692 0 11-.98.978l-4.33-4.33A7.615 7.615 0 010 7.616z",
            clipRule: "evenodd"
        })
    }));
}
function ContactIconV1(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        xmlns: "http://www.w3.org/2000/svg",
        width: "20",
        height: "20",
        fill: "none",
        viewBox: "0 0 20 20"
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#111C36",
                d: "M12.152 11.57c-.138.021-.226.154-.364.362-.144.223-.31.479-.63.564-.171.048-.492.048-1.25-.474A11.523 11.523 0 018.457 10.8c-.763-.75-.774-.937-.774-1.006-.017-.309.238-.564.464-.788.138-.133.276-.271.32-.388.017-.085-.099-.469-.414-1.011-.315-.543-.597-.841-.685-.873-.011-.005-.033-.005-.055-.005-.16 0-.553.09-.896.393-.353.32-.707.937-.38 2.054.602 2.081 2.497 3.763 5.337 4.726.752.255 1.37.255 1.83-.01.64-.373.834-1.155.884-1.475.005-.026-.006-.053-.022-.074-.382-.383-1.564-.83-1.912-.772z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#111C36",
                stroke: "#111C36",
                strokeWidth: "0.2",
                d: "M1.076 8.937l-.1-.008a8.694 8.694 0 012.552-5.48l.07.071-.07-.07C5.192 1.804 7.42.9 9.8.9c2.466 0 4.796.96 6.561 2.704 1.733 1.712 2.706 3.973 2.737 6.366a8.616 8.616 0 01-2.58 6.305c-1.664 1.644-3.893 2.539-6.273 2.539h0a9.278 9.278 0 01-4.83-1.343l-3.76 1.581h0a.552.552 0 01-.213.048.546.546 0 01-.374-.148m.007-10.015l.061 9.942m-.061-9.942l-.1-.008a9.056 9.056 0 001.402 5.59M1.076 8.936l1.413 5.57m-1.42 4.445l.068-.073m-.068.073s0 0 0 0l.068-.073m-.068.073a.534.534 0 01-.135-.577h0l1.444-3.857m-1.24 4.36a.434.434 0 01-.11-.468l1.462-3.903m-.112.011l.028.043.083-.054m-.11.011l.017-.047.094.036m2.764 1.874l-2.864 1.2 1.102-2.943h0a.533.533 0 00-.06-.488h0c-2.148-3.145-1.783-7.325.863-9.94 1.459-1.44 3.414-2.234 5.506-2.234a8.2 8.2 0 015.794 2.39l.07-.072-.07.072c1.532 1.513 2.39 3.508 2.418 5.618a7.575 7.575 0 01-2.262 5.54c-1.458 1.441-3.413 2.235-5.505 2.235a8.2 8.2 0 01-4.482-1.332l-.054.084.054-.084a.547.547 0 00-.51-.046z"
            })
        ]
    }));
}

;// CONCATENATED MODULE: ./src/components/WidgetMaker/WidgetDnD/WidgetProperties/HeaderBuilder/NewHeaderConfig.ts



var POSITIONS_DATA = [
    {
        text: "Left",
        value: "left",
        iconBaseClass: "wb-sprite ic-align-left faded",
        iconActiveClass: "wb-sprite ic-align-left",
        itemLevelClass: "tw-w-[33%]"
    },
    {
        text: "Centre",
        value: "center",
        iconBaseClass: "wb-sprite ic-align-center faded",
        iconActiveClass: "wb-sprite ic-align-center",
        itemLevelClass: "tw-w-[33%]"
    },
    {
        text: "Right",
        value: "right",
        iconBaseClass: "wb-sprite ic-align-right faded",
        iconActiveClass: "wb-sprite ic-align-right",
        itemLevelClass: "tw-w-[33%]"
    }, 
];
var SEAECHDROPDOWNVALUE = [
    {
        name: "Icon",
        value: "icon"
    },
    {
        name: "Icon + Label",
        value: "labelIcon"
    },
    {
        name: "Field",
        value: "field"
    }, 
];
var HEADER_CONFIG = {
    desktopHeader: "header1",
    mobileHeader: "header5",
    globalClass: {
        staticClass: {
            base_config: {
                defaultFillColorType: "colors",
                defaultBackgroundColor: "#ffffff",
                defaultNavLinksColor: "#000000",
                defaultTextFontWeight: "400",
                defaultTextFontSize: "14px",
                defaulthoverType: "Underline",
                defaultUnderLineType: "above",
                defaultUnderlineColor: "#000000",
                defaultUnderlineTextColor: "#000000",
                defaultBoxBackgroundColor: "#F1F1F3",
                defaultBoxTextColor: "#000000",
                defaultTextFontWeightOnHover: "none",
                defaultSeparatorLine: [
                    ""
                ],
                defaultSeparator1Color: "#000000",
                defaultSeparator1Opacity: 10,
                defaultSeparator2Color: "#000000",
                defaultSeparator2Opacity: 10,
                defaultTextDecoration: "none",
                defaultHoverIconState: "none",
                defaultContentSize: "default",
                defaultFontSizeType: "n",
                defaultFontSizeTypeMobile: "n"
            },
            leftSectionConfig: {
                sectionTitle: {
                    data: {
                        section_title: "Header design",
                        tooltip: "Please select header1 to header6 to apply changes"
                    },
                    componentName: "sectionTitle"
                },
                headerFill: {
                    key: "defaultFillColorType",
                    label: "Header background",
                    data: [
                        {
                            text: "Colour",
                            value: "colors",
                            iconBaseClass: "wb-sprite ic-color-icon",
                            iconActiveClass: "wb-sprite ic-color-icon-active",
                            itemLevelClass: "tw-w-[50%]"
                        },
                        {
                            text: "Transparent",
                            value: "transparent",
                            iconBaseClass: "wb-sprite ic-transparent faded ",
                            iconActiveClass: "wb-sprite ic-transparent-active",
                            itemLevelClass: "tw-w-[50%]"
                        }, 
                    ],
                    componentName: "multiselect"
                },
                backgroundColors: {
                    key: [
                        "defaultBackgroundColor",
                        "defaultNavLinksColor"
                    ],
                    label: "Header colour",
                    data: {
                        normal: [
                            {
                                header: "#ffffff",
                                navLinks: "#000000",
                                isDefault: true
                            }, 
                        ],
                        transparent: [
                            {
                                header: "#0000001A",
                                navLinks: "#ffffff",
                                isDefault: true
                            }, 
                        ]
                    },
                    selectedIndexNormal: 0,
                    selectedIndexTransparent: 0,
                    restriction: 5
                },
                hoverState: {
                    types: [
                        {
                            type: "None",
                            sprite: "wb-sprite ic-none"
                        },
                        {
                            type: "Underline",
                            sprite: "wb-sprite ic-underline",
                            sprite1: "wb-sprite ic-underline-header"
                        },
                        {
                            type: "Background Box",
                            sprite: "wb-sprite ic-background-box"
                        }, 
                    ],
                    multiSelect: {
                        label: "Underline placement",
                        key: "defaultUnderLineType",
                        data: [
                            {
                                text: "Below Text",
                                value: "above",
                                itemLevelClass: "tw-w-[50%]"
                            },
                            {
                                text: "Below header",
                                value: "below",
                                itemLevelClass: "tw-w-[50%]"
                            }, 
                        ]
                    },
                    underline: {
                        key: [
                            "defaultUnderlineColor",
                            "defaultUnderlineTextColor"
                        ],
                        data: [
                            {
                                underline: "#000000",
                                text: "#000000"
                            }, 
                        ],
                        selectedIndex: 0
                    },
                    box: {
                        key: [
                            "defaultBoxBackgroundColor",
                            "defaultBoxTextColor"
                        ],
                        boxData: [
                            {
                                boxBackground: "#F1F1F3",
                                boxText: "#000000"
                            }, 
                        ],
                        selectedIndex: 0
                    },
                    selectedIndex: 1,
                    checkbox: [
                        {
                            key: "defaultTextFontWeightOnHover",
                            label: "Bold",
                            id: "logoCheckbox",
                            isChecked: false,
                            opType: "normal",
                            value: {
                                isChecked: "bold",
                                unChecked: "500"
                            }
                        }, 
                    ],
                    iconHoverState: {
                        label: "Icon hover interaction",
                        subLabel: "Search, Profile, Cart etc.",
                        placeholder: "Select icon hover state",
                        key: "defaultHoverIconState",
                        data: [
                            {
                                text: "None",
                                value: "none"
                            },
                            {
                                text: "Zoom In",
                                value: "zoomin"
                            },
                            {
                                text: "Background",
                                value: "background"
                            }, 
                        ]
                    },
                    label: "Navigation link hover interaction"
                },
                sepratorLine: {
                    label: "Separator line",
                    key: "separator",
                    separator1: {
                        label: "Line color 1",
                        key: [
                            "defaultSeparator1Color"
                        ],
                        data: [
                            {
                                lineColor: "#000000"
                            }, 
                        ],
                        selectedIndex: 0
                    },
                    separator2: {
                        label: "Line color 2",
                        key: [
                            "defaultSeparator2Color"
                        ],
                        data: [
                            {
                                lineColor: "#000000"
                            }, 
                        ],
                        selectedIndex: 0
                    },
                    checkbox: [
                        {
                            key: "defaultSeparatorLine",
                            label: "Add separator line (below header)",
                            id: "belowHeader",
                            isChecked: false,
                            opType: "addRemove",
                            value: {
                                isChecked: "BELOW_HEADER"
                            }
                        },
                        {
                            key: "defaultSeparatorLine",
                            label: "Add separator line (above nav links)",
                            id: "belowHeader",
                            isChecked: false,
                            opType: "addRemove",
                            value: {
                                isChecked: "ABOVE_NAVLINKS"
                            }
                        }, 
                    ]
                },
                textDetails: {
                    sectionTitle: {
                        data: {
                            section_title: "Header properties",
                            tooltip: "Please select header1 to header6 to apply changes"
                        },
                        componentName: "sectionTitle"
                    },
                    textCase: {
                        label: "Text Case",
                        placeholder: "Select Case Type",
                        key: "defaultTextDecoration",
                        data: [
                            {
                                text: "Default",
                                value: "none",
                                itemLevelClass: "tw-w-[33%]"
                            },
                            {
                                text: "Aa",
                                value: "capitalize",
                                itemLevelClass: "tw-w-[33%]"
                            },
                            {
                                text: "AA",
                                value: "uppercase",
                                itemLevelClass: "tw-w-[33%]"
                            }, 
                        ]
                    },
                    contentThicness: {
                        key: "defaultTextFontWeight",
                        placeholder: "Select Thickness Type",
                        label: "Navigation link thickness",
                        data: [
                            {
                                text: "Thin",
                                value: "300",
                                itemLevelClass: {
                                    fontWeight: "300 !important"
                                }
                            },
                            {
                                text: "Regular",
                                value: "400",
                                itemLevelClass: {
                                    fontWeight: "400 !important"
                                }
                            },
                            {
                                text: "Medium",
                                value: "500",
                                itemLevelClass: {
                                    fontWeight: "500 !important"
                                }
                            },
                            {
                                text: "Bold",
                                value: "700",
                                itemLevelClass: {
                                    fontWeight: "700 !important"
                                }
                            }, 
                        ]
                    },
                    contentSizeWeb: {
                        key: "defaultFontSizeType",
                        placeholder: "Select Content Size",
                        label: "Content Size Web",
                        data: [
                            {
                                text: "Extra small (11px)",
                                value: "n-3",
                                itemLevelClass: {
                                    fontSize: "11px !important"
                                }
                            },
                            {
                                text: "Small (13px)",
                                value: "n-1",
                                itemLevelClass: {
                                    fontSize: "13px !important"
                                }
                            },
                            {
                                text: "Default (14px)",
                                value: "n",
                                itemLevelClass: {
                                    fontSize: "14px !important"
                                }
                            },
                            {
                                text: "Large (15px)",
                                value: "n+1",
                                itemLevelClass: {
                                    fontSize: "15px !important"
                                }
                            },
                            {
                                text: "Extra Large (17px)",
                                value: "n+3",
                                itemLevelClass: {
                                    fontSize: "17px !important"
                                }
                            }, 
                        ]
                    },
                    contentSizeMobile: {
                        key: "defaultFontSizeTypeMobile",
                        placeholder: "Select Content Size",
                        label: "Content Size Mobile",
                        data: [
                            {
                                text: "Extra small (11px)",
                                value: "n-3",
                                itemLevelClass: {
                                    fontSize: "11px !important"
                                }
                            },
                            {
                                text: "Small (13px)",
                                value: "n-1",
                                itemLevelClass: {
                                    fontSize: "13px !important"
                                }
                            },
                            {
                                text: "Default (14px)",
                                value: "n",
                                itemLevelClass: {
                                    fontSize: "14px !important"
                                }
                            },
                            {
                                text: "Large (15px)",
                                value: "n+1",
                                itemLevelClass: {
                                    fontSize: "15px !important"
                                }
                            },
                            {
                                text: "Extra Large (17px)",
                                value: "n+3",
                                itemLevelClass: {
                                    fontSize: "17px !important"
                                }
                            }, 
                        ]
                    }
                }
            }
        },
        scrollClass: {
            base_config: {
                defaultFillColorType: "colors",
                defaultBackgroundColor: "#ffffff",
                defaultNavLinksColor: "#000000",
                defaultTextFontWeight: "400",
                defaultTextFontSize: "14px",
                defaulthoverType: "Underline",
                defaultUnderLineType: "above",
                defaultUnderlineColor: "#000000",
                defaultUnderlineTextColor: "#000000",
                defaultBoxBackgroundColor: "#F1F1F3",
                defaultBoxTextColor: "#000000",
                defaultTextFontWeightOnHover: "500",
                defaultSeparatorLine: [
                    ""
                ],
                defaultSeparator1Color: "#000000",
                defaultSeparator1Opacity: 30,
                defaultSeparator2Color: "#000000",
                defaultSeparator2Opacity: 30,
                defaultTextDecoration: "none",
                defaultHoverIconState: "none",
                defaultContentSize: "default",
                defaultFontSizeType: "n",
                defaultScrollType: "sticky"
            },
            leftSectionConfig: {
                sectionTitle: {
                    data: {
                        section_title: "Header scroll settings",
                        tooltip: "Please select header1 to header6 to apply changes"
                    },
                    componentName: "sectionTitle"
                },
                scrollOption: {
                    key: "defaultScrollType",
                    data: [
                        {
                            label: "Make header sticky on scroll",
                            id: "logoCheckbox",
                            value: "sticky"
                        },
                        {
                            label: "Show when scrolling up",
                            id: "logoCheckbox",
                            value: "scrollUp"
                        },
                        {
                            label: "Hide on scroll",
                            id: "logoCheckbox",
                            value: "hide"
                        }, 
                    ]
                },
                backgroundColors: {
                    key: [
                        "defaultBackgroundColor",
                        "defaultNavLinksColor"
                    ],
                    label: "Header colour",
                    data: {
                        transparent: [
                            {
                                header: "#ffffff",
                                navLinks: "#000000",
                                isDefault: true
                            }, 
                        ]
                    },
                    selectedIndexNormal: 0,
                    selectedIndexTransparent: 0,
                    restriction: 5
                },
                hoverState: {
                    types: [
                        {
                            type: "None",
                            sprite: "wb-sprite ic-none"
                        },
                        {
                            type: "Underline",
                            sprite: "wb-sprite ic-underline",
                            sprite1: "wb-sprite ic-underline-header"
                        },
                        {
                            type: "Background Box",
                            sprite: "wb-sprite ic-background-box"
                        }, 
                    ],
                    multiSelect: {
                        label: "Underline placement",
                        key: "defaultUnderLineType",
                        data: [
                            {
                                text: "Below Text",
                                value: "above",
                                itemLevelClass: "tw-w-[50%]"
                            },
                            {
                                text: "Below header",
                                value: "below",
                                itemLevelClass: "tw-w-[50%]"
                            }, 
                        ]
                    },
                    underline: {
                        key: [
                            "defaultUnderlineColor",
                            "defaultUnderlineTextColor"
                        ],
                        data: [
                            {
                                underline: "#000000",
                                text: "#000000"
                            }, 
                        ],
                        selectedIndex: 0
                    },
                    box: {
                        key: [
                            "defaultBoxBackgroundColor",
                            "defaultBoxTextColor"
                        ],
                        boxData: [
                            {
                                boxBackground: "#F1F1F3",
                                boxText: "#000000"
                            }, 
                        ],
                        selectedIndex: 0
                    },
                    selectedIndex: 1,
                    checkbox: [
                        {
                            key: "defaultTextFontWeightOnHover",
                            label: "Bold",
                            id: "logoCheckbox",
                            isChecked: false,
                            opType: "normal",
                            value: {
                                isChecked: "bold",
                                unChecked: "500"
                            }
                        }, 
                    ],
                    iconHoverState: {
                        label: "Icon hover interaction",
                        subLabel: "Search, Profile, Cart etc.",
                        key: "defaultHoverIconState",
                        data: [
                            {
                                text: "None",
                                value: "none"
                            },
                            {
                                text: "Zoom In",
                                value: "zoomin"
                            },
                            {
                                text: "Background",
                                value: "background"
                            }, 
                        ]
                    },
                    label: "Navigation link hover interaction"
                }
            }
        }
    },
    logo_section: {
        customClass: "",
        componentName: "LogoRenderer",
        staticLogo: {
            sectionId: "logo-section",
            componentData: {
                url: "",
                src: "",
                storeName: "Blue tokai"
            },
            base_config: {
                section_title: "Logo",
                defaultDesktopSize: 60,
                defaultMobileSize: 48,
                showLogo: true,
                showStoreName: false,
                customClass: "",
                tooltip: "Please select from header 1 to 6 to configure."
            },
            leftSectionConfig: {
                slider: [
                    {
                        key: "defaultMobileSize",
                        value: {
                            min: 16,
                            value: 48,
                            max: 144
                        }
                    },
                    {
                        key: "defaultDesktopSize",
                        value: {
                            min: 20,
                            value: 60,
                            max: 180
                        }
                    }, 
                ],
                checkbox: [
                    {
                        key: "showLogo",
                        label: "Hide logo",
                        isChecked: false,
                        id: "logoCheckbox",
                        value: false
                    },
                    {
                        key: "showStoreName",
                        label: "Hide Store name",
                        isChecked: true,
                        id: "storeNameCheckBox",
                        value: false
                    }, 
                ]
            }
        },
        scrollLogo: {
            sectionId: "logo-section",
            componentData: {
                url: "",
                src: "",
                storeName: "shree ram"
            },
            base_config: {
                section_title: "Logo",
                defaultDesktopSize: 60,
                defaultMobileSize: 48,
                showLogo: true,
                showStoreName: false,
                tooltip: "Please select from header 1 to 6 to configure."
            },
            leftSectionConfig: {
                slider: [
                    {
                        key: "defaultMobileSize",
                        value: {
                            min: 16,
                            value: 48,
                            max: 144
                        }
                    },
                    {
                        key: "defaultDesktopSize",
                        value: {
                            min: 20,
                            value: 60,
                            max: 180
                        }
                    }, 
                ],
                checkbox: [
                    {
                        key: "showLogo",
                        label: "Hide logo",
                        id: "logoCheckbox",
                        value: true
                    },
                    {
                        key: "showStoreName",
                        label: "Hide Store name",
                        id: "storeNameCheckBox",
                        value: true
                    }, 
                ]
            }
        }
    },
    navLinks_section: {
        componentName: "NavLinkRenderer",
        sectionId: "navLinks-section",
        componentData: [],
        base_config: {
            section_title: "Nav link settings",
            type: "flatElement",
            defaultPosition: "center",
            customClass: "",
            tooltip: "Please select header1 to header6 to apply changes"
        },
        leftSectionConfig: {
            sectionTitle: {
                data: {
                    section_title: "Menu",
                    tooltip: "Please select header1 to header6 to apply changes"
                },
                componentName: "sectionTitle"
            },
            positions: {
                key: "defaultPosition",
                value: POSITIONS_DATA,
                renderCondition: [
                    "header1"
                ]
            }
        }
    },
    navIcons_section: {
        componentName: "NavIconRenderer",
        sectionId: "navIcons-section",
        componentData: {
            appearanceType: "icon",
            iconsList: [
                {
                    spriteDetail: "",
                    ImageComponent: SearchIconV1,
                    id: 0,
                    defaultPosition: 0,
                    label: "Search",
                    name: "search",
                    visibility: {
                        desktopHeader: true,
                        mobileHeader: true,
                        hamburger: false
                    }
                },
                {
                    name: "loginLogout",
                    spriteDetail1: "wb-sprite ic-user-16",
                    spriteDetail2: "wb-sprite ic-user-20",
                    spriteDetail: "wb-sprite ic-user",
                    spriteDetail3: "wb-sprite ic-user-28",
                    spriteDetail4: "wb-sprite ic-user-32",
                    ImageComponent: UserIconV1,
                    id: 1,
                    label: "My Orders",
                    elementLevelClass: "",
                    action: {
                        isCta: true,
                        actionType: "login-logout",
                        actionData: ""
                    },
                    visibility: {
                        desktopHeader: true,
                        mobileHeader: false,
                        hamburger: true
                    }
                },
                {
                    name: "contact",
                    spriteDetail1: "wb-sprite ic-align-left-new",
                    spriteDetail2: "wb-sprite backword-arrow",
                    spriteDetail: "wb-sprite ic-whatsapp",
                    spriteDetail3: "wb-sprite ic-none",
                    spriteDetail4: "wb-sprite ic-none",
                    ImageComponent: ContactIconV1,
                    id: 2,
                    elementLevelClass: "",
                    label: "Whatsapp",
                    action: {
                        isCta: true,
                        actionType: "whatsapp",
                        actionData: ""
                    },
                    visibility: {
                        desktopHeader: true,
                        mobileHeader: false,
                        hamburger: true
                    }
                },
                {
                    name: "wishlist",
                    spriteDetail: "wb-sprite ic-cart-16",
                    ImageComponent: WishlistIcon,
                    id: 4,
                    label: "Wishlist",
                    elementLevelClass: "",
                    action: {
                        isCta: true,
                        actionType: "redirect",
                        actionData: "/wishlist"
                    },
                    visibility: {
                        desktopHeader: true,
                        mobileHeader: true,
                        hamburger: false
                    }
                },
                {
                    name: "cart",
                    spriteDetail1: "wb-sprite ic-cart-16",
                    spriteDetail2: "wb-sprite ic-cart-20",
                    spriteDetail: "wb-sprite ic-cart",
                    spriteDetail3: "wb-sprite ic-cart-28",
                    spriteDetail4: "wb-sprite ic-cart-32",
                    ImageComponent: CartIconV1,
                    id: 3,
                    label: "Cart",
                    elementLevelClass: "",
                    action: {
                        isCta: true,
                        actionType: "redirect",
                        actionData: "/cart"
                    },
                    visibility: {
                        desktopHeader: true,
                        mobileHeader: true,
                        hamburger: false
                    }
                }, 
            ]
        },
        base_config: {
            section_title: "Header icons",
            defaultPosition: "right",
            customClass: "",
            tooltip: "Please select header1 to header6 to apply changes"
        },
        leftSectionConfig: {
            sectionTitle: {
                data: {
                    section_title: "Icon appearance",
                    tooltip: "Please select header1 to header6 to apply changes"
                },
                componentName: "sectionTitle"
            },
            appearanceType: [
                {
                    label: "Icon",
                    type: "icon"
                },
                {
                    label: "Icon + Text",
                    type: "icon-text"
                },
                {
                    label: "Text only",
                    type: "text"
                }, 
            ],
            appearanceVariants: {
                searchIcon: {
                    variants: [
                        {
                            spriteDetail: "",
                            ImageComponent: SearchIconV1,
                            id: 0
                        },
                        {
                            spriteDetail: "",
                            ImageComponent: SearchIconV2,
                            id: 1
                        }, 
                    ],
                    details: {
                        defaultPosition: 0,
                        label: "Search",
                        name: "search"
                    }
                },
                contactIcon: {
                    variants: [
                        {
                            spriteDetail: "",
                            ImageComponent: ContactIconV1,
                            id: 0
                        }, 
                    ],
                    details: {
                        defaultPosition: 2,
                        name: "contact",
                        label: "Contact",
                        action: {
                            isCta: true,
                            actionType: "whatsapp",
                            actionData: ""
                        }
                    }
                },
                userIcon: {
                    variants: [
                        {
                            spriteDetail: "",
                            ImageComponent: UserIconV1,
                            id: 0
                        },
                        {
                            spriteDetail: "",
                            ImageComponent: UserIconV2,
                            id: 1
                        }, 
                    ],
                    details: {
                        defaultPosition: 1,
                        name: "loginLogout",
                        label: "User",
                        action: {
                            isCta: true,
                            actionType: "login-logout",
                            actionData: ""
                        }
                    }
                },
                cartIcon: {
                    variants: [
                        {
                            spriteDetail: "",
                            ImageComponent: CartIconV1,
                            id: 0
                        },
                        {
                            spriteDetail: "",
                            ImageComponent: CartIconV2,
                            id: 1
                        },
                        {
                            spriteDetail: "",
                            ImageComponent: CartIconV3,
                            id: 2
                        }, 
                    ],
                    details: {
                        defaultPosition: 3,
                        name: "cart",
                        label: "Cart",
                        action: {
                            isCta: true,
                            actionType: "redirect",
                            actionData: "/cart"
                        }
                    }
                }
            }
        }
    },
    dynamic_section: {
        componentName: "dynamicComponent",
        sectionId: "dynamic-section",
        componentData: {
            search: {
                type: "search",
                placeholder: "",
                action: {}
            }
        },
        base_config: {
            section_title: "Search settings",
            defaultPosition: "left",
            defaultType: "icon",
            searchAlignment: {},
            customClass: "",
            tooltip: "Please select header1 to header6 to apply changes",
            showSearch: true,
            showSearchAlignment: [
                "header3",
                "header4",
                "header6"
            ],
            placeholderMaxLength: 60,
            defaultPlaceholder: "Search store",
            placeholder: [
                {
                    label: "Placeholder 1",
                    value: "Search store"
                }, 
            ]
        },
        leftSection_config: {
            search: {
                positions: {
                    key: "defaultPosition",
                    value: POSITIONS_DATA
                },
                dropdown: {
                    key: "defaultType",
                    value: SEAECHDROPDOWNVALUE
                }
            }
        }
    },
    announcementConfig: (0,_object_spread/* default */.Z)({}, AnnouncementConfig/* AnnouncementConfig */.Jn)
};


/***/ }),

/***/ 101813:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": function() { return /* binding */ useOldNavLinksList; },
/* harmony export */   "s": function() { return /* binding */ useGetCategoriesList; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(629815);
/* harmony import */ var _components_DesignSystem_Drawer_MenuDrawerMobile_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(572164);
/* harmony import */ var _redux_ssrStore__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(326706);
/* harmony import */ var _utils_emoticonsStatus__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(218626);
/* harmony import */ var _utils_isPLPRequiredSystem__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(586423);
/* harmony import */ var _utils_routes__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(540190);
/* harmony import */ var _utils_routeToCollectionPage__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(385618);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(811163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(667294);
/* harmony import */ var src_redux_store__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(167261);
// import { toggleRfqFormModal } from '@/redux/actions';
// import { useSSRSelector } from '@/redux/ssrStore';
// import { STORE_CUSTOMIZATION } from '@/utils/constants';
// import { deviceWidth } from '@/utils/deviceWidth';
// import { getStoreType } from '@/utils/getStoreType';
// import { getRoute, PATH } from '@/utils/routes';
// import { useRouter } from 'next/router';
// import { useState } from 'react';
// import { useDispatch } from 'react-redux';










var generateCategoryMenuItem = function(categories) {
    var ref, ref1;
    var storeData = (ref = src_redux_store__WEBPACK_IMPORTED_MODULE_6__/* ["default"].getState */ .Z.getState()) === null || ref === void 0 ? void 0 : (ref1 = ref.storeReducer) === null || ref1 === void 0 ? void 0 : ref1.store;
    var onCategoriesLinkHandle = function(category) {
        var ref, ref1, ref2;
        var route = (0,_utils_routes__WEBPACK_IMPORTED_MODULE_2__.getRoute)("".concat((0,_utils_isPLPRequiredSystem__WEBPACK_IMPORTED_MODULE_7__/* .isPLPRequiredSystem */ .q)(storeData === null || storeData === void 0 ? void 0 : (ref = storeData.theme) === null || ref === void 0 ? void 0 : ref.theme_class) ? _utils_routes__WEBPACK_IMPORTED_MODULE_2__.PATH.SHOP : _utils_routes__WEBPACK_IMPORTED_MODULE_2__.PATH.PRODUCT, "?cid=").concat(category.id), storeData === null || storeData === void 0 ? void 0 : (ref1 = storeData.store_info) === null || ref1 === void 0 ? void 0 : ref1.domain);
        if ((0,_utils_isPLPRequiredSystem__WEBPACK_IMPORTED_MODULE_7__/* .isPLPRequiredSystem */ .q)(storeData === null || storeData === void 0 ? void 0 : (ref2 = storeData.theme) === null || ref2 === void 0 ? void 0 : ref2.theme_class)) {
            window.location.href = route;
        } else {
            next_router__WEBPACK_IMPORTED_MODULE_4___default().push(route, undefined, {
                shallow: true
            });
        }
    };
    var categoriesMap = categories.reduce(function(coll, item) {
        var _status;
        coll[item.id] = {
            name: (0,_utils_emoticonsStatus__WEBPACK_IMPORTED_MODULE_8__/* .removeEmoticons */ ._)(item.name) || "Available Items",
            showOnHeader: (_status = item.status) !== null && _status !== void 0 ? _status : 1,
            type: "text",
            onClick: function() {
                return onCategoriesLinkHandle(item);
            },
            id: item.id
        };
        return coll;
    }, {});
    return categoriesMap;
};
function useGetCategoriesList() {
    var ref = (0,_redux_ssrStore__WEBPACK_IMPORTED_MODULE_1__/* .useSSRSelector */ .kF)(function(state) {
        return {
            categories: state.catalogReducer.categories,
            productTags: state.catalogReducer.productTags
        };
    }), productTags = ref.productTags, categories = ref.categories;
    return (0,react__WEBPACK_IMPORTED_MODULE_5__.useMemo)(function() {
        var concatCategories = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(productTags || []).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(categories || []));
        if (!(concatCategories === null || concatCategories === void 0 ? void 0 : concatCategories.length)) return {};
        return generateCategoryMenuItem(concatCategories);
    }, [
        productTags,
        categories
    ]);
}
var useOldNavLinksList = function() {
    var ref = (0,_redux_ssrStore__WEBPACK_IMPORTED_MODULE_1__/* .useSSRSelector */ .kF)(function(state) {
        return {
            navigationList: state.additionalPagesReducer.navigationList,
            categories: state.catalogReducer.categories,
            productTags: state.catalogReducer.productTags,
            collections: state.catalogReducer.collections
        };
    }), navigationList = ref.navigationList, productTags = ref.productTags, categories = ref.categories, collections = ref.collections;
    var oldNavItemsList = (0,_components_DesignSystem_Drawer_MenuDrawerMobile_utils__WEBPACK_IMPORTED_MODULE_0__/* .useGetNavList */ .Yt)(navigationList);
    var categoriesList = useGetCategoriesList();
    var collectionCategoriesList = (0,react__WEBPACK_IMPORTED_MODULE_5__.useMemo)(function() {
        if (!(collections === null || collections === void 0 ? void 0 : collections.length)) return {};
        var collectionMap = collections === null || collections === void 0 ? void 0 : collections.reduce(function(coll, item) {
            coll[item.id] = {
                name: (0,_utils_emoticonsStatus__WEBPACK_IMPORTED_MODULE_8__/* .removeEmoticons */ ._)(item.name),
                showOnHeader: item.status === "A",
                type: "text",
                onClick: function() {
                    return (0,_utils_routeToCollectionPage__WEBPACK_IMPORTED_MODULE_3__/* .routeToCollectionPage */ .L)(item);
                },
                option: generateCategoryMenuItem(item.categories)
            };
            return coll;
        }, {});
        return collectionMap;
    }, [
        productTags,
        categories,
        collections
    ]);
    var defaultNavItemsList = (0,react__WEBPACK_IMPORTED_MODULE_5__.useMemo)(function() {
        var shopDrowdownList = Object.values(categoriesList);
        var list = function convertOldNavListToNew(oldNavItemsList) {
            return oldNavItemsList === null || oldNavItemsList === void 0 ? void 0 : oldNavItemsList.map(function(item) {
                var ref;
                var isDropdownAvailable = ((ref = item.subNavs) === null || ref === void 0 ? void 0 : ref.length) || item.page_type === "shop" && (shopDrowdownList === null || shopDrowdownList === void 0 ? void 0 : shopDrowdownList.length);
                var _status;
                return {
                    redirectionLink: !isDropdownAvailable ? item.slug_url : "",
                    name: item.page_name,
                    showOnHeader: (_status = item.status) !== null && _status !== void 0 ? _status : 1,
                    option: item.subNavs ? convertOldNavListToNew(item.subNavs) : item.page_type === "shop" ? shopDrowdownList : null,
                    type: isDropdownAvailable ? "dropdown" : "text",
                    isDefaultNavList: true,
                    id: item.page_id,
                    isShopComponent: item.page_type === "shop"
                };
            });
        }(oldNavItemsList);
        return list;
    }, [
        productTags,
        categories,
        collectionCategoriesList,
        oldNavItemsList
    ]);
    return {
        defaultNavItemsList: defaultNavItemsList,
        categoriesList: categoriesList,
        collectionCategoriesList: collectionCategoriesList
    };
};


/***/ }),

/***/ 565286:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ HEADER_INITIATOR_TYPE; }
/* harmony export */ });
var HEADER_INITIATOR_TYPE = {
    HEADER: "headerOutline",
    ANNOUNCEMENT: "headerAnnouncementOutline"
};


/***/ }),

/***/ 578943:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ DEFAULT_ANNUNCEMENT; }
/* harmony export */ });
var DEFAULT_ANNUNCEMENT = {
    announcementText: "Highlight promotions, sales, or updates here.",
    textCharCount: 0,
    redirectUrl: "",
    redirectionType: "link",
    isOpenInNewTab: true,
    isVisible: true
};


/***/ }),

/***/ 939597:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ NEW_ANNOUNCEMENT_BAR_PRESENTATION_CONFIG; }
/* harmony export */ });
/* unused harmony export DEFAULT_COLOR_CONFIG */
/* harmony import */ var src_constants_widgets__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(442381);
/* harmony import */ var _Constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(889489);


var DEFAULT_COLOR_CONFIG = {
    background: "#ffffff",
    text: "#111C36",
    isDefault: true
};
var NEW_ANNOUNCEMENT_BAR_PRESENTATION_CONFIG = {
    layoutName: "layout1",
    viewLabel: src_constants_widgets__WEBPACK_IMPORTED_MODULE_0__/* .ADMIN_WIDGETS.NEW_ANNOUNCEMENT_BAR.label */ .Pe.NEW_ANNOUNCEMENT_BAR.label,
    widgetName: src_constants_widgets__WEBPACK_IMPORTED_MODULE_0__/* .ADMIN_WIDGETS.NEW_ANNOUNCEMENT_BAR.name */ .Pe.NEW_ANNOUNCEMENT_BAR.name,
    layoutType: "carousel",
    heading: "",
    descriptionPosition: "below",
    textAlign: "center",
    headingCharCount: 0,
    description: "",
    descriptionCharCount: 0,
    type: src_constants_widgets__WEBPACK_IMPORTED_MODULE_0__/* .ADMIN_WIDGETS.NEW_ANNOUNCEMENT_BAR.type */ .Pe.NEW_ANNOUNCEMENT_BAR.type,
    colors: {
        selectedColorSchemeIndex: 0,
        colorSchemes: [
            {
                background: "#ffffff",
                text: "#111C36",
                isDefault: true
            },
            {
                background: "#000000",
                text: "#ffffff",
                isDefault: false
            }, 
        ]
    },
    appearance: "standard",
    backgroundColor: "#FFFFFF",
    borderColor: "#E2E4E7",
    numColumnsDesktop: 1,
    numColumnsMobile: 1,
    mobilePaddingY: 6,
    paddingY: 8,
    marginTop: 0,
    marginBottom: 0,
    autoPlayConfig: {
        type: _Constants__WEBPACK_IMPORTED_MODULE_1__/* .SCROLL_TYPE.AUTO_ROTATE */ .ej.AUTO_ROTATE,
        autoplayTimer: 30,
        autoRotateTimer: 4
    },
    seperator: _Constants__WEBPACK_IMPORTED_MODULE_1__/* .SEPERATOR_TYPE.DOT */ .WY.DOT,
    colGap: 24,
    colGapMobile: 20,
    showArrow: true
};


/***/ }),

/***/ 935789:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "NEW_ANNOUNCEMENT_BAR_PRESENTATION_CONFIG": function() { return /* reexport */ ListPresentationConfig/* NEW_ANNOUNCEMENT_BAR_PRESENTATION_CONFIG */.L; },
  "NEW_ANNOUNCEMENT_CARD_CONFIG": function() { return /* reexport */ NEW_ANNOUNCEMENT_CARD_CONFIG; }
});

// EXTERNAL MODULE: ./node_modules/lodash/cloneDeep.js
var cloneDeep = __webpack_require__(150361);
var cloneDeep_default = /*#__PURE__*/__webpack_require__.n(cloneDeep);
// EXTERNAL MODULE: ./src/components/WidgetMaker/WidgetDnD/WidgetProperties/NewAnnouncementBar/Constants/index.tsx
var Constants = __webpack_require__(889489);
// EXTERNAL MODULE: ./src/components/WidgetMaker/WidgetDnD/WidgetProperties/NewAnnouncementBar/Config/DefaultConfigs.ts
var DefaultConfigs = __webpack_require__(578943);
;// CONCATENATED MODULE: ./src/components/WidgetMaker/WidgetDnD/WidgetProperties/NewAnnouncementBar/Config/CardFrameConfig.ts



var NEW_ANNOUNCEMENT_CARD_CONFIG = {
    hoverEffect: "zoomIn",
    textAlign: "center",
    textSizeDesktop: "medium",
    textSizeMobile: "small",
    textThickness: "regular",
    textCase: "none",
    textAnimationType: Constants/* ANIMATION_TYPE.FADE_IN */.vR.FADE_IN,
    announcementList: [
        cloneDeep_default()(DefaultConfigs/* DEFAULT_ANNUNCEMENT */.f)
    ]
};

// EXTERNAL MODULE: ./src/components/WidgetMaker/WidgetDnD/WidgetProperties/NewAnnouncementBar/Config/ListPresentationConfig.ts
var ListPresentationConfig = __webpack_require__(939597);
;// CONCATENATED MODULE: ./src/components/WidgetMaker/WidgetDnD/WidgetProperties/NewAnnouncementBar/Config/index.ts




/***/ }),

/***/ 889489:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "It": function() { return /* binding */ SEPERATOR_TYPE_OPTIONS; },
/* harmony export */   "Um": function() { return /* binding */ CONFIG_TYPE; },
/* harmony export */   "WY": function() { return /* binding */ SEPERATOR_TYPE; },
/* harmony export */   "ej": function() { return /* binding */ SCROLL_TYPE; },
/* harmony export */   "fr": function() { return /* binding */ AUTO_PLAY_SPEED_OPTIONS; },
/* harmony export */   "hn": function() { return /* binding */ CONTENT_ANIMATION_TYPE_OPTIONS; },
/* harmony export */   "ot": function() { return /* binding */ ANIMATION_TYPE_MAP; },
/* harmony export */   "vR": function() { return /* binding */ ANIMATION_TYPE; },
/* harmony export */   "xA": function() { return /* binding */ ELEMENT_TYPE; }
/* harmony export */ });
/* unused harmony export getSeperator */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(414924);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(785893);
/* harmony import */ var _Utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(154697);
/* harmony import */ var src_components_WidgetMaker_WidgetDnD_WIdgetPropertiesBasic_EcommWidgets_HeroBanner_Svgs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(837210);




var SEPERATOR_TYPE = {
    CIRCLE_OUTLINE: "circleOutline",
    DOT: "dot",
    DIAMOND_OUTLINE: "diamondOutline",
    DIAMOND: "diamond",
    SQUARE: "square",
    SQUARE_ROUNDED: "squareRounded",
    SQUARE_OUTLINE: "squareOutline",
    DIAMOND_GROUP: "diamondGroup",
    VERIFIED_SOLID: "verifiedSolid",
    VERIFIED_OUTLINE: "verifiedOutline"
};
function getSeperator(seperatorType) {
    var SeperatorIcon = (0,_Utils__WEBPACK_IMPORTED_MODULE_1__/* .getSeperatorByType */ .W)(seperatorType);
    return SeperatorIcon ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SeperatorIcon, {}) : null;
}
var SEPERATOR_TYPE_OPTIONS = Object.values(SEPERATOR_TYPE).map(function(value) {
    return {
        value: value,
        renderData: function() {
            return getSeperator(value);
        }
    };
});
var CONFIG_TYPE = {
    LAYOUT: "layout",
    CARD: "card"
};
var ELEMENT_TYPE = {
    COLOR_COMBINATION: "colorsCombination",
    SLIDER: "slider",
    DROPDOWN: "dropdown",
    MULTI_SELECT: "multiselect",
    RADIO_BUTTON: "radioButton",
    CHECKBOX: "checkbox",
    ANIMATION_SELECTOR: "contentAnimation",
    CONTENT_ANIMATION: "contentAnimation"
};
var AUTO_PLAY_SPEED_OPTIONS = [
    {
        text: "0.5x",
        value: 45
    },
    {
        text: "1x",
        value: 30
    },
    {
        text: "1.5x",
        value: 22.5
    },
    {
        text: "2x",
        value: 15
    }, 
];
var SCROLL_TYPE = {
    MANUAL: "manual",
    AUTO_SCROLL: "autoScroll",
    AUTO_ROTATE: "autoRotate"
};
var ANIMATION_TYPE = {
    NONE: "none",
    FADE_IN: "fadeIn",
    MOVE_DOWN: "moveDown",
    MOVE_UP: "moveUp",
    SLIDE_LEFT: "slideLeft",
    SLIDE_RIGHT: "slideRight"
};
var CONTENT_ANIMATION_TYPE_OPTIONS = [
    {
        animeType: "none",
        animationName: "None"
    },
    {
        animeType: "fadeIn",
        Icon: src_components_WidgetMaker_WidgetDnD_WIdgetPropertiesBasic_EcommWidgets_HeroBanner_Svgs__WEBPACK_IMPORTED_MODULE_2__/* .CONTENT_ANIMATION_ICONS.Expand */ .le.Expand,
        animationName: "Fade in"
    },
    {
        animeType: "moveDown",
        Icon: src_components_WidgetMaker_WidgetDnD_WIdgetPropertiesBasic_EcommWidgets_HeroBanner_Svgs__WEBPACK_IMPORTED_MODULE_2__/* .CONTENT_ANIMATION_ICONS.Up */ .le.Up,
        animationName: "Slide in bottom"
    },
    {
        animeType: "moveUp",
        Icon: src_components_WidgetMaker_WidgetDnD_WIdgetPropertiesBasic_EcommWidgets_HeroBanner_Svgs__WEBPACK_IMPORTED_MODULE_2__/* .CONTENT_ANIMATION_ICONS.Down */ .le.Down,
        animationName: "Slide in top"
    },
    {
        animeType: "slideLeft",
        Icon: src_components_WidgetMaker_WidgetDnD_WIdgetPropertiesBasic_EcommWidgets_HeroBanner_Svgs__WEBPACK_IMPORTED_MODULE_2__/* .CONTENT_ANIMATION_ICONS.Right */ .le.Right,
        animationName: "Slide in right"
    },
    {
        animeType: "slideRight",
        Icon: src_components_WidgetMaker_WidgetDnD_WIdgetPropertiesBasic_EcommWidgets_HeroBanner_Svgs__WEBPACK_IMPORTED_MODULE_2__/* .CONTENT_ANIMATION_ICONS.Left */ .le.Left,
        animationName: "Slide in left"
    }, 
];
var _obj;
var ANIMATION_TYPE_MAP = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, ANIMATION_TYPE.NONE, {
    animeClassName: "",
    animationName: "None"
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, ANIMATION_TYPE.FADE_IN, {
    animeClassName: "widgetContentFadeInWrapper",
    animationName: "Fade in"
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, ANIMATION_TYPE.MOVE_DOWN, {
    animeClassName: "widgetContentMoveDownWrapper",
    animationName: "Slide in bottom"
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, ANIMATION_TYPE.MOVE_UP, {
    animeClassName: "widgetContentMoveUpWrapper",
    animationName: "Slide in top"
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, ANIMATION_TYPE.SLIDE_LEFT, {
    animeClassName: "widgetContentSlideLeftWrapper",
    animationName: "Slide in right"
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, ANIMATION_TYPE.SLIDE_RIGHT, {
    animeClassName: "widgetContentSlideRightWrapper",
    animationName: "Slide in left"
}), _obj);


/***/ }),

/***/ 154697:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "s": function() { return /* binding */ getAnnouncementSeperatorOptionsAndMap; },
  "W": function() { return /* binding */ getSeperatorByType; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(626042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(269396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(999534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(785893);
;// CONCATENATED MODULE: ./src/components/WidgetMaker/WidgetDnD/WidgetProperties/NewAnnouncementBar/Components/Seperators.tsx




var CircleOutline = function(_param) /*#__PURE__*/ {
    var _color = _param.color, color = _color === void 0 ? "black" : _color, restProps = (0,_object_without_properties/* default */.Z)(_param, [
        "color"
    ]);
    return (0,jsx_runtime.jsxs)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: color,
        xmlns: "http://www.w3.org/2000/svg"
    }, restProps), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                "clip-path": "url(#clip0_507_802)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("mask", {
                        id: "mask0_507_802",
                        x: "0",
                        y: "0",
                        width: "20",
                        height: "20",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M0 0H20V20H0V0Z",
                            fill: "white"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                        mask: "url(#mask0_507_802)",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M10 7C11.655 7 13 8.345 13 10C13 11.655 11.655 13 10 13C8.345 13 7 11.655 7 10C7 8.345 8.345 7 10 7ZM10 6C7.79 6 6 7.79 6 10C6 12.21 7.79 14 10 14C12.21 14 14 12.21 14 10C14 7.79 12.21 6 10 6Z",
                            fill: color
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_507_802",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "20",
                        height: "20",
                        fill: "white"
                    })
                })
            })
        ]
    }));
};
var DiamondGroup = function(_param) /*#__PURE__*/ {
    var _color = _param.color, color = _color === void 0 ? "black" : _color, restProps = (0,_object_without_properties/* default */.Z)(_param, [
        "color"
    ]);
    return (0,jsx_runtime.jsxs)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: color,
        xmlns: "http://www.w3.org/2000/svg"
    }, restProps), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M7.73792 6.08903C7.57499 6.25197 7.57499 6.51615 7.73792 6.67908L9.7047 8.64586C9.86764 8.8088 10.1318 8.8088 10.2948 8.64586L12.2616 6.67903C12.4245 6.5161 12.4245 6.25192 12.2616 6.08898L10.2948 4.12221C10.1319 3.95926 9.86769 3.95926 9.70475 4.12221L7.73792 6.08903Z",
                fill: color
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M11.3541 10.295L13.3209 12.2618C13.4838 12.4248 13.748 12.4248 13.911 12.2618L15.8778 10.295C16.0407 10.132 16.0407 9.86791 15.8778 9.70497L13.911 7.73817C13.7481 7.57523 13.4839 7.57523 13.3209 7.73817L11.3541 9.70502C11.1912 9.86796 11.1912 10.1321 11.3541 10.295Z",
                fill: color
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M4.1222 9.70502C3.95927 9.86796 3.95927 10.1321 4.1222 10.295L6.08898 12.2618C6.25192 12.4248 6.51609 12.4248 6.67903 12.2618L8.64586 10.295C8.80879 10.132 8.80879 9.86791 8.64586 9.70497L6.67908 7.73817C6.51614 7.57523 6.25197 7.57523 6.08903 7.73817L4.1222 9.70502Z",
                fill: color
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M7.73792 13.321C7.57499 13.4839 7.57499 13.7481 7.73792 13.911L9.7047 15.8778C9.86764 16.0408 10.1318 16.0408 10.2948 15.8778L12.2616 13.911C12.4245 13.748 12.4245 13.4839 12.2616 13.3209L10.2948 11.3541C10.1319 11.1912 9.86769 11.1912 9.70475 11.3541L7.73792 13.321Z",
                fill: color
            })
        ]
    }));
};
var DiamondOutlined = function(_param) /*#__PURE__*/ {
    var _color = _param.color, color = _color === void 0 ? "black" : _color, restProps = (0,_object_without_properties/* default */.Z)(_param, [
        "color"
    ]);
    return (0,jsx_runtime.jsx)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: color,
        xmlns: "http://www.w3.org/2000/svg"
    }, restProps), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M9.98505 16.9963H9.98231C9.7746 16.9963 9.48489 16.9143 9.2799 16.5344C8.52283 15.1405 7.59356 13.8478 6.51398 12.6889C5.81703 11.9346 5.05176 11.2486 4.22635 10.6363C3.87651 10.3904 3.79179 9.90934 4.03777 9.5595C4.09243 9.48024 4.16349 9.41191 4.24549 9.35725C4.90417 8.89808 5.55192 8.33506 6.28166 7.58892C7.26012 6.58039 8.12379 5.46254 8.85353 4.25997C8.9246 4.14518 8.99019 4.02492 9.06125 3.8992C9.14598 3.74614 9.23617 3.58762 9.33183 3.43183C9.40563 3.32251 9.49855 3.22685 9.60514 3.15032C9.61608 3.14212 9.62428 3.13392 9.63247 3.12846L9.76913 3L9.95772 3.01093C10.2966 3.0328 10.5344 3.16945 10.7011 3.45097C10.7941 3.60675 10.8897 3.76527 10.9799 3.91833C11.2396 4.35563 11.5074 4.8066 11.7916 5.2275C12.5515 6.35354 13.4452 7.3812 14.4537 8.29133C14.7817 8.58651 15.1343 8.87075 15.4759 9.1468C15.5743 9.22606 15.6727 9.30532 15.7711 9.38731C15.9843 9.56223 16.1045 9.80548 16.0936 10.0542C16.0826 10.2947 15.9597 10.5134 15.7601 10.65C14.9921 11.1912 14.2542 11.8499 13.437 12.7245C12.3656 13.8778 11.4418 15.1624 10.6847 16.5426C10.4879 16.9171 10.1955 16.9963 9.98505 16.9963ZM4.87684 10.005C5.69951 10.6281 6.46752 11.3224 7.1672 12.0794C8.26318 13.2547 9.21157 14.5611 9.98778 15.9659C10.764 14.5748 11.7042 13.282 12.7892 12.115C13.6037 11.2431 14.3471 10.5708 15.1206 10.0105C15.0523 9.9558 14.9839 9.90114 14.9156 9.84374C14.5685 9.56223 14.2077 9.26979 13.8633 8.96094C12.8002 8.00435 11.8572 6.9193 11.0564 5.73312C10.7558 5.29036 10.4825 4.82573 10.2146 4.37749C10.149 4.26544 10.0807 4.15065 10.0124 4.03585C9.95498 4.13151 9.90032 4.22991 9.84293 4.33376C9.77186 4.46222 9.69807 4.59341 9.61881 4.7246C8.85353 5.9873 7.94614 7.15708 6.91575 8.2148C6.19147 8.95821 5.54099 9.52943 4.87684 10.005Z",
            fill: color
        })
    }));
};
var DiamondSolid = function(_param) /*#__PURE__*/ {
    var _width = _param.width, width = _width === void 0 ? 36 : _width, _height = _param.height, height = _height === void 0 ? 40 : _height, _color = _param.color, color = _color === void 0 ? "black" : _color, restProps = (0,_object_without_properties/* default */.Z)(_param, [
        "width",
        "height",
        "color"
    ]);
    return (0,jsx_runtime.jsx)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: color,
        xmlns: "http://www.w3.org/2000/svg"
    }, restProps), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M15.1252 9.84297C15.1588 9.89128 15.1794 9.94991 15.1794 10.0133C15.1794 10.1402 15.0996 10.2481 14.987 10.2896C14.5315 10.6125 12.094 12.4423 10.2686 15.8085C10.2326 15.8981 10.1572 15.9699 10.0623 15.9914C10.0376 15.9976 10.0128 15.9994 9.9881 15.9994C9.88822 15.9994 9.79483 15.9534 9.74298 15.8659C9.72914 15.8453 9.71824 15.8229 9.70999 15.7988C9.47312 15.3392 7.90345 12.4338 5.00097 10.2731C4.8955 10.2283 4.82184 10.1237 4.82184 10.0018C4.82184 9.9994 4.82184 9.99705 4.82184 9.99528C4.82067 9.9393 4.8351 9.88303 4.86574 9.83354C4.9005 9.77756 4.95265 9.73544 5.01275 9.71275C5.38955 9.44937 7.85543 7.64401 9.71617 4.2295C9.74504 4.0984 9.86289 4 10.0034 4C10.0612 4 10.1151 4.01679 10.1604 4.04537C10.2232 4.08072 10.2712 4.13847 10.2945 4.20829C10.4751 4.56447 12.0439 7.54267 15.02 9.74751C15.0624 9.77049 15.099 9.80319 15.1252 9.84297Z",
            fill: color
        })
    }));
};
var Dot = function(_param) /*#__PURE__*/ {
    var _color = _param.color, color = _color === void 0 ? "black" : _color, restProps = (0,_object_without_properties/* default */.Z)(_param, [
        "color"
    ]);
    return (0,jsx_runtime.jsx)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: color,
        xmlns: "http://www.w3.org/2000/svg"
    }, restProps), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M10 7.5C8.61925 7.5 7.5 8.61925 7.5 10C7.5 11.3807 8.61925 12.5 10 12.5C11.3807 12.5 12.5 11.3807 12.5 10C12.5 8.61925 11.3807 7.5 10 7.5Z",
            fill: color
        })
    }));
};
var SquareOutlined = function(_param) /*#__PURE__*/ {
    var _color = _param.color, color = _color === void 0 ? "black" : _color, restProps = (0,_object_without_properties/* default */.Z)(_param, [
        "color"
    ]);
    return (0,jsx_runtime.jsx)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: color,
        xmlns: "http://www.w3.org/2000/svg"
    }, restProps), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M14.2393 14H6.76068C6.6167 14 6.5 13.8833 6.5 13.7393V6.26068C6.5 6.1167 6.6167 6 6.76068 6H14.2393C14.3833 6 14.5 6.1167 14.5 6.26068V13.7393C14.5 13.8833 14.3833 14 14.2393 14ZM7.02134 13.4786H13.9787V6.52134H7.02134V13.4786Z",
            fill: color
        })
    }));
};
var SquareRoundedSolid = function(_param) /*#__PURE__*/ {
    var _color = _param.color, color = _color === void 0 ? "black" : _color, restProps = (0,_object_without_properties/* default */.Z)(_param, [
        "color"
    ]);
    return (0,jsx_runtime.jsx)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: color,
        xmlns: "http://www.w3.org/2000/svg"
    }, restProps), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M13.5599 6.44006C13.2666 6.14671 12.9133 6 12.5001 6H7.50001C7.08685 6 6.73349 6.14671 6.44007 6.44006C6.14671 6.73348 6 7.08681 6 7.49999V12.5C6 12.9131 6.14671 13.2665 6.44007 13.5599C6.73349 13.8533 7.08685 14 7.50001 14H12.5001C12.9132 14 13.2666 13.8533 13.5599 13.5599C13.8533 13.2665 14 12.9131 14 12.5V7.49999C14 7.08681 13.8533 6.73342 13.5599 6.44006Z",
            fill: color
        })
    }));
};
var SquareSolid = function(_param) /*#__PURE__*/ {
    var _color = _param.color, color = _color === void 0 ? "black" : _color, restProps = (0,_object_without_properties/* default */.Z)(_param, [
        "color"
    ]);
    return (0,jsx_runtime.jsx)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: color,
        xmlns: "http://www.w3.org/2000/svg"
    }, restProps), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M13.8181 6H6.17888C6.08065 6 6 6.07946 6 6.17832V13.8221C6 13.919 6.08065 14 6.17888 14H13.8181C13.9186 14 14 13.919 14 13.8221V6.17832C14 6.07946 13.9182 6 13.8181 6Z",
            fill: color
        })
    }));
};
var VerifiedOutlined = function(_param) /*#__PURE__*/ {
    var _color = _param.color, color = _color === void 0 ? "black" : _color, restProps = (0,_object_without_properties/* default */.Z)(_param, [
        "color"
    ]);
    return (0,jsx_runtime.jsxs)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: color,
        xmlns: "http://www.w3.org/2000/svg"
    }, restProps), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M4.82982 8.57613C4.46001 8.85813 4 9.20917 4 9.75239C4 10.2956 4.46001 10.6467 4.82982 10.9287C4.98386 11.0321 5.12298 11.1561 5.24328 11.2974C5.23434 11.494 5.19482 11.6881 5.12611 11.8726C4.99695 12.3098 4.8361 12.854 5.14611 13.2798C5.45835 13.709 6.02878 13.7234 6.48705 13.7351C6.67983 13.7274 6.8727 13.7481 7.05943 13.7966C7.16209 13.9577 7.24049 14.133 7.2921 14.3169C7.44517 14.7524 7.6356 15.2944 8.14572 15.4602C8.2361 15.4898 8.3306 15.5049 8.42572 15.5049C8.80966 15.5049 9.16023 15.2639 9.47665 15.0466C9.63405 14.9209 9.8108 14.8215 9.99999 14.7524C10.1893 14.8215 10.3661 14.9208 10.5236 15.0466C10.9153 15.3156 11.3595 15.62 11.8545 15.4601C12.3645 15.2944 12.5549 14.7526 12.708 14.3171C12.7595 14.1341 12.837 13.9594 12.9382 13.7985C13.1256 13.7485 13.3194 13.7272 13.5131 13.7353C13.9713 13.7236 14.5418 13.7092 14.854 13.28C15.164 12.8539 15.0032 12.3098 14.874 11.8725C14.8061 11.689 14.7662 11.4963 14.7557 11.3009C14.8755 11.1577 15.0151 11.0323 15.1704 10.9286C15.54 10.6467 16 10.2956 16 9.75239C16 9.20917 15.54 8.85813 15.1702 8.57611C15.0161 8.4727 14.877 8.34864 14.7567 8.20739C14.7657 8.01074 14.8052 7.81667 14.8739 7.63221C15.003 7.19495 15.1639 6.65078 14.8539 6.22499C14.5416 5.79578 13.9712 5.7814 13.5129 5.76967C13.3202 5.77736 13.1273 5.75664 12.9406 5.70814C12.8379 5.54707 12.7595 5.37178 12.7079 5.18788C12.555 4.7524 12.3645 4.21042 11.8544 4.04463C11.3594 3.88376 10.9152 4.1894 10.5235 4.4582C10.366 4.58388 10.1893 4.68324 10.0001 4.7524C9.81084 4.68332 9.63403 4.58396 9.47659 4.4582C9.08486 4.18918 8.64052 3.88447 8.14564 4.04463C7.63564 4.2104 7.44521 4.75213 7.29214 5.18771C7.24065 5.3707 7.1631 5.54532 7.06191 5.70625C6.87459 5.75622 6.68077 5.77756 6.48705 5.76949C6.0288 5.78118 5.45837 5.79561 5.14613 6.22479C4.83612 6.65084 4.99695 7.19501 5.12613 7.63228C5.19403 7.81579 5.23391 8.00846 5.2444 8.20383C5.12467 8.34708 4.98506 8.47244 4.82982 8.57613ZM5.43639 9.37112C5.75037 9.13162 6.07505 8.88407 6.19457 8.5159C6.31786 8.13591 6.19421 7.71781 6.08519 7.34891C6.02644 7.17718 5.98621 6.99966 5.96518 6.81939C6.14528 6.78295 6.3288 6.7662 6.51254 6.76939C6.91403 6.75939 7.32932 6.74865 7.64952 6.51572C7.96651 6.28476 8.10336 5.89585 8.23557 5.5194C8.28936 5.34172 8.36278 5.17058 8.45444 5.00914C8.61521 5.08463 8.76793 5.17619 8.91027 5.28242C9.23083 5.50267 9.59425 5.75242 9.99999 5.75242C10.4057 5.75242 10.7692 5.50293 11.0897 5.28242C11.2321 5.17613 11.3849 5.08451 11.5458 5.00899C11.6375 5.17048 11.7109 5.3417 11.7646 5.51948C11.8968 5.89568 12.0336 6.28461 12.3507 6.51554C12.6709 6.74847 13.086 6.7592 13.4875 6.76947C13.6713 6.76603 13.8549 6.7828 14.035 6.81947C14.0139 6.99956 13.9737 7.17692 13.915 7.34852C13.8059 7.71765 13.6822 8.13587 13.8055 8.51574C13.9252 8.88391 14.2497 9.13146 14.5636 9.37096C14.7222 9.47947 14.8664 9.60762 14.9928 9.75239C14.8663 9.89704 14.7221 10.0252 14.5636 10.1337C14.2496 10.3732 13.9249 10.6208 13.8054 10.989C13.6821 11.369 13.8057 11.7871 13.9148 12.1559C13.9735 12.3277 14.0138 12.5052 14.0348 12.6855C13.8547 12.7219 13.6712 12.7387 13.4874 12.7355C13.0859 12.7455 12.6706 12.7562 12.3504 12.9891C12.0335 13.2201 11.8966 13.6091 11.7644 13.9855C11.7106 14.1631 11.6372 14.3343 11.5455 14.4957C11.3847 14.4202 11.232 14.3286 11.0897 14.2224C10.7692 14.0021 10.4057 13.7524 9.99999 13.7524C9.59425 13.7524 9.23083 14.0019 8.91027 14.2224C8.76787 14.3286 8.61507 14.4203 8.45423 14.4958C8.36252 14.3343 8.28911 14.1631 8.23535 13.9853C8.10314 13.6091 7.96643 13.2202 7.6493 12.9892C7.3291 12.7563 6.91395 12.7456 6.51246 12.7353C6.32869 12.7388 6.14508 12.722 5.96497 12.6853C5.98609 12.5052 6.02632 12.3279 6.08497 12.1563C6.19411 11.7871 6.31778 11.3689 6.19447 10.989C6.07501 10.6208 5.75039 10.3732 5.43655 10.1337C5.2779 10.0253 5.13365 9.89714 5.00723 9.75239C5.13371 9.60774 5.2779 9.47963 5.43643 9.37104V9.37112H5.43639Z",
                fill: color
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M9.37507 11.5023C9.50771 11.5025 9.63494 11.4497 9.72859 11.3558L12.2286 8.85581C12.4263 8.66304 12.4303 8.34648 12.2376 8.14877C12.0448 7.95104 11.7282 7.94702 11.5305 8.1398C11.5275 8.14275 11.5245 8.14574 11.5215 8.14877L9.37507 10.2953L8.4786 9.39878C8.28583 9.20107 7.96927 9.19705 7.77156 9.38983C7.57384 9.5826 7.56983 9.89916 7.7626 10.0969C7.76555 10.0999 7.76854 10.1029 7.77156 10.1058L9.02155 11.3558C9.11518 11.4497 9.24243 11.5025 9.37507 11.5023Z",
                fill: color
            })
        ]
    }));
};
var VerifiedSolid = function(_param) /*#__PURE__*/ {
    var _color = _param.color, color = _color === void 0 ? "black" : _color, restProps = (0,_object_without_properties/* default */.Z)(_param, [
        "color"
    ]);
    return (0,jsx_runtime.jsx)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: color,
        xmlns: "http://www.w3.org/2000/svg"
    }, restProps), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M15.3925 8.77305C15.2319 8.66518 15.0868 8.53578 14.9613 8.38846C14.9706 8.18334 15.0118 7.98092 15.0835 7.78851C15.2182 7.33244 15.386 6.76485 15.0627 6.32073C14.737 5.87306 14.142 5.85804 13.664 5.84581C13.4629 5.85384 13.2618 5.83222 13.067 5.78164C12.9599 5.61365 12.8781 5.43081 12.8243 5.239C12.6648 4.78478 12.4661 4.21946 11.9341 4.04655C11.4178 3.87876 10.9544 4.19756 10.5459 4.47793C10.3817 4.60902 10.1973 4.71264 10 4.78478C9.80258 4.71272 9.61816 4.60908 9.45394 4.47793C9.04535 4.19732 8.58188 3.87951 8.06571 4.04655C7.53377 4.21946 7.33515 4.7845 7.17549 5.23882C7.12177 5.42968 7.0409 5.61183 6.93536 5.77968C6.73997 5.83181 6.53782 5.85405 6.33577 5.84565C5.8578 5.85786 5.26283 5.8729 4.93714 6.32054C4.6138 6.76493 4.78155 7.33252 4.91628 7.78861C4.98711 7.98 5.0287 8.18097 5.03965 8.38475C4.91474 8.53417 4.76909 8.66493 4.60713 8.77307C4.22149 9.06718 3.7417 9.43334 3.7417 9.99994C3.7417 10.5665 4.22149 10.9327 4.60723 11.2268C4.7679 11.3347 4.913 11.4641 5.03847 11.6114C5.02916 11.8165 4.98793 12.019 4.91626 12.2114C4.78155 12.6674 4.61378 13.2351 4.93712 13.6792C5.2628 14.1268 5.85777 14.1418 6.33577 14.1541C6.53684 14.146 6.738 14.1677 6.93277 14.2182C7.03986 14.3862 7.12164 14.5691 7.17546 14.7609C7.33512 15.2152 7.53374 15.7804 8.06582 15.9534C8.16009 15.9843 8.25866 16 8.35787 16C8.75831 16 9.12397 15.7487 9.45401 15.522C9.6182 15.3909 9.80254 15.2872 9.99988 15.2151C10.1973 15.2872 10.3818 15.3908 10.546 15.522C10.9545 15.8026 11.4179 16.1201 11.9342 15.9533C12.4661 15.7804 12.6648 15.2154 12.8244 14.7611C12.8781 14.5702 12.959 14.388 13.0645 14.2202C13.2599 14.1681 13.4621 14.1458 13.6641 14.1542C14.1421 14.142 14.7371 14.127 15.0628 13.6793C15.3861 13.235 15.2183 12.6674 15.0836 12.2113C15.0128 12.0199 14.9712 11.8189 14.9603 11.6151C15.0852 11.4657 15.2308 11.3349 15.3928 11.2268C15.7783 10.9327 16.2581 10.5665 16.2581 9.99994C16.2581 9.43334 15.7783 9.06718 15.3925 8.77305ZM12.3243 9.06489L9.71673 11.6725C9.66831 11.7209 9.61083 11.7593 9.54756 11.7855C9.48429 11.8117 9.41647 11.8252 9.34799 11.8252C9.27951 11.8252 9.21169 11.8117 9.14842 11.7855C9.08515 11.7593 9.02767 11.7209 8.97925 11.6725L7.67546 10.3687C7.62603 10.3205 7.58666 10.2629 7.55963 10.1994C7.5326 10.1359 7.51846 10.0676 7.51802 9.99857C7.51759 9.92953 7.53086 9.86109 7.55708 9.79722C7.5833 9.73335 7.62194 9.67532 7.67076 9.6265C7.71958 9.57768 7.77761 9.53904 7.84148 9.51282C7.90535 9.4866 7.97379 9.47332 8.04283 9.47376C8.11187 9.4742 8.18014 9.48834 8.24367 9.51537C8.30721 9.54239 8.36474 9.58177 8.41294 9.6312L9.34799 10.5663L11.5868 8.32741C11.635 8.27798 11.6926 8.23861 11.7561 8.21158C11.8196 8.18455 11.8879 8.17041 11.9569 8.16997C12.026 8.16953 12.0944 8.18281 12.1583 8.20903C12.2222 8.23525 12.2802 8.27389 12.329 8.32271C12.3778 8.37153 12.4165 8.42956 12.4427 8.49343C12.4689 8.5573 12.4822 8.62574 12.4817 8.69478C12.4813 8.76382 12.4672 8.83209 12.4401 8.89562C12.4131 8.95916 12.3737 9.01669 12.3243 9.06489Z",
            fill: color
        })
    }));
};

// EXTERNAL MODULE: ./src/components/WidgetMaker/WidgetDnD/WidgetProperties/NewAnnouncementBar/Constants/index.tsx
var Constants = __webpack_require__(889489);
;// CONCATENATED MODULE: ./src/components/WidgetMaker/WidgetDnD/WidgetProperties/NewAnnouncementBar/Utils/index.tsx


function getSeperatorByType(iconType) {
    switch(iconType){
        case Constants/* SEPERATOR_TYPE.CIRCLE_OUTLINE */.WY.CIRCLE_OUTLINE:
            return CircleOutline;
        case Constants/* SEPERATOR_TYPE.DOT */.WY.DOT:
            return Dot;
        case Constants/* SEPERATOR_TYPE.DIAMOND_OUTLINE */.WY.DIAMOND_OUTLINE:
            return DiamondOutlined;
        case Constants/* SEPERATOR_TYPE.DIAMOND */.WY.DIAMOND:
            return DiamondSolid;
        case Constants/* SEPERATOR_TYPE.SQUARE */.WY.SQUARE:
            return SquareSolid;
        case Constants/* SEPERATOR_TYPE.SQUARE_ROUNDED */.WY.SQUARE_ROUNDED:
            return SquareRoundedSolid;
        case Constants/* SEPERATOR_TYPE.SQUARE_OUTLINE */.WY.SQUARE_OUTLINE:
            return SquareOutlined;
        case Constants/* SEPERATOR_TYPE.DIAMOND_GROUP */.WY.DIAMOND_GROUP:
            return DiamondGroup;
        case Constants/* SEPERATOR_TYPE.VERIFIED_SOLID */.WY.VERIFIED_SOLID:
            return VerifiedSolid;
        case Constants/* SEPERATOR_TYPE.VERIFIED_OUTLINE */.WY.VERIFIED_OUTLINE:
            return VerifiedOutlined;
        default:
            return null;
    }
}
function getAnnouncementSeperatorOptionsAndMap() {
    var allowedAnimationTypes = [
        Constants/* ANIMATION_TYPE.NONE */.vR.NONE,
        Constants/* ANIMATION_TYPE.FADE_IN */.vR.FADE_IN,
        Constants/* ANIMATION_TYPE.MOVE_UP */.vR.MOVE_UP,
        Constants/* ANIMATION_TYPE.MOVE_DOWN */.vR.MOVE_DOWN, 
    ];
    var animationOptions = Constants/* CONTENT_ANIMATION_TYPE_OPTIONS.filter */.hn.filter(function(option) {
        return allowedAnimationTypes.includes(option.animeType);
    });
    var animationOptionsMap = allowedAnimationTypes.reduce(function(newMap, type) {
        newMap[type] = Constants/* ANIMATION_TYPE_MAP */.ot[type];
        return newMap;
    }, {});
    return {
        animationOptions: animationOptions,
        animationOptionsMap: animationOptionsMap
    };
}


/***/ }),

/***/ 171468:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ useDeviceType; }
/* harmony export */ });
/* harmony import */ var src_context_WidgetDndContext__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(474151);
/* harmony import */ var src_hooks_useGetDeviceType__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(662946);


function useDeviceType() {
    var ref = (0,src_context_WidgetDndContext__WEBPACK_IMPORTED_MODULE_0__/* .useWidgetDndContextData */ .KX)(), _widgetContextState = ref.widgetContextState, isBuilder = _widgetContextState.isBuilder, previewDevice = _widgetContextState.previewDevice;
    var ref1 = (0,src_hooks_useGetDeviceType__WEBPACK_IMPORTED_MODULE_1__/* .useGetDeviceType */ .n)(), deviceTypeActual = ref1.deviceType;
    var deviceTypeToCheck = isBuilder ? previewDevice : deviceTypeActual;
    var isMobile = deviceTypeToCheck === "mobile";
    return {
        isMobile: isMobile
    };
}


/***/ }),

/***/ 826910:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": function() { return /* binding */ isMobileDevice; }
/* harmony export */ });
/* harmony import */ var _context_WidgetDndContext__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(474151);
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(913886);
/* harmony import */ var _utils_deviceWidth__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(186812);



var isMobileDevice = function() {
    var ref = (0,_context_WidgetDndContext__WEBPACK_IMPORTED_MODULE_0__/* .useWidgetDndContextData */ .KX)(), previewDevice = ref.widgetContextState.previewDevice;
    var isDeviceMobile = (_utils_deviceWidth__WEBPACK_IMPORTED_MODULE_2__/* .deviceWidth */ .o || 0) <= _utils_constants__WEBPACK_IMPORTED_MODULE_1__/* .MAX_MOBILE_WIDTH */ .Cf;
    var isMobile = isDeviceMobile || previewDevice === "mobile";
    return isMobile;
};


/***/ }),

/***/ 844369:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "LAST_ACTIVE_WIDGET_KEY_BUILDER": function() { return /* binding */ LAST_ACTIVE_WIDGET_KEY_BUILDER; },
/* harmony export */   "NEW_FOOTER_ID": function() { return /* binding */ NEW_FOOTER_ID; },
/* harmony export */   "NEW_HEADER_ID": function() { return /* binding */ NEW_HEADER_ID; },
/* harmony export */   "WIDGET_GROUPS": function() { return /* binding */ WIDGET_GROUPS; },
/* harmony export */   "clearLastActiveWidgetIntoView": function() { return /* binding */ clearLastActiveWidgetIntoView; },
/* harmony export */   "extractNumberFromString": function() { return /* binding */ extractNumberFromString; },
/* harmony export */   "generateHeaderOrFooterPropsConfig": function() { return /* binding */ generateHeaderOrFooterPropsConfig; },
/* harmony export */   "getBuilderReadyHeaderElement": function() { return /* binding */ getBuilderReadyHeaderElement; },
/* harmony export */   "getCFEHeaderElementStructure": function() { return /* binding */ getCFEHeaderElementStructure; },
/* harmony export */   "getGlobalStyleForPublishedLayout": function() { return /* binding */ getGlobalStyleForPublishedLayout; },
/* harmony export */   "getGroupAndWidgetsMap": function() { return /* binding */ getGroupAndWidgetsMap; },
/* harmony export */   "getHeaderElement": function() { return /* binding */ getHeaderElement; },
/* harmony export */   "getLastActiveWidgetId": function() { return /* binding */ getLastActiveWidgetId; },
/* harmony export */   "getLastActiveWidgetIntoView": function() { return /* binding */ getLastActiveWidgetIntoView; },
/* harmony export */   "getOrderedWidgetGroups": function() { return /* binding */ getOrderedWidgetGroups; },
/* harmony export */   "getUpdatedGlobalSetting": function() { return /* binding */ getUpdatedGlobalSetting; },
/* harmony export */   "setLastActiveWidget": function() { return /* binding */ setLastActiveWidget; },
/* harmony export */   "updateGlobalStyleAndSettingAccToSubs": function() { return /* binding */ updateGlobalStyleAndSettingAccToSubs; },
/* harmony export */   "updateInfoList": function() { return /* binding */ updateInfoList; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(414924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(626042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(269396);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(629815);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(785893);
/* harmony import */ var _WidgetProperties_HeaderBuilder_NewHeaderConfig__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(436303);
/* harmony import */ var lodash_merge__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(682492);
/* harmony import */ var lodash_merge__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lodash_merge__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var lodash_cloneDeep__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(150361);
/* harmony import */ var lodash_cloneDeep__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lodash_cloneDeep__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _DesignSystem_Widgets2_0_Header__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(950479);
/* harmony import */ var src_constants_widgets__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(442381);
/* harmony import */ var src_constants_globalConfigs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(337392);
/* harmony import */ var src_utils_isThemeBrandWebsite__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(920955);
/* harmony import */ var _WidgetProperties_FooterBuilder_NewFooterConfig__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(577682);
/* harmony import */ var src_components_DesignSystem_Widgets2_0_Footer_utils__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(637062);
/* harmony import */ var src_utils_storeSubscriptionConfigs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(114150);















var LAST_ACTIVE_WIDGET_KEY_BUILDER = "lastActiveWidgetBuilder";
var NEW_FOOTER_ID = "footer-builder";
var NEW_HEADER_ID = "header-builder";
var WIDGET_GROUPS = {
    NEW: "New Widgets",
    LEGACY: "legacy"
};
var getGroupAndWidgetsMap = function(widgets) {
    var adminWidgetNames = Object.values(src_constants_widgets__WEBPACK_IMPORTED_MODULE_5__/* .ADMIN_WIDGETS_NAMES */ .G);
    var isBrandWebsite = (0,src_utils_isThemeBrandWebsite__WEBPACK_IMPORTED_MODULE_7__/* .isThemeBrandWebsite */ .h)();
    var map = {};
    widgets === null || widgets === void 0 ? void 0 : widgets.forEach(function(widget) {
        var widgetGroup = widget.group || widget.type;
        // separate out new(admin) widgets from legacy
        if (widgetGroup === WIDGET_GROUPS.LEGACY && adminWidgetNames.includes(widget.name)) {
            // in case of brand website, only allowed widgets would be visible
            if (isBrandWebsite && !src_constants_widgets__WEBPACK_IMPORTED_MODULE_5__/* .ADMIN_WIDGETS_FOR_BRAND_WEBSITE.includes */ .b_.includes(widget.name)) {
                return;
            }
            map[WIDGET_GROUPS.NEW] = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(map[WIDGET_GROUPS.NEW] || []).concat([
                widget
            ]);
        } else if (!isBrandWebsite) {
            // consider other groups only if not brand website
            map[widgetGroup] = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(map[widgetGroup] || []).concat([
                widget
            ]);
        }
    });
    return map;
};
function getOrderedWidgetGroups(widgetGroups) {
    return widgetGroups.reduce(function(orderedGroups, group) {
        if (group === WIDGET_GROUPS.LEGACY || group === WIDGET_GROUPS.NEW) {
            if (orderedGroups.includes(WIDGET_GROUPS.NEW)) {
                orderedGroups.splice(1, 0, group);
            } else {
                orderedGroups.unshift(group);
            }
        } else {
            orderedGroups.push(group);
        }
        return orderedGroups;
    }, []);
}
function getBuilderReadyHeaderElement(newHeaderComponent) {
    if (newHeaderComponent === null || newHeaderComponent === void 0 ? void 0 : newHeaderComponent.config) {
        for(var key in _WidgetProperties_HeaderBuilder_NewHeaderConfig__WEBPACK_IMPORTED_MODULE_1__/* .HEADER_CONFIG */ .m){
            if (key) {
                if (key === "globalClass") {
                    newHeaderComponent.config[key] = lodash_merge__WEBPACK_IMPORTED_MODULE_2___default()(_WidgetProperties_HeaderBuilder_NewHeaderConfig__WEBPACK_IMPORTED_MODULE_1__/* .HEADER_CONFIG */ .m[key], newHeaderComponent.config[key]);
                } else {
                    var ref, ref1;
                    if (_WidgetProperties_HeaderBuilder_NewHeaderConfig__WEBPACK_IMPORTED_MODULE_1__/* .HEADER_CONFIG */ .m[key] && !(newHeaderComponent === null || newHeaderComponent === void 0 ? void 0 : newHeaderComponent.config[key])) {
                        newHeaderComponent.config[key] = _WidgetProperties_HeaderBuilder_NewHeaderConfig__WEBPACK_IMPORTED_MODULE_1__/* .HEADER_CONFIG */ .m[key];
                    }
                    if ((ref = _WidgetProperties_HeaderBuilder_NewHeaderConfig__WEBPACK_IMPORTED_MODULE_1__/* .HEADER_CONFIG */ .m[key]) === null || ref === void 0 ? void 0 : ref.leftSection_config) {
                        newHeaderComponent.config[key].leftSection_config = _WidgetProperties_HeaderBuilder_NewHeaderConfig__WEBPACK_IMPORTED_MODULE_1__/* .HEADER_CONFIG */ .m[key].leftSection_config;
                    }
                    if ((ref1 = _WidgetProperties_HeaderBuilder_NewHeaderConfig__WEBPACK_IMPORTED_MODULE_1__/* .HEADER_CONFIG */ .m[key]) === null || ref1 === void 0 ? void 0 : ref1.leftSectionConfig) {
                        newHeaderComponent.config[key].leftSectionConfig = _WidgetProperties_HeaderBuilder_NewHeaderConfig__WEBPACK_IMPORTED_MODULE_1__/* .HEADER_CONFIG */ .m[key].leftSectionConfig;
                    }
                    // if (HEADER_CONFIG[key]?.componentData) {
                    //   newHeaderComponent.config[key].componentData = HEADER_CONFIG[key].componentData;
                    // }
                    if (key === "navIcons_section") {
                        var ref2;
                        newHeaderComponent.config[key].componentData = (ref2 = _WidgetProperties_HeaderBuilder_NewHeaderConfig__WEBPACK_IMPORTED_MODULE_1__/* .HEADER_CONFIG */ .m[key]) === null || ref2 === void 0 ? void 0 : ref2.componentData;
                    }
                }
            }
        }
    }
    return newHeaderComponent;
}
function getCFEHeaderElementStructure(headerElProps) {
    var headerElementProps = lodash_cloneDeep__WEBPACK_IMPORTED_MODULE_3___default()(headerElProps);
    if (headerElementProps) {
        for(var key in headerElementProps){
            if (key) {
                var ref, ref1;
                if ((ref = headerElementProps[key]) === null || ref === void 0 ? void 0 : ref.leftSection_config) {
                    delete headerElementProps[key].leftSection_config;
                }
                if ((ref1 = headerElementProps[key]) === null || ref1 === void 0 ? void 0 : ref1.leftSectionConfig) {
                    delete headerElementProps[key].leftSectionConfig;
                }
                // if (headerElementProps[key]?.componentData) {
                //   delete headerElementProps[key].componentData;
                // }
                if (key === "globalClass") {
                    delete headerElementProps[key];
                }
            }
        }
    }
    return headerElementProps;
}
function generateHeaderOrFooterPropsConfig(component) {
    var isHeader = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
    var currentComponentOnStore = (component === null || component === void 0 ? void 0 : component[0]) || {};
    var newComponentPropConfig = {};
    var currentConfig = (currentComponentOnStore === null || currentComponentOnStore === void 0 ? void 0 : currentComponentOnStore.config) || (isHeader ? _WidgetProperties_HeaderBuilder_NewHeaderConfig__WEBPACK_IMPORTED_MODULE_1__/* .HEADER_CONFIG */ .m : _WidgetProperties_FooterBuilder_NewFooterConfig__WEBPACK_IMPORTED_MODULE_8__.FOOTER_DATA);
    if (!isHeader) {
        currentConfig = (0,src_components_DesignSystem_Widgets2_0_Footer_utils__WEBPACK_IMPORTED_MODULE_11__/* .normalizeFooterConfig */ .Q)(currentConfig);
    }
    if ([
        src_constants_widgets__WEBPACK_IMPORTED_MODULE_5__/* .ADMIN_WIDGETS.HEADER.type */ .Pe.HEADER.type,
        src_constants_widgets__WEBPACK_IMPORTED_MODULE_5__/* .ADMIN_WIDGETS.FOOTER.type */ .Pe.FOOTER.type
    ].includes(currentComponentOnStore === null || currentComponentOnStore === void 0 ? void 0 : currentComponentOnStore.name)) {
        var ref, ref1, ref2;
        // sync wishlist in header config
        if (!(currentConfig === null || currentConfig === void 0 ? void 0 : (ref = currentConfig.navIcons_section) === null || ref === void 0 ? void 0 : (ref1 = ref.componentData) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.iconsList) === null || ref2 === void 0 ? void 0 : ref2.some(function(item) {
            return item.name === "wishlist";
        }))) {
            var ref3, ref4;
            currentConfig === null || currentConfig === void 0 ? void 0 : (ref3 = currentConfig.navIcons_section) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.componentData) === null || ref4 === void 0 ? void 0 : ref4.iconsList.splice(currentConfig.navIcons_section.componentData.iconsList.length - 1, 0, _WidgetProperties_HeaderBuilder_NewHeaderConfig__WEBPACK_IMPORTED_MODULE_1__/* .HEADER_CONFIG.navIcons_section.componentData.iconsList.find */ .m.navIcons_section.componentData.iconsList.find(function(item) {
                return item.name === "wishlist";
            }));
        }
        newComponentPropConfig = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({}, currentConfig), {
            widget_id: currentComponentOnStore === null || currentComponentOnStore === void 0 ? void 0 : currentComponentOnStore.widget_id,
            sub_type: isHeader ? "Header" : "Footer"
        });
    } else {
        newComponentPropConfig = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({}, currentComponentOnStore), {
            widget_id: currentComponentOnStore === null || currentComponentOnStore === void 0 ? void 0 : currentComponentOnStore.widget_id
        }), currentConfig || {});
    }
    return newComponentPropConfig;
}
function getHeaderElement(headerComponents, headerElement, headerPropsConfig) {
    var ref;
    return ((ref = headerComponents[0]) === null || ref === void 0 ? void 0 : ref.name) === src_constants_widgets__WEBPACK_IMPORTED_MODULE_5__/* .ADMIN_WIDGETS.HEADER.type */ .Pe.HEADER.type ? [
        // eslint-disable-next-line
        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_DesignSystem_Widgets2_0_Header__WEBPACK_IMPORTED_MODULE_4__.NewHeaderComponent, {
            sub_type: "Header",
            name: src_constants_widgets__WEBPACK_IMPORTED_MODULE_5__/* .ADMIN_WIDGETS.HEADER.type */ .Pe.HEADER.type,
            config: headerPropsConfig
        }), 
    ] : headerElement;
}
function getUpdatedGlobalSetting(globalStyle, globalSetting) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10;
    globalSetting.fonts.base_config = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({}, globalStyle === null || globalStyle === void 0 ? void 0 : globalStyle.fonts), {
        selectedId: (globalStyle === null || globalStyle === void 0 ? void 0 : (ref = globalStyle.fonts) === null || ref === void 0 ? void 0 : ref.id) || ""
    });
    globalSetting.appearance.base_config = {
        btnType: (globalStyle === null || globalStyle === void 0 ? void 0 : (ref1 = globalStyle.buttons) === null || ref1 === void 0 ? void 0 : ref1.borderType) || "",
        btnRadius: extractNumberFromString(globalStyle === null || globalStyle === void 0 ? void 0 : (ref2 = globalStyle.buttons) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.style) === null || ref3 === void 0 ? void 0 : ref3.borderRadius),
        inputRadius: extractNumberFromString(globalStyle === null || globalStyle === void 0 ? void 0 : (ref4 = globalStyle.inputs) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.style) === null || ref5 === void 0 ? void 0 : ref5.borderRadius),
        imageCardRadius: extractNumberFromString(globalStyle === null || globalStyle === void 0 ? void 0 : (ref6 = globalStyle.imageCards) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.style) === null || ref7 === void 0 ? void 0 : ref7.borderRadius),
        isEnabled: globalStyle === null || globalStyle === void 0 ? void 0 : (ref8 = globalStyle.imageCards) === null || ref8 === void 0 ? void 0 : ref8.isEnabled
    };
    globalSetting.loader.base_config = globalStyle === null || globalStyle === void 0 ? void 0 : globalStyle.appLoader;
    globalSetting.chevrons.base_config = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({}, src_constants_globalConfigs__WEBPACK_IMPORTED_MODULE_6__/* .GLOBAL_STYLE.chevrons */ .$.chevrons), {
        chevronId: globalStyle === null || globalStyle === void 0 ? void 0 : (ref9 = globalStyle.chevrons) === null || ref9 === void 0 ? void 0 : ref9.selected,
        isEnabled: globalStyle === null || globalStyle === void 0 ? void 0 : (ref10 = globalStyle.chevrons) === null || ref10 === void 0 ? void 0 : ref10.isEnabled
    });
    return globalSetting;
}
function enableAllGlobalStyle(globalStyle, notToUpdateConfig) {
    var globalStyleKeys = Object.keys(globalStyle || {});
    var updatedData = globalStyleKeys === null || globalStyleKeys === void 0 ? void 0 : globalStyleKeys.reduce(function(acc, curr) {
        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({}, acc), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)({}, curr, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({}, (notToUpdateConfig === null || notToUpdateConfig === void 0 ? void 0 : notToUpdateConfig.length) && (notToUpdateConfig === null || notToUpdateConfig === void 0 ? void 0 : notToUpdateConfig.includes(curr)) ? globalStyle[curr] : (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({}, globalStyle[curr]), {
            isEnabled: true
        }))));
    }, {});
    return updatedData;
}
function updateGlobalStyleAndSetting(globalStyle, globalSetting, setGlobalSetting, setGlobalStyle) {
    setGlobalSetting(globalSetting);
    setGlobalStyle(globalStyle);
}
function updateInfoList(infoList) {
    return infoList === null || infoList === void 0 ? void 0 : infoList.map(function(data) {
        if ((data === null || data === void 0 ? void 0 : data.type) === "name") {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({}, data), {
                config: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({}, data === null || data === void 0 ? void 0 : data.config), {
                    productNameNumOfLine: "two"
                })
            });
        }
        return data;
    });
}
function getGlobalStyleForPublishedLayout(globalStyle) {
    var ref, ref1;
    var updatedGlobalStyle = lodash_cloneDeep__WEBPACK_IMPORTED_MODULE_3___default()(globalStyle);
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({}, updatedGlobalStyle), {
        productCard: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({}, (updatedGlobalStyle === null || updatedGlobalStyle === void 0 ? void 0 : (ref = updatedGlobalStyle.productCard) === null || ref === void 0 ? void 0 : ref.isEnabled) ? updatedGlobalStyle === null || updatedGlobalStyle === void 0 ? void 0 : updatedGlobalStyle.productCard : (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({}, updatedGlobalStyle === null || updatedGlobalStyle === void 0 ? void 0 : updatedGlobalStyle.productCard), {
            infoList: updateInfoList(updatedGlobalStyle === null || updatedGlobalStyle === void 0 ? void 0 : (ref1 = updatedGlobalStyle.productCard) === null || ref1 === void 0 ? void 0 : ref1.infoList),
            isEnabled: false,
            layoutName: "layout0"
        }))
    });
}
function enableAndUpdateGlobalStyle(globalStyle, globalSettings, setGlobalSetting, setGlobalStyle) {
    var notToUpdateConfig = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : [];
    var updatedGlobalStyle = enableAllGlobalStyle(globalStyle, notToUpdateConfig);
    var updatedGlobalSetting = getUpdatedGlobalSetting(lodash_cloneDeep__WEBPACK_IMPORTED_MODULE_3___default()(updatedGlobalStyle), lodash_cloneDeep__WEBPACK_IMPORTED_MODULE_3___default()(globalSettings));
    updateGlobalStyleAndSetting(updatedGlobalStyle, updatedGlobalSetting, setGlobalSetting, setGlobalStyle);
    return {
        updatedGlobalStyle: updatedGlobalStyle,
        updatedGlobalSetting: updatedGlobalSetting
    };
}
function updateGlobalStyleAndSettingAccToSubs(globalStyle, globalSettings, setGlobalSetting, setGlobalStyle, storeInfo) {
    var updatedDataForGlobalStyle = {};
    var ref = (0,src_utils_storeSubscriptionConfigs__WEBPACK_IMPORTED_MODULE_9__/* .getWebsiteLiveStatus */ .B)(storeInfo), isNewStoreWebsiteInactive = ref.isNewStoreWebsiteInactive, isNewStoreWebsiteLive = ref.isNewStoreWebsiteLive;
    if (isNewStoreWebsiteInactive || isNewStoreWebsiteLive) {
        updatedDataForGlobalStyle = enableAndUpdateGlobalStyle(globalStyle, globalSettings, setGlobalSetting, setGlobalStyle);
    } else {
        var updatedGlobalStyle = getGlobalStyleForPublishedLayout(globalStyle);
        updatedDataForGlobalStyle = enableAndUpdateGlobalStyle(updatedGlobalStyle, globalSettings, setGlobalSetting, setGlobalStyle, [
            "productCard",
            "fonts"
        ]);
    }
    return updatedDataForGlobalStyle.updatedGlobalSetting;
}
function extractNumberFromString(value) {
    if (typeof value === "number") {
        return value;
    }
    if (typeof value === "string") {
        var match = value.match(/-?\d+(\.\d+)?/);
        return match ? parseInt(match[0]) : null;
    }
    return null;
}
function getLastActiveWidgetIntoView(activeWidgetId) {
    var widgetId = activeWidgetId || getLastActiveWidgetId();
    if (widgetId) {
        var ref;
        (ref = document === null || document === void 0 ? void 0 : document.getElementById(widgetId)) === null || ref === void 0 ? void 0 : ref.scrollIntoView({
            behavior: "instant",
            block: "center"
        });
        clearLastActiveWidgetIntoView();
    }
}
function getLastActiveWidgetId() {
    return sessionStorage === null || sessionStorage === void 0 ? void 0 : sessionStorage.getItem(LAST_ACTIVE_WIDGET_KEY_BUILDER);
}
function setLastActiveWidget(id) {
    sessionStorage === null || sessionStorage === void 0 ? void 0 : sessionStorage.setItem(LAST_ACTIVE_WIDGET_KEY_BUILDER, id);
}
function clearLastActiveWidgetIntoView() {
    sessionStorage === null || sessionStorage === void 0 ? void 0 : sessionStorage.removeItem(LAST_ACTIVE_WIDGET_KEY_BUILDER);
}


/***/ }),

/***/ 298627:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ ITEM_WISHLIST_STATE; },
/* harmony export */   "g": function() { return /* binding */ WISHLIST_FEATURE_STATUS; }
/* harmony export */ });
var ITEM_WISHLIST_STATE = {
    ITEM_WISHLISTED: 0,
    ADD_TO_CART: 1,
    REMOVE_FROM_WISHLIST: 3,
    ORDER_PLACED: 2
};
var WISHLIST_FEATURE_STATUS = {
    WISHLIST_INACTIVE: -1,
    WISHLIST_DISABLED: 0,
    WISHLIST_ACTIVE: 1
};


/***/ }),

/***/ 772911:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DA": function() { return /* binding */ getVariantIdFromUrl; },
/* harmony export */   "_h": function() { return /* binding */ isShowPPModal; },
/* harmony export */   "wj": function() { return /* binding */ checkProductPersonalizationExist; }
/* harmony export */ });
function getVariantIdFromUrl() {
    if (true) {
        var urlParams = new URLSearchParams(window.location.search);
        var variantId = parseInt(urlParams.get("vid"));
        return variantId;
    }
}
var isShowPPModal = function(type, items, source) {
    if (!items || source === "cartPage" || (type === "add" || type === "inc" || type === "save") && (items === null || items === void 0 ? void 0 : items.quantity) === 1) {
        return false;
    }
    return items.quantity >= 1;
};
var checkProductPersonalizationExist = function(storeType, productPersonalization) {
    return storeType !== 3 && !!productPersonalization;
};


/***/ }),

/***/ 852271:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ CartContext; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(667294);

var CartContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({});


/***/ }),

/***/ 491240:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "u": function() { return /* binding */ useCartHandlers; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(147568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(626042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(269396);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(629815);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(197582);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(667294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(225617);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(811163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _utils_mutateItemObjectWithCartData__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(822787);
/* harmony import */ var _utils_mutateVariantItemWithCartData__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(759186);
/* harmony import */ var _redux_actions__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(96031);
/* harmony import */ var _redux_actions__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(731024);
/* harmony import */ var _redux_actions__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(666162);
/* harmony import */ var _redux_actions__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(467936);
/* harmony import */ var _utils_routes__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(540190);
/* harmony import */ var _utils_deviceWidth__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(186812);
/* harmony import */ var _utils_itemIndexFromCart__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(648670);
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(913886);
/* harmony import */ var _containers_ProductDescription_Utils_common__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(772911);
/* harmony import */ var _redux_ssrStore__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(326706);
/* harmony import */ var _utils_checkRenderEnv__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(506337);


















function useCartHandlers() {
    var handleSetProductData = function handleSetProductData(data) {
        dispatch((0,_redux_actions__WEBPACK_IMPORTED_MODULE_10__/* .setProductDataPersonalised */ .$d)(data));
    };
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useDispatch */ .I0)();
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    var storeInfo = (0,_redux_ssrStore__WEBPACK_IMPORTED_MODULE_8__/* .useSSRSelector */ .kF)(function(state) {
        return {
            storeInfo: state.storeReducer.store
        };
    }).storeInfo;
    var ref = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(function(state) {
        var ref, ref1;
        return {
            cartData: state.cartReducer,
            userData: state.userReducer,
            commonReducer: state.commonReducer,
            productData: (ref = state.catalogReducer) === null || ref === void 0 ? void 0 : (ref1 = ref.personalizedProduct) === null || ref1 === void 0 ? void 0 : ref1.productData
        };
    }), cartData = ref.cartData, userData = ref.userData, detailedItem = ref.commonReducer.detailedItem, productData = ref.productData;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)({
        itemCartIdx: -1,
        cartCount: 0,
        showFullImage: {
            show: false,
            currentIndex: 0
        },
        discountPercentage: 0,
        activeVariant: -1,
        OSName: null,
        ownerNumber: null,
        isRedirect: false,
        cost: {
            discounted_price: 0,
            price: 0
        },
        viewDescription: false,
        selectedVariantId: -1,
        additionalRemark: [],
        showAuthModal: false,
        isMainProductLink: false
    }), state = ref1[0], setState = ref1[1];
    var itemIndexInCart = (0,_utils_itemIndexFromCart__WEBPACK_IMPORTED_MODULE_11__/* .itemIndexFromCart */ .R)(cartData, productData);
    var onPersonalizeProductClick = function() {
        dispatch((0,_redux_actions__WEBPACK_IMPORTED_MODULE_10__/* .openProductPersonalizationPopUp */ .w4)());
    };
    var getType = function(type) {
        switch(type){
            case "add":
            case "inc":
                return "inc";
            case "dec":
            case "save":
                return type;
            case "confirm":
                return type;
            default:
                return "";
        }
    };
    var handleCart = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(function(type) {
            var personalizedProductData, ppIdx, itemData, source, personalizationLocalState, scheduleInfo, ref, ref1, ref2, item, ref3, activeVariantId, activeVariant, newCart, ref4, ref5, ref6, idx, cartItem, updatedCartItems, newState, ref7, ref8, ref9, idx1, cartItem1, updatedCartItems1;
            var _arguments = arguments;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_13__.__generator)(this, function(_state) {
                personalizedProductData = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : null, ppIdx = _arguments.length > 2 ? _arguments[2] : void 0, itemData = _arguments.length > 3 && _arguments[3] !== void 0 ? _arguments[3] : null, source = _arguments.length > 4 && _arguments[4] !== void 0 ? _arguments[4] : "", personalizationLocalState = _arguments.length > 5 && _arguments[5] !== void 0 ? _arguments[5] : null, scheduleInfo = _arguments.length > 6 && _arguments[6] !== void 0 ? _arguments[6] : null;
                item = (ref2 = itemData !== null && itemData !== void 0 ? itemData : productData) !== null && ref2 !== void 0 ? ref2 : detailedItem;
                if ((item === null || item === void 0 ? void 0 : item.variants_count) > 0) {
                    ;
                    dispatch((0,_redux_actions__WEBPACK_IMPORTED_MODULE_14__/* .saveProductLoaderId */ .XG)(item === null || item === void 0 ? void 0 : item.id));
                    dispatch((0,_redux_actions__WEBPACK_IMPORTED_MODULE_14__/* .saveDetailedItemById */ .VY)(item));
                    activeVariantId = _utils_checkRenderEnv__WEBPACK_IMPORTED_MODULE_9__/* .IS_CLIENT */ .kc && localStorage.getItem("activeVariantId");
                    activeVariant = item === null || item === void 0 ? void 0 : (ref3 = item.variants) === null || ref3 === void 0 ? void 0 : ref3.find(function(el) {
                        return "".concat(el === null || el === void 0 ? void 0 : el.variant_id) === activeVariantId;
                    });
                    if (state.activeVariant === -1 && _utils_checkRenderEnv__WEBPACK_IMPORTED_MODULE_9__/* .IS_CLIENT */ .kc && !localStorage.getItem("activeVariantId")) {
                        switch(type){
                            case "add":
                                dispatch((0,_redux_actions__WEBPACK_IMPORTED_MODULE_14__/* .setVariantModalVisibility */ .VZ)(true));
                                break;
                            case "inc":
                                dispatch((0,_redux_actions__WEBPACK_IMPORTED_MODULE_14__/* .setChooseAndRepeatModalVisibility */ .uT)(true));
                                break;
                            case "dec":
                                dispatch((0,_redux_actions__WEBPACK_IMPORTED_MODULE_14__/* .setSelectedVariantModalVisibility */ .rV)(true));
                                break;
                            default:
                                break;
                        }
                    } else {
                        if (type === "inc" || type === "add") {
                            dispatch((0,_redux_actions__WEBPACK_IMPORTED_MODULE_14__/* .setVariantModalVisibility */ .VZ)(false));
                        } else if (type === "dec") {
                            dispatch((0,_redux_actions__WEBPACK_IMPORTED_MODULE_14__/* .setSelectedVariantModalVisibility */ .rV)(false));
                        }
                        newCart = (0,_utils_mutateVariantItemWithCartData__WEBPACK_IMPORTED_MODULE_4__/* .mutateVariantItemWithCartData */ .I)(getType(type), item, activeVariant, cartData, personalizedProductData, ppIdx, personalizationLocalState);
                        if (newCart) {
                            ;
                            newCart["store_id"] = storeInfo === null || storeInfo === void 0 ? void 0 : storeInfo.store_id;
                            idx = newCart === null || newCart === void 0 ? void 0 : (ref4 = newCart.items) === null || ref4 === void 0 ? void 0 : ref4.findIndex(function(ele) {
                                return (ele === null || ele === void 0 ? void 0 : ele.item_id) === (item === null || item === void 0 ? void 0 : item.id);
                            });
                            cartItem = newCart === null || newCart === void 0 ? void 0 : (ref5 = newCart.items) === null || ref5 === void 0 ? void 0 : ref5[idx];
                            if (scheduleInfo && cartItem) {
                                cartItem.schedule_info = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)({}, cartItem.schedule_info || {}), {
                                    item_id: item === null || item === void 0 ? void 0 : item.id
                                }), scheduleInfo);
                            }
                            updatedCartItems = cartItem === null || cartItem === void 0 ? void 0 : (ref6 = cartItem.variants_selected) === null || ref6 === void 0 ? void 0 : ref6.find(function(el) {
                                return (el === null || el === void 0 ? void 0 : el.variant_id) === (activeVariant === null || activeVariant === void 0 ? void 0 : activeVariant.variant_id);
                            });
                            dispatch((0,_redux_actions__WEBPACK_IMPORTED_MODULE_17__/* .setCart */ .RV)(newCart));
                            if (item === null || item === void 0 ? void 0 : item.product_personalization) {
                                dispatch((0,_redux_actions__WEBPACK_IMPORTED_MODULE_10__/* .addProductPersonalizationData */ .Qe)({
                                    personalizationData: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)({}, updatedCartItems), {
                                        id: cartItem === null || cartItem === void 0 ? void 0 : cartItem.id,
                                        discounted_price: cartItem === null || cartItem === void 0 ? void 0 : cartItem.discounted_price,
                                        item_name: cartItem === null || cartItem === void 0 ? void 0 : cartItem.item_name
                                    }),
                                    showPopUp: (0,_containers_ProductDescription_Utils_common__WEBPACK_IMPORTED_MODULE_18__/* .isShowPPModal */ ._h)(getType(type), updatedCartItems, source),
                                    source: source
                                }));
                            }
                        }
                    }
                } else {
                    newState = (0,_utils_mutateItemObjectWithCartData__WEBPACK_IMPORTED_MODULE_3__/* .mutateItemObjectWithCartData */ .L)(type, item, cartData, personalizedProductData, ppIdx, personalizationLocalState);
                    if (newState) {
                        ;
                        newState["store_id"] = storeInfo === null || storeInfo === void 0 ? void 0 : storeInfo.store_id;
                        idx1 = newState === null || newState === void 0 ? void 0 : (ref7 = newState.items) === null || ref7 === void 0 ? void 0 : ref7.findIndex(function(ele) {
                            return (ele === null || ele === void 0 ? void 0 : ele.item_id) === (item === null || item === void 0 ? void 0 : item.id);
                        });
                        cartItem1 = newState === null || newState === void 0 ? void 0 : (ref8 = newState.items) === null || ref8 === void 0 ? void 0 : ref8[idx1];
                        if (scheduleInfo && cartItem1) {
                            cartItem1.schedule_info = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)({}, cartItem1.schedule_info || {}), {
                                item_id: item === null || item === void 0 ? void 0 : item.id
                            }), scheduleInfo);
                        }
                        dispatch((0,_redux_actions__WEBPACK_IMPORTED_MODULE_17__/* .setCart */ .RV)(newState));
                        updatedCartItems1 = newState === null || newState === void 0 ? void 0 : (ref9 = newState.items) === null || ref9 === void 0 ? void 0 : ref9.find(function(ele) {
                            return (ele === null || ele === void 0 ? void 0 : ele.item_id) === (item === null || item === void 0 ? void 0 : item.id) || (ele === null || ele === void 0 ? void 0 : ele.item_id) === (item === null || item === void 0 ? void 0 : item.item_id);
                        });
                        if (item === null || item === void 0 ? void 0 : item.product_personalization) {
                            dispatch((0,_redux_actions__WEBPACK_IMPORTED_MODULE_10__/* .addProductPersonalizationData */ .Qe)({
                                personalizationData: updatedCartItems1,
                                showPopUp: false,
                                source: source
                            }));
                        }
                    } else {
                        dispatch((0,_redux_actions__WEBPACK_IMPORTED_MODULE_17__/* .setCart */ .RV)(cartData));
                    }
                }
                dispatch((0,_redux_actions__WEBPACK_IMPORTED_MODULE_19__/* .pushEventsLog */ .U)({
                    event_name: "Cx_ATC",
                    data: {
                        store_id: storeInfo === null || storeInfo === void 0 ? void 0 : storeInfo.store_id,
                        domain: storeInfo === null || storeInfo === void 0 ? void 0 : (ref = storeInfo.store_info) === null || ref === void 0 ? void 0 : ref.domain,
                        page: window.location.href,
                        device: _utils_deviceWidth__WEBPACK_IMPORTED_MODULE_6__/* .deviceWidth */ .o <= _utils_constants__WEBPACK_IMPORTED_MODULE_7__/* .MAX_MOBILE_WIDTH */ .Cf ? "Mobile" : "Desktop",
                        cx_number: userData === null || userData === void 0 ? void 0 : (ref1 = userData.data) === null || ref1 === void 0 ? void 0 : ref1.phone
                    }
                }));
                return [
                    2
                ];
            });
        });
        return function(type) {
            return _ref.apply(this, arguments);
        };
    }(), [
        productData,
        cartData,
        storeInfo,
        userData
    ]);
    var onBuyNowClick = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
        var personalizedProductData = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, scheduleInfo = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
        var ref;
        setState(function(state) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)({}, state), {
                isRedirect: true
            });
        });
        var itemIndex = (0,_utils_itemIndexFromCart__WEBPACK_IMPORTED_MODULE_11__/* .itemIndexFromCart */ .R)(cartData, productData);
        if (itemIndex === -1 || (productData === null || productData === void 0 ? void 0 : productData.product_personalization)) {
            handleCart("add", personalizedProductData, null, productData, null, null, scheduleInfo);
        }
        router.push((0,_utils_routes__WEBPACK_IMPORTED_MODULE_5__.getRoute)(_utils_routes__WEBPACK_IMPORTED_MODULE_5__.PATH.CART, storeInfo === null || storeInfo === void 0 ? void 0 : (ref = storeInfo.store_info) === null || ref === void 0 ? void 0 : ref.domain));
    }, [
        handleCart,
        router,
        cartData,
        productData,
        storeInfo
    ]);
    var handleIncreamentClick = function(type) {
        var detailedItem = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
        var itemData = detailedItem !== null && detailedItem !== void 0 ? detailedItem : productData;
        handleSetProductData(itemData);
        var activeVariantId = _utils_checkRenderEnv__WEBPACK_IMPORTED_MODULE_9__/* .IS_CLIENT */ .kc && localStorage.getItem("activeVariantId");
        if (itemData === null || itemData === void 0 ? void 0 : itemData.product_personalization) {
            var ref;
            handleSetProductCustomizationCount(itemData);
            var cartItem = cartData === null || cartData === void 0 ? void 0 : (ref = cartData.items) === null || ref === void 0 ? void 0 : ref.find(function(ele) {
                return (ele === null || ele === void 0 ? void 0 : ele.item_id) === (itemData === null || itemData === void 0 ? void 0 : itemData.id) || (ele === null || ele === void 0 ? void 0 : ele.item_id) === (itemData === null || itemData === void 0 ? void 0 : itemData.item_id);
            });
            var findCartItem = (itemData === null || itemData === void 0 ? void 0 : itemData.variants_count) > 0 ? cartItem === null || cartItem === void 0 ? void 0 : cartItem.variants_selected.find(function(el) {
                return "".concat(el === null || el === void 0 ? void 0 : el.variant_id) === activeVariantId;
            }) : cartItem;
            if ((itemData === null || itemData === void 0 ? void 0 : itemData.variants_count) > 0) {
                findCartItem = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)({}, findCartItem), {
                    id: cartItem === null || cartItem === void 0 ? void 0 : cartItem.id,
                    amount: cartItem === null || cartItem === void 0 ? void 0 : cartItem.amount,
                    item_name: cartItem === null || cartItem === void 0 ? void 0 : cartItem.item_name
                });
            }
            dispatch((0,_redux_actions__WEBPACK_IMPORTED_MODULE_10__/* .addProductPersonalizationData */ .Qe)({
                personalizationData: findCartItem,
                actionType: "inc"
            }));
        } else {
            handleCart(type);
        }
    };
    var handleDecreamentClick = function(type) {
        var detailedItem = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, source = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "";
        var itemData = detailedItem !== null && detailedItem !== void 0 ? detailedItem : productData;
        handleSetProductData(itemData);
        var activeVariantId = _utils_checkRenderEnv__WEBPACK_IMPORTED_MODULE_9__/* .IS_CLIENT */ .kc && localStorage.getItem("activeVariantId");
        if (itemData === null || itemData === void 0 ? void 0 : itemData.product_personalization) {
            var ref, ref1;
            handleSetProductCustomizationCount(itemData);
            var cartItem = cartData === null || cartData === void 0 ? void 0 : (ref = cartData.items) === null || ref === void 0 ? void 0 : ref.find(function(ele) {
                return ele.item_id === itemData.id || ele.item_id === itemData.item_id;
            });
            var findCartItem = (itemData === null || itemData === void 0 ? void 0 : itemData.variants_count) > 0 ? cartItem === null || cartItem === void 0 ? void 0 : cartItem.variants_selected.find(function(el) {
                return "".concat(el === null || el === void 0 ? void 0 : el.variant_id) === activeVariantId;
            }) : cartData === null || cartData === void 0 ? void 0 : (ref1 = cartData.items) === null || ref1 === void 0 ? void 0 : ref1.find(function(item) {
                return (item === null || item === void 0 ? void 0 : item.item_id) === (itemData === null || itemData === void 0 ? void 0 : itemData.id) || (item === null || item === void 0 ? void 0 : item.item_id) === (itemData === null || itemData === void 0 ? void 0 : itemData.item_id);
            });
            if ((itemData === null || itemData === void 0 ? void 0 : itemData.variants_count) > 0) {
                findCartItem = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)({}, findCartItem), {
                    id: (cartItem === null || cartItem === void 0 ? void 0 : cartItem.id) || (cartItem === null || cartItem === void 0 ? void 0 : cartItem.item_id),
                    amount: cartItem === null || cartItem === void 0 ? void 0 : cartItem.amount,
                    item_name: cartItem === null || cartItem === void 0 ? void 0 : cartItem.item_name
                });
            }
            if ((findCartItem === null || findCartItem === void 0 ? void 0 : findCartItem.quantity) > 1) {
                dispatch((0,_redux_actions__WEBPACK_IMPORTED_MODULE_10__/* .addProductPersonalizationData */ .Qe)({
                    personalizationData: findCartItem,
                    source: source,
                    actionType: "dec"
                }));
            } else {
                var ref2;
                handleCart(type, findCartItem === null || findCartItem === void 0 ? void 0 : (ref2 = findCartItem.personalization_info) === null || ref2 === void 0 ? void 0 : ref2.personalizations[0], null, itemData);
            }
        } else {
            handleCart(type);
        }
    };
    var handleSetProductCustomizationCount = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(data) {
        var ref, ref1, ref2;
        dispatch((0,_redux_actions__WEBPACK_IMPORTED_MODULE_10__/* .setPersonalizedProductCustomizationCount */ .An)({
            imageCount: data === null || data === void 0 ? void 0 : (ref = data.product_personalization) === null || ref === void 0 ? void 0 : ref.image_count,
            textCount: data === null || data === void 0 ? void 0 : (ref1 = data.product_personalization) === null || ref1 === void 0 ? void 0 : ref1.text_limit,
            allImageMandatory: data === null || data === void 0 ? void 0 : (ref2 = data.product_personalization) === null || ref2 === void 0 ? void 0 : ref2.is_image_mandatory
        }));
    }, []);
    var hydrateAdditionalRemarks = function() {
        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19;
        var value = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)(state.additionalRemark);
        if (itemIndexInCart === -1) return;
        if (state.activeVariant !== -1 && ((ref = cartData.items) === null || ref === void 0 ? void 0 : (ref1 = ref.variants_selected) === null || ref1 === void 0 ? void 0 : ref1[state.activeVariant])) (cartData === null || cartData === void 0 ? void 0 : (ref2 = cartData.items) === null || ref2 === void 0 ? void 0 : (ref3 = ref2[itemIndexInCart]) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.variants_selected) === null || ref4 === void 0 ? void 0 : (ref5 = ref4[state.activeVariant]) === null || ref5 === void 0 ? void 0 : ref5.additional_remark) && value.push({
            id: (ref6 = cartData.items) === null || ref6 === void 0 ? void 0 : (ref7 = ref6[itemIndexInCart]) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.variants_selected) === null || ref8 === void 0 ? void 0 : (ref9 = ref8[state.activeVariant]) === null || ref9 === void 0 ? void 0 : ref9.variant_id,
            remark: (cartData === null || cartData === void 0 ? void 0 : (ref10 = cartData.items) === null || ref10 === void 0 ? void 0 : (ref11 = ref10[itemIndexInCart]) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.variants_selected) === null || ref12 === void 0 ? void 0 : (ref13 = ref12[state.activeVariant]) === null || ref13 === void 0 ? void 0 : ref13.additional_remark) || ""
        });
        else (cartData === null || cartData === void 0 ? void 0 : (ref14 = cartData.items) === null || ref14 === void 0 ? void 0 : (ref15 = ref14[itemIndexInCart]) === null || ref15 === void 0 ? void 0 : ref15.additional_remark) && value.push({
            id: cartData === null || cartData === void 0 ? void 0 : (ref16 = cartData.items) === null || ref16 === void 0 ? void 0 : (ref17 = ref16[itemIndexInCart]) === null || ref17 === void 0 ? void 0 : ref17.item_id,
            remark: (cartData === null || cartData === void 0 ? void 0 : (ref18 = cartData.items) === null || ref18 === void 0 ? void 0 : (ref19 = ref18[itemIndexInCart]) === null || ref19 === void 0 ? void 0 : ref19.additional_remark) || ""
        });
        value !== state.additionalRemark && setState(function(state) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)({}, state), {
                additionalRemark: value
            });
        });
    };
    var handleSetState = function(data) {
        setState(function(prevState) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)({}, prevState), {
                activeVariant: data
            });
        });
    };
    var setProductData = function(data) {
        dispatch((0,_redux_actions__WEBPACK_IMPORTED_MODULE_10__/* .setProductDataPersonalised */ .$d)(data));
    };
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        hydrateAdditionalRemarks();
    }, [
        cartData
    ]);
    return {
        productData: productData,
        setProductData: setProductData,
        handleCart: handleCart,
        onBuyNowClick: onBuyNowClick,
        handleIncreamentClick: handleIncreamentClick,
        handleDecreamentClick: handleDecreamentClick,
        onPersonalizeProductClick: onPersonalizeProductClick,
        handleSetProductCustomizationCount: handleSetProductCustomizationCount,
        setState: setState,
        handleSetState: handleSetState,
        handleSetProductData: handleSetProductData
    };
}


/***/ }),

/***/ 482516:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ useFeatureLocks; }
/* harmony export */ });
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(913886);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(667294);
/* harmony import */ var src_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(268037);



function useFeatureLocks() {
    var ref = (0,src_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSSRSelector */ .kF)(function(state) {
        return {
            featureLocks: state.commonReducer.featureLocksData.featureLocks,
            storeData: state.storeReducer.store
        };
    }), featureLocks = ref.featureLocks, storeData = ref.storeData;
    var isEcommExpired = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return (storeData === null || storeData === void 0 ? void 0 : storeData.subscription_flag) === _utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .SUBSCRIPTION_FLAG.EXPIRED */ .NU.EXPIRED;
    }, [
        storeData === null || storeData === void 0 ? void 0 : storeData.subscription_flag
    ]);
    var crrFeatureStatus = featureLocks["crr"];
    var couponsFeatureStatus = featureLocks["couponsVouchers"];
    var fbPixelFeatureStatus = featureLocks["fbPixel"];
    var googleAnalyticsFeatureStatus = featureLocks["googleAnalytics"];
    var googleTagFeatureStatus = featureLocks["gtm"];
    var installAppFeatureStatus = featureLocks["installApp"];
    var leadGenFeatureStatus = featureLocks["leadGen"];
    var visitorLoginFeatureStatus = featureLocks["visitorLogin"];
    var collectionsFeatureStatus = featureLocks["collections"];
    var notifyMeFeatureStatus = featureLocks["notifyMe"];
    var partialPaymentFeatureStatus = featureLocks["partialPayment"];
    var memberOnlyLoginFeatureStatus = featureLocks["memberOnlyLogin"];
    var wishlistFeatureStatus = featureLocks["wishlist"];
    return {
        collectionsFeatureStatus: collectionsFeatureStatus,
        couponsFeatureStatus: couponsFeatureStatus,
        crrFeatureStatus: crrFeatureStatus,
        fbPixelFeatureStatus: fbPixelFeatureStatus,
        googleAnalyticsFeatureStatus: googleAnalyticsFeatureStatus,
        googleTagFeatureStatus: googleTagFeatureStatus,
        installAppFeatureStatus: installAppFeatureStatus,
        leadGenFeatureStatus: leadGenFeatureStatus,
        visitorLoginFeatureStatus: visitorLoginFeatureStatus,
        isEcommExpired: isEcommExpired,
        notifyMeFeatureStatus: notifyMeFeatureStatus,
        partialPaymentFeatureStatus: partialPaymentFeatureStatus,
        memberOnlyLoginFeatureStatus: memberOnlyLoginFeatureStatus,
        wishlistFeatureStatus: wishlistFeatureStatus
    };
}


/***/ }),

/***/ 662946:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n": function() { return /* binding */ useGetDeviceType; }
/* harmony export */ });
/* harmony import */ var _components_WidgetMaker_WidgetDnD_isMobileDevice__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(826910);
/* harmony import */ var src_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(268037);
/* harmony import */ var src_utils_checkRenderEnv__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(506337);
/* harmony import */ var src_utils_operatingSystem__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(755311);




function useGetDeviceType() {
    var props = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : undefined;
    // eslint-disable-next-line
    // const { customDeviceCheck } = (props || {}) as IProps;
    var userAgent = (0,src_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSSRSelector */ .kF)(function(state) {
        return state.commonReducer.userAgent;
    });
    var isInitialRequestByMobile = (0,_components_WidgetMaker_WidgetDnD_isMobileDevice__WEBPACK_IMPORTED_MODULE_0__/* .isMobileDevice */ .s)();
    if (src_utils_checkRenderEnv__WEBPACK_IMPORTED_MODULE_2__/* .IS_SERVER */ .W6 && userAgent) {
        isInitialRequestByMobile = (0,src_utils_operatingSystem__WEBPACK_IMPORTED_MODULE_3__/* .isMobileByUA */ .wi)({
            skipServerCheck: true,
            uAgent: userAgent
        });
    } else {
        isInitialRequestByMobile = (0,_components_WidgetMaker_WidgetDnD_isMobileDevice__WEBPACK_IMPORTED_MODULE_0__/* .isMobileDevice */ .s)();
    }
    var isMobile = isInitialRequestByMobile;
    return {
        deviceType: isMobile ? "mobile" : "desktop",
        isMobile: isMobile
    };
}


/***/ }),

/***/ 232876:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useNavConfigs; }
/* harmony export */ });
/* harmony import */ var src_context_WidgetDndContext__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(474151);
/* harmony import */ var src_utils_useCheckIfHomePage__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(576609);


var useNavConfigs = function(isScrollable) {
    var isHeaderHovered = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6;
    var isHomePage = (0,src_utils_useCheckIfHomePage__WEBPACK_IMPORTED_MODULE_1__/* .useCheckIfHomePage */ .t)();
    var ref7 = (0,src_context_WidgetDndContext__WEBPACK_IMPORTED_MODULE_0__/* .useWidgetDndContextData */ .KX)(), _widgetContextState = ref7.widgetContextState, isBuilder = _widgetContextState.isBuilder, activeHeaderData = _widgetContextState.activeHeaderData;
    var globalClass = (activeHeaderData === null || activeHeaderData === void 0 ? void 0 : (ref = activeHeaderData.headerPropsConfig) === null || ref === void 0 ? void 0 : ref.globalClass) || {};
    var ref8 = globalClass || {}, staticClass = ref8.staticClass, scrollClass = ref8.scrollClass;
    var isTransparent = (globalClass === null || globalClass === void 0 ? void 0 : (ref1 = globalClass.staticClass) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.base_config) === null || ref2 === void 0 ? void 0 : ref2.defaultFillColorType) === "transparent";
    var scrollType = (activeHeaderData === null || activeHeaderData === void 0 ? void 0 : (ref3 = activeHeaderData.headerPropsConfig) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.globalClass) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.scrollClass) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.base_config) === null || ref6 === void 0 ? void 0 : ref6.defaultScrollType) || "";
    var shouldUseScrollClass = isTransparent && (isScrollable || isHeaderHovered || !isBuilder && !isHomePage);
    var showTransparentBgHeader = isTransparent && !shouldUseScrollClass;
    var currentClass = shouldUseScrollClass ? scrollClass : staticClass;
    return {
        isHomePage: isHomePage,
        isBuilder: isBuilder,
        globalClass: globalClass,
        scrollClass: scrollClass,
        staticClass: staticClass,
        currentClass: currentClass,
        isTransparent: isTransparent,
        shouldUseScrollClass: shouldUseScrollClass,
        showTransparentBgHeader: showTransparentBgHeader,
        scrollType: scrollType
    };
};


/***/ }),

/***/ 177137:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "u": function() { return /* binding */ useNavlinkStyling; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(626042);
/* harmony import */ var src_components_DesignSystem_Widgets2_0_Header_components_getSizeAccType__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(106790);
/* harmony import */ var src_context_WidgetDndContext__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(474151);
/* harmony import */ var _useGetDeviceType__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(662946);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(667294);
/* harmony import */ var _useNavConfigs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(232876);






function useNavlinkStyling() {
    var props = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var getHoverTextColor = function getHoverTextColor() {
        var ref;
        var type = currentClass === null || currentClass === void 0 ? void 0 : (ref = currentClass.base_config) === null || ref === void 0 ? void 0 : ref.defaulthoverType;
        switch(type){
            case "Underline":
                var ref1;
                return currentClass === null || currentClass === void 0 ? void 0 : (ref1 = currentClass.base_config) === null || ref1 === void 0 ? void 0 : ref1.defaultUnderlineTextColor;
            case "Background Box":
                var ref2;
                return currentClass === null || currentClass === void 0 ? void 0 : (ref2 = currentClass.base_config) === null || ref2 === void 0 ? void 0 : ref2.defaultBoxTextColor;
            case "None":
                var ref3;
                return currentClass === null || currentClass === void 0 ? void 0 : (ref3 = currentClass.base_config) === null || ref3 === void 0 ? void 0 : ref3.defaultNavLinksColor;
        }
    };
    var getNavElementStyle = function getNavElementStyle() {
        var index = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, parentIndex = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : -1, isHoverEnabled = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13;
        var noParentSet = parentHoverIndex === -1;
        var isParentHovered = parentIndex === parentHoverIndex;
        var isHovered = isHoverEnabled && (noParentSet || isParentHovered) && hoverIndex === index;
        var textColor = isHovered ? getHoverTextColor() : currentClass === null || currentClass === void 0 ? void 0 : (ref = currentClass.base_config) === null || ref === void 0 ? void 0 : ref.defaultNavLinksColor;
        return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
            fontSize: (0,src_components_DesignSystem_Widgets2_0_Header_components_getSizeAccType__WEBPACK_IMPORTED_MODULE_5__/* .getSizeAccType */ .IZ)(globalClass === null || globalClass === void 0 ? void 0 : (ref1 = globalClass.staticClass) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.base_config) === null || ref2 === void 0 ? void 0 : ref2.defaultTextFontSize, isMobile ? globalClass === null || globalClass === void 0 ? void 0 : (ref3 = globalClass.staticClass) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.base_config) === null || ref4 === void 0 ? void 0 : ref4.defaultFontSizeTypeMobile : globalClass === null || globalClass === void 0 ? void 0 : (ref5 = globalClass.staticClass) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.base_config) === null || ref6 === void 0 ? void 0 : ref6.defaultFontSizeType),
            fontWeight: isHovered ? currentClass === null || currentClass === void 0 ? void 0 : (ref7 = currentClass.base_config) === null || ref7 === void 0 ? void 0 : ref7.defaultTextFontWeightOnHover : globalClass === null || globalClass === void 0 ? void 0 : (ref8 = globalClass.staticClass) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.base_config) === null || ref9 === void 0 ? void 0 : ref9.defaultTextFontWeight,
            color: textColor || "#000",
            borderColor: (textColor || "#111C36") + "1F",
            textTransform: (globalClass === null || globalClass === void 0 ? void 0 : (ref10 = globalClass.staticClass) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.base_config) === null || ref11 === void 0 ? void 0 : ref11.defaultTextDecoration) || "capitalize"
        }, isHovered && (currentClass === null || currentClass === void 0 ? void 0 : (ref12 = currentClass.base_config) === null || ref12 === void 0 ? void 0 : ref12.defaulthoverType) === "Background Box" ? {
            width: "max-content",
            backgroundColor: currentClass === null || currentClass === void 0 ? void 0 : (ref13 = currentClass.base_config) === null || ref13 === void 0 ? void 0 : ref13.defaultBoxBackgroundColor
        } : {});
    };
    var ref;
    var _isScrollable = props.isScrollable, isScrollable = _isScrollable === void 0 ? false : _isScrollable, _parentHoverIndex = props.parentHoverIndex, parentHoverIndex = _parentHoverIndex === void 0 ? -1 : _parentHoverIndex, _isHeaderHovered = props.isHeaderHovered, isHeaderHovered = _isHeaderHovered === void 0 ? true : _isHeaderHovered;
    var deviceType = (0,_useGetDeviceType__WEBPACK_IMPORTED_MODULE_1__/* .useGetDeviceType */ .n)().deviceType;
    var isMobile = deviceType === "mobile";
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(null), hoverIndex = ref1[0], setHoverIndex = ref1[1];
    var getWidgetSSRState = (0,src_context_WidgetDndContext__WEBPACK_IMPORTED_MODULE_0__/* .useWidgetDndContextData */ .KX)().getWidgetSSRState;
    var activeHeaderData = getWidgetSSRState().activeHeaderData;
    var globalClass = (activeHeaderData === null || activeHeaderData === void 0 ? void 0 : (ref = activeHeaderData.headerPropsConfig) === null || ref === void 0 ? void 0 : ref.globalClass) || {};
    var currentClass = (0,_useNavConfigs__WEBPACK_IMPORTED_MODULE_3__/* .useNavConfigs */ .Z)(isScrollable, isHeaderHovered).currentClass;
    var onLinkHoverEnter = function(index) {
        setHoverIndex(index);
    };
    var onLinkHoverLeave = function() {
        setHoverIndex(null);
    };
    return {
        onLinkHoverLeave: onLinkHoverLeave,
        onLinkHoverEnter: onLinkHoverEnter,
        getNavElementStyle: getNavElementStyle,
        hoverIndex: hoverIndex
    };
}


/***/ }),

/***/ 953395:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(667294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(225617);
/* harmony import */ var _redux_actions__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(731024);



function useSaveHeaderHeight(ref) {
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useDispatch */ .I0)();
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var _$ref;
        dispatch((0,_redux_actions__WEBPACK_IMPORTED_MODULE_2__/* .saveHeaderRef */ .hq)(ref));
        dispatch((0,_redux_actions__WEBPACK_IMPORTED_MODULE_2__/* .saveHeaderHeight */ .OP)((_$ref = ref.current) === null || _$ref === void 0 ? void 0 : _$ref.offsetHeight));
    }, [
        ref === null || ref === void 0 ? void 0 : ref.current
    ]);
}
/* harmony default export */ __webpack_exports__["Z"] = (useSaveHeaderHeight);


/***/ }),

/***/ 299375:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var src_redux__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(268037);
/* harmony import */ var src_utils_getContactDetails__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(160492);


var useStoreContactDetails = function() {
    var hideOwnerPhone = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    var storeData = (0,src_redux__WEBPACK_IMPORTED_MODULE_0__/* .useSSRSelector */ .kF)(function(state) {
        return state.storeReducer.store;
    });
    return (0,src_utils_getContactDetails__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(storeData, true, hideOwnerPhone);
};
/* harmony default export */ __webpack_exports__["Z"] = (useStoreContactDetails);


/***/ }),

/***/ 313508:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ty": function() { return /* binding */ SSR_MOBILE; },
/* harmony export */   "q$": function() { return /* binding */ IS_MOBILE; },
/* harmony export */   "wd": function() { return /* binding */ SSR_DESKTOP; },
/* harmony export */   "yn": function() { return /* binding */ IS_DESKTOP; }
/* harmony export */ });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(913886);
/* harmony import */ var _checkRenderEnv__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(506337);
/* harmony import */ var _deviceWidth__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(186812);



/**
 * `false` if code is running on SSR
 * `true` if code is running in browser Desktop
 * @type {Boolean}
 */ var IS_DESKTOP = _checkRenderEnv__WEBPACK_IMPORTED_MODULE_1__/* .IS_CLIENT */ .kc && _deviceWidth__WEBPACK_IMPORTED_MODULE_2__/* .deviceWidth */ .o > _constants__WEBPACK_IMPORTED_MODULE_0__/* .MAX_MOBILE_WIDTH */ .Cf;
/**
 * `false` if code is running on SSR
 * `true` if code is running in browser Mobile
 * * @type {Boolean}
 */ var IS_MOBILE = _checkRenderEnv__WEBPACK_IMPORTED_MODULE_1__/* .IS_CLIENT */ .kc && _deviceWidth__WEBPACK_IMPORTED_MODULE_2__/* .deviceWidth */ .o <= _constants__WEBPACK_IMPORTED_MODULE_0__/* .MAX_MOBILE_WIDTH */ .Cf;
/**
 * - `true` if code is running on SSR or browser Desktop
 * - Use with CSS utility class `.visible-desktop` for correct SSR behavior.
 *
 * ```javascript
 * {SSR_DESKTOP && <div className="visible-desktop"></div>}
 * ```
 */ var SSR_DESKTOP = _checkRenderEnv__WEBPACK_IMPORTED_MODULE_1__/* .IS_SERVER */ .W6 || IS_DESKTOP;
/**
 * - `true` if code is running on SSR or browser Mobile
 * - Use with CSS utility class `.visible-mobile` for correct SSR behavior.
 * ```javascript
 * {SSR_MOBILE && <div className="visible-mobile"></div>}
 * ```
 */ var SSR_MOBILE = _checkRenderEnv__WEBPACK_IMPORTED_MODULE_1__/* .IS_SERVER */ .W6 || IS_MOBILE;


/***/ }),

/***/ 990864:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ getDeviceInfo; }
/* harmony export */ });
/* harmony import */ var _checkRenderEnv__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(506337);
/* eslint-disable react/no-is-mounted */ 
var getDeviceInfo = function() {
    if (_checkRenderEnv__WEBPACK_IMPORTED_MODULE_0__/* .IS_SERVER */ .W6) {
        return {
            deviceWidth: 0,
            OSName: ""
        };
    }
    var modular = {
        options: [],
        header: [
            navigator.platform,
            navigator.userAgent,
            navigator.appVersion,
            navigator.vendor,
            window.opera, 
        ],
        dataos: [
            {
                name: "Windows Phone",
                value: "Windows Phone",
                version: "OS"
            },
            {
                name: "Windows",
                value: "Win",
                version: "NT"
            },
            {
                name: "iPhone",
                value: "iPhone",
                version: "OS"
            },
            {
                name: "iPad",
                value: "iPad",
                version: "OS"
            },
            {
                name: "Kindle",
                value: "Silk",
                version: "Silk"
            },
            {
                name: "Android",
                value: "Android",
                version: "Android"
            },
            {
                name: "PlayBook",
                value: "PlayBook",
                version: "OS"
            },
            {
                name: "BlackBerry",
                value: "BlackBerry",
                version: "/"
            },
            {
                name: "Macintosh",
                value: "Mac",
                version: "OS X"
            },
            {
                name: "Linux",
                value: "Linux",
                version: "rv"
            },
            {
                name: "Palm",
                value: "Palm",
                version: "PalmOS"
            }, 
        ],
        databrowser: [
            {
                name: "Chrome",
                value: "Chrome",
                version: "Chrome"
            },
            {
                name: "Firefox",
                value: "Firefox",
                version: "Firefox"
            },
            {
                name: "Safari",
                value: "Safari",
                version: "Version"
            },
            {
                name: "Internet Explorer",
                value: "MSIE",
                version: "MSIE"
            },
            {
                name: "Opera",
                value: "Opera",
                version: "Opera"
            },
            {
                name: "BlackBerry",
                value: "CLDC",
                version: "CLDC"
            },
            {
                name: "Mozilla",
                value: "Mozilla",
                version: "Mozilla"
            }, 
        ],
        init: function init() {
            var agent = this.header.join(" ");
            var os = this.matchItem(agent, this.dataos);
            var browser = this.matchItem(agent, this.databrowser);
            return {
                os: os,
                browser: browser
            };
        },
        matchItem: function matchItem(string, data) {
            var i = 0;
            var j = 0;
            var regex;
            var regexv;
            var match;
            var matches;
            var version;
            for(i = 0; i < data.length; i += 1){
                regex = new RegExp(data[i].value, "i");
                match = regex.test(string);
                if (match) {
                    regexv = new RegExp(data[i].version + "[- /:;]([\\d._]+)", "i");
                    matches = string.match(regexv);
                    version = "";
                    if (matches) {
                        if (matches[1]) {
                            matches = matches[1];
                        }
                    }
                    if (matches) {
                        matches = matches.split(/[._]+/);
                        for(j = 0; j < matches.length; j += 1){
                            if (j === 0) {
                                version += matches[j] + ".";
                            } else {
                                version += matches[j];
                            }
                        }
                    } else {
                        version = "0";
                    }
                    return {
                        name: data[i].name,
                        version: parseFloat(version)
                    };
                }
            }
            return {
                name: "unknown",
                version: 0
            };
        }
    };
    var getVisualViewportWidth = function() {
        return window.visualViewport ? window.visualViewport.width : window.innerWidth;
    };
    var e = modular.init();
    return {
        OSName: e.os.name,
        OSVersion: e.os.version,
        BrowserName: e.browser.name,
        BrowserVersion: e.browser.version,
        userAgent: navigator.userAgent,
        platform: navigator.platform,
        deviceWidth: getVisualViewportWidth(),
        deviceHeight: window.innerHeight
    };
};


/***/ }),

/***/ 186812:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ OSName; },
/* harmony export */   "o": function() { return /* binding */ deviceWidth; }
/* harmony export */ });
/* harmony import */ var _deviceInfo__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(990864);

var ref = (0,_deviceInfo__WEBPACK_IMPORTED_MODULE_0__/* .getDeviceInfo */ .d)();
var deviceWidth = ref.deviceWidth, OSName = ref.OSName;


/***/ }),

/***/ 218626:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ removeEmoticons; }
/* harmony export */ });
/* unused harmony export ifEmoticonsExists */
/**
 * Helper function to check whether
 * emoticons exists in string
 * @param string
 * @returns boolean
 */ var ifEmoticonsExists = function(text) {
    var regexExp = /(\u00a9|\u00ae|[\u2000-\u3300]|\ud83c[\ud000-\udfff]|\ud83d[\ud000-\udfff]|\ud83e[\ud000-\udfff])/gi;
    return regexExp.test(text); // true or false
};
/**
 * Replace all emoticons from string provided
 * @param string
 * @returns boolean
 */ var removeEmoticons = function(text) {
    if (ifEmoticonsExists(text)) return text.replace(/(\u00a9|\u00ae|[\u2000-\u3300]|\ud83c[\ud000-\udfff]|\ud83d[\ud000-\udfff]|\ud83e[\ud000-\udfff])/g, "").trim();
    return text;
};


/***/ }),

/***/ 385126:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": function() { return /* binding */ executeLogout; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(626042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(269396);
/* harmony import */ var _redux_actions__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(656173);
/* harmony import */ var _redux_actions__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(666162);
/* harmony import */ var _redux_actions__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(368060);
/* harmony import */ var _redux_store__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(167261);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(811163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _routes__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(540190);
/**
 * common logout component. After logout
 * is initiated, if successful
 * reroute to product
 */ 





function executeLogout() {
    var ref, ref1, ref2, ref3;
    var storeData = (ref = _redux_store__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z === null || _redux_store__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z === void 0 ? void 0 : _redux_store__WEBPACK_IMPORTED_MODULE_0__/* ["default"].getState */ .Z.getState().storeReducer) === null || ref === void 0 ? void 0 : ref.store;
    var cartData = _redux_store__WEBPACK_IMPORTED_MODULE_0__/* ["default"].getState */ .Z.getState().cartReducer;
    localStorage.clear();
    _redux_store__WEBPACK_IMPORTED_MODULE_0__/* ["default"].dispatch */ .Z.dispatch((0,_redux_actions__WEBPACK_IMPORTED_MODULE_3__/* .setLogout */ .wt)());
    _redux_store__WEBPACK_IMPORTED_MODULE_0__/* ["default"].dispatch */ .Z.dispatch((0,_redux_actions__WEBPACK_IMPORTED_MODULE_4__/* .setCart */ .RV)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, cartData), {
        items: [],
        store_offer: {},
        payment_offer: {},
        cart_id: ""
    })));
    _redux_store__WEBPACK_IMPORTED_MODULE_0__/* ["default"].dispatch */ .Z.dispatch((0,_redux_actions__WEBPACK_IMPORTED_MODULE_7__/* .removeSelectedAddress */ .uz)());
    _redux_store__WEBPACK_IMPORTED_MODULE_0__/* ["default"].dispatch */ .Z.dispatch((0,_redux_actions__WEBPACK_IMPORTED_MODULE_7__/* .saveAddressList */ .Af)({
        addressList: [],
        defaultAddress: {}
    }));
    var route = (0,_routes__WEBPACK_IMPORTED_MODULE_2__.getRoute)((storeData === null || storeData === void 0 ? void 0 : (ref1 = storeData.theme) === null || ref1 === void 0 ? void 0 : ref1.custom_theme_flag) ? _routes__WEBPACK_IMPORTED_MODULE_2__.PATH.PRODUCT : _routes__WEBPACK_IMPORTED_MODULE_2__.PATH.SHOP, storeData === null || storeData === void 0 ? void 0 : (ref2 = storeData.store_info) === null || ref2 === void 0 ? void 0 : ref2.domain);
    if (storeData === null || storeData === void 0 ? void 0 : (ref3 = storeData.theme) === null || ref3 === void 0 ? void 0 : ref3.custom_theme_flag) {
        next_router__WEBPACK_IMPORTED_MODULE_1___default().push(route);
    } else {
        window.location.href = route;
    }
}


/***/ }),

/***/ 833104:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ getContrastingColor; }
/* harmony export */ });
/**
 * return the black/white color based on the contrast.
 * @param {*} bgColor background color given to header
 * @return {string} return black when contrast is high and vice versa
 */ function getContrastingColor(bgColor) {
    var lightColor = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, darkColor = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
    var c = bgColor === null || bgColor === void 0 ? void 0 : bgColor.substring(1);
    var rgb = parseInt(c, 16);
    var r = rgb >> 16 & 0xff;
    var g = rgb >> 8 & 0xff;
    var b = rgb >> 0 & 0xff;
    var luma = 0.2126 * r + 0.7152 * g + 0.0722 * b;
    if (luma < 127) {
        return lightColor || "#ffffff";
    } else {
        return darkColor || "#000000";
    }
}


/***/ }),

/***/ 336623:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _redux_store__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(167261);
/* harmony import */ var _utils_getStoreType__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66871);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(913886);



/** This utility function returns custom cta texts, certain labels based on is the store deliverying orders or
 * booking services
 * @param {string} type -> type of text you want
 * @return {string} -> text you wanted
 */ var getCustomCtaText = function(type) {
    var _store = _redux_store__WEBPACK_IMPORTED_MODULE_0__/* ["default"].getState */ .Z.getState().storeReducer.store, theme = _store.theme, services = _store.services;
    var isStoreServiceBased = (0,_utils_getStoreType__WEBPACK_IMPORTED_MODULE_1__/* .getStoreType */ .K)() !== _constants__WEBPACK_IMPORTED_MODULE_2__/* .STORE_CUSTOMIZATION.ORDER_BASED */ .DO.ORDER_BASED && (0,_utils_getStoreType__WEBPACK_IMPORTED_MODULE_1__/* .getStoreType */ .K)() != _constants__WEBPACK_IMPORTED_MODULE_2__/* .STORE_CUSTOMIZATION.B2B */ .DO.B2B;
    var isExtraChargeForCODActive = (services === null || services === void 0 ? void 0 : services.cod_charge_flag) > _constants__WEBPACK_IMPORTED_MODULE_2__/* .COD_CHARGE_TYPE.FREE */ .VV.FREE;
    var getBillConfirmedHeading = function() {
        switch((0,_utils_getStoreType__WEBPACK_IMPORTED_MODULE_1__/* .getStoreType */ .K)()){
            case _constants__WEBPACK_IMPORTED_MODULE_2__/* .STORE_CUSTOMIZATION.ORDER_BASED */ .DO.ORDER_BASED:
                return "Order placed successfully!";
            case _constants__WEBPACK_IMPORTED_MODULE_2__/* .STORE_CUSTOMIZATION.B2B */ .DO.B2B:
                return "Request submitted Successfully";
            default:
                return "Booked Successfully";
        }
    };
    var getBillOrderIdLabel = function() {
        var cart = _redux_store__WEBPACK_IMPORTED_MODULE_0__/* ["default"].getState */ .Z.getState().cartReducer;
        switch(cart.order_type){
            case _constants__WEBPACK_IMPORTED_MODULE_2__/* .ORDER_TYPE.SERVICE */ .Jm.SERVICE:
                return "Your Booking ID:";
            case _constants__WEBPACK_IMPORTED_MODULE_2__/* .ORDER_TYPE.B2B */ .Jm.B2B:
                return "Your Request ID:";
            default:
                return "Your Order ID:";
        }
    };
    switch(type){
        case "my_orders_cta":
            var ref, ref1;
            if ((0,_utils_getStoreType__WEBPACK_IMPORTED_MODULE_1__/* .getStoreType */ .K)() === _constants__WEBPACK_IMPORTED_MODULE_2__/* .STORE_CUSTOMIZATION.B2B */ .DO.B2B) return "My Requests";
            else if (theme === null || theme === void 0 ? void 0 : (ref = theme.cta_config) === null || ref === void 0 ? void 0 : ref.my_orders) return theme === null || theme === void 0 ? void 0 : (ref1 = theme.cta_config) === null || ref1 === void 0 ? void 0 : ref1.my_orders;
            else if (isStoreServiceBased) return "My Bookings";
            else return "My Orders";
        case "bill_confirm_heading":
            return getBillConfirmedHeading();
        case "placing_order_cta":
            if (isStoreServiceBased) return "Booking your Service";
            else return "Placing Your Order";
        case "buy_now_cta":
            var ref2, ref3;
            if (theme === null || theme === void 0 ? void 0 : (ref2 = theme.cta_config) === null || ref2 === void 0 ? void 0 : ref2.pdp_cta) return theme === null || theme === void 0 ? void 0 : (ref3 = theme.cta_config) === null || ref3 === void 0 ? void 0 : ref3.pdp_cta;
            else if (isStoreServiceBased) return "Book Now";
            else "Buy NOW";
        case "empty_cart_cta":
            return isStoreServiceBased ? "Book Now" : "Shop Now";
        case "banner_cta":
            var ref4, ref5;
            if ((0,_utils_getStoreType__WEBPACK_IMPORTED_MODULE_1__/* .getStoreType */ .K)() === _constants__WEBPACK_IMPORTED_MODULE_2__/* .STORE_CUSTOMIZATION.B2B */ .DO.B2B) return "My Requests";
            else if (theme === null || theme === void 0 ? void 0 : (ref4 = theme.cta_config) === null || ref4 === void 0 ? void 0 : ref4.banner_cta) return theme === null || theme === void 0 ? void 0 : (ref5 = theme.cta_config) === null || ref5 === void 0 ? void 0 : ref5.banner_cta;
            else if (isStoreServiceBased) return "Book Now";
            else return "Shop Now";
        case "order_instructions_label":
            if (isStoreServiceBased) return "Booking Instructions";
            else return "Order Instructions";
        case "cart_cta":
            var ref6, ref7;
            if (theme === null || theme === void 0 ? void 0 : (ref6 = theme.cta_config) === null || ref6 === void 0 ? void 0 : ref6.postpaid_cart_cta) return theme === null || theme === void 0 ? void 0 : (ref7 = theme.cta_config) === null || ref7 === void 0 ? void 0 : ref7.postpaid_cart_cta;
            else if (isStoreServiceBased) return "Book Now";
            else return "Place Order";
        case "item_total_label":
            if (isStoreServiceBased) return "Total";
            else return "Item Total";
        case "order_summary_heading":
            if (isStoreServiceBased) return "Summary";
            else return "Order Summary";
        case "item_details_heading":
            if (isStoreServiceBased) return "Details";
            else return "Item Details";
        case "widget_cta":
            if (isStoreServiceBased) return "Book Now";
            else return "Explore Now";
        case "cart_confirm_cta":
            {
                var cart = _redux_store__WEBPACK_IMPORTED_MODULE_0__/* ["default"].getState */ .Z.getState().cartReducer;
                var isOrderServiceType = cart.order_type === _constants__WEBPACK_IMPORTED_MODULE_2__/* .ORDER_TYPE.SERVICE */ .Jm.SERVICE;
                if (isOrderServiceType) return "Pay after service";
                else if (cart.order_type === _constants__WEBPACK_IMPORTED_MODULE_2__/* .ORDER_TYPE.DELIVERY */ .Jm.DELIVERY) return isExtraChargeForCODActive ? "Cash On Delivery" : "Pay On Delivery";
                else return "Pay on Pickup";
            }
        case "pay_after_cta":
            if (isStoreServiceBased) return "Pay after Service using";
            else return "Pay on Delivery / Pickup using";
        case "other_payment_modes_cta":
            if (isStoreServiceBased) return "Pay after service";
            else {
                var _orderDetails = _redux_store__WEBPACK_IMPORTED_MODULE_0__/* ["default"].getState */ .Z.getState().orderReducer.orderDetails, prepaid_flag = _orderDetails.prepaid_flag, order_type = _orderDetails.order_type;
                if (prepaid_flag === 1) {
                    if (order_type === _constants__WEBPACK_IMPORTED_MODULE_2__/* .ORDER_TYPE.DELIVERY */ .Jm.DELIVERY) return isExtraChargeForCODActive ? "Cash On Delivery" : "Pay On Delivery";
                    else return "Pay On Pick Up";
                } else return "Cash On Delivery";
            }
        case "bill_order_id":
            {
                return getBillOrderIdLabel();
            }
        case "order_list_heading":
            return isStoreServiceBased ? "My Bookings" : "My Orders";
        default:
            return "";
    }
};
/* harmony default export */ __webpack_exports__["Z"] = (getCustomCtaText);


/***/ }),

/***/ 956494:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": function() { return /* binding */ getCustomHeaderTextColor; }
/* harmony export */ });
/* harmony import */ var _deviceWidth__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(186812);
/* harmony import */ var _getContrastingColor__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(833104);


function getCustomHeaderTextColor(bgColor) {
    if (_deviceWidth__WEBPACK_IMPORTED_MODULE_0__/* .deviceWidth */ .o > 767) {
        return (0,_getContrastingColor__WEBPACK_IMPORTED_MODULE_1__/* .getContrastingColor */ .Q)(bgColor);
    }
    return "black-90";
}


/***/ }),

/***/ 153716:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ getDiscountPercentage; }
/* harmony export */ });
/**
 * @param {number} price
 * @param {number} discountedPrice
 * @return {number}
 */ var getDiscountPercentage = function(price, discountedPrice) {
    if (price === 0) return 0;
    return Math.round(100 - discountedPrice / price * 100);
};


/***/ }),

/***/ 270758:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ getThemeColor; }
/* harmony export */ });
/* harmony import */ var _redux_store__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(167261);

function getThemeColor() {
    var ref, ref1;
    var storeInfo = _redux_store__WEBPACK_IMPORTED_MODULE_0__/* ["default"].getState */ .Z.getState().storeReducer.store;
    return storeInfo === null || storeInfo === void 0 ? void 0 : (ref = storeInfo.theme) === null || ref === void 0 ? void 0 : (ref1 = ref.colors) === null || ref1 === void 0 ? void 0 : ref1.primary_color;
}


/***/ }),

/***/ 230066:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "eo": function() { return /* binding */ getWhatAppRedirectionUrlCODRequest; },
/* harmony export */   "gi": function() { return /* binding */ getWhatAppRedirectionUrl; },
/* harmony export */   "iM": function() { return /* binding */ openWhatsAppLeadModal; }
/* harmony export */ });
/* harmony import */ var _redux_store__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(167261);
/* harmony import */ var _getContactDetails__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(160492);
/* harmony import */ var src_redux_actions__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(731024);



function openWhatsAppLeadModal() {
    _redux_store__WEBPACK_IMPORTED_MODULE_0__/* ["default"].dispatch */ .Z.dispatch((0,src_redux_actions__WEBPACK_IMPORTED_MODULE_2__/* .setWhatsAppLeadModalState */ .lT)({
        show: true
    }));
}
function getWhatAppRedirectionUrlCODRequest(payAmount, orderId) {
    var ref;
    var storeData = _redux_store__WEBPACK_IMPORTED_MODULE_0__/* ["default"].getState */ .Z.getState().storeReducer.store;
    var message = "Hi%2C%0AI%20would%20pay%20Rs.".concat(payAmount, "%20in%20*cash*%20for%20the%20*Order%20%23*%20-%20").concat(orderId, "%0Athat%20was%20placed%20at%20your%20online%20store%20-%20%0A").concat(storeData === null || storeData === void 0 ? void 0 : (ref = storeData.store_info) === null || ref === void 0 ? void 0 : ref.store_url);
    return getWhatAppRedirectionUrl(message);
}
function getWhatAppRedirectionUrl() {
    var message = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    var storeData = _redux_store__WEBPACK_IMPORTED_MODULE_0__/* ["default"].getState */ .Z.getState().storeReducer.store;
    var storePhone = (0,_getContactDetails__WEBPACK_IMPORTED_MODULE_1__/* .getVisibleStorePhone */ .qQ)(storeData);
    return "https://api.whatsapp.com/send?phone=+91".concat(storePhone, "&text=").concat(message);
}


/***/ }),

/***/ 586423:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": function() { return /* binding */ isPLPRequiredSystem; }
/* harmony export */ });
var isPLPRequiredSystem = function(themeVar) {
    switch(themeVar){
        case 1:
            return true;
        case 2:
            return true;
        case 3:
            return false;
        case 4:
            return false;
        default:
            return true;
    }
};


/***/ }),

/***/ 43935:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ isB2BStore; }
/* harmony export */ });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(913886);
/* harmony import */ var _getStoreType__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66871);


var isB2BStore = function() {
    return (0,_getStoreType__WEBPACK_IMPORTED_MODULE_1__/* .getStoreType */ .K)() === _constants__WEBPACK_IMPORTED_MODULE_0__/* .STORE_CUSTOMIZATION.B2B */ .DO.B2B;
};


/***/ }),

/***/ 648670:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ itemIndexFromCart; }
/* harmony export */ });
/**
 * get index of specific item based on id from cart
 * if doesn't exist return -1
 * @param {*} cartData
 * @param {*} product
 * @return {*} number
 */ var itemIndexFromCart = function(cartData, product) {
    if (cartData && product) {
        var ref;
        return cartData === null || cartData === void 0 ? void 0 : (ref = cartData.items) === null || ref === void 0 ? void 0 : ref.findIndex(function(el) {
            return (el.id || el.item_id) === product.id;
        });
    }
    return -1;
};


/***/ }),

/***/ 822787:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ mutateItemObjectWithCartData; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(626042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(269396);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(629815);
/* harmony import */ var _getTotalCartAmounts__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(668246);
/* harmony import */ var _components_Common_Toast__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40804);





var updatePersonalizationQuantity = function(cart, idx, ppIdx, type) {
    var ref, ref1;
    var personalizations = (ref = cart[idx]) === null || ref === void 0 ? void 0 : (ref1 = ref.personalization_info) === null || ref1 === void 0 ? void 0 : ref1.personalizations;
    if (personalizations && personalizations[ppIdx]) {
        if (personalizations[ppIdx].quantity === 1) {
            // Remove the personalization item if its quantity is 1
            personalizations.splice(ppIdx, 1);
        } else {
            // Decrement the personalization quantity
            personalizations[ppIdx].quantity -= 1;
        }
    }
};
/**
 * Helper function for addition of the product
 * item to the cart for update the cart
 * @param {string} type
 * @param {object} item
 * @param {Array} cart
 * @return {Array}
 */ var mutateItemObjectWithCartData = function(type, item, cart) {
    var personalizedProductData = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null, ppIdx = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : null, personalizationLocalState = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : null, count = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : null;
    try {
        var tempCart = JSON.parse(JSON.stringify(cart.items));
        // create important keys in the Item
        item = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, item), {
            item_name: item.name,
            quantity: item.quantity ? item.quantity : 1,
            amount: (item.quantity ? item.quantity : 1) * item.discounted_price,
            actual_price: item.price,
            discounted_price: item.discounted_price,
            item_id: item.id || item.item_id,
            item_type: "catalog"
        });
        var personalization_info = {};
        var idx = tempCart === null || tempCart === void 0 ? void 0 : tempCart.findIndex(function(ele) {
            return (ele === null || ele === void 0 ? void 0 : ele.item_id) === (item === null || item === void 0 ? void 0 : item.item_id);
        });
        switch(type){
            // case for increase in item quantity
            case "inc":
                // if managed inventory is acvtivated and,
                // quantity is same as available quantity,
                // disallow addition
                if (tempCart[idx].managed_inventory && tempCart[idx].quantity === tempCart[idx].available_quantity) {
                    (0,_components_Common_Toast__WEBPACK_IMPORTED_MODULE_0__/* .toastNotifyInfo */ .lU)("No more units available for purchase");
                } else {
                    tempCart[idx].quantity = tempCart[idx].quantity + 1;
                    tempCart[idx].amount = tempCart[idx].quantity * tempCart[idx].discounted_price;
                    if (personalizedProductData && ppIdx !== undefined) {
                        var ref;
                        tempCart[idx].personalization_info.personalizations[ppIdx] = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, tempCart[idx].personalization_info.personalizations[ppIdx]), {
                            quantity: ((ref = tempCart[idx].personalization_info.personalizations[ppIdx]) === null || ref === void 0 ? void 0 : ref.quantity) + 1
                        });
                    }
                }
                break;
            // case for descrease in item quantity
            case "dec":
                // if the quantity is one i.e you cannot reduce the quantity more so remove that item
                if (tempCart[idx].quantity === 1) {
                    tempCart.splice(idx, 1);
                } else {
                    tempCart[idx].quantity = tempCart[idx].quantity - 1;
                    tempCart[idx].amount = tempCart[idx].quantity * tempCart[idx].discounted_price;
                    if (personalizedProductData && ppIdx !== undefined) {
                        updatePersonalizationQuantity(tempCart, idx, ppIdx);
                    }
                }
                break;
            case "custom":
                if (tempCart[idx].managed_inventory && count > tempCart[idx].available_quantity) {
                    (0,_components_Common_Toast__WEBPACK_IMPORTED_MODULE_0__/* .toastNotifyInfo */ .lU)("No more units available for purchase");
                } else if (count === 0) {
                    tempCart.splice(idx, 1);
                } else {
                    tempCart[idx].quantity = count;
                    tempCart[idx].amount = tempCart[idx].quantity * tempCart[idx].discounted_price;
                    if (personalizedProductData && ppIdx !== undefined) {
                        tempCart[idx].personalization_info.personalizations[ppIdx] = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, tempCart[idx].personalization_info.personalizations[ppIdx]), {
                            quantity: count
                        });
                    }
                }
                break;
            // case for the add item in cart
            case "add":
                if (personalizedProductData) {
                    var personalizations = [
                        (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, personalizedProductData), {
                            quantity: 1
                        })
                    ];
                    personalization_info["personalizations"] = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(personalizations);
                }
                if (idx === -1) {
                    tempCart.push((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, item), {
                        personalization_info: personalizedProductData ? personalization_info : null
                    }));
                } else {
                    tempCart[idx].quantity = tempCart[idx].quantity + 1;
                    tempCart[idx].personalization_info.personalizations.push(personalization_info["personalizations"][0]);
                    tempCart[idx].amount = tempCart[idx].quantity * tempCart[idx].discounted_price;
                }
                break;
            case "remove":
                {
                    idx = tempCart.findIndex(function(ele) {
                        return ele.item_id === item.item_id;
                    });
                    tempCart[idx].quantity = 0;
                    if (personalizedProductData && ppIdx !== undefined) {
                        updatePersonalizationQuantity(tempCart, idx, ppIdx);
                    }
                    break;
                }
            case "save":
                if (personalizedProductData) {
                    tempCart[idx].personalization_info["personalizations"][ppIdx] = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, personalizedProductData);
                }
                break;
            case "confirm":
                if (personalizationLocalState) {
                    var ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
                    var finalPersonalizedData = personalizationLocalState.filter(function(ele) {
                        return (ele === null || ele === void 0 ? void 0 : ele.quantity) !== 0;
                    });
                    tempCart[idx].personalization_info["personalizations"] = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(finalPersonalizedData);
                    var totalPersonalizationQuantity = tempCart === null || tempCart === void 0 ? void 0 : (ref1 = tempCart[idx]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.personalization_info) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.personalizations) === null || ref3 === void 0 ? void 0 : ref3.reduce(function(total, personalization) {
                        return total + (personalization === null || personalization === void 0 ? void 0 : personalization.quantity);
                    }, 0);
                    tempCart[idx].quantity = totalPersonalizationQuantity;
                    tempCart[idx].amount = (tempCart === null || tempCart === void 0 ? void 0 : (ref4 = tempCart[idx]) === null || ref4 === void 0 ? void 0 : ref4.quantity) * (tempCart === null || tempCart === void 0 ? void 0 : (ref5 = tempCart[idx]) === null || ref5 === void 0 ? void 0 : ref5.discounted_price);
                    if ((tempCart === null || tempCart === void 0 ? void 0 : (ref6 = tempCart[idx]) === null || ref6 === void 0 ? void 0 : ref6.managed_inventory) && (tempCart === null || tempCart === void 0 ? void 0 : (ref7 = tempCart[idx]) === null || ref7 === void 0 ? void 0 : ref7.quantity) > (tempCart === null || tempCart === void 0 ? void 0 : (ref8 = tempCart[idx]) === null || ref8 === void 0 ? void 0 : ref8.available_quantity)) {
                        (0,_components_Common_Toast__WEBPACK_IMPORTED_MODULE_0__/* .toastNotifyInfo */ .lU)("Purchase quantity exceeds the available quantity");
                        return;
                    }
                    if ((tempCart === null || tempCart === void 0 ? void 0 : (ref9 = tempCart[idx]) === null || ref9 === void 0 ? void 0 : ref9.quantity) === 0) {
                        tempCart === null || tempCart === void 0 ? void 0 : tempCart.splice(idx, 1);
                    }
                }
                break;
            default:
                break;
        }
        var amount_values = (0,_getTotalCartAmounts__WEBPACK_IMPORTED_MODULE_4__/* .getTotalCartAmounts */ .a)(tempCart);
        return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, cart), {
            items: tempCart
        }), amount_values);
    } catch (err) {
        console.log(err);
        return cart;
    }
};


/***/ }),

/***/ 759186:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ mutateVariantItemWithCartData; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(626042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(269396);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(629815);
/* harmony import */ var _getTotalCartAmounts__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(668246);
/* harmony import */ var _components_Common_Toast__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40804);





/**
 * Helper function for addition of the variant product
 * item to the cart for update the cart
 * @param {string} type
 * @param {object} item
 * @param {object} variant
 * @param {Array} cart
 * @return {Array}
 */ var mutateVariantItemWithCartData = function(type, item, variant, cart) {
    var personalizedProductData = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : null, ppIdx = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : null, personalizationLocalState = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : null, count = arguments.length > 7 && arguments[7] !== void 0 ? arguments[7] : null;
    try {
        var tempCart = JSON.parse(JSON.stringify(cart.items));
        // create important keys in the Item
        item = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, item), {
            item_name: item.name,
            quantity: item.quantity ? item.quantity : 1,
            actual_price: item.price,
            discounted_price: item.discounted_price,
            item_id: item.id || item.item_id,
            item_type: "catalog"
        });
        var personalization_info = {};
        var idx = tempCart === null || tempCart === void 0 ? void 0 : tempCart.findIndex(function(ele) {
            return (ele === null || ele === void 0 ? void 0 : ele.item_id) === (item === null || item === void 0 ? void 0 : item.item_id);
        });
        switch(type){
            // case for increase in item quantity
            case "inc":
                {
                    if (personalizedProductData) {
                        var personalizations = [
                            (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, personalizedProductData), {
                                quantity: personalizedProductData === null || personalizedProductData === void 0 ? void 0 : personalizedProductData.quantity
                            }), 
                        ];
                        personalization_info["personalizations"] = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(personalizations);
                    }
                    // if variant data and variant selected
                    if (tempCart[idx] && tempCart[idx].variants_selected) {
                        var variantIdx = tempCart[idx].variants_selected.findIndex(function(el) {
                            return el.variant_id === (variant === null || variant === void 0 ? void 0 : variant.variant_id);
                        });
                        // if managed inventory is acvtivated and,
                        // variant quantity is same as available quantity,
                        // disallow addition
                        if (variantIdx !== -1 && tempCart[idx].variants_selected[variantIdx].managed_inventory && tempCart[idx].variants_selected[variantIdx].quantity === tempCart[idx].variants_selected[variantIdx].available_quantity) {
                            (0,_components_Common_Toast__WEBPACK_IMPORTED_MODULE_0__/* .toastNotifyInfo */ .lU)("No more units available for purchase");
                        } else {
                            var ref, ref1;
                            if (((ref = tempCart[idx]) === null || ref === void 0 ? void 0 : (ref1 = ref.variants_selected) === null || ref1 === void 0 ? void 0 : ref1.length) > 0 && variantIdx !== -1) {
                                var ref2, ref3;
                                // Increase the variant quantity by one
                                tempCart[idx].variants_selected[variantIdx].quantity = ((ref2 = tempCart[idx].variants_selected) === null || ref2 === void 0 ? void 0 : (ref3 = ref2[variantIdx]) === null || ref3 === void 0 ? void 0 : ref3.quantity) + 1;
                                tempCart[idx].variants_selected[variantIdx].amount += variant === null || variant === void 0 ? void 0 : variant.discounted_price;
                                if (personalizedProductData) {
                                    if (!!(personalizedProductData === null || personalizedProductData === void 0 ? void 0 : personalizedProductData.quantity)) {
                                        tempCart[idx].variants_selected[variantIdx].personalization_info.personalizations.push((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, personalizedProductData));
                                    }
                                    if (ppIdx !== undefined && ppIdx !== null) {
                                        var personalizations1 = tempCart[idx].variants_selected[variantIdx].personalization_info.personalizations;
                                        personalizations1[ppIdx].quantity += 1;
                                    }
                                }
                            } else {
                                // add new variant to the selected variant list
                                tempCart[idx].variants_selected.push((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, variant), {
                                    quantity: 1,
                                    amount: variant === null || variant === void 0 ? void 0 : variant.discounted_price,
                                    personalization_info: personalizedProductData ? personalization_info : null
                                }));
                            }
                            /** Increase the whole item quantity by one */ tempCart[idx].quantity = tempCart[idx].quantity + 1;
                            // calculate the new amount
                            tempCart[idx].amount = tempCart[idx].variants_selected.reduce(function(acc, curr) {
                                return acc + curr.amount;
                            }, 0);
                        }
                    } else {
                        item.variants_selected = [
                            (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, variant), {
                                quantity: 1,
                                amount: variant === null || variant === void 0 ? void 0 : variant.discounted_price,
                                personalization_info: personalizedProductData ? personalization_info : null
                            }), 
                        ];
                        item.amount = variant === null || variant === void 0 ? void 0 : variant.discounted_price;
                        tempCart.push(item);
                    }
                }
                break;
            case "dec":
                {
                    if (tempCart[idx].variants_selected) {
                        var variantIdx1 = tempCart[idx].variants_selected.findIndex(function(el) {
                            return el.variant_id === (variant === null || variant === void 0 ? void 0 : variant.variant_id);
                        });
                        if (tempCart[idx].variants_selected[variantIdx1].quantity === 1) {
                            // Remove the variant if its a last one
                            tempCart[idx].variants_selected.splice(variantIdx1, 1);
                            if (tempCart[idx].variants_selected.length === 0) {
                                tempCart.splice(idx, 1);
                            } else {
                                tempCart[idx].quantity = tempCart[idx].quantity - 1;
                                tempCart[idx].amount -= variant === null || variant === void 0 ? void 0 : variant.discounted_price;
                            }
                        } else {
                            // Decrease the variant quantity by one
                            tempCart[idx].variants_selected[variantIdx1].quantity = tempCart[idx].variants_selected[variantIdx1].quantity - 1;
                            tempCart[idx].variants_selected[variantIdx1].amount -= variant === null || variant === void 0 ? void 0 : variant.discounted_price;
                            tempCart[idx].quantity = tempCart[idx].quantity - 1;
                            tempCart[idx].amount -= tempCart[idx].variants_selected[variantIdx1].discounted_price;
                            if (personalizedProductData && ppIdx !== undefined) {
                                var personalizations2 = tempCart[idx].variants_selected[variantIdx1].personalization_info.personalizations;
                                if (personalizations2 && personalizations2[ppIdx]) {
                                    if (personalizations2[ppIdx].quantity === 1) {
                                        personalizations2.splice(ppIdx, 1);
                                    } else {
                                        personalizations2[ppIdx].quantity -= 1;
                                    }
                                }
                            }
                        }
                    }
                }
                break;
            case "custom":
                {
                    var ref4;
                    if (personalizedProductData) {
                        var personalizations3 = [
                            (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, personalizedProductData), {
                                quantity: personalizedProductData === null || personalizedProductData === void 0 ? void 0 : personalizedProductData.quantity
                            }), 
                        ];
                        personalization_info["personalizations"] = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(personalizations3);
                    }
                    if ((ref4 = tempCart[idx]) === null || ref4 === void 0 ? void 0 : ref4.variants_selected) {
                        var ref5;
                        var variantIdx2 = tempCart[idx].variants_selected.findIndex(function(el) {
                            return el.variant_id === variant.variant_id;
                        });
                        var desiredVariant = (ref5 = tempCart[idx].variants_selected) === null || ref5 === void 0 ? void 0 : ref5[variantIdx2];
                        if (desiredVariant) {
                            var quantityDiff = count - desiredVariant.quantity;
                            if (desiredVariant.managed_inventory && count > desiredVariant.available_quantity) {
                                (0,_components_Common_Toast__WEBPACK_IMPORTED_MODULE_0__/* .toastNotifyInfo */ .lU)("No more units available for purchase");
                            } else if (count === 0) {
                                // remove desired variant from item's variant list in cart.
                                tempCart[idx].variants_selected.splice(variantIdx2, 1);
                                // if desired variant was the only variant of item in cart, remove the item as well from cart.
                                if (tempCart[idx].variants_selected.length === 0) {
                                    tempCart.splice(idx, 1);
                                } else {
                                    // adjust quantity and amount of item.
                                    tempCart[idx].quantity = tempCart[idx].quantity + quantityDiff;
                                    tempCart[idx].amount += quantityDiff * variant.discounted_price;
                                }
                            } else {
                                // adjust variant info
                                desiredVariant.quantity = count;
                                desiredVariant.amount += quantityDiff * variant.discounted_price;
                                // adjust item info
                                tempCart[idx].quantity = tempCart[idx].quantity + quantityDiff;
                                tempCart[idx].amount += quantityDiff * desiredVariant.discounted_price;
                            }
                        } else {
                            // add new variant to the selected variant list
                            tempCart[idx].variants_selected.push((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, variant), {
                                quantity: count,
                                amount: count * variant.discounted_price,
                                personalization_info: personalizedProductData ? personalization_info : null
                            }));
                            // adjust item quantity and amount
                            tempCart[idx].quantity += count;
                            tempCart[idx].amount += count * variant.discounted_price;
                        }
                    } else {
                        item.variants_selected = [
                            (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, variant), {
                                quantity: count,
                                amount: count * variant.discounted_price,
                                personalization_info: personalizedProductData ? personalization_info : null
                            }), 
                        ];
                        item.amount = count * variant.discounted_price;
                        tempCart.push(item);
                    }
                }
                break;
            case "repeat":
                {
                    var ref6, ref7, ref8;
                    if ((tempCart === null || tempCart === void 0 ? void 0 : (ref6 = tempCart[idx]) === null || ref6 === void 0 ? void 0 : ref6.variants_selected) && (tempCart === null || tempCart === void 0 ? void 0 : (ref7 = tempCart[idx]) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.variants_selected) === null || ref8 === void 0 ? void 0 : ref8.length) > 0) {
                        var ref9, ref10, ref11;
                        tempCart[idx].variants_selected[tempCart[idx].variants_selected.length - 1].quantity = (tempCart === null || tempCart === void 0 ? void 0 : (ref9 = tempCart[idx]) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.variants_selected) === null || ref10 === void 0 ? void 0 : (ref11 = ref10[tempCart[idx].variants_selected.length - 1]) === null || ref11 === void 0 ? void 0 : ref11.quantity) + 1;
                        tempCart[idx].quantity = tempCart[idx].quantity + 1;
                        tempCart[idx].variants_selected[tempCart[idx].variants_selected.length - 1].amount += variant.discounted_price;
                        // add this new variant price the overall item amount
                        tempCart[idx].amount = tempCart[idx].variants_selected.reduce(function(acc, curr) {
                            return acc + curr.discounted_price * curr.quantity;
                        }, 0);
                    }
                }
                break;
            case "save":
                {
                    var ref12, ref13;
                    var variantIdx3 = tempCart === null || tempCart === void 0 ? void 0 : (ref12 = tempCart[idx]) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.variants_selected) === null || ref13 === void 0 ? void 0 : ref13.findIndex(function(el) {
                        return (el === null || el === void 0 ? void 0 : el.variant_id) === (variant === null || variant === void 0 ? void 0 : variant.variant_id);
                    });
                    if (personalizedProductData) {
                        tempCart[idx].variants_selected[variantIdx3].personalization_info["personalizations"][ppIdx] = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, personalizedProductData);
                    }
                }
            case "confirm":
                {
                    var ref14, ref15, ref16, ref17;
                    if (idx === -1) return;
                    var variantIdx4 = tempCart === null || tempCart === void 0 ? void 0 : (ref14 = tempCart[idx]) === null || ref14 === void 0 ? void 0 : (ref15 = ref14.variants_selected) === null || ref15 === void 0 ? void 0 : ref15.findIndex(function(el) {
                        return (el === null || el === void 0 ? void 0 : el.variant_id) === (variant === null || variant === void 0 ? void 0 : variant.variant_id);
                    });
                    if (variantIdx4 === -1) return;
                    var selectedVariant = tempCart === null || tempCart === void 0 ? void 0 : (ref16 = tempCart[idx]) === null || ref16 === void 0 ? void 0 : (ref17 = ref16.variants_selected) === null || ref17 === void 0 ? void 0 : ref17[variantIdx4];
                    if (personalizationLocalState) {
                        var finalPersonalizedData = personalizationLocalState === null || personalizationLocalState === void 0 ? void 0 : personalizationLocalState.filter(function(ele) {
                            return (ele === null || ele === void 0 ? void 0 : ele.quantity) !== 0;
                        });
                        if ((finalPersonalizedData === null || finalPersonalizedData === void 0 ? void 0 : finalPersonalizedData.length) > 0) {
                            selectedVariant.personalization_info = {
                                personalizations: finalPersonalizedData
                            };
                            var variantItemQty = finalPersonalizedData === null || finalPersonalizedData === void 0 ? void 0 : finalPersonalizedData.reduce(function(total, personalization) {
                                return total + (personalization === null || personalization === void 0 ? void 0 : personalization.quantity);
                            }, 0);
                            selectedVariant.quantity = variantItemQty;
                            selectedVariant.amount = variantItemQty * (variant === null || variant === void 0 ? void 0 : variant.discounted_price);
                        } else {
                            tempCart[idx].variants_selected.splice(variantIdx4, 1);
                        }
                        updateCartItemQuantitiesAndAmounts(tempCart[idx]);
                        if (tempCart[idx].variants_selected.length === 0) {
                            tempCart.splice(idx, 1);
                        }
                    }
                }
                break;
            default:
                break;
        }
        var amount_values = (0,_getTotalCartAmounts__WEBPACK_IMPORTED_MODULE_4__/* .getTotalCartAmounts */ .a)(tempCart);
        return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, cart), {
            items: tempCart
        }), amount_values);
    } catch (err) {
        console.log(err);
        return cart;
    }
};
function updateCartItemQuantitiesAndAmounts(cartItem) {
    cartItem.quantity = cartItem.variants_selected.reduce(function(total, variantData) {
        return total + variantData.quantity;
    }, 0);
    cartItem.amount = cartItem.quantity * cartItem.discounted_price;
}


/***/ }),

/***/ 20503:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _getCustomCtaText__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(336623);
/* harmony import */ var _redux_store__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(167261);


function getOrdersDropdownList() {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10;
    var ordersDropdownList = [
        {
            id: 1,
            name: "000000000",
            action: "defaultPhone"
        },
        {
            id: 2,
            name: (0,_getCustomCtaText__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("my_orders_cta"),
            action: "orders"
        },
        {
            id: 3,
            name: "Logout",
            action: "logout"
        }, 
    ];
    var userContact = ((ref = _redux_store__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z === null || _redux_store__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z === void 0 ? void 0 : _redux_store__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getState */ .Z.getState()) === null || ref === void 0 ? void 0 : (ref1 = ref.userReducer) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.data) === null || ref2 === void 0 ? void 0 : ref2.phone) || ((ref3 = _redux_store__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z === null || _redux_store__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z === void 0 ? void 0 : _redux_store__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getState */ .Z.getState()) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.userReducer) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.data) === null || ref5 === void 0 ? void 0 : ref5.email);
    ordersDropdownList[0].name = userContact;
    var isVisitorLoginVisible = (ref6 = _redux_store__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z === null || _redux_store__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z === void 0 ? void 0 : _redux_store__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getState */ .Z.getState()) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.commonReducer) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.featureLocksData) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.featureLocks) === null || ref9 === void 0 ? void 0 : (ref10 = ref9["visitorLogin"]) === null || ref10 === void 0 ? void 0 : ref10.isVisible;
    return ordersDropdownList.slice(0, !isVisitorLoginVisible ? 2 : undefined);
}
/* harmony default export */ __webpack_exports__["Z"] = (getOrdersDropdownList);


/***/ }),

/***/ 236913:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "IV": function() { return /* binding */ handlePDPErrorCaseRedirection; },
/* harmony export */   "ts": function() { return /* binding */ getProductPathFromUrl; }
/* harmony export */ });
/* unused harmony exports PDP_ROUTE_IDENTIFIER, CATEGORY_ROUTE_IDENTIFIER, COLLECTION_ROUTE_IDENTIFIER, handleCategoryCollectionRedirect, getPathFromUrl */
/* harmony import */ var src_constants_common__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(742783);
/* harmony import */ var _404Redirect__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(178453);
/* harmony import */ var _routes__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(540190);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(913886);




var PDP_ROUTE_IDENTIFIER = "/product/";
var CATEGORY_ROUTE_IDENTIFIER = "/shop/";
var COLLECTION_ROUTE_IDENTIFIER = "/collections/";
/**
 * function for returing product page path following domain.
 * sample product url - "httts://wwww.domain.com/product/remaining_string"
 * then this would return "/product/remaining_string" or "product/remaining_string" depending on the value of startWithSlash.
 * @param productUrl - product link received from backend.
 * @param startWithSlash - tells us whether to start the Path with "/" or not.
 * @returns - path of product following domain - "/product/remaining_string"
 */ function getProductPathFromUrl(productUrl) {
    var startWithSlash = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
    var splittedArray = productUrl === null || productUrl === void 0 ? void 0 : productUrl.split(PDP_ROUTE_IDENTIFIER);
    if ((splittedArray === null || splittedArray === void 0 ? void 0 : splittedArray.length) > 1) {
        var route = PDP_ROUTE_IDENTIFIER + splittedArray[1];
        return startWithSlash ? route : route === null || route === void 0 ? void 0 : route.slice(1);
    } else {
        return "";
    }
}
/**
 * This function handles the redirection for pdp page on server side in case of error while fetching product data.
 * if the status code id 3XX - it redirects to new product Url
 * else it would redirect to 404 - Not Fund page.
 * @param {*} ctx
 * @param {*} productResponse
 * @param {*} propType
 */ function handlePDPErrorCaseRedirection(param) {
    var ctx = param.ctx, productResponse = param.productResponse, propType = param.propType;
    var ref, ref1;
    var statusCode = productResponse === null || productResponse === void 0 ? void 0 : (ref = productResponse.error) === null || ref === void 0 ? void 0 : (ref1 = ref.response) === null || ref1 === void 0 ? void 0 : ref1.status;
    if (src_constants_common__WEBPACK_IMPORTED_MODULE_0__/* .REDIRECT_STATUS_CODES.includes */ .Ye.includes(statusCode)) {
        var ref2, ref3, ref4, ref5, ref6, ref7;
        var productItem = JSON.parse(productResponse === null || productResponse === void 0 ? void 0 : (ref2 = productResponse.error) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.response) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.data) === null || ref4 === void 0 ? void 0 : ref4.data);
        var newProductPath = getProductPathFromUrl(productItem === null || productItem === void 0 ? void 0 : productItem.link, false);
        var domainFromStore = propType === null || propType === void 0 ? void 0 : (ref5 = propType.ssrStore) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.storeReducer) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.store) === null || ref7 === void 0 ? void 0 : ref7.domain;
        return (0,_404Redirect__WEBPACK_IMPORTED_MODULE_1__/* ._redirectToOtherRoute */ .O1)({
            ctx: ctx,
            statusCode: statusCode,
            route: (0,_routes__WEBPACK_IMPORTED_MODULE_2__.getRoute)(newProductPath, domainFromStore, ctx)
        });
    } else {
        return (0,_404Redirect__WEBPACK_IMPORTED_MODULE_1__/* .set404Response */ .xH)(ctx, propType);
    }
}
function handleCategoryCollectionRedirect(param) {
    var ctx = param.ctx, redirectionLink = param.redirectionLink, type = param.type, propType = param.propType;
    return {
        redirect: {
            destination: redirectionLink,
            permanent: false
        }
    };
}
function getPathFromUrl(url) {
    var startWithSlash = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true, type = arguments.length > 2 ? arguments[2] : void 0;
    var identifier;
    if (type === PAGE_TYPE_ID.COLLECTION) {
        identifier = COLLECTION_ROUTE_IDENTIFIER;
    } else if (type === PAGE_TYPE_ID.CATEGORY) {
        identifier = CATEGORY_ROUTE_IDENTIFIER;
    }
    var splittedArray = url === null || url === void 0 ? void 0 : url.split(identifier);
    if ((splittedArray === null || splittedArray === void 0 ? void 0 : splittedArray.length) > 1) {
        var route = identifier + splittedArray[1];
        return startWithSlash ? route : route === null || route === void 0 ? void 0 : route.slice(1);
    } else {
        return "";
    }
}


/***/ }),

/***/ 936083:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "HN": function() { return /* binding */ emailRegex; },
/* harmony export */   "L_": function() { return /* binding */ addressRegex; },
/* harmony export */   "PG": function() { return /* binding */ alphabetsAndSpaceRegex; },
/* harmony export */   "Zn": function() { return /* binding */ removeSpecialCharAndNumbers; },
/* harmony export */   "fw": function() { return /* binding */ alphaNumericLettersRegex; },
/* harmony export */   "oe": function() { return /* binding */ allowEverything; },
/* harmony export */   "yf": function() { return /* binding */ isValidPhoneNumber; }
/* harmony export */ });
/* unused harmony exports removeSpecialCharacters, allowOnlyNumber, allowRange, allowAllNumbers, decimalPriceRegex, passwordRegex, validateEmail */
var addressRegex = function() {
    return /[^\w\@\-\.]/gi;
};
var alphaNumericLettersRegex = function() {
    return /[^\w\@\-\.]/gi;
};
var alphabetsAndSpaceRegex = function() {
    return /[^\w\@\-\.]/gi;
};
var emailRegex = function() {
    return /[^\w\@\-\.]/gi;
};
function removeSpecialCharAndNumbers(inputStr) {
    var opStr = inputStr.replace(/[^a-zA-Z ]/g, "");
    return opStr;
}
function removeSpecialCharacters(inputStr) {
    var opStr = inputStr.replace(/[^a-zA-Z0-9 ]/g, "");
    return opStr;
}
function allowOnlyNumber(inputStr) {
    var opStr = inputStr.replace(/[^0-9]/g, "");
    return opStr;
}
function allowRange(inputStr) {
    var opStr = inputStr.replace(/^\d+:\d+$|[A-Z]+:[A-Z]$/g, "");
    return opStr;
}
function allowAllNumbers(inputStr) {
    var opStr = inputStr.replace(/[^0-9 . -]/g, "");
    return opStr;
}
function decimalPriceRegex(inputStr) {
    var maxDecimalPlaces = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2;
    var opStr = inputStr.replace(/[^0-9\.]/g, "");
    if (opStr.split(".").length > 2) opStr = opStr.replace(/\.+$/, "");
    var decimalPointIndex = opStr.indexOf(".");
    opStr = decimalPointIndex >= 0 ? opStr.slice(0, decimalPointIndex) + opStr.slice(decimalPointIndex, decimalPointIndex + maxDecimalPlaces + 1) : opStr;
    return opStr;
}
function allowEverything(inputStr) {
    return inputStr;
}
function passwordRegex(inputStr) {
    var opStr = allowOnlyNumber(inputStr).replace(/./g, "*");
    return opStr;
}
var validateEmail = function(email) {
    return String(email).toLowerCase().match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
};
var isValidPhoneNumber = function(number) {
    return /^[6-9]\d{9}$/.test(number);
};


/***/ }),

/***/ 385618:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ routeToCollectionPage; }
/* harmony export */ });
/* harmony import */ var _redux_store__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(167261);
/* harmony import */ var _routes__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(540190);


var routeToCollectionPage = function(collection) {
    var openInNewTab = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var ref, ref1;
    var storeData = (ref = _redux_store__WEBPACK_IMPORTED_MODULE_0__/* ["default"].getState */ .Z.getState().storeReducer) === null || ref === void 0 ? void 0 : ref.store;
    var link = (0,_routes__WEBPACK_IMPORTED_MODULE_1__.getRoute)(_routes__WEBPACK_IMPORTED_MODULE_1__.PATH.collectionCategories(collection === null || collection === void 0 ? void 0 : collection.id), storeData === null || storeData === void 0 ? void 0 : (ref1 = storeData.store_info) === null || ref1 === void 0 ? void 0 : ref1.domain);
    if (openInNewTab) {
        window.open(window.location.origin + (!(link === null || link === void 0 ? void 0 : link.startsWith("/")) ? "/" + link : link), "_blank");
        return;
    }
    window.location.href = link;
};


/***/ }),

/***/ 36408:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ showMegaMenu; }
/* harmony export */ });
/* harmony import */ var _redux_store__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(167261);

function showMegaMenu() {
    var ref, ref1, ref2, ref3, ref4, ref5;
    var featureLocks = (ref = _redux_store__WEBPACK_IMPORTED_MODULE_0__/* ["default"].getState */ .Z.getState()) === null || ref === void 0 ? void 0 : (ref1 = ref.commonReducer) === null || ref1 === void 0 ? void 0 : ref1.featureLocksData.featureLocks;
    return (featureLocks === null || featureLocks === void 0 ? void 0 : (ref2 = featureLocks.collections) === null || ref2 === void 0 ? void 0 : ref2.isVisible) && ((ref3 = _redux_store__WEBPACK_IMPORTED_MODULE_0__/* ["default"].getState */ .Z.getState()) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.catalogReducer) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.collections) === null || ref5 === void 0 ? void 0 : ref5.length) > 0;
}


/***/ }),

/***/ 451959:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ smartWordBreakStyle; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(667294);

// Prioritizes word break, else  if a word is long enough that it overflow it breaks it mid-word
// & wraps it in the next line with a hyphen
var smartWordBreakStyle = {
    wordBreak: "break-word",
    hyphens: "auto",
    overflowWrap: "break-word"
};


/***/ }),

/***/ 576609:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ useCheckIfHomePage; }
/* harmony export */ });
/* harmony import */ var _routes__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(540190);
/* harmony import */ var src_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(268037);


var useCheckIfHomePage = function() {
    var ref = (0,src_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSSRSelector */ .kF)(function(state) {
        return {
            storeDomain: state.storeReducer.store.domain,
            accessPath: state.commonReducer.path
        };
    }), storeDomain = ref.storeDomain, accessPath = ref.accessPath;
    if (typeof accessPath !== "string") return false;
    var domainWithoutForwardSlash = (0,_routes__WEBPACK_IMPORTED_MODULE_0__.getRoute)("", storeDomain);
    var domainNameLength = domainWithoutForwardSlash === null || domainWithoutForwardSlash === void 0 ? void 0 : domainWithoutForwardSlash.length;
    if ((domainWithoutForwardSlash === null || domainWithoutForwardSlash === void 0 ? void 0 : domainWithoutForwardSlash.lastIndexOf("/")) === domainNameLength - 1) {
        domainWithoutForwardSlash = domainWithoutForwardSlash === null || domainWithoutForwardSlash === void 0 ? void 0 : domainWithoutForwardSlash.slice(0, domainNameLength - 1);
    }
    var isHomePage = [
        "/",
        "",
        "/" + storeDomain,
        (0,_routes__WEBPACK_IMPORTED_MODULE_0__.getRoute)("/", storeDomain),
        domainWithoutForwardSlash, 
    ].includes(accessPath);
    return isHomePage;
};


/***/ }),

/***/ 9844:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"widgetBtnShadowWrapper":"ButtonAnimationStyles_widgetBtnShadowWrapper__I9lHm","widgetProductBtnShadowWrapper":"ButtonAnimationStyles_widgetProductBtnShadowWrapper__PxIWk","widgetBtnMoveUpWrapper":"ButtonAnimationStyles_widgetBtnMoveUpWrapper__uRskr","widgetBtnFillDownWrapper":"ButtonAnimationStyles_widgetBtnFillDownWrapper__ErH71","widgetBtnFillUpWrapper":"ButtonAnimationStyles_widgetBtnFillUpWrapper__8zKq3","widgetBtnFillInWrapper":"ButtonAnimationStyles_widgetBtnFillInWrapper__r9Dn5","widgetBtnFillRightWrapper":"ButtonAnimationStyles_widgetBtnFillRightWrapper__7LrYk","widgetBtnUnderlineRightWrapper":"ButtonAnimationStyles_widgetBtnUnderlineRightWrapper__XNBd7","textualElement":"ButtonAnimationStyles_textualElement__Sj94z","widgetBtnUnderlineRightWrapper2":"ButtonAnimationStyles_widgetBtnUnderlineRightWrapper2__D6HzR","animateUnderlineRightWrapper2":"ButtonAnimationStyles_animateUnderlineRightWrapper2__GOChf"};

/***/ }),

/***/ 489429:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"widgetContentFadeInWrapper":"ContentAnimationStyles_widgetContentFadeInWrapper__H7SoP","fadeIn":"ContentAnimationStyles_fadeIn__leIhU","widgetContentFadeInZoomInWrapper":"ContentAnimationStyles_widgetContentFadeInZoomInWrapper__YoutJ","fadeInZoomIn":"ContentAnimationStyles_fadeInZoomIn__NmZUI","widgetContentMoveDownWrapper":"ContentAnimationStyles_widgetContentMoveDownWrapper__zTAx7","moveDown":"ContentAnimationStyles_moveDown__9h9CD","builderSelectorDemo":"ContentAnimationStyles_builderSelectorDemo__eZ4MI","demoMoveDown":"ContentAnimationStyles_demoMoveDown__ZJM6x","widgetContentMoveUpWrapper":"ContentAnimationStyles_widgetContentMoveUpWrapper__eYvDF","moveUp":"ContentAnimationStyles_moveUp__RN9DE","demoMoveUp":"ContentAnimationStyles_demoMoveUp__kSRDz","widgetContentSlideLeftWrapper":"ContentAnimationStyles_widgetContentSlideLeftWrapper__QCzLT","moveLeft":"ContentAnimationStyles_moveLeft__000sW","demoMoveLeft":"ContentAnimationStyles_demoMoveLeft__ezDvi","widgetContentSlideRightWrapper":"ContentAnimationStyles_widgetContentSlideRightWrapper__YD0Ol","moveRight":"ContentAnimationStyles_moveRight__yGnUp","demoMoveRight":"ContentAnimationStyles_demoMoveRight__xU342","imageZoomIn":"ContentAnimationStyles_imageZoomIn__46R47","imageZoomOut":"ContentAnimationStyles_imageZoomOut__Zs1O1","zoomInOnHover":"ContentAnimationStyles_zoomInOnHover__5qMeI","containerShadow":"ContentAnimationStyles_containerShadow__YOHbc","ambient":"ContentAnimationStyles_ambient__BwaC1","animationAmbient":"ContentAnimationStyles_animationAmbient__rtkcT","ambientOnHover":"ContentAnimationStyles_ambientOnHover__7o9GI","animationAmbientOnHover":"ContentAnimationStyles_animationAmbientOnHover__iZzZe"};

/***/ }),

/***/ 759443:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"megaMenuScrollStyle":"megaMenu_megaMenuScrollStyle__og6_h"};

/***/ }),

/***/ 132780:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"cfe-dropdown-nav":"shopComponent_cfe-dropdown-nav__mfnO3","cfe-dropdown-nav__items":"shopComponent_cfe-dropdown-nav__items___awXP","cfe-dropdown-nav__item":"shopComponent_cfe-dropdown-nav__item__zwzRg"};

/***/ }),

/***/ 899214:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"cfe-dropdown-nav":"shopComponent_cfe-dropdown-nav__i04VH","cfe-dropdown-nav__items":"shopComponent_cfe-dropdown-nav__items__yqigN","cfe-dropdown-nav__item":"shopComponent_cfe-dropdown-nav__item__iAcxF"};

/***/ }),

/***/ 583060:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"tertiaryBtnCustomStyle":"styles_tertiaryBtnCustomStyle__otiDn","textualElement":"styles_textualElement__4cGu9"};

/***/ }),

/***/ 981673:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"carousel":"ListPresentation_carousel__wtJ8q","group":"ListPresentation_group__j8hdO","scrolling":"ListPresentation_scrolling__byDt8"};

/***/ })

}]);